{
  "pyramid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Kheops-Pyramid.jpg/500px-Kheops-Pyramid.jpg",
    "c": "Nina, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Kheops-Pyramid.jpg"
  },
  "anc_stonehenge": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Stonehenge_Total.jpg/500px-Stonehenge_Total.jpg",
    "c": "Stefan Kühn, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Stonehenge_Total.jpg"
  },
  "anc_caral": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Caral_2.JPG/500px-Caral_2.JPG",
    "c": "KyleThayer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Caral_2.JPG"
  },
  "anc_sargon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Sargon_of_Akkad_%28frontal%29.jpg/500px-Sargon_of_Akkad_%28frontal%29.jpg",
    "c": "Hans Ollermann, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sargon_of_Akkad_(frontal).jpg"
  },
  "anc_mohenjodaro": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Mohenjodaro_Sindh.jpeg/500px-Mohenjodaro_Sindh.jpeg",
    "c": "The original uploader was M.Imran at English Wikipedia., CC SA 1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mohenjodaro_Sindh.jpeg"
  },
  "anc_hammurabi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/P1050763_Louvre_code_Hammurabi_face_rwk.JPG/500px-P1050763_Louvre_code_Hammurabi_face_rwk.JPG",
    "c": "Mbzt, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:P1050763_Louvre_code_Hammurabi_face_rwk.JPG"
  },
  "anc_hatshepsut": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Chr%C3%A1m_kr%C3%A1lovny_Hat%C5%A1epsovet_-_panoramio_%288%29.jpg/500px-Chr%C3%A1m_kr%C3%A1lovny_Hat%C5%A1epsovet_-_panoramio_%288%29.jpg",
    "c": "Pavel Špindler, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chr%C3%A1m_kr%C3%A1lovny_Hat%C5%A1epsovet_-_panoramio_(8).jpg"
  },
  "anc_akhenaten": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/GD-EG-Caire-Mus%C3%A9e061.JPG/500px-GD-EG-Caire-Mus%C3%A9e061.JPG",
    "c": "Wikimedia Commons, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:GD-EG-Caire-Mus%C3%A9e061.JPG"
  },
  "anc_kadesh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/d3/Ramesseum_siege_of_Dapur.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ramesseum_siege_of_Dapur.jpg"
  },
  "anc_shang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Shang_dynasty_inscribed_tortoise_plastron.jpg/500px-Shang_dynasty_inscribed_tortoise_plastron.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Shang_dynasty_inscribed_tortoise_plastron.jpg"
  },
  "anc_olmec": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Olmeca_head_in_Villahermosa.jpg/500px-Olmeca_head_in_Villahermosa.jpg",
    "c": "Glysiak, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Olmeca_head_in_Villahermosa.jpg"
  },
  "anc_seapeoples": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Philistine_captives_at_Medinet_Habu.jpg/500px-Philistine_captives_at_Medinet_Habu.jpg",
    "c": "Drawn by Faucher-Gudin, from a photograph by Insinger., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Philistine_captives_at_Medinet_Habu.jpg"
  },
  "anc_rome": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Kapitolinische_W%C3%B6lfin_Museum_Capitolini.jpg/500px-Kapitolinische_W%C3%B6lfin_Museum_Capitolini.jpg",
    "c": "Rabax63, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kapitolinische_W%C3%B6lfin_Museum_Capitolini.jpg"
  },
  "anc_firsttemple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Tissot_The_Flight_of_the_Prisoners.jpg/500px-Tissot_The_Flight_of_the_Prisoners.jpg",
    "c": "James Tissot, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Tissot_The_Flight_of_the_Prisoners.jpg"
  },
  "anc_confucius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Konfuzius-1770.jpg/500px-Konfuzius-1770.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Konfuzius-1770.jpg"
  },
  "anc_cyrus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Cyrus_Cylinder.jpg/500px-Cyrus_Cylinder.jpg",
    "c": "Photograph by Mike Peel (www.mikepeel.net). Modifications by مانفی, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cyrus_Cylinder.jpg"
  },
  "anc_behistun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Darius_I_the_Great%27s_inscription.jpg/500px-Darius_I_the_Great%27s_inscription.jpg",
    "c": "Unknown artistUnknown artist ⧼for⧽ Darius I, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Darius_I_the_Great%27s_inscription.jpg"
  },
  "anc_thermopylae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/L%C3%A9onidas_aux_Thermopyles_%28Jacques-Louis_David%29.PNG/500px-L%C3%A9onidas_aux_Thermopyles_%28Jacques-Louis_David%29.PNG",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:L%C3%A9onidas_aux_Thermopyles_(Jacques-Louis_David).PNG"
  },
  "anc_parthenon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/The_Parthenon_in_Athens.jpg/500px-The_Parthenon_in_Athens.jpg",
    "c": "Steve Swayne, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_Parthenon_in_Athens.jpg"
  },
  "anc_gaugamela": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/AlexanderTheGreat_Bust.jpg/500px-AlexanderTheGreat_Bust.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlexanderTheGreat_Bust.jpg"
  },
  "anc_socrates": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/David_-_The_Death_of_Socrates.jpg/500px-David_-_The_Death_of_Socrates.jpg",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:David_-_The_Death_of_Socrates.jpg"
  },
  "anc_persepolis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Cornelis_de_bruijn_persepolis.JPG/500px-Cornelis_de_bruijn_persepolis.JPG",
    "c": "Cornelis de Bruijn, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cornelis_de_bruijn_persepolis.JPG"
  },
  "anc_pytheas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Pyth%C3%A9as.jpg/500px-Pyth%C3%A9as.jpg",
    "c": "Rvalette, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pyth%C3%A9as.jpg"
  },
  "anc_library": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Ancientlibraryalex.jpg/500px-Ancientlibraryalex.jpg",
    "c": "O. Von Corven, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ancientlibraryalex.jpg"
  },
  "anc_qin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Qin_Shi_Huang_statue.jpg/500px-Qin_Shi_Huang_statue.jpg",
    "c": "JesseW900, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Qin_Shi_Huang_statue.jpg"
  },
  "anc_terracotta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Xian_guerreros_terracota_detalle.JPG/500px-Xian_guerreros_terracota_detalle.JPG",
    "c": "User:airunp, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Xian_guerreros_terracota_detalle.JPG"
  },
  "anc_zama": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Slaget_ved_Zama_-_Cornelis_Cort%2C_1567.jpg/500px-Slaget_ved_Zama_-_Cornelis_Cort%2C_1567.jpg",
    "c": "Cornelis Cort, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Slaget_ved_Zama_-_Cornelis_Cort,_1567.jpg"
  },
  "anc_rosetta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Rosetta_Stone.JPG/500px-Rosetta_Stone.JPG",
    "c": "Hans Hillewaert, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Rosetta_Stone.JPG"
  },
  "anc_zhangqian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Zhang_Qian.jpg/500px-Zhang_Qian.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Zhang_Qian.jpg"
  },
  "anc_maccabees": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/143.Judas_Maccabeus_Pursues_Timotheus.jpg/500px-143.Judas_Maccabeus_Pursues_Timotheus.jpg",
    "c": "Gustave Doré, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:143.Judas_Maccabeus_Pursues_Timotheus.jpg"
  },
  "anc_caesar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Jean-L%C3%A9on_G%C3%A9r%C3%B4me_-_The_Death_of_Caesar_-_Walters_37884.jpg/500px-Jean-L%C3%A9on_G%C3%A9r%C3%B4me_-_The_Death_of_Caesar_-_Walters_37884.jpg",
    "c": "Jean-Léon Gérôme, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jean-L%C3%A9on_G%C3%A9r%C3%B4me_-_The_Death_of_Caesar_-_Walters_37884.jpg"
  },
  "anc_actium": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Castro_Battle_of_Actium.jpg/500px-Castro_Battle_of_Actium.jpg",
    "c": "Laureys a Castro, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Castro_Battle_of_Actium.jpg"
  },
  "anc_jesus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Giambattista_Tiepolo_-_The_Crucifixion.jpg/500px-Giambattista_Tiepolo_-_The_Crucifixion.jpg",
    "c": "Giovanni Battista Tiepolo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Giambattista_Tiepolo_-_The_Crucifixion.jpg"
  },
  "anc_secondtemple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Arc_titus_relief_sud.jpg/500px-Arc_titus_relief_sud.jpg",
    "c": "Cassius Ahenobarbus, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Arc_titus_relief_sud.jpg"
  },
  "anc_colosseum": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Milan_Naumanchia%2C_1807.jpeg/500px-Milan_Naumanchia%2C_1807.jpeg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Milan_Naumanchia,_1807.jpeg"
  },
  "anc_hadrianwall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Hadrian%27s_Wall_view_near_Greenhead.jpg/500px-Hadrian%27s_Wall_view_near_Greenhead.jpg",
    "c": "Photographed by Mark Burnett, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hadrian%27s_Wall_view_near_Greenhead.jpg"
  },
  "anc_redcliffs": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/51/Chibi.jpg",
    "c": "User Jie on en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chibi.jpg"
  },
  "anc_milan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Bust_of_Licinius%2C_Kunsthistorisches_Museum.jpg/500px-Bust_of_Licinius%2C_Kunsthistorisches_Museum.jpg",
    "c": "unknown, found in Ephesos, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Bust_of_Licinius,_Kunsthistorisches_Museum.jpg"
  },
  "anc_constantinople": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Nuremberg_chronicles_-_CONSTANTINOPEL.png/500px-Nuremberg_chronicles_-_CONSTANTINOPEL.png",
    "c": "Michel Wolgemut, Wilhelm Pleydenwurff (Text: Hartmann Schedel), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nuremberg_chronicles_-_CONSTANTINOPEL.png"
  },
  "anc_nicaea": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/EcumenicalCouncil_4th_11-18.jpg/500px-EcumenicalCouncil_4th_11-18.jpg",
    "c": "Dionisius, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:EcumenicalCouncil_4th_11-18.jpg"
  },
  "anc_hagiasophia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Hagia_Sophia_Mars_2013.jpg/500px-Hagia_Sophia_Mars_2013.jpg",
    "c": "Arild Vågen, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hagia_Sophia_Mars_2013.jpg"
  },
  "anc_benedict": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Monte_Cassino_abbey_from_cemetery.JPG/500px-Monte_Cassino_abbey_from_cemetery.JPG",
    "c": "Ludmiła Pilecka, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Monte_Cassino_abbey_from_cemetery.JPG"
  },
  "anc_shotoku": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Prince_Shotoku_with_Two_Princes_by_Kano_Osanobu_1842.png/500px-Prince_Shotoku_with_Two_Princes_by_Kano_Osanobu_1842.png",
    "c": "Kano Osanobu (August 18, 1796 - June 12, 1846), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Prince_Shotoku_with_Two_Princes_by_Kano_Osanobu_1842.png"
  },
  "anc_hijra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Mescidi_nebevi.JPG/500px-Mescidi_nebevi.JPG",
    "c": "Noumenon, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mescidi_nebevi.JPG"
  },
  "anc_domerock": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/16-04-04-Felsendom-Tempelberg-Jerusalem-RalfR-WAT_6385.jpg/500px-16-04-04-Felsendom-Tempelberg-Jerusalem-RalfR-WAT_6385.jpg",
    "c": "Ralf Roletschek, GFDL 1.2",
    "p": "https://commons.wikimedia.org/wiki/File:16-04-04-Felsendom-Tempelberg-Jerusalem-RalfR-WAT_6385.jpg"
  },
  "anc_borobudur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Borobudur_2008.JPG/500px-Borobudur_2008.JPG",
    "c": "Heaven's Army (uploader at EN.Wikipedia), CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Borobudur_2008.JPG"
  },
  "anc_charlemagne": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Charlemagne_coronation.jpg/500px-Charlemagne_coronation.jpg",
    "c": "http://www.uncp.edu/home/rwb/lecture_mid_civ.htm, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Charlemagne_coronation.jpg"
  },
  "anc_cordoba": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Medina_Azahara_010.jpg/500px-Medina_Azahara_010.jpg",
    "c": "losmininos, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Medina_Azahara_010.jpg"
  },
  "anc_optics": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/45/Book_of_Optics_Cover_Page.jpg",
    "c": "Ibn al-Haytham, Vitello, Friedrich Risner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Book_of_Optics_Cover_Page.jpg"
  },
  "anc_genji": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Ilustration_of_The_Tale_of_Genji.jpg/500px-Ilustration_of_The_Tale_of_Genji.jpg",
    "c": "Tosa Mitsuoki, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ilustration_of_The_Tale_of_Genji.jpg"
  },
  "anc_canon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/%C4%B0bni_Sina_Heykeli_Ankara.JPG/500px-%C4%B0bni_Sina_Heykeli_Ankara.JPG",
    "c": "Nosferatü, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%C4%B0bni_Sina_Heykeli_Ankara.JPG"
  },
  "anc_manzikert": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/131_Bataille_de_Malazgirt.jpg/500px-131_Bataille_de_Malazgirt.jpg",
    "c": "Rohan Master, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:131_Bataille_de_Malazgirt.jpg"
  },
  "anc_angkorwat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/72/Angkor_wat_temple.jpg",
    "c": "The original uploader was Fuzheado at English Wikipedia., CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Angkor_wat_temple.jpg"
  },
  "anc_jerusalem1099": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/1099jerusalem.jpg/500px-1099jerusalem.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1099jerusalem.jpg"
  },
  "anc_genghis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/YuanEmperorAlbumGenghisPortrait.jpg/500px-YuanEmperorAlbumGenghisPortrait.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:YuanEmperorAlbumGenghisPortrait.jpg"
  },
  "anc_nalanda": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Nalanda_University_ruins.JPG/500px-Nalanda_University_ruins.JPG",
    "c": "Mrityunjay.nalanda, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nalanda_University_ruins.JPG"
  },
  "anc_baghdad1258": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/DiezAlbumsFallOfBaghdad_a.jpg/500px-DiezAlbumsFallOfBaghdad_a.jpg",
    "c": "unknown / (of the reproduction) Staatsbibliothek Berlin/Schacht, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DiezAlbumsFallOfBaghdad_a.jpg"
  },
  "anc_yuan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Liu-Kuan-Tao-Jagd.JPG/500px-Liu-Kuan-Tao-Jagd.JPG",
    "c": "Liu Guandao, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Liu-Kuan-Tao-Jagd.JPG"
  },
  "anc_tenochtitlan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Painting_of_Tenochtitlan-Tlatelolco_on_Lake_Texcoco_%289755215791%29.jpg/500px-Painting_of_Tenochtitlan-Tlatelolco_on_Lake_Texcoco_%289755215791%29.jpg",
    "c": "Gary Todd from Xinzheng, China, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Painting_of_Tenochtitlan-Tlatelolco_on_Lake_Texcoco_(9755215791).jpg"
  },
  "anc_blackdeath": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Doutielt3.jpg/500px-Doutielt3.jpg",
    "c": "Pierart dou Tielt (fl. 1340-1360), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Doutielt3.jpg"
  },
  "anc_timur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Behzad_timur_egyptian.jpg/500px-Behzad_timur_egyptian.jpg",
    "c": "Assigned to Kamaleddin Behzad, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Behzad_timur_egyptian.jpg"
  },
  "anc_zhenghe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/%E3%80%8A%E9%84%AD%E5%92%8C%E6%AD%B8%E4%BE%86%E3%80%8B%E3%80%82_%E8%97%9D%E8%A1%93%E5%AE%B6%E5%BC%97%E6%8B%89%E5%9F%BA%E7%B1%B3%E7%88%BE%C2%B7%E7%A7%91%E7%B4%A2%E5%A4%AB_2018.jpg/500px-%E3%80%8A%E9%84%AD%E5%92%8C%E6%AD%B8%E4%BE%86%E3%80%8B%E3%80%82_%E8%97%9D%E8%A1%93%E5%AE%B6%E5%BC%97%E6%8B%89%E5%9F%BA%E7%B1%B3%E7%88%BE%C2%B7%E7%A7%91%E7%B4%A2%E5%A4%AB_2018.jpg",
    "c": "Kosov vladimir 09071967, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:%E3%80%8A%E9%84%AD%E5%92%8C%E6%AD%B8%E4%BE%86%E3%80%8B%E3%80%82_%E8%97%9D%E8%A1%93%E5%AE%B6%E5%BC%97%E6%8B%89%E5%9F%BA%E7%B1%B3%E7%88%BE%C2%B7%E7%A7%91%E7%B4%A2%E5%A4%AB_2018.jpg"
  },
  "anc_hangul": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/c7/Hunmin_jeong-eum.jpg",
    "c": "Sejong the Great, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hunmin_jeong-eum.jpg"
  },
  "anc_constantinople_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Benjamin-Constant-The_Entry_of_Mahomet_II_into_Constantinople-1876.jpg/500px-Benjamin-Constant-The_Entry_of_Mahomet_II_into_Constantinople-1876.jpg",
    "c": "Jean-Joseph Benjamin-Constant, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Benjamin-Constant-The_Entry_of_Mahomet_II_into_Constantinople-1876.jpg"
  },
  "anc_gutenberg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Gutenberg_Bible%2C_Lenox_Copy%2C_New_York_Public_Library%2C_2009._Pic_01.jpg/500px-Gutenberg_Bible%2C_Lenox_Copy%2C_New_York_Public_Library%2C_2009._Pic_01.jpg",
    "c": "NYC Wanderer (Kevin Eng), CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gutenberg_Bible,_Lenox_Copy,_New_York_Public_Library,_2009._Pic_01.jpg"
  },
  "anc_machupicchu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Machu-picchu-c01.jpg/500px-Machu-picchu-c01.jpg",
    "c": "Colegota, CC BY-SA 2.5 es",
    "p": "https://commons.wikimedia.org/wiki/File:Machu-picchu-c01.jpg"
  },
  "anc_vascodagama": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Lisboa-Museu_Nacional_de_Arte_Antiga-Retrato_dito_de_Vasco_da_Gama-20140917.jpg/500px-Lisboa-Museu_Nacional_de_Arte_Antiga-Retrato_dito_de_Vasco_da_Gama-20140917.jpg",
    "c": "Unknown master of the Portuguese School.., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lisboa-Museu_Nacional_de_Arte_Antiga-Retrato_dito_de_Vasco_da_Gama-20140917.jpg"
  },
  "anc_sistine": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/CAPPELLA_SISTINA_Ceiling.jpg/500px-CAPPELLA_SISTINA_Ceiling.jpg",
    "c": "Michelangelo, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:CAPPELLA_SISTINA_Ceiling.jpg"
  },
  "anc_tenochtitlanfall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Aztec_Indians_Mexico_Tlaxcalan_Cortez.jpg/500px-Aztec_Indians_Mexico_Tlaxcalan_Cortez.jpg",
    "c": "Wilhelm Sievers (1860 - 1921), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Aztec_Indians_Mexico_Tlaxcalan_Cortez.jpg"
  },
  "anc_luther": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Luther_95_Thesen.png/500px-Luther_95_Thesen.png",
    "c": "Martin Luther, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Luther_95_Thesen.png"
  },
  "anc_copernicus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Jan_Matejko-Astronomer_Copernicus-Conversation_with_God.jpg/500px-Jan_Matejko-Astronomer_Copernicus-Conversation_with_God.jpg",
    "c": "Jan Matejko, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jan_Matejko-Astronomer_Copernicus-Conversation_with_God.jpg"
  },
  "anc_jamestown": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Jamestown-Virginia-settlement-ships-NOAA.jpg/500px-Jamestown-Virginia-settlement-ships-NOAA.jpg",
    "c": "The original uploader was Wikid77 at English Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jamestown-Virginia-settlement-ships-NOAA.jpg"
  },
  "anc_galileo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Galileo_moon_phases.jpg/500px-Galileo_moon_phases.jpg",
    "c": "Galileo Galilei, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Galileo_moon_phases.jpg"
  },
  "anc_tajmahal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Taj_Mahal%2C_Agra%2C_India_edit3.jpg/500px-Taj_Mahal%2C_Agra%2C_India_edit3.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Taj_Mahal,_Agra,_India_edit3.jpg"
  },
  "anc_principia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/GodfreyKneller-IsaacNewton-1689.jpg/500px-GodfreyKneller-IsaacNewton-1689.jpg",
    "c": "Godfrey Kneller, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:GodfreyKneller-IsaacNewton-1689.jpg"
  },
  "anc_watt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/James_Watt_by_Henry_Howard.jpg/500px-James_Watt_by_Henry_Howard.jpg",
    "c": "Henry Howard, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:James_Watt_by_Henry_Howard.jpg"
  },
  "anc_cook": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Captainjamescookportrait.jpg/500px-Captainjamescookportrait.jpg",
    "c": "Nathaniel Dance-Holland, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Captainjamescookportrait.jpg"
  },
  "anc_declaration": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/USA_declaration_independence.jpg/500px-USA_declaration_independence.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:USA_declaration_independence.jpg"
  },
  "anc_rosetta_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Rosetta_Stone.JPG/500px-Rosetta_Stone.JPG",
    "c": "Hans Hillewaert, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Rosetta_Stone.JPG"
  },
  "anc_opiumwar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Destroying_Chinese_war_junks%2C_by_E._Duncan_%281843%29.jpg/500px-Destroying_Chinese_war_junks%2C_by_E._Duncan_%281843%29.jpg",
    "c": "Edward Duncan, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Destroying_Chinese_war_junks,_by_E._Duncan_(1843).jpg"
  },
  "anc_perry": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Commodore_Matthew_Calbraith_Perry.jpg/500px-Commodore_Matthew_Calbraith_Perry.jpg",
    "c": "Mathew Benjamin Brady, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Commodore_Matthew_Calbraith_Perry.jpg"
  },
  "anc_darwin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/1878_Darwin_photo_by_Leonard_from_Woodall_1884_-_cropped_grayed_partially_cleaned.jpg/500px-1878_Darwin_photo_by_Leonard_from_Woodall_1884_-_cropped_grayed_partially_cleaned.jpg",
    "c": "Leonard Darwin, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1878_Darwin_photo_by_Leonard_from_Woodall_1884_-_cropped_grayed_partially_cleaned.jpg"
  },
  "anc_krakatoa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Indonesia%2C_Sunda_Straits.jpg/500px-Indonesia%2C_Sunda_Straits.jpg",
    "c": "flydime, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Indonesia,_Sunda_Straits.jpg"
  },
  "anc_benz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/1885Benz.jpg/500px-1885Benz.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1885Benz.jpg"
  },
  "anc_einstein": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Einstein_patentoffice.jpg/500px-Einstein_patentoffice.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Einstein_patentoffice.jpg"
  },
  "anc_sarajevo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/DC-1914-27-d-Sarajevo-cropped.jpg/500px-DC-1914-27-d-Sarajevo-cropped.jpg",
    "c": "Achille Beltrame, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DC-1914-27-d-Sarajevo-cropped.jpg"
  },
  "anc_october": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Kustodiev_The_Bolshevik.jpg/500px-Kustodiev_The_Bolshevik.jpg",
    "c": "Boris Kustodiev, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kustodiev_The_Bolshevik.jpg"
  },
  "anc_flu1918": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/CampFunstonKS-InfluenzaHospital.jpg/500px-CampFunstonKS-InfluenzaHospital.jpg",
    "c": "U.S. Army photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:CampFunstonKS-InfluenzaHospital.jpg"
  },
  "anc_turkey": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Atat%C3%BCrk_Kemal.jpg/500px-Atat%C3%BCrk_Kemal.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Atat%C3%BCrk_Kemal.jpg"
  },
  "anc_penicillin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Bacillus_anthracis_Lyse.jpg/500px-Bacillus_anthracis_Lyse.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bacillus_anthracis_Lyse.jpg"
  },
  "anc_crash": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Crowd_outside_nyse.jpg/500px-Crowd_outside_nyse.jpg",
    "c": "US-gov, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Crowd_outside_nyse.jpg"
  },
  "anc_saltmarch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Marche_sel.jpg/500px-Marche_sel.jpg",
    "c": "Yann (talk), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Marche_sel.jpg"
  },
  "anc_india1947": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Emergency_trains_crowded_with_desperate_refugees.jpg/500px-Emergency_trains_crowded_with_desperate_refugees.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Emergency_trains_crowded_with_desperate_refugees.jpg"
  },
  "anc_hiroshima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/AtomicEffects-p32b.jpg/500px-AtomicEffects-p32b.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:AtomicEffects-p32b.jpg"
  },
  "anc_israel1948": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/0a/Israel_-Independence_May_14%2C_1948.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Israel_-Independence_May_14,_1948.jpg"
  },
  "anc_sputnik": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Laika_ac_Sputnik_2_Replica_%286995685051%29.jpg/500px-Laika_ac_Sputnik_2_Replica_%286995685051%29.jpg",
    "c": "Laika ac from USA, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Laika_ac_Sputnik_2_Replica_(6995685051).jpg"
  },
  "anc_cuba": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Cuban_missiles.jpg/500px-Cuban_missiles.jpg",
    "c": "see above, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cuban_missiles.jpg"
  },
  "anc_apollo11": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Apollo_11_first_step.jpg/500px-Apollo_11_first_step.jpg",
    "c": "National Aeronautics and Space Administration, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Apollo_11_first_step.jpg"
  },
  "anc_chernobyl": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/IAEA_02790015_%285613115146%29.jpg/500px-IAEA_02790015_%285613115146%29.jpg",
    "c": "IAEA Imagebank, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:IAEA_02790015_(5613115146).jpg"
  },
  "anc_iran1979": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Imam_Khomeini_in_Mehrabad.jpg/500px-Imam_Khomeini_in_Mehrabad.jpg",
    "c": "Wikimedia Commons, GFDL",
    "p": "https://commons.wikimedia.org/wiki/File:Imam_Khomeini_in_Mehrabad.jpg"
  },
  "anc_ussr": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/57/RIAN_archive_850809_General_Secretary_of_the_CPSU_CC_M._Gorbachev_%28crop%29.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:RIAN_archive_850809_General_Secretary_of_the_CPSU_CC_M._Gorbachev_(crop).jpg"
  },
  "anc_dolly": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Dollyscotland.JPG/500px-Dollyscotland.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dollyscotland.JPG"
  },
  "anc_sept11": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/fd/National_Park_Service_9-11_Statue_of_Liberty_and_WTC_fire.jpg",
    "c": "National Park Service, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:National_Park_Service_9-11_Statue_of_Liberty_and_WTC_fire.jpg"
  },
  "anc_tsunami2004": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/2004-tsunami.jpg/500px-2004-tsunami.jpg",
    "c": "David Rydevik (email: david.rydevikgmail.com), Stockholm, Sweden., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:2004-tsunami.jpg"
  },
  "bastille": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Prise_de_la_Bastille.jpg/500px-Prise_de_la_Bastille.jpg",
    "c": "Jean-Pierre Houël, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Prise_de_la_Bastille.jpg"
  },
  "berlinwall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/BerlinWall-BrandenburgGate.jpg/500px-BerlinWall-BrandenburgGate.jpg",
    "c": "Sue Ream, photographer (San Francisco, California), CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:BerlinWall-BrandenburgGate.jpg"
  },
  "anq_uruk_writing": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Cuneiform_script2.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cuneiform_script2.jpg"
  },
  "anq_skara_brae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Orkney_Skara_Brae.jpg/500px-Orkney_Skara_Brae.jpg",
    "c": "Dr. John F. Burka, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Orkney_Skara_Brae.jpg"
  },
  "anq_stonehenge": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Stonehenge_Total.jpg/500px-Stonehenge_Total.jpg",
    "c": "Stefan Kühn, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Stonehenge_Total.jpg"
  },
  "anq_ur_tombs": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Standard_of_Ur_-_War.jpg/500px-Standard_of_Ur_-_War.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Standard_of_Ur_-_War.jpg"
  },
  "anq_djoser": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Pyramid_of_djozer_01.jpg/500px-Pyramid_of_djozer_01.jpg",
    "c": "Markh at English Wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pyramid_of_djozer_01.jpg"
  },
  "anq_giza": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Kheops-Pyramid.jpg/500px-Kheops-Pyramid.jpg",
    "c": "Nina, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Kheops-Pyramid.jpg"
  },
  "anq_sargon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Sargon_of_Akkad_%28frontal%29.jpg/500px-Sargon_of_Akkad_%28frontal%29.jpg",
    "c": "Hans Ollermann, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sargon_of_Akkad_(frontal).jpg"
  },
  "anq_ur_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Ur-Nassiriyah.jpg/500px-Ur-Nassiriyah.jpg",
    "c": "M.Lubinski from Iraq,USA., CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ur-Nassiriyah.jpg"
  },
  "anq_knossos": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Knossos_-_North_Portico_02.jpg/500px-Knossos_-_North_Portico_02.jpg",
    "c": "Bernard Gagnon, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Knossos_-_North_Portico_02.jpg"
  },
  "anq_mari": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Ebish-Il_Louvre_AO17551.jpg/500px-Ebish-Il_Louvre_AO17551.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ebish-Il_Louvre_AO17551.jpg"
  },
  "hammurabi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/D542-_code_des_lois_du_roi_hammurabi._-L2-Ch_3.png/500px-D542-_code_des_lois_du_roi_hammurabi._-L2-Ch_3.png",
    "c": "Élisée Reclus, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:D542-_code_des_lois_du_roi_hammurabi._-L2-Ch_3.png"
  },
  "anq_hattusa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/86/Hattusa.king.jpg",
    "c": "China Crisis, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hattusa.king.jpg"
  },
  "anq_hatshepsut": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Chr%C3%A1m_kr%C3%A1lovny_Hat%C5%A1epsovet_-_panoramio_%288%29.jpg/500px-Chr%C3%A1m_kr%C3%A1lovny_Hat%C5%A1epsovet_-_panoramio_%288%29.jpg",
    "c": "Pavel Špindler, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chr%C3%A1m_kr%C3%A1lovny_Hat%C5%A1epsovet_-_panoramio_(8).jpg"
  },
  "anq_ugarit": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/04/22_alphabet.jpg",
    "c": "Chaos, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:22_alphabet.jpg"
  },
  "anq_akhenaten": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/GD-EG-Caire-Mus%C3%A9e061.JPG/500px-GD-EG-Caire-Mus%C3%A9e061.JPG",
    "c": "Wikimedia Commons, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:GD-EG-Caire-Mus%C3%A9e061.JPG"
  },
  "anq_tutankhamun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Tutanchamun_Maske.jpg/500px-Tutanchamun_Maske.jpg",
    "c": "en:User:MykReeve, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tutanchamun_Maske.jpg"
  },
  "anq_kadesh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/d3/Ramesseum_siege_of_Dapur.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ramesseum_siege_of_Dapur.jpg"
  },
  "anq_merneptah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/43/Merenptah_Israel_Stele_Cairo.jpg",
    "c": "Webscribe, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Merenptah_Israel_Stele_Cairo.jpg"
  },
  "anq_lion_gate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Lions-Gate-Mycenae.jpg/500px-Lions-Gate-Mycenae.jpg",
    "c": "Andreas Trepte, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Lions-Gate-Mycenae.jpg"
  },
  "anq_olmec": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Olmeca_head_in_Villahermosa.jpg/500px-Olmeca_head_in_Villahermosa.jpg",
    "c": "Glysiak, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Olmeca_head_in_Villahermosa.jpg"
  },
  "anq_phoenician_alphabet": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Pergamonmuseum_-_Vorderasiatisches_Museum_046.JPG/500px-Pergamonmuseum_-_Vorderasiatisches_Museum_046.JPG",
    "c": "Wikimedia Commons, CC SA 1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pergamonmuseum_-_Vorderasiatisches_Museum_046.JPG"
  },
  "anq_shoshenq": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Karnak_Tempel_19.jpg/500px-Karnak_Tempel_19.jpg",
    "c": "Olaf Tausch, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Karnak_Tempel_19.jpg"
  },
  "anq_nimrud": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Ashurnasirpal2_stele.jpg/500px-Ashurnasirpal2_stele.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ashurnasirpal2_stele.jpg"
  },
  "anq_mesha": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Mesha_Stele_%28511142469%29.jpg/500px-Mesha_Stele_%28511142469%29.jpg",
    "c": "Henri Sivonen from Helsinki, Finland, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mesha_Stele_(511142469).jpg"
  },
  "anq_urartu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Erebuni.jpg/500px-Erebuni.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Erebuni.jpg"
  },
  "anq_olympics": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Antikes_Olympia_Stadion.JPG/500px-Antikes_Olympia_Stadion.JPG",
    "c": "Guenter Wieschendahl, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Antikes_Olympia_Stadion.JPG"
  },
  "anq_rome": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Kapitolinische_W%C3%B6lfin_Museum_Capitolini.jpg/500px-Kapitolinische_W%C3%B6lfin_Museum_Capitolini.jpg",
    "c": "Rabax63, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kapitolinische_W%C3%B6lfin_Museum_Capitolini.jpg"
  },
  "anq_homer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Rembrandt_Harmensz._van_Rijn_061.jpg/500px-Rembrandt_Harmensz._van_Rijn_061.jpg",
    "c": "Rembrandt, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rembrandt_Harmensz._van_Rijn_061.jpg"
  },
  "anq_syracuse": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Theatre_at_Syracuse%2C_Sicily.jpg/500px-Theatre_at_Syracuse%2C_Sicily.jpg",
    "c": "Victoria from London, UK, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Theatre_at_Syracuse,_Sicily.jpg"
  },
  "anq_khorsabad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Lammasu.jpg/500px-Lammasu.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Lammasu.jpg"
  },
  "anq_gordion": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Museum_of_Anatolian_Civilizations055_kopie1.jpg/500px-Museum_of_Anatolian_Civilizations055_kopie1.jpg",
    "c": "Georges Jansoone (JoJan), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Museum_of_Anatolian_Civilizations055_kopie1.jpg"
  },
  "anq_josiah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Schnorr_von_Carolsfeld_Bibel_in_Bildern_1860_123.png/500px-Schnorr_von_Carolsfeld_Bibel_in_Bildern_1860_123.png",
    "c": "Julius Schnorr von Carolsfeld, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Schnorr_von_Carolsfeld_Bibel_in_Bildern_1860_123.png"
  },
  "anq_nineveh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Fall_of_nineveh.jpg/500px-Fall_of_nineveh.jpg",
    "c": "(Mu-tamajo) むーたんじょ, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Fall_of_nineveh.jpg"
  },
  "anq_megiddo_609": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Schnorr_von_Carolsfeld_Bibel_in_Bildern_1860_123.png/500px-Schnorr_von_Carolsfeld_Bibel_in_Bildern_1860_123.png",
    "c": "Julius Schnorr von Carolsfeld, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Schnorr_von_Carolsfeld_Bibel_in_Bildern_1860_123.png"
  },
  "anq_solon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Solon.jpg",
    "c": "No machine-readable author provided. Kpjas assumed (based on copyright claims)., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Solon.jpg"
  },
  "anq_delphi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Teatro_di_Delfi.jpg/500px-Teatro_di_Delfi.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Teatro_di_Delfi.jpg"
  },
  "anq_jerusalem_586": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/The_art_Bible%2C_comprising_the_Old_and_new_Testaments_-_with_numerous_illustrations_%281896%29_%2814783032815%29.jpg/500px-The_art_Bible%2C_comprising_the_Old_and_new_Testaments_-_with_numerous_illustrations_%281896%29_%2814783032815%29.jpg",
    "c": "Internet Archive Book Images, No restrictions",
    "p": "https://commons.wikimedia.org/wiki/File:The_art_Bible,_comprising_the_Old_and_new_Testaments_-_with_numerous_illustrations_(1896)_(14783032815).jpg"
  },
  "anq_ishtar_gate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Ishtar_Gate_at_Berlin_Museum.jpg/500px-Ishtar_Gate_at_Berlin_Museum.jpg",
    "c": "Rictor Norton, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ishtar_Gate_at_Berlin_Museum.jpg"
  },
  "anq_ephesus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Ac_artemisephesus.jpg/500px-Ac_artemisephesus.jpg",
    "c": "Adam Carr, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ac_artemisephesus.jpg"
  },
  "anq_pythagoras": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/3d/Kapitolinischer_Pythagoras.jpg",
    "c": "The original uploader was Galilea at German Wikipedia., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kapitolinischer_Pythagoras.jpg"
  },
  "cyrus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Cyrus_Cylinder.jpg/500px-Cyrus_Cylinder.jpg",
    "c": "Photograph by Mike Peel (www.mikepeel.net). Modifications by مانفی, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cyrus_Cylinder.jpg"
  },
  "anq_behistun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Darius_I_the_Great%27s_inscription.jpg/500px-Darius_I_the_Great%27s_inscription.jpg",
    "c": "Unknown artistUnknown artist ⧼for⧽ Darius I, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Darius_I_the_Great%27s_inscription.jpg"
  },
  "anq_persepolis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/36/Takht-jamshid.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Takht-jamshid.jpg"
  },
  "anq_roman_republic": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Eckhel_ii_13.jpg/500px-Eckhel_ii_13.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eckhel_ii_13.jpg"
  },
  "anq_monte_alban": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Monte-Alban-South-Platform.jpg/500px-Monte-Alban-South-Platform.jpg",
    "c": "Uspn, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Monte-Alban-South-Platform.jpg"
  },
  "anq_thermopylae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/L%C3%A9onidas_aux_Thermopyles_%28Jacques-Louis_David%29.PNG/500px-L%C3%A9onidas_aux_Thermopyles_%28Jacques-Louis_David%29.PNG",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:L%C3%A9onidas_aux_Thermopyles_(Jacques-Louis_David).PNG"
  },
  "anq_confucius_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Confuciustombqufu.jpg/500px-Confuciustombqufu.jpg",
    "c": "Rolf Müller (User:Rolfmueller), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Confuciustombqufu.jpg"
  },
  "anq_parthenon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/The_Parthenon_in_Athens.jpg/500px-The_Parthenon_in_Athens.jpg",
    "c": "Steve Swayne, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_Parthenon_in_Athens.jpg"
  },
  "anq_socrates": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/David_-_The_Death_of_Socrates.jpg/500px-David_-_The_Death_of_Socrates.jpg",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:David_-_The_Death_of_Socrates.jpg"
  },
  "gaugamela": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/AlexanderTheGreat_Bust.jpg/500px-AlexanderTheGreat_Bust.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlexanderTheGreat_Bust.jpg"
  },
  "anq_tyre": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Naval_Helepolis.jpg/500px-Naval_Helepolis.jpg",
    "c": "Gre regiment, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Naval_Helepolis.jpg"
  },
  "anq_persepolis_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/36/Takht-jamshid.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Takht-jamshid.jpg"
  },
  "anq_hydaspes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Le_Brun%2C_Alexander_and_Porus.jpg/500px-Le_Brun%2C_Alexander_and_Porus.jpg",
    "c": "Charles Le Brun, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Le_Brun,_Alexander_and_Porus.jpg"
  },
  "anq_alex_death": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/AlexanderTheGreat_Bust.jpg/500px-AlexanderTheGreat_Bust.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlexanderTheGreat_Bust.jpg"
  },
  "anq_septuagint": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Ptoleme_2_by_Jean-Baptiste_de_Champaigne.jpg/500px-Ptoleme_2_by_Jean-Baptiste_de_Champaigne.jpg",
    "c": "Jean Baptiste de Champaigne, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ptoleme_2_by_Jean-Baptiste_de_Champaigne.jpg"
  },
  "qin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Group_of_soldiers.jpg/500px-Group_of_soldiers.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Group_of_soldiers.jpg"
  },
  "anq_hannibal_alps": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Joseph_Mallord_William_Turner_081.jpg/500px-Joseph_Mallord_William_Turner_081.jpg",
    "c": "J. M. W. Turner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Joseph_Mallord_William_Turner_081.jpg"
  },
  "anq_zama": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Slaget_ved_Zama_-_Cornelis_Cort%2C_1567.jpg/500px-Slaget_ved_Zama_-_Cornelis_Cort%2C_1567.jpg",
    "c": "Cornelis Cort, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Slaget_ved_Zama_-_Cornelis_Cort,_1567.jpg"
  },
  "anq_han_founding": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/f1/Cao_Pi_Tang-detail.jpg",
    "c": "Yan Li-pen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cao_Pi_Tang-detail.jpg"
  },
  "anq_rosetta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Rosetta_Stone.JPG/500px-Rosetta_Stone.JPG",
    "c": "Hans Hillewaert, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Rosetta_Stone.JPG"
  },
  "anq_pydna": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/Perseus_of_Macedon_BM.jpg/500px-Perseus_of_Macedon_BM.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Perseus_of_Macedon_BM.jpg"
  },
  "anq_spartacus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Tod_des_Spartacus_by_Hermann_Vogel.jpg/500px-Tod_des_Spartacus_by_Hermann_Vogel.jpg",
    "c": "Hermann Vogel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Tod_des_Spartacus_by_Hermann_Vogel.jpg"
  },
  "anq_pompey": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Pom004.jpg/500px-Pom004.jpg",
    "c": "Sergey Sosnovskiy, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pom004.jpg"
  },
  "anq_rubicon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/03/PM_110509_Liebig_Chromos.jpg",
    "c": "PMRMaeyaert, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:PM_110509_Liebig_Chromos.jpg"
  },
  "anq_alesia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Lionel_Royer_-_Vercingetorix_Throwing_down_His_Weapons_at_the_feet_of_Julius_Caesar.jpg/500px-Lionel_Royer_-_Vercingetorix_Throwing_down_His_Weapons_at_the_feet_of_Julius_Caesar.jpg",
    "c": "Lionel Royer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lionel_Royer_-_Vercingetorix_Throwing_down_His_Weapons_at_the_feet_of_Julius_Caesar.jpg"
  },
  "caesar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Jean-L%C3%A9on_G%C3%A9r%C3%B4me_-_The_Death_of_Caesar_-_Walters_37884.jpg/500px-Jean-L%C3%A9on_G%C3%A9r%C3%B4me_-_The_Death_of_Caesar_-_Walters_37884.jpg",
    "c": "Jean-Léon Gérôme, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jean-L%C3%A9on_G%C3%A9r%C3%B4me_-_The_Death_of_Caesar_-_Walters_37884.jpg"
  },
  "anq_actium": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Castro_Battle_of_Actium.jpg/500px-Castro_Battle_of_Actium.jpg",
    "c": "Laureys a Castro, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Castro_Battle_of_Actium.jpg"
  },
  "anq_herod_temple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Jerusalem_Modell_BW_2.JPG/500px-Jerusalem_Modell_BW_2.JPG",
    "c": "Berthold Werner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jerusalem_Modell_BW_2.JPG"
  },
  "anq_augustus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Statue-Augustus.jpg/500px-Statue-Augustus.jpg",
    "c": "Till Niermann, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Statue-Augustus.jpg"
  },
  "anq_jesus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Giambattista_Tiepolo_-_The_Crucifixion.jpg/500px-Giambattista_Tiepolo_-_The_Crucifixion.jpg",
    "c": "Giovanni Battista Tiepolo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Giambattista_Tiepolo_-_The_Crucifixion.jpg"
  },
  "anq_teutoburg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Hermannsdenkmal_statue.jpg/500px-Hermannsdenkmal_statue.jpg",
    "c": "Daniel Schwen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hermannsdenkmal_statue.jpg"
  },
  "anq_rome_fire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Nero_pushkin.jpg/500px-Nero_pushkin.jpg",
    "c": "shakko, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nero_pushkin.jpg"
  },
  "temple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Arc_titus_relief_sud.jpg/500px-Arc_titus_relief_sud.jpg",
    "c": "Cassius Ahenobarbus, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Arc_titus_relief_sud.jpg"
  },
  "anq_vesuvius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/f4/Vesuvius1822scrope.jpg",
    "c": "George Julius Poulett Scrope, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Vesuvius1822scrope.jpg"
  },
  "anq_masada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Israel-2013-Aerial_21-Masada.jpg/500px-Israel-2013-Aerial_21-Masada.jpg",
    "c": "Godot13, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Israel-2013-Aerial_21-Masada.jpg"
  },
  "anq_teotihuacan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/MW-Teotihuacan9.jpg/500px-MW-Teotihuacan9.jpg",
    "c": "Michael Wassmer from France, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:MW-Teotihuacan9.jpg"
  },
  "anq_hadrian_wall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Hadrian%27s_Wall_view_near_Greenhead.jpg/500px-Hadrian%27s_Wall_view_near_Greenhead.jpg",
    "c": "Photographed by Mark Burnett, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hadrian%27s_Wall_view_near_Greenhead.jpg"
  },
  "anq_cai_lun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/be/Cai-lun.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cai-lun.jpg"
  },
  "anq_pantheon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Rome_Pantheon_front.jpg/500px-Rome_Pantheon_front.jpg",
    "c": "Roberta Dragan, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Rome_Pantheon_front.jpg"
  },
  "anq_almagest": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/34/Almagest_1.jpeg",
    "c": "Ptolemy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Almagest_1.jpeg"
  },
  "anq_antonine_plague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Marcus_Aurelius_Glyptothek_Munich.jpg/500px-Marcus_Aurelius_Glyptothek_Munich.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Marcus_Aurelius_Glyptothek_Munich.jpg"
  },
  "anq_bar_kokhba": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Barkokhba-silver-tetradrachm.jpg/500px-Barkokhba-silver-tetradrachm.jpg",
    "c": "CNG, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Barkokhba-silver-tetradrachm.jpg"
  },
  "anq_yellow_turban": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/df/Three_Brothers_during_the_Yellow_Turban_Rebellion.jpg",
    "c": "Qing Dynasty, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Three_Brothers_during_the_Yellow_Turban_Rebellion.jpg"
  },
  "anq_red_cliffs": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/51/Chibi.jpg",
    "c": "User Jie on en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chibi.jpg"
  },
  "anq_mishnah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/KaufmannManuscript.jpg/500px-KaufmannManuscript.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KaufmannManuscript.jpg"
  },
  "anq_palmyra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Herbert_Schmalz-Zenobia.jpg/500px-Herbert_Schmalz-Zenobia.jpg",
    "c": "Herbert Gustave Schmalz, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Herbert_Schmalz-Zenobia.jpg"
  },
  "anq_milvian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Battle_at_the_Milvian_Bridge%2C_G%C3%A9rard_Audran_after_Charles_Le_Brun%2C_1666-crop.jpg/500px-Battle_at_the_Milvian_Bridge%2C_G%C3%A9rard_Audran_after_Charles_Le_Brun%2C_1666-crop.jpg",
    "c": "Charles Le Brun, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_at_the_Milvian_Bridge,_G%C3%A9rard_Audran_after_Charles_Le_Brun,_1666-crop.jpg"
  },
  "anq_constantinople": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Constantinopolis_coin.jpg/500px-Constantinopolis_coin.jpg",
    "c": "Ingsoc, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Constantinopolis_coin.jpg"
  },
  "anq_gupta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Queen_Kumaradevi_and_King_Chandragupta_I_on_a_coin.jpg/500px-Queen_Kumaradevi_and_King_Chandragupta_I_on_a_coin.jpg",
    "c": "Uploadalt, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Queen_Kumaradevi_and_King_Chandragupta_I_on_a_coin.jpg"
  },
  "anq_nicaea": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/%CE%9C%CE%B9%CF%87%CE%B1%CE%AE%CE%BB_%CE%94%CE%B1%CE%BC%CE%B1%CF%83%CE%BA%CE%B7%CE%BD%CF%8C%CF%82_-_%CE%91%CE%84_%CE%9F%CE%B9%CE%BA%CE%BF%CF%85%CE%BC%CE%B5%CE%BD%CE%B9%CE%BA%CE%AE_%CE%A3%CF%8D%CE%BD%CE%BF%CE%B4%CE%BF%CF%82_7741.jpg/500px-%CE%9C%CE%B9%CF%87%CE%B1%CE%AE%CE%BB_%CE%94%CE%B1%CE%BC%CE%B1%CF%83%CE%BA%CE%B7%CE%BD%CF%8C%CF%82_-_%CE%91%CE%84_%CE%9F%CE%B9%CE%BA%CE%BF%CF%85%CE%BC%CE%B5%CE%BD%CE%B9%CE%BA%CE%AE_%CE%A3%CF%8D%CE%BD%CE%BF%CE%B4%CE%BF%CF%82_7741.jpg",
    "c": "C messier, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%CE%9C%CE%B9%CF%87%CE%B1%CE%AE%CE%BB_%CE%94%CE%B1%CE%BC%CE%B1%CF%83%CE%BA%CE%B7%CE%BD%CF%8C%CF%82_-_%CE%91%CE%84_%CE%9F%CE%B9%CE%BA%CE%BF%CF%85%CE%BC%CE%B5%CE%BD%CE%B9%CE%BA%CE%AE_%CE%A3%CF%8D%CE%BD%CE%BF%CE%B4%CE%BF%CF%82_7741.jpg"
  },
  "anq_adrianople": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/O_Fritsche_-_Invasion_of_the_Goths_into_the_Roman_Empire.jpg/500px-O_Fritsche_-_Invasion_of_the_Goths_into_the_Roman_Empire.jpg",
    "c": "O. Fritsche, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:O_Fritsche_-_Invasion_of_the_Goths_into_the_Roman_Empire.jpg"
  },
  "anq_yungang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Buddhas_in_collapsed_cave_Yungang.jpg/500px-Buddhas_in_collapsed_cave_Yungang.jpg",
    "c": "Felix Andrews (Floybix), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Buddhas_in_collapsed_cave_Yungang.jpg"
  },
  "hijra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Mescidi_nebevi.JPG/500px-Mescidi_nebevi.JPG",
    "c": "Noumenon, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mescidi_nebevi.JPG"
  },
  "charlemagne": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Charlemagne_coronation.jpg/500px-Charlemagne_coronation.jpg",
    "c": "http://www.uncp.edu/home/rwb/lecture_mid_civ.htm, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Charlemagne_coronation.jpg"
  },
  "crusade": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/1099jerusalem.jpg/500px-1099jerusalem.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1099jerusalem.jpg"
  },
  "med_vouille": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Clovis_tue_Alaric_II.jpg/500px-Clovis_tue_Alaric_II.jpg",
    "c": "http://www.bnf.fr, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Clovis_tue_Alaric_II.jpg"
  },
  "med_montecassino": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Monte_Cassino_abbey_from_cemetery.JPG/500px-Monte_Cassino_abbey_from_cemetery.JPG",
    "c": "Ludmiła Pilecka, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Monte_Cassino_abbey_from_cemetery.JPG"
  },
  "med_hagiasophia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Hagia_Sophia_Mars_2013.jpg/500px-Hagia_Sophia_Mars_2013.jpg",
    "c": "Arild Vågen, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hagia_Sophia_Mars_2013.jpg"
  },
  "med_corpusjuris": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Corpus_Iuris_Civilis_02.jpg/500px-Corpus_Iuris_Civilis_02.jpg",
    "c": "Denis Godefroy, Simon van Leeuwen, and Johann Friedrich Gleditsch the Younger, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Corpus_Iuris_Civilis_02.jpg"
  },
  "med_vandalwar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Meister_von_San_Vitale_in_Ravenna_013.jpg/500px-Meister_von_San_Vitale_in_Ravenna_013.jpg",
    "c": "Meister von San Vitale in Ravenna, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Meister_von_San_Vitale_in_Ravenna_013.jpg"
  },
  "med_plaguejust": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Mosaic_of_Justinianus_I_-_Basilica_San_Vitale_%28Ravenna%29.jpg/500px-Mosaic_of_Justinianus_I_-_Basilica_San_Vitale_%28Ravenna%29.jpg",
    "c": "Petar Milošević, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mosaic_of_Justinianus_I_-_Basilica_San_Vitale_(Ravenna).jpg"
  },
  "med_gregory": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Pope_Gregory_I_illustration.jpg/500px-Pope_Gregory_I_illustration.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pope_Gregory_I_illustration.jpg"
  },
  "med_tours": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Steuben_-_Bataille_de_Poitiers.png/500px-Steuben_-_Bataille_de_Poitiers.png",
    "c": "Charles de Steuben, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Steuben_-_Bataille_de_Poitiers.png"
  },
  "med_otto": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Siegel_Otto_I_Posse.JPG/500px-Siegel_Otto_I_Posse.JPG",
    "c": "Otto Posse, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siegel_Otto_I_Posse.JPG"
  },
  "med_rus988": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Lebedev_baptism.jpg/500px-Lebedev_baptism.jpg",
    "c": "Klavdy Lebedev, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lebedev_baptism.jpg"
  },
  "med_vinland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Leif_Erikson_Discovers_America_Hans_Dahl.jpg/500px-Leif_Erikson_Discovers_America_Hans_Dahl.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Leif_Erikson_Discovers_America_Hans_Dahl.jpg"
  },
  "med_hastings": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Bayeux_Tapestry_scene51_Battle_of_Hastings_Norman_knights_and_archers.jpg/500px-Bayeux_Tapestry_scene51_Battle_of_Hastings_Norman_knights_and_archers.jpg",
    "c": "Myrabella, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bayeux_Tapestry_scene51_Battle_of_Hastings_Norman_knights_and_archers.jpg"
  },
  "med_canossa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/1b/Canossa-three.jpg",
    "c": "The original uploader was Nicola Romani at Italian Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Canossa-three.jpg"
  },
  "med_toledo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/El_Greco_View_of_Toledo.jpg/500px-El_Greco_View_of_Toledo.jpg",
    "c": "El Greco, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:El_Greco_View_of_Toledo.jpg"
  },
  "med_clermont": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CouncilofClermont.jpg/500px-CouncilofClermont.jpg",
    "c": "Jean Colombe, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:CouncilofClermont.jpg"
  },
  "med_templars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Seal_of_Templars.jpg/500px-Seal_of_Templars.jpg",
    "c": "Thomas Andrew Archer, Charles Lethbridge Kingsford, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Seal_of_Templars.jpg"
  },
  "med_becket": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Thomas_Becket_Murder.JPG/500px-Thomas_Becket_Murder.JPG",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thomas_Becket_Murder.JPG"
  },
  "med_richard": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Church_of_Fontevraud_Abbey_Richard_I_effigy.jpg/500px-Church_of_Fontevraud_Abbey_Richard_I_effigy.jpg",
    "c": "Adam Bishop, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Church_of_Fontevraud_Abbey_Richard_I_effigy.jpg"
  },
  "med_revelation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Jabal_Nur.JPG/500px-Jabal_Nur.JPG",
    "c": "Adiput (talk), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jabal_Nur.JPG"
  },
  "med_deathmuhammad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Mrs_Aisha_room.jpg/500px-Mrs_Aisha_room.jpg",
    "c": "Aiman titi, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mrs_Aisha_room.jpg"
  },
  "med_yarmouk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4b/Battlefield_of_yarmouk-mohammad_adil.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 375
  },
  "med_umayyad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Omayyad_mosque.jpg/500px-Omayyad_mosque.jpg",
    "c": "Original uploader was Isam at en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Omayyad_mosque.jpg"
  },
  "med_domerock": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/16-04-04-Felsendom-Tempelberg-Jerusalem-RalfR-WAT_6385.jpg/500px-16-04-04-Felsendom-Tempelberg-Jerusalem-RalfR-WAT_6385.jpg",
    "c": "Ralf Roletschek, GFDL 1.2",
    "p": "https://commons.wikimedia.org/wiki/File:16-04-04-Felsendom-Tempelberg-Jerusalem-RalfR-WAT_6385.jpg"
  },
  "med_hispania": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/El_rey_Don_Rodrigo_arengando_a_sus_tropas_en_la_batalla_de_Guadalete_%28Museo_del_Prado%29.jpg/500px-El_rey_Don_Rodrigo_arengando_a_sus_tropas_en_la_batalla_de_Guadalete_%28Museo_del_Prado%29.jpg",
    "c": "Bernardo Blanco y Pérez, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:El_rey_Don_Rodrigo_arengando_a_sus_tropas_en_la_batalla_de_Guadalete_(Museo_del_Prado).jpg"
  },
  "med_umayyadspain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Abd_ar-Rahman_I.jpg/500px-Abd_ar-Rahman_I.jpg",
    "c": "NoelWalley at English Wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Abd_ar-Rahman_I.jpg"
  },
  "med_houseofwisdom": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Maqamat_hariri.jpg/500px-Maqamat_hariri.jpg",
    "c": "Zereshk, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Maqamat_hariri.jpg"
  },
  "med_cairo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Al-Azhar_%28inside%29_2006.jpg/500px-Al-Azhar_%28inside%29_2006.jpg",
    "c": "Tentoila, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Al-Azhar_(inside)_2006.jpg"
  },
  "med_optics": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Alhazen_%28122459248%29.jpg/500px-Alhazen_%28122459248%29.jpg",
    "c": "Jan Heweliusz, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Alhazen_(122459248).jpg"
  },
  "med_edessa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Sanliurfa_Castle.jpg/500px-Sanliurfa_Castle.jpg",
    "c": "Brejnev, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sanliurfa_Castle.jpg"
  },
  "med_hattin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Hittin.jpg/500px-Hittin.jpg",
    "c": "Almog, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hittin.jpg"
  },
  "med_siege717": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/47-cropped-manasses-chronicle.jpg/500px-47-cropped-manasses-chronicle.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:47-cropped-manasses-chronicle.jpg"
  },
  "med_iconoclasm": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Triumph_orthodoxy.jpg/500px-Triumph_orthodoxy.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Triumph_orthodoxy.jpg"
  },
  "med_talmud": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Talmud_set.JPG/500px-Talmud_set.JPG",
    "c": "Reuvenk, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Talmud_set.JPG"
  },
  "med_rashi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Troyes_houses.JPG/500px-Troyes_houses.JPG",
    "c": "Piotr Tysarczyk, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Troyes_houses.JPG"
  },
  "med_rhineland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Hep-hep_riots.jpg/500px-Hep-hep_riots.jpg",
    "c": "Johann Michael Voltz, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hep-hep_riots.jpg"
  },
  "med_mishneh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Rambam_mishne-torah.jpg/500px-Rambam_mishne-torah.jpg",
    "c": "Maimonides (text); Isaac (copist), Matteo di Ser Cambio (illumination), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Rambam_mishne-torah.jpg"
  },
  "med_york": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/CLIFFOR1.JPG/500px-CLIFFOR1.JPG",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:CLIFFOR1.JPG"
  },
  "med_angkorwat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/72/Angkor_wat_temple.jpg",
    "c": "The original uploader was Fuzheado at English Wikipedia., CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Angkor_wat_temple.jpg"
  },
  "med_tang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Emperor_Taizong_gives_an_audience_to_the_ambassador_of_Tibet.jpg/500px-Emperor_Taizong_gives_an_audience_to_the_ambassador_of_Tibet.jpg",
    "c": "Yan Liben, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Emperor_Taizong_gives_an_audience_to_the_ambassador_of_Tibet.jpg"
  },
  "med_sui": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Sui_Wendi_Tang.jpg/500px-Sui_Wendi_Tang.jpg",
    "c": "Yan Li-pen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sui_Wendi_Tang.jpg"
  },
  "med_anlushan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/%E5%AE%89%E7%A5%BF%E5%B1%B1.jpg/500px-%E5%AE%89%E7%A5%BF%E5%B1%B1.jpg",
    "c": "混唐後傳, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%E5%AE%89%E7%A5%BF%E5%B1%B1.jpg"
  },
  "med_genji": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Ilustration_of_The_Tale_of_Genji.jpg/500px-Ilustration_of_The_Tale_of_Genji.jpg",
    "c": "Tosa Mitsuoki, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ilustration_of_The_Tale_of_Genji.jpg"
  },
  "med_igbo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/ee/Igbo_ukwu_bronzes.jpg",
    "c": "Ukabia Modestusonyeke, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Igbo_ukwu_bronzes.jpg"
  },
  "med_timbuktu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Barth_1858_Timbuktu_from_terrace.jpg/500px-Barth_1858_Timbuktu_from_terrace.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Barth_1858_Timbuktu_from_terrace.jpg"
  },
  "med_zagwe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Lalibela_%C3%89glise_Bet_Giyorgis.JPG/500px-Lalibela_%C3%89glise_Bet_Giyorgis.JPG",
    "c": "Julien Demade, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Lalibela_%C3%89glise_Bet_Giyorgis.JPG"
  },
  "med_tonina": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Palenque_Relief.jpg/500px-Palenque_Relief.jpg",
    "c": "Wikimedia Commons, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Palenque_Relief.jpg"
  },
  "constantinople": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Benjamin-Constant-The_Entry_of_Mahomet_II_into_Constantinople-1876.jpg/500px-Benjamin-Constant-The_Entry_of_Mahomet_II_into_Constantinople-1876.jpg",
    "c": "Jean-Joseph Benjamin-Constant, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Benjamin-Constant-The_Entry_of_Mahomet_II_into_Constantinople-1876.jpg"
  },
  "plague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Doutielt1.jpg/500px-Doutielt1.jpg",
    "c": "Pierart dou Tielt (fl. 1340-1360), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Doutielt1.jpg"
  },
  "luther": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Luther_95_Thesen.png/500px-Luther_95_Thesen.png",
    "c": "Martin Luther, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Luther_95_Thesen.png"
  },
  "med_fourth_crusade": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Siege_constantinople_bnf_fr2691.jpg/500px-Siege_constantinople_bnf_fr2691.jpg",
    "c": "Attributed to Philippe de Mazerolles, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siege_constantinople_bnf_fr2691.jpg"
  },
  "med_maimonides": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b3/Maimonides-Statue.jpg",
    "c": "Dr. Manuel at de.wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Maimonides-Statue.jpg"
  },
  "med_genghis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/YuanEmperorAlbumGenghisPortrait.jpg/500px-YuanEmperorAlbumGenghisPortrait.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:YuanEmperorAlbumGenghisPortrait.jpg"
  },
  "med_delhi_sultanate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Qutab.jpg/500px-Qutab.jpg",
    "c": "Wikimedia Commons, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Qutab.jpg"
  },
  "med_lalibela": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Bet_Giyorgis_church_Lalibela_03.jpg/500px-Bet_Giyorgis_church_Lalibela_03.jpg",
    "c": "Armin Hamm, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Bet_Giyorgis_church_Lalibela_03.jpg"
  },
  "med_magna_carta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Magna_Carta_%281297_version%2C_Parliament_House%2C_Canberra%2C_Australia%29_-_20080416.jpg/500px-Magna_Carta_%281297_version%2C_Parliament_House%2C_Canberra%2C_Australia%29_-_20080416.jpg",
    "c": "Wongm (Marcus Wong)., CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Magna_Carta_(1297_version,_Parliament_House,_Canberra,_Australia)_-_20080416.jpg"
  },
  "med_lateran_iv": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Cosimo_I_Enters_the_College_of_Cardinals_ca.1582_print_by_Stradanus%2C_S.I_54394%2C_Prints_Department%2C_Royal_Library_of_Belgium.jpg/500px-Cosimo_I_Enters_the_College_of_Cardinals_ca.1582_print_by_Stradanus%2C_S.I_54394%2C_Prints_Department%2C_Royal_Library_of_Belgium.jpg",
    "c": "Philip Galle / Stradanus, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cosimo_I_Enters_the_College_of_Cardinals_ca.1582_print_by_Stradanus,_S.I_54394,_Prints_Department,_Royal_Library_of_Belgium.jpg"
  },
  "med_mohi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Battle_of_Mohi_1241.PNG/500px-Battle_of_Mohi_1241.PNG",
    "c": "Anonymous illumination, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Mohi_1241.PNG"
  },
  "med_mamluk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Three_Mamelukes_with_lances_on_horseback.jpg/500px-Three_Mamelukes_with_lances_on_horseback.jpg",
    "c": "Daniel Hopfer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Three_Mamelukes_with_lances_on_horseback.jpg"
  },
  "med_baghdad_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Si%C3%A8ge_de_Sidon_%281260%29.jpeg/500px-Si%C3%A8ge_de_Sidon_%281260%29.jpeg",
    "c": "Unknown. Catalonia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Si%C3%A8ge_de_Sidon_(1260).jpeg"
  },
  "med_nachmanides": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Beit_HaTfutzot_20162029-438.jpg/500px-Beit_HaTfutzot_20162029-438.jpg",
    "c": "ביקורת, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Beit_HaTfutzot_20162029-438.jpg"
  },
  "med_yuan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Liu-Kuan-Tao-Jagd.JPG/500px-Liu-Kuan-Tao-Jagd.JPG",
    "c": "Liu Guandao, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Liu-Kuan-Tao-Jagd.JPG"
  },
  "med_marco_polo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Marco_Polo_Kubilai_Khan.jpg/500px-Marco_Polo_Kubilai_Khan.jpg",
    "c": "Maître de la mazarine et collab., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Marco_Polo_Kubilai_Khan.jpg"
  },
  "med_mongol_japan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Mooko-SamuraiShips.jpg/500px-Mooko-SamuraiShips.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mooko-SamuraiShips.jpg"
  },
  "med_acre": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Masakra_mameluk%C3%B3w.jpg/500px-Masakra_mameluk%C3%B3w.jpg",
    "c": "Horace Vernet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Masakra_mameluk%C3%B3w.jpg"
  },
  "med_zohar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/21/Zohar.png",
    "c": "Possibly Simeon bar Yochai, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Zohar.png"
  },
  "med_avignon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Simone_dei_crocifissi%2C_urbano_V%2C_1375_ca.%2C_forse_dalla_cattedrale_di_s._pietro_01_%28cropped%29.jpg/500px-Simone_dei_crocifissi%2C_urbano_V%2C_1375_ca.%2C_forse_dalla_cattedrale_di_s._pietro_01_%28cropped%29.jpg",
    "c": "Sailko, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Simone_dei_crocifissi,_urbano_V,_1375_ca.,_forse_dalla_cattedrale_di_s._pietro_01_(cropped).jpg"
  },
  "med_dante": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/15th-century_painters_-_Portrait_of_Dante_Alighieri_-_WGA15992.jpg/500px-15th-century_painters_-_Portrait_of_Dante_Alighieri_-_WGA15992.jpg",
    "c": "Unknown Miniaturist, Italian (active 1440s in Florence), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:15th-century_painters_-_Portrait_of_Dante_Alighieri_-_WGA15992.jpg"
  },
  "med_battuta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/9/9c/Handmade_oil_painting_reproduction_of_Ibn_Battuta_in_Egypt%2C_a_painting_by_Hippolyte_Leon_Benett..jpg",
    "c": "Léon Benett, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Handmade_oil_painting_reproduction_of_Ibn_Battuta_in_Egypt,_a_painting_by_Hippolyte_Leon_Benett..jpg"
  },
  "med_crecy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Battle_of_crecy_froissart.jpg/500px-Battle_of_crecy_froissart.jpg",
    "c": "Loyset Liédet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_crecy_froissart.jpg"
  },
  "med_kulikovo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Dmitry_Donskoy_in_the_Battle_of_Kulikovo.jpg/500px-Dmitry_Donskoy_in_the_Battle_of_Kulikovo.jpg",
    "c": "Adolphe Yvon, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dmitry_Donskoy_in_the_Battle_of_Kulikovo.jpg"
  },
  "med_peasants_revolt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/DeathWatTylerFull.jpg/500px-DeathWatTylerFull.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DeathWatTylerFull.jpg"
  },
  "med_kosovo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Facial_Chronicle_-_b.10%2C_p.299_-_Battle_of_Kosovo_%281389%29.png/500px-Facial_Chronicle_-_b.10%2C_p.299_-_Battle_of_Kosovo_%281389%29.png",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Facial_Chronicle_-_b.10,_p.299_-_Battle_of_Kosovo_(1389).png"
  },
  "med_zheng_he": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/%E3%80%8A%E9%84%AD%E5%92%8C%E6%AD%B8%E4%BE%86%E3%80%8B%E3%80%82_%E8%97%9D%E8%A1%93%E5%AE%B6%E5%BC%97%E6%8B%89%E5%9F%BA%E7%B1%B3%E7%88%BE%C2%B7%E7%A7%91%E7%B4%A2%E5%A4%AB_2018.jpg/500px-%E3%80%8A%E9%84%AD%E5%92%8C%E6%AD%B8%E4%BE%86%E3%80%8B%E3%80%82_%E8%97%9D%E8%A1%93%E5%AE%B6%E5%BC%97%E6%8B%89%E5%9F%BA%E7%B1%B3%E7%88%BE%C2%B7%E7%A7%91%E7%B4%A2%E5%A4%AB_2018.jpg",
    "c": "Kosov vladimir 09071967, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:%E3%80%8A%E9%84%AD%E5%92%8C%E6%AD%B8%E4%BE%86%E3%80%8B%E3%80%82_%E8%97%9D%E8%A1%93%E5%AE%B6%E5%BC%97%E6%8B%89%E5%9F%BA%E7%B1%B3%E7%88%BE%C2%B7%E7%A7%91%E7%B4%A2%E5%A4%AB_2018.jpg"
  },
  "med_grunwald": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/07/Battle_of_%C5%BDalgiris.jpg",
    "c": "w:Diebold Schilling the Younger (1460 - 1515?), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_%C5%BDalgiris.jpg"
  },
  "med_hus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Burning_of_jan_hus_at_the_stake_at_council_of_constance.jpg/500px-Burning_of_jan_hus_at_the_stake_at_council_of_constance.jpg",
    "c": "Carl Gustaf Hellqvist, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Burning_of_jan_hus_at_the_stake_at_council_of_constance.jpg"
  },
  "med_forbidden_city": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Beijing-forbidden4.jpg/500px-Beijing-forbidden4.jpg",
    "c": "Saad Akhtar from New Delhi, India, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Beijing-forbidden4.jpg"
  },
  "med_ulugh_beg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Ulugh_Beg%2C_Timurid_painting_1425-50.jpg/500px-Ulugh_Beg%2C_Timurid_painting_1425-50.jpg",
    "c": "Unknown artistUnknown artist, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ulugh_Beg,_Timurid_painting_1425-50.jpg"
  },
  "med_dome": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/67/Santa_Maria_del_Fiore.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Santa_Maria_del_Fiore.jpg"
  },
  "med_gutenberg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Gutenberg.jpg/500px-Gutenberg.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gutenberg.jpg"
  },
  "med_isabella": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/IsabellaofCastile03.jpg/500px-IsabellaofCastile03.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:IsabellaofCastile03.jpg"
  },
  "med_inquisition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Pedro_Berruguete_Saint_Dominic_Presiding_over_an_Auto-da-fe_1495.jpg/500px-Pedro_Berruguete_Saint_Dominic_Presiding_over_an_Auto-da-fe_1495.jpg",
    "c": "Pedro Berruguete, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pedro_Berruguete_Saint_Dominic_Presiding_over_an_Auto-da-fe_1495.jpg"
  },
  "med_dias": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Cape_of_Good_Hope_%28Zaian_2008%29.JPG/500px-Cape_of_Good_Hope_%28Zaian_2008%29.JPG",
    "c": "Zaian (talk) at en.wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cape_of_Good_Hope_(Zaian_2008).JPG"
  },
  "med_granada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Court_of_the_Lions_-_2013.07_-_panoramio.jpg/500px-Court_of_the_Lions_-_2013.07_-_panoramio.jpg",
    "c": "rheins, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Court_of_the_Lions_-_2013.07_-_panoramio.jpg"
  },
  "med_expulsion": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/9/9e/Alhambra_Decree.jpg",
    "c": "The original uploader was Goodoldpolonius2 at English Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Alhambra_Decree.jpg"
  },
  "med_columbus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Christophe_Colomb_devant_le_conseil_de_Salamanque_-_Emanuel_Leutze_-_MBA_Lyon_2014.jpg/500px-Christophe_Colomb_devant_le_conseil_de_Salamanque_-_Emanuel_Leutze_-_MBA_Lyon_2014.jpg",
    "c": "Emanuel Leutze, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Christophe_Colomb_devant_le_conseil_de_Salamanque_-_Emanuel_Leutze_-_MBA_Lyon_2014.jpg"
  },
  "med_tordesillas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Treaty_of_Tordesillas.jpg/500px-Treaty_of_Tordesillas.jpg",
    "c": "Original: Biblioteca Nacional de Lisboa Photo: User:Joserebelo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Treaty_of_Tordesillas.jpg"
  },
  "med_last_supper": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Leonardo_da_Vinci_%281452-1519%29_-_The_Last_Supper_%281495-1498%29.jpg/500px-Leonardo_da_Vinci_%281452-1519%29_-_The_Last_Supper_%281495-1498%29.jpg",
    "c": "Leonardo da Vinci, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Leonardo_da_Vinci_(1452-1519)_-_The_Last_Supper_(1495-1498).jpg"
  },
  "med_gama": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Lisboa-Museu_Nacional_de_Arte_Antiga-Retrato_dito_de_Vasco_da_Gama-20140917.jpg/500px-Lisboa-Museu_Nacional_de_Arte_Antiga-Retrato_dito_de_Vasco_da_Gama-20140917.jpg",
    "c": "Unknown master of the Portuguese School.., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lisboa-Museu_Nacional_de_Arte_Antiga-Retrato_dito_de_Vasco_da_Gama-20140917.jpg"
  },
  "med_cabral": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Pedro_%C3%81lvares_Cabral_-_steel_engraving_by_American_Bank_Note_Company.jpg/500px-Pedro_%C3%81lvares_Cabral_-_steel_engraving_by_American_Bank_Note_Company.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pedro_%C3%81lvares_Cabral_-_steel_engraving_by_American_Bank_Note_Company.jpg"
  },
  "med_sistine": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/CAPPELLA_SISTINA_Ceiling.jpg/500px-CAPPELLA_SISTINA_Ceiling.jpg",
    "c": "Michelangelo, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:CAPPELLA_SISTINA_Ceiling.jpg"
  },
  "med_ghetto": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Ghetto_IMG_4122.JPG/500px-Ghetto_IMG_4122.JPG",
    "c": "Deror avi, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ghetto_IMG_4122.JPG"
  },
  "med_magellan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Ferdinand_Magellan.jpg/500px-Ferdinand_Magellan.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ferdinand_Magellan.jpg"
  },
  "med_cortes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Cortes-Hernan-LOC.jpg/500px-Cortes-Hernan-LOC.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cortes-Hernan-LOC.jpg"
  },
  "med_mohacs": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Battle_of_Moh%C3%A1cs%2C_Turkish_miniature.jpg/500px-Battle_of_Moh%C3%A1cs%2C_Turkish_miniature.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Moh%C3%A1cs,_Turkish_miniature.jpg"
  },
  "med_vienna": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Siegeofvienna1529.jpg/500px-Siegeofvienna1529.jpg",
    "c": "Bartel Beham, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siegeofvienna1529.jpg"
  },
  "med_copernicus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Nikolaus_Kopernikus.jpg/500px-Nikolaus_Kopernikus.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nikolaus_Kopernikus.jpg"
  },
  "med_shulchan_aruch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Brockhaus_and_Efron_Jewish_Encyclopedia_e9_327-0.jpg/500px-Brockhaus_and_Efron_Jewish_Encyclopedia_e9_327-0.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Brockhaus_and_Efron_Jewish_Encyclopedia_e9_327-0.jpg"
  },
  "med_lepanto": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Battle_of_Lepanto_1571.jpg/500px-Battle_of_Lepanto_1571.jpg",
    "c": "Unidentified painter, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Lepanto_1571.jpg"
  },
  "med_armada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Loutherbourg-Spanish_Armada.jpg/500px-Loutherbourg-Spanish_Armada.jpg",
    "c": "Philip James de Loutherbourg, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Loutherbourg-Spanish_Armada.jpg"
  },
  "med_hideyoshi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Toyotomi_hideyoshi_face.png/500px-Toyotomi_hideyoshi_face.png",
    "c": "Kanō Mitsunobu, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Toyotomi_hideyoshi_face.png"
  },
  "med_sekigahara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Sekigaharascreen.jpg/500px-Sekigaharascreen.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sekigaharascreen.jpg"
  },
  "med_imjin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Siege-of-Busanjin-1592.jpg/500px-Siege-of-Busanjin-1592.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siege-of-Busanjin-1592.jpg"
  },
  "med_voc": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/5e/VOC_duit.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:VOC_duit.jpg"
  },
  "med_jamestown": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Jamestown-Virginia-settlement-ships-NOAA.jpg/500px-Jamestown-Virginia-settlement-ships-NOAA.jpg",
    "c": "The original uploader was Wikid77 at English Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jamestown-Virginia-settlement-ships-NOAA.jpg"
  },
  "med_galileo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Galileo_moon_phases.jpg/500px-Galileo_moon_phases.jpg",
    "c": "Galileo Galilei, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Galileo_moon_phases.jpg"
  },
  "med_prague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Defenestration-prague-1618.jpg/500px-Defenestration-prague-1618.jpg",
    "c": "Maximilian Ornelas Solis, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Defenestration-prague-1618.jpg"
  },
  "med_westphalia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Westfaelischer_Friede_in_Muenster_%28Gerard_Terborch_1648%29.jpg/500px-Westfaelischer_Friede_in_Muenster_%28Gerard_Terborch_1648%29.jpg",
    "c": "Gerard ter Borch, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Westfaelischer_Friede_in_Muenster_(Gerard_Terborch_1648).jpg"
  },
  "med_suleymaniye": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/S%C3%BCleymaniye_Mosque_2.jpg/500px-S%C3%BCleymaniye_Mosque_2.jpg",
    "c": "İhsan Deniz Kılıçoğlu, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:S%C3%BCleymaniye_Mosque_2.jpg"
  },
  "med_khmelnytsky": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Pic_I_V_Ivasiuk_Mykola_Bohdan_Khmelnytskys_Entry_to_Kyiv.jpg/500px-Pic_I_V_Ivasiuk_Mykola_Bohdan_Khmelnytskys_Entry_to_Kyiv.jpg",
    "c": "Mykola Ivasiuk, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pic_I_V_Ivasiuk_Mykola_Bohdan_Khmelnytskys_Entry_to_Kyiv.jpg"
  },
  "mod_capetown": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Charles_Bell_-_Jan_van_Riebeeck_se_aankoms_aan_die_Kaap.jpg/500px-Charles_Bell_-_Jan_van_Riebeeck_se_aankoms_aan_die_Kaap.jpg",
    "c": "Charles Davidson Bell, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Charles_Bell_-_Jan_van_Riebeeck_se_aankoms_aan_die_Kaap.jpg"
  },
  "mod_restoration": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Charles_II_of_England.jpeg/500px-Charles_II_of_England.jpeg",
    "c": "Peter Lely, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Charles_II_of_England.jpeg"
  },
  "mod_londonfire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Great_Fire_London.jpg/500px-Great_Fire_London.jpg",
    "c": "Unknown artistUnknown artist, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Great_Fire_London.jpg"
  },
  "mod_vienna1683": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Anonym_Entsatz_Wien_1683.jpg/500px-Anonym_Entsatz_Wien_1683.jpg",
    "c": "Anonymer, zeitgenössischer Maler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Anonym_Entsatz_Wien_1683.jpg"
  },
  "mod_principia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/NewtonsPrincipia.jpg/500px-NewtonsPrincipia.jpg",
    "c": "Isaac Newton, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:NewtonsPrincipia.jpg"
  },
  "mod_nerchinsk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b3/Treaty_of_Nerchinsk_%281689%29.jpg",
    "c": "Governments of Russia and China, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Treaty_of_Nerchinsk_(1689).jpg"
  },
  "mod_poltava": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Lomonosov_Poltava_fragment.jpg/500px-Lomonosov_Poltava_fragment.jpg",
    "c": "Serge Lachinov (обработка для wiki), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lomonosov_Poltava_fragment.jpg"
  },
  "mod_nader": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/d8/NaderShahPainting.png",
    "c": "Abolhassan Mostofi Ghaffari, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:NaderShahPainting.png"
  },
  "mod_lisbon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/1755_Lisbon_earthquake.jpg/500px-1755_Lisbon_earthquake.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1755_Lisbon_earthquake.jpg"
  },
  "mod_teaparty": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Boston_Tea_Party_Currier_colored.jpg/500px-Boston_Tea_Party_Currier_colored.jpg",
    "c": "Nathaniel Currier, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Boston_Tea_Party_Currier_colored.jpg"
  },
  "mod_cook": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/La_Perouse_3.JPG/500px-La_Perouse_3.JPG",
    "c": "J Bar, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:La_Perouse_3.JPG"
  },
  "mod_saintdomingue": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Manuel_Lopez_Lopez_Iodibo_-_Desalines_-_Huyes_del_valor_frances%2C_pero_matando_blancos.jpg/500px-Manuel_Lopez_Lopez_Iodibo_-_Desalines_-_Huyes_del_valor_frances%2C_pero_matando_blancos.jpg",
    "c": "Manuel López López, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Manuel_Lopez_Lopez_Iodibo_-_Desalines_-_Huyes_del_valor_frances,_pero_matando_blancos.jpg"
  },
  "mod_valmy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Valmy_Battle_painting.jpg/500px-Valmy_Battle_painting.jpg",
    "c": "Horace Vernet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Valmy_Battle_painting.jpg"
  },
  "mod_louis16": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4c/Duplessi-Bertaux_-_Arrivee_de_Louis_Seize_a_Paris.png/500px-Duplessi-Bertaux_-_Arrivee_de_Louis_Seize_a_Paris.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 428
  },
  "mod_rosetta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Rosetta_Stone.JPG/500px-Rosetta_Stone.JPG",
    "c": "Hans Hillewaert, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Rosetta_Stone.JPG"
  },
  "mod_trafalgar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Turner%2C_The_Battle_of_Trafalgar_%281806%29.jpg/500px-Turner%2C_The_Battle_of_Trafalgar_%281806%29.jpg",
    "c": "J. M. W. Turner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Turner,_The_Battle_of_Trafalgar_(1806).jpg"
  },
  "mod_austerlitz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/La_bataille_d%27Austerlitz._2_decembre_1805_%28Fran%C3%A7ois_G%C3%A9rard%29.jpg/500px-La_bataille_d%27Austerlitz._2_decembre_1805_%28Fran%C3%A7ois_G%C3%A9rard%29.jpg",
    "c": "François Gérard, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:La_bataille_d%27Austerlitz._2_decembre_1805_(Fran%C3%A7ois_G%C3%A9rard).jpg"
  },
  "mod_muhammadali": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/ModernEgypt%2C_Muhammad_Ali_by_Auguste_Couder%2C_BAP_17996.jpg/500px-ModernEgypt%2C_Muhammad_Ali_by_Auguste_Couder%2C_BAP_17996.jpg",
    "c": "Auguste Couder, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:ModernEgypt,_Muhammad_Ali_by_Auguste_Couder,_BAP_17996.jpg"
  },
  "mod_braziljoao": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/bd/Debret31.jpg",
    "c": "Jean-Baptiste Debret, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Debret31.jpg"
  },
  "mod_dolores": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Dolores_hidalgo.jpg/500px-Dolores_hidalgo.jpg",
    "c": "Paigemorrison at English Wikipedia, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Dolores_hidalgo.jpg"
  },
  "mod_borodino": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Battle_of_Borodino.jpg/500px-Battle_of_Borodino.jpg",
    "c": "Louis Lejeune, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Borodino.jpg"
  },
  "mod_leipzig": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/MoshkovVI_SrazhLeypcigomGRM.jpg/500px-MoshkovVI_SrazhLeypcigomGRM.jpg",
    "c": "Vladimir Moshkov, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:MoshkovVI_SrazhLeypcigomGRM.jpg"
  },
  "mod_vienna1815": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/a5/CongressVienna.jpg",
    "c": "Jean-Baptiste Isabey, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:CongressVienna.jpg"
  },
  "waterloo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Wellington_at_Waterloo_Hillingford.jpg/500px-Wellington_at_Waterloo_Hillingford.jpg",
    "c": "Robert Alexander Hillingford, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Wellington_at_Waterloo_Hillingford.jpg"
  },
  "mod_raffles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/George_Francis_Joseph_-_Sir_Thomas_Stamford_Bingley_Raffles.jpg/500px-George_Francis_Joseph_-_Sir_Thomas_Stamford_Bingley_Raffles.jpg",
    "c": "George Francis Joseph, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:George_Francis_Joseph_-_Sir_Thomas_Stamford_Bingley_Raffles.jpg"
  },
  "mod_peterloo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Peterloo_Massacre.png/500px-Peterloo_Massacre.png",
    "c": "Richard Carlile, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Peterloo_Massacre.png"
  },
  "mod_ipiranga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Pedro_Am%C3%A9rico_-_Independ%C3%AAncia_ou_Morte_-_Google_Art_Project.jpg/500px-Pedro_Am%C3%A9rico_-_Independ%C3%AAncia_ou_Morte_-_Google_Art_Project.jpg",
    "c": "Pedro Américo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pedro_Am%C3%A9rico_-_Independ%C3%AAncia_ou_Morte_-_Google_Art_Project.jpg"
  },
  "mod_erie": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/8e/Lockport_bartlett_color_crop.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lockport_bartlett_color_crop.jpg"
  },
  "mod_navarino": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Navarino.JPG/500px-Navarino.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Navarino.JPG"
  },
  "mod_belgium": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Wappers_-_Episodes_from_September_Days_1830_on_the_Place_de_l%E2%80%99H%C3%B4tel_de_Ville_in_Brussels.JPG/500px-Wappers_-_Episodes_from_September_Days_1830_on_the_Place_de_l%E2%80%99H%C3%B4tel_de_Ville_in_Brussels.JPG",
    "c": "Photo by Szilas at the Royal Museums of Fine Arts of Belgium, Brussels, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Wappers_-_Episodes_from_September_Days_1830_on_the_Place_de_l%E2%80%99H%C3%B4tel_de_Ville_in_Brussels.JPG"
  },
  "mod_alamo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/1854_Alamo.jpg/500px-1854_Alamo.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1854_Alamo.jpg"
  },
  "mod_trailoftears": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Trail_of_Tears_for_the_Creek_People_%287222969326%29.jpg/500px-Trail_of_Tears_for_the_Creek_People_%287222969326%29.jpg",
    "c": "TradingCardsNPS, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Trail_of_Tears_for_the_Creek_People_(7222969326).jpg"
  },
  "mod_nanjing": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/The_Signing_of_the_Treaty_of_Nanking.jpg/500px-The_Signing_of_the_Treaty_of_Nanking.jpg",
    "c": "Painted by Captain John Platt, Bengal Volunteers. Engraved by John Burnet., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Signing_of_the_Treaty_of_Nanking.jpg"
  },
  "mod_famine": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Irish_potato_famine_Bridget_O%27Donnel.jpg/500px-Irish_potato_famine_Bridget_O%27Donnel.jpg",
    "c": "Illustrated London News, December 22, 1849, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Irish_potato_famine_Bridget_O%27Donnel.jpg"
  },
  "mod_frankfurt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Bilderrevolution0234.jpg/500px-Bilderrevolution0234.jpg",
    "c": "Unknown authorUnknown author, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Bilderrevolution0234.jpg"
  },
  "mod_manifesto": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Communist-manifesto.png/500px-Communist-manifesto.png",
    "c": "Friedrich Engels, Karl Marx, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Communist-manifesto.png"
  },
  "mod_hungary1848": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/21/March15.jpg",
    "c": "Mihály Zichy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:March15.jpg"
  },
  "mod_taiping": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cc/Hong_Xiuquan.jpg",
    "c": "Ford &amp; West Lith., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hong_Xiuquan.jpg"
  },
  "mod_goldrush": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Gold_seeking_river_operations_California.jpg/500px-Gold_seeking_river_operations_California.jpg",
    "c": "Harper's Magazine, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gold_seeking_river_operations_California.jpg"
  },
  "mod_perry": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Commodore_Perry%27s_second_fleet.jpg/500px-Commodore_Perry%27s_second_fleet.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Commodore_Perry%27s_second_fleet.jpg"
  },
  "mod_greatexhibition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Crystal_Palace_-_Queen_Victoria_opens_the_Great_Exhibition.jpg/500px-Crystal_Palace_-_Queen_Victoria_opens_the_Great_Exhibition.jpg",
    "c": "Louis Haghe, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Crystal_Palace_-_Queen_Victoria_opens_the_Great_Exhibition.jpg"
  },
  "mod_darwin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Charles_Darwin_seated.jpg/500px-Charles_Darwin_seated.jpg",
    "c": "Henry Maull (1829–1914) and John Fox (1832–1907) (Maull &amp; Fox)[1], Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Charles_Darwin_seated.jpg"
  },
  "mod_sumter": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Bombardment_of_Fort_Sumter.jpg/500px-Bombardment_of_Fort_Sumter.jpg",
    "c": "Currier &amp; Ives. Uploaded by Christophe cagé 12:52, 6 September 2006 (UTC), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bombardment_of_Fort_Sumter.jpg"
  },
  "mod_gettysburg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Battle_of_Gettysburg%2C_by_Currier_and_Ives.png/500px-Battle_of_Gettysburg%2C_by_Currier_and_Ives.png",
    "c": "Nathaniel Currier and James Merritt Ives, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Gettysburg,_by_Currier_and_Ives.png"
  },
  "mod_paraguay": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Tuyuti.jpg/500px-Tuyuti.jpg",
    "c": "Luis Candido Lopez, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Tuyuti.jpg"
  },
  "mod_appomattox": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/General_Robert_E._Lee_surrenders_at_Appomattox_Court_House_1865.jpg/500px-General_Robert_E._Lee_surrenders_at_Appomattox_Court_House_1865.jpg",
    "c": "Thomas Nast, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:General_Robert_E._Lee_surrenders_at_Appomattox_Court_House_1865.jpg"
  },
  "mod_koniggratz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Battle_of_Koniggratz_by_Georg_Bleibtreu.jpg/500px-Battle_of_Koniggratz_by_Georg_Bleibtreu.jpg",
    "c": "Attributed to Georg Bleibtreu, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Koniggratz_by_Georg_Bleibtreu.jpg"
  },
  "mod_meiji": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Black_and_white_portrait_of_emperor_Meiji_of_Japan.jpg/500px-Black_and_white_portrait_of_emperor_Meiji_of_Japan.jpg",
    "c": "Takagi Haisui, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Black_and_white_portrait_of_emperor_Meiji_of_Japan.jpg"
  },
  "mod_sedan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/BismarckundNapoleonIII.jpg/500px-BismarckundNapoleonIII.jpg",
    "c": "Wilhelm Camphausen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BismarckundNapoleonIII.jpg"
  },
  "mod_commune": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Barricade18March1871.jpg/500px-Barricade18March1871.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Barricade18March1871.jpg"
  },
  "mod_bighorn": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Charles_Marion_Russell_-_The_Custer_Fight_%281903%29.jpg/500px-Charles_Marion_Russell_-_The_Custer_Fight_%281903%29.jpg",
    "c": "Charles Marion Russell, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Charles_Marion_Russell_-_The_Custer_Fight_(1903).jpg"
  },
  "mod_chicagofire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Chicago-fire1.jpg/500px-Chicago-fire1.jpg",
    "c": "John R. Chapin, died 1907, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Chicago-fire1.jpg"
  },
  "mod_berlin1878": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Berliner_kongress.jpg/500px-Berliner_kongress.jpg",
    "c": "Anton von Werner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Berliner_kongress.jpg"
  },
  "mod_isandlwana": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Isandhlwana.jpg/500px-Isandhlwana.jpg",
    "c": "Charles Edwin Fripp, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Isandhlwana.jpg"
  },
  "mod_edison": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Thomas_Edison2.jpg/500px-Thomas_Edison2.jpg",
    "c": "Louis Bachrach, Bachrach Studios, restored by Michel Vuijlsteke, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thomas_Edison2.jpg"
  },
  "sarajevo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/DC-1914-27-d-Sarajevo-cropped.jpg/500px-DC-1914-27-d-Sarajevo-cropped.jpg",
    "c": "Achille Beltrame, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DC-1914-27-d-Sarajevo-cropped.jpg"
  },
  "october": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Ivan_Vladimirov_the-pogrom-of-the-winter-palace.jpg%21HD.jpg/500px-Ivan_Vladimirov_the-pogrom-of-the-winter-palace.jpg%21HD.jpg",
    "c": "Ivan Vladimirov, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ivan_Vladimirov_the-pogrom-of-the-winter-palace.jpg!HD.jpg"
  },
  "israel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Israel_ind_hall.JPG/500px-Israel_ind_hall.JPG",
    "c": "Amit A., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Israel_ind_hall.JPG"
  },
  "mod_easter_rising": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Easter_Proclamation_of_1916.png/500px-Easter_Proclamation_of_1916.png",
    "c": "originally uploaded to the English Wikipedia by w:User:Jtdirl, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Easter_Proclamation_of_1916.png"
  },
  "mod_versailles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Treaty_of_Versailles%2C_English_version.jpg/500px-Treaty_of_Versailles%2C_English_version.jpg",
    "c": "David Lloyd George, Woodrow Wilson and Georges Clemenceau, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Treaty_of_Versailles,_English_version.jpg"
  },
  "mod_somme": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Hawthorn_Ridge_Redoubt_mine_%281_July_1916%29_1.jpg/500px-Hawthorn_Ridge_Redoubt_mine_%281_July_1916%29_1.jpg",
    "c": "Ernest Brooks, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hawthorn_Ridge_Redoubt_mine_(1_July_1916)_1.jpg"
  },
  "mod_gallipoli": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Anzac_Beach_4th_Bn_landing_8am_April_25_1915.jpg/500px-Anzac_Beach_4th_Bn_landing_8am_April_25_1915.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Anzac_Beach_4th_Bn_landing_8am_April_25_1915.jpg"
  },
  "mod_armenian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/April24Victims.jpg/500px-April24Victims.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:April24Victims.jpg"
  },
  "mod_hitler": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Bundesarchiv_Bild_102-15348%2C_Reichskabinett_Adolf_Hitler.jpg/500px-Bundesarchiv_Bild_102-15348%2C_Reichskabinett_Adolf_Hitler.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 3.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_102-15348,_Reichskabinett_Adolf_Hitler.jpg"
  },
  "mod_kristallnacht": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/The_day_after_Kristallnacht.jpg/500px-The_day_after_Kristallnacht.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_day_after_Kristallnacht.jpg"
  },
  "mod_battle_britain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Boulton_Paul_Defiant.jpg/500px-Boulton_Paul_Defiant.jpg",
    "c": "B.J. Daventry, Royal Air Force official photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Boulton_Paul_Defiant.jpg"
  },
  "mod_babi_yar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/P1170835%3D.jpg/500px-P1170835%3D.jpg",
    "c": "Moti1980, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:P1170835%3D.jpg"
  },
  "mod_stalingrad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Bundesarchiv_Bild_183-R74190%2C_Russland%2C_Kesselschlacht_Stalingrad.jpg/500px-Bundesarchiv_Bild_183-R74190%2C_Russland%2C_Kesselschlacht_Stalingrad.jpg",
    "c": "UnknownUnknown, CC BY-SA 3.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_183-R74190,_Russland,_Kesselschlacht_Stalingrad.jpg"
  },
  "mod_warsaw_ghetto": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Stroop_Report_-_Warsaw_Ghetto_Uprising_06b.jpg/500px-Stroop_Report_-_Warsaw_Ghetto_Uprising_06b.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Stroop_Report_-_Warsaw_Ghetto_Uprising_06b.jpg"
  },
  "mod_auschwitz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Auschwitz_gate.jpg/500px-Auschwitz_gate.jpg",
    "c": "Itaypap, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Auschwitz_gate.jpg"
  },
  "mod_dday": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/1944_NormandyLST.jpg/500px-1944_NormandyLST.jpg",
    "c": "Chief Photographer's Mate (CPHOM) Robert F. Sargent, U.S. Coast Guard, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1944_NormandyLST.jpg"
  },
  "mod_berlin_surrender": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Colonal_General_Alfred_Jodl%2C_Chief_of_Staff_under_the_Doenitz_Regime%2C_signs_the_document_of_unconditional_surrender...._-_NARA_-_195338.jpg/500px-Colonal_General_Alfred_Jodl%2C_Chief_of_Staff_under_the_Doenitz_Regime%2C_signs_the_document_of_unconditional_surrender...._-_NARA_-_195338.jpg",
    "c": "Unknown authorUnknown author or not provided, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Colonal_General_Alfred_Jodl,_Chief_of_Staff_under_the_Doenitz_Regime,_signs_the_document_of_unconditional_surrender...._-_NARA_-_195338.jpg"
  },
  "mod_nuremberg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Defendants_in_the_dock_at_the_Nuremberg_Trials.jpg/500px-Defendants_in_the_dock_at_the_Nuremberg_Trials.jpg",
    "c": "Work of the United States Government, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Defendants_in_the_dock_at_the_Nuremberg_Trials.jpg"
  },
  "mod_wall_built": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Berlinermauer.jpg/500px-Berlinermauer.jpg",
    "c": "Noir, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Berlinermauer.jpg"
  },
  "mod_prague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/10_Soviet_Invasion_of_Czechoslovakia_-_Flickr_-_The_Central_Intelligence_Agency.jpg/500px-10_Soviet_Invasion_of_Czechoslovakia_-_Flickr_-_The_Central_Intelligence_Agency.jpg",
    "c": "The Central Intelligence Agency, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:10_Soviet_Invasion_of_Czechoslovakia_-_Flickr_-_The_Central_Intelligence_Agency.jpg"
  },
  "mod_solidarity": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Monument_to_the_fallen_Shipyard_workers_of_1970.JPG/500px-Monument_to_the_fallen_Shipyard_workers_of_1970.JPG",
    "c": "Avi1111 dr. avishai teicher, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Monument_to_the_fallen_Shipyard_workers_of_1970.JPG"
  },
  "mod_mexico_rev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Mexican_rebel_camp.jpg/500px-Mexican_rebel_camp.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mexican_rebel_camp.jpg"
  },
  "mod_panama_canal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Panama_Canal_Gatun_Locks_opening.jpg/500px-Panama_Canal_Gatun_Locks_opening.jpg",
    "c": "User:Stan Shebs, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Panama_Canal_Gatun_Locks_opening.jpg"
  },
  "mod_wall_street": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Crowd_outside_nyse.jpg/500px-Crowd_outside_nyse.jpg",
    "c": "US-gov, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Crowd_outside_nyse.jpg"
  },
  "mod_pearl_harbor": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/USSArizona_PearlHarbor.jpg/500px-USSArizona_PearlHarbor.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:USSArizona_PearlHarbor.jpg"
  },
  "mod_trinity": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Trinity_Test_Fireball_16ms.jpg/500px-Trinity_Test_Fireball_16ms.jpg",
    "c": "Berlyn Brixner / Los Alamos National Laboratory, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Trinity_Test_Fireball_16ms.jpg"
  },
  "mod_march_washington": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Martin_Luther_King_-_March_on_Washington.jpg/500px-Martin_Luther_King_-_March_on_Washington.jpg",
    "c": "Rowland Scherman, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Martin_Luther_King_-_March_on_Washington.jpg"
  },
  "mod_jfk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/JFK_limousine.png/500px-JFK_limousine.png",
    "c": "Walt Cisco, Dallas Morning News, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:JFK_limousine.png"
  },
  "mod_cuba_rev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Tren_blindado-Santa_Clara_%28Cuba%29-Che_Guevara-Flikr-emeryjl-388610245_%28CC-BY%29.jpg/500px-Tren_blindado-Santa_Clara_%28Cuba%29-Che_Guevara-Flikr-emeryjl-388610245_%28CC-BY%29.jpg",
    "c": "James Emery from Douglasville, United States, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tren_blindado-Santa_Clara_(Cuba)-Che_Guevara-Flikr-emeryjl-388610245_(CC-BY).jpg"
  },
  "mod_missile_crisis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Cuban_missiles.jpg/500px-Cuban_missiles.jpg",
    "c": "see above, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cuban_missiles.jpg"
  },
  "mod_allende": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Golpe_de_Estado_1973.jpg/500px-Golpe_de_Estado_1973.jpg",
    "c": "Biblioteca del Congreso Nacional de Chile, CC BY 3.0 cl",
    "p": "https://commons.wikimedia.org/wiki/File:Golpe_de_Estado_1973.jpg"
  },
  "mod_apollo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Apollo16LM.jpg/500px-Apollo16LM.jpg",
    "c": "Apollo 16 astronauts, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Apollo16LM.jpg"
  },
  "mod_watergate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Watergate.jpg/500px-Watergate.jpg",
    "c": "Allen Lew from Berkeley, USA, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Watergate.jpg"
  },
  "mod_sept11": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/fd/National_Park_Service_9-11_Statue_of_Liberty_and_WTC_fire.jpg",
    "c": "National Park Service, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:National_Park_Service_9-11_Statue_of_Liberty_and_WTC_fire.jpg"
  },
  "mod_falklands": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Argentine_POWs_guarded_by_2_Para.jpg/500px-Argentine_POWs_guarded_by_2_Para.jpg",
    "c": "Ken Griffiths at en.wikipedia), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Argentine_POWs_guarded_by_2_Para.jpg"
  },
  "mod_boxer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Boxer_Rebellion.jpg/500px-Boxer_Rebellion.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Boxer_Rebellion.jpg"
  },
  "mod_tsushima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/5b/JBMikasa.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:JBMikasa.jpg"
  },
  "mod_amritsar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/JallianwalaBaghmemorial1227.JPG/500px-JallianwalaBaghmemorial1227.JPG",
    "c": "No machine-readable author provided. Soman assumed (based on copyright claims)., CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:JallianwalaBaghmemorial1227.JPG"
  },
  "mod_salt_march": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Marche_sel.jpg/500px-Marche_sel.jpg",
    "c": "Yann (talk), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Marche_sel.jpg"
  },
  "mod_nanjing_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Nanking_bodies_1937.jpg/500px-Nanking_bodies_1937.jpg",
    "c": "Originally Moriyasu Murase, 村瀬守保, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nanking_bodies_1937.jpg"
  },
  "mod_hiroshima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/AtomicEffects-p32b.jpg/500px-AtomicEffects-p32b.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:AtomicEffects-p32b.jpg"
  },
  "mod_partition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/37/A_refugee_train%2C_Punjab%2C_1947.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_refugee_train,_Punjab,_1947.jpg"
  },
  "mod_korea": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/U.S._Army_machine_gun_team_near_the_Chongchon_River_in_North_Korea_%28November_1950%29.jpg/500px-U.S._Army_machine_gun_team_near_the_Chongchon_River_in_North_Korea_%28November_1950%29.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:U.S._Army_machine_gun_team_near_the_Chongchon_River_in_North_Korea_(November_1950).jpg"
  },
  "mod_tsunami": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/2004-tsunami.jpg/500px-2004-tsunami.jpg",
    "c": "David Rydevik (email: david.rydevikgmail.com), Stockholm, Sweden., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:2004-tsunami.jpg"
  },
  "mod_adwa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/COLLECTIE_TROPENMUSEUM_De_slag_bij_Adua_TMnr_5956-2.jpg/500px-COLLECTIE_TROPENMUSEUM_De_slag_bij_Adua_TMnr_5956-2.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:COLLECTIE_TROPENMUSEUM_De_slag_bij_Adua_TMnr_5956-2.jpg"
  },
  "mod_boer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Guerra_boeres.jpg/500px-Guerra_boeres.jpg",
    "c": "Van Hoepen, Pretoria, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Guerra_boeres.jpg"
  },
  "mod_congo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Leopold_ii_garter_knight.jpg/500px-Leopold_ii_garter_knight.jpg",
    "c": "London Stereoscopic and Photographic Company, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Leopold_ii_garter_knight.jpg"
  },
  "mod_egypt_rev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/7a/Nasser_and_Naguib%2C_1954.jpg",
    "c": "Not credited, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nasser_and_Naguib,_1954.jpg"
  },
  "mod_algeria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Semaine_des_barricades_Alger_1960_Haute_Qualit%C3%A9.jpg/500px-Semaine_des_barricades_Alger_1960_Haute_Qualit%C3%A9.jpg",
    "c": "Christophe Marcheux, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Semaine_des_barricades_Alger_1960_Haute_Qualit%C3%A9.jpg"
  },
  "mod_rwanda": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Nyamata_Memorial_Site_13.jpg/500px-Nyamata_Memorial_Site_13.jpg",
    "c": "Fanny Schertzer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nyamata_Memorial_Site_13.jpg"
  },
  "mod_sharpeville": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Murder_at_Sharpeville_21_March_1960.jpg/500px-Murder_at_Sharpeville_21_March_1960.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Murder_at_Sharpeville_21_March_1960.jpg"
  },
  "mod_mandela": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Nelson_Mandela_1994.jpg/500px-Nelson_Mandela_1994.jpg",
    "c": "Kingkongphoto &amp; www.celebrity-photos.com from Laurel, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nelson_Mandela_1994.jpg"
  },
  "mod_basel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/THEODOR_HERZL_AT_THE_FIRST_ZIONIST_CONGRESS_IN_BASEL_ON_25.8.1897._%D7%AA%D7%90%D7%95%D7%93%D7%95%D7%A8_%D7%94%D7%A8%D7%A6%D7%9C_%D7%91%D7%A7%D7%95%D7%A0%D7%92%D7%A8%D7%A1_%D7%94%D7%A6%D7%99%D7%95%D7%A0%D7%99_%D7%94%D7%A8%D7%90%D7%A9%D7%95%D7%9F_-_1897.8.25.jpg/500px-THEODOR_HERZL_AT_THE_FIRST_ZIONIST_CONGRESS_IN_BASEL_ON_25.8.1897._%D7%AA%D7%90%D7%95%D7%93%D7%95%D7%A8_%D7%94%D7%A8%D7%A6%D7%9C_%D7%91%D7%A7%D7%95%D7%A0%D7%92%D7%A8%D7%A1_%D7%94%D7%A6%D7%99%D7%95%D7%A0%D7%99_%D7%94%D7%A8%D7%90%D7%A9%D7%95%D7%9F_-_1897.8.25.jpg",
    "c": "Government Press Office, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:THEODOR_HERZL_AT_THE_FIRST_ZIONIST_CONGRESS_IN_BASEL_ON_25.8.1897._%D7%AA%D7%90%D7%95%D7%93%D7%95%D7%A8_%D7%94%D7%A8%D7%A6%D7%9C_%D7%91%D7%A7%D7%95%D7%A0%D7%92%D7%A8%D7%A1_%D7%94%D7%A6%D7%99%D7%95%D7%A0%D7%99_%D7%94%D7%A8%D7%90%D7%A9%D7%95%D7%9F_-_1897.8.25.jpg"
  },
  "mod_first_aliyah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Be%27er_Tuvia_%28before_1899%29.jpg/500px-Be%27er_Tuvia_%28before_1899%29.jpg",
    "c": "See the description, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Be%27er_Tuvia_(before_1899).jpg"
  },
  "mod_balfour": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Balfour_portrait_and_declaration.JPG/500px-Balfour_portrait_and_declaration.JPG",
    "c": "see original image descriptions, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Balfour_portrait_and_declaration.JPG"
  },
  "mod_refugees48": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Palestinian_refugees.jpg/500px-Palestinian_refugees.jpg",
    "c": "Fred Csasznik, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Palestinian_refugees.jpg"
  },
  "mod_eichmann": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Eichman_Trial1961.jpg/500px-Eichman_Trial1961.jpg",
    "c": "Milli John, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eichman_Trial1961.jpg"
  },
  "mod_six_day": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/6_Day_War-Amos.jpg/500px-6_Day_War-Amos.jpg",
    "c": "Rafi Rogel (רפי רוגל), Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:6_Day_War-Amos.jpg"
  },
  "mod_camp_david": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Begin%2C_Carter_and_Sadat_at_Camp_David_1978.jpg/500px-Begin%2C_Carter_and_Sadat_at_Camp_David_1978.jpg",
    "c": "Fitz-Patrick, Bill, photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Begin,_Carter_and_Sadat_at_Camp_David_1978.jpg"
  },
  "mod_iran_rev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Imam_Khomeini_in_Mehrabad.jpg/500px-Imam_Khomeini_in_Mehrabad.jpg",
    "c": "Wikimedia Commons, GFDL",
    "p": "https://commons.wikimedia.org/wiki/File:Imam_Khomeini_in_Mehrabad.jpg"
  },
  "mod_oslo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Bill_Clinton%2C_Yitzhak_Rabin%2C_Yasser_Arafat_at_the_White_House_1993-09-13.jpg/500px-Bill_Clinton%2C_Yitzhak_Rabin%2C_Yasser_Arafat_at_the_White_House_1993-09-13.jpg",
    "c": "Vince Musi / The White House, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bill_Clinton,_Yitzhak_Rabin,_Yasser_Arafat_at_the_White_House_1993-09-13.jpg"
  },
  "mod_gaza_withdrawal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Flickr_-_Israel_Defense_Forces_-_The_Evacuation_of_Shirat_Hayam_%282%29.jpg/500px-Flickr_-_Israel_Defense_Forces_-_The_Evacuation_of_Shirat_Hayam_%282%29.jpg",
    "c": "Israel Defense Forces, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Flickr_-_Israel_Defense_Forces_-_The_Evacuation_of_Shirat_Hayam_(2).jpg"
  },
  "mod_sputnik": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Laika_ac_Sputnik_2_Replica_%286995685051%29.jpg/500px-Laika_ac_Sputnik_2_Replica_%286995685051%29.jpg",
    "c": "Laika ac from USA, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Laika_ac_Sputnik_2_Replica_(6995685051).jpg"
  },
  "mod_darwin_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Darwin_42.jpg/500px-Darwin_42.jpg",
    "c": "RAN Historical Collection, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Darwin_42.jpg"
  },
  "mod_bikini": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Crossroads_baker_explosion.jpg/500px-Crossroads_baker_explosion.jpg",
    "c": "U.S. Army Photographic Signal Corps, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Crossroads_baker_explosion.jpg"
  },
  "anc_thera": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Ancient_Akrotiri.jpeg/500px-Ancient_Akrotiri.jpeg",
    "c": "Rt44, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ancient_Akrotiri.jpeg"
  },
  "anc_urziggurat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Ziggarat_of_Ur_001.jpg/500px-Ziggarat_of_Ur_001.jpg",
    "c": "Tla2006 at English Wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ziggarat_of_Ur_001.jpg"
  },
  "anc_carthage": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Archaeological_Site_of_Carthage-130237.jpg/500px-Archaeological_Site_of_Carthage-130237.jpg",
    "c": "Christian Manhart, CC BY-SA 3.0 igo",
    "p": "https://commons.wikimedia.org/wiki/File:Archaeological_Site_of_Carthage-130237.jpg"
  },
  "anc_piye": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Stele_Piye_Mariette.jpg/500px-Stele_Piye_Mariette.jpg",
    "c": "Auguste Mariette (1821-1881), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Stele_Piye_Mariette.jpg"
  },
  "anc_cleisthenes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Cleisthenes.jpg/500px-Cleisthenes.jpg",
    "c": "Unknown authorUnknown author, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Cleisthenes.jpg"
  },
  "anc_buddha": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Bodhgaya_3639641913_f4c5f73689_t.jpg/500px-Bodhgaya_3639641913_f4c5f73689_t.jpg",
    "c": "Ken Wieland from Philadelphia, USA, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Bodhgaya_3639641913_f4c5f73689_t.jpg"
  },
  "anc_athensplague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Plague_in_an_Ancient_City_LACMA_AC1997.10.1_%281_of_2%29.jpg/500px-Plague_in_an_Ancient_City_LACMA_AC1997.10.1_%281_of_2%29.jpg",
    "c": "Michiel Sweerts, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Plague_in_an_Ancient_City_LACMA_AC1997.10.1_(1_of_2).jpg"
  },
  "anc_salamis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/df/Greek_Galleys.jpg",
    "c": "Tungsten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Greek_Galleys.jpg"
  },
  "anc_pharos": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Lighthouse_-_Thiersch.png/500px-Lighthouse_-_Thiersch.png",
    "c": "Prof. Hermann Thiersch (1874–1939), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lighthouse_-_Thiersch.png"
  },
  "anc_archimedes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Archimedes_Directing_the_Defenses_of_Syracuse.jpg/500px-Archimedes_Directing_the_Defenses_of_Syracuse.jpg",
    "c": "Thomas Ralph Spence, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Archimedes_Directing_the_Defenses_of_Syracuse.jpg"
  },
  "anc_teotihuacan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/2020-02-11_Teotihuacan_la_Avenida_de_los_Muertos_y_la_Pir%C3%A1mide_del_Sol.jpg/500px-2020-02-11_Teotihuacan_la_Avenida_de_los_Muertos_y_la_Pir%C3%A1mide_del_Sol.jpg",
    "c": "Burkhard Mücke, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:2020-02-11_Teotihuacan_la_Avenida_de_los_Muertos_y_la_Pir%C3%A1mide_del_Sol.jpg"
  },
  "anc_sasanian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Dinar_of_Ardashir_I_%28cropped%29.jpg/500px-Dinar_of_Ardashir_I_%28cropped%29.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dinar_of_Ardashir_I_(cropped).jpg"
  },
  "anc_tikal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Tikal_3.jpg/500px-Tikal_3.jpg",
    "c": "Mundo Maya, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tikal_3.jpg"
  },
  "romefall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Coin_of_Odoacer_at_the_British_Museum_%28obverse%29.png/500px-Coin_of_Odoacer_at_the_British_Museum_%28obverse%29.png",
    "c": "British Museum (photo), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Coin_of_Odoacer_at_the_British_Museum_(obverse).png"
  },
  "anc_grandcanal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Gcjiangnan1.JPG/500px-Gcjiangnan1.JPG",
    "c": "Tomtom08 at en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gcjiangnan1.JPG"
  },
  "anc_brahmagupta": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/ba/Bas-relief_of_Brahmagupta.jpg/500px-Bas-relief_of_Brahmagupta.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 371
  },
  "anc_yarmouk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Hayton_BNF886_9v.jpg/500px-Hayton_BNF886_9v.jpg",
    "c": "anonymous Catalonian illustrator, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hayton_BNF886_9v.jpg"
  },
  "anc_silla": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Cheomseongdae_%EC%B2%A8%EC%84%B1%EB%8C%80.jpg/500px-Cheomseongdae_%EC%B2%A8%EC%84%B1%EB%8C%80.jpg",
    "c": "Photographer: Mosbatho, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cheomseongdae_%EC%B2%A8%EC%84%B1%EB%8C%80.jpg"
  },
  "anc_nara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/T%C5%8Ddai-ji_Kon-d%C5%8D.jpg/500px-T%C5%8Ddai-ji_Kon-d%C5%8D.jpg",
    "c": "Wiiii, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:T%C5%8Ddai-ji_Kon-d%C5%8D.jpg"
  },
  "anc_palenque": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Ajuar_funerario_de_Pakal_el_Grande_%28Museo_Nacional_de_Antropolog%C3%ADa%29.JPG/500px-Ajuar_funerario_de_Pakal_el_Grande_%28Museo_Nacional_de_Antropolog%C3%ADa%29.JPG",
    "c": "El Comandante, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ajuar_funerario_de_Pakal_el_Grande_(Museo_Nacional_de_Antropolog%C3%ADa).JPG"
  },
  "anc_talas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/20090822_Shanghai_Museum_3596.jpg/500px-20090822_Shanghai_Museum_3596.jpg",
    "c": "Jakub Hałun, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:20090822_Shanghai_Museum_3596.jpg"
  },
  "anc_baghdad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Abb%C4%81sid_Caliph_al-Man%E1%B9%A3%C5%ABr_from_the_genealogy_%28silsilan%C4%81ma%29%2C_Cream_of_Histories_%28Z%C3%BCbdet-%C3%BCt_Tevarih%2C_1598%29.jpg/500px-Abb%C4%81sid_Caliph_al-Man%E1%B9%A3%C5%ABr_from_the_genealogy_%28silsilan%C4%81ma%29%2C_Cream_of_Histories_%28Z%C3%BCbdet-%C3%BCt_Tevarih%2C_1598%29.jpg",
    "c": "1598 author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Abb%C4%81sid_Caliph_al-Man%E1%B9%A3%C5%ABr_from_the_genealogy_(silsilan%C4%81ma),_Cream_of_Histories_(Z%C3%BCbdet-%C3%BCt_Tevarih,_1598).jpg"
  },
  "anc_angkor": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Angkor_Wat.jpg/500px-Angkor_Wat.jpg",
    "c": "Bjørn Christian Tørrissen, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Angkor_Wat.jpg"
  },
  "anc_diamondsutra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Jingangjing.jpg/500px-Jingangjing.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jingangjing.jpg"
  },
  "anc_schism": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Hagia_Sophia_%28228968325%29.jpeg/500px-Hagia_Sophia_%28228968325%29.jpeg",
    "c": "Adli Wahid, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hagia_Sophia_(228968325).jpeg"
  },
  "anc_thanjavur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Brihadeeswarar_Kovil.jpg/500px-Brihadeeswarar_Kovil.jpg",
    "c": "Nirinsanity, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Brihadeeswarar_Kovil.jpg"
  },
  "anc_ainjalut": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/%D8%AA%D9%85%D8%AB%D8%A7%D9%84_%D9%84%D9%84%D8%B3%D9%84%D8%B7%D8%A7%D9%86_%D8%A7%D9%84%D8%B8%D8%A7%D9%87%D8%B1_%D8%A8%D9%8A%D8%A8%D8%B1%D8%B3.JPG/500px-%D8%AA%D9%85%D8%AB%D8%A7%D9%84_%D9%84%D9%84%D8%B3%D9%84%D8%B7%D8%A7%D9%86_%D8%A7%D9%84%D8%B8%D8%A7%D9%87%D8%B1_%D8%A8%D9%8A%D8%A8%D8%B1%D8%B3.JPG",
    "c": "Ahmed yousri elmamlouk, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:%D8%AA%D9%85%D8%AB%D8%A7%D9%84_%D9%84%D9%84%D8%B3%D9%84%D8%B7%D8%A7%D9%86_%D8%A7%D9%84%D8%B8%D8%A7%D9%87%D8%B1_%D8%A8%D9%8A%D8%A8%D8%B1%D8%B3.JPG"
  },
  "anc_vijayanagara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Wide_angle_of_Galigopuram_of_Virupaksha_Temple%2C_Hampi_%2804%29_%28cropped%29.jpg/500px-Wide_angle_of_Galigopuram_of_Virupaksha_Temple%2C_Hampi_%2804%29_%28cropped%29.jpg",
    "c": "iMahesh, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Wide_angle_of_Galigopuram_of_Virupaksha_Temple,_Hampi_(04)_(cropped).jpg"
  },
  "anc_tordesillas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Treaty_of_Tordesillas.jpg/500px-Treaty_of_Tordesillas.jpg",
    "c": "Original: Biblioteca Nacional de Lisboa Photo: User:Joserebelo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Treaty_of_Tordesillas.jpg"
  },
  "anc_circumnavigation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Ferdinand_Magellan.jpg/500px-Ferdinand_Magellan.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ferdinand_Magellan.jpg"
  },
  "anc_panipat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/The_battle_of_Panipat_and_the_death_of_Sultan_Ibr%C4%81h%C4%ABm%2C_the_last_of_the_L%C5%8Dd%C4%AB_Sultans_of_Delhi.jpg/500px-The_battle_of_Panipat_and_the_death_of_Sultan_Ibr%C4%81h%C4%ABm%2C_the_last_of_the_L%C5%8Dd%C4%AB_Sultans_of_Delhi.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_battle_of_Panipat_and_the_death_of_Sultan_Ibr%C4%81h%C4%ABm,_the_last_of_the_L%C5%8Dd%C4%AB_Sultans_of_Delhi.jpg"
  },
  "anc_tokugawa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Tokugawa_Ieyasu2.JPG/500px-Tokugawa_Ieyasu2.JPG",
    "c": "Kanō Tan'yū, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Tokugawa_Ieyasu2.JPG"
  },
  "anc_plassey": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Lord_Clive_meeting_with_Mir_Jafar_after_the_Battle_of_Plassey.jpg/500px-Lord_Clive_meeting_with_Mir_Jafar_after_the_Battle_of_Plassey.jpg",
    "c": "Francis Hayman, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lord_Clive_meeting_with_Mir_Jafar_after_the_Battle_of_Plassey.jpg"
  },
  "anc_ayacucho": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Batalla_de_Ayacucho_by_Mart%C3%ADn_Tovar_y_Tovar_%281827_-_1902%29.jpg/500px-Batalla_de_Ayacucho_by_Mart%C3%ADn_Tovar_y_Tovar_%281827_-_1902%29.jpg",
    "c": "Martín Tovar y Tovar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Batalla_de_Ayacucho_by_Mart%C3%ADn_Tovar_y_Tovar_(1827_-_1902).jpg"
  },
  "anc_vaccine": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Edward_Jenner.jpg/500px-Edward_Jenner.jpg",
    "c": "John Raphael Smith, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Edward_Jenner.jpg"
  },
  "anc_taiping": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Regaining_the_Provincial_City_Anqing2.jpg/500px-Regaining_the_Provincial_City_Anqing2.jpg",
    "c": "Wu Youru, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Regaining_the_Provincial_City_Anqing2.jpg"
  },
  "anc_adwa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Avanti_i_mei_alpini_Adua.jpg/500px-Avanti_i_mei_alpini_Adua.jpg",
    "c": "R. Miseno, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Avanti_i_mei_alpini_Adua.jpg"
  },
  "anc_xinhai": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Opstanden%2C_revolutie%2C_SFA022823302.jpg/500px-Opstanden%2C_revolutie%2C_SFA022823302.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Opstanden,_revolutie,_SFA022823302.jpg"
  },
  "anc_suez": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Aerial_view_of_city_of_Suez_and_Suez_Canal.jpg/500px-Aerial_view_of_city_of_Suez_and_Suez_Canal.jpg",
    "c": "Baycrest, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Aerial_view_of_city_of_Suez_and_Suez_Canal.jpg"
  },
  "anc_apartheid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Nelson_Mandela_1994.jpg/500px-Nelson_Mandela_1994.jpg",
    "c": "Kingkongphoto &amp; www.celebrity-photos.com from Laurel, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nelson_Mandela_1994.jpg"
  },
  "anc_ghana": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Kwame_Nkrumah_Portrait%2C_The_National_Archives_UK.jpg/500px-Kwame_Nkrumah_Portrait%2C_The_National_Archives_UK.jpg",
    "c": "The National Archives UK - Flickr account, OGL v1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kwame_Nkrumah_Portrait,_The_National_Archives_UK.jpg"
  },
  "anc_wannsee": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Haus_der_Wannsee-Konferenz_02-2014.jpg/500px-Haus_der_Wannsee-Konferenz_02-2014.jpg",
    "c": "A.Savin, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Haus_der_Wannsee-Konferenz_02-2014.jpg"
  },
  "anc_covid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Novel_Coronavirus_SARS-CoV-2.jpg/500px-Novel_Coronavirus_SARS-CoV-2.jpg",
    "c": "Wikimedia Commons, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Novel_Coronavirus_SARS-CoV-2.jpg"
  },
  "anc_fukushima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/SH-60B_helicopter_flies_over_Sendai.jpg/500px-SH-60B_helicopter_flies_over_Sendai.jpg",
    "c": "U.S. Navy photo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:SH-60B_helicopter_flies_over_Sendai.jpg"
  },
  "anq_newgrange": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Irelands_history.jpg/500px-Irelands_history.jpg",
    "c": "Tjp finn, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Irelands_history.jpg"
  },
  "anq_mohenjo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Mohenjodaro_-_view_of_the_stupa_mound.JPG/500px-Mohenjodaro_-_view_of_the_stupa_mound.JPG",
    "c": "Saqib Qayyum, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mohenjodaro_-_view_of_the_stupa_mound.JPG"
  },
  "anq_lothal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/The_drainage_system_at_Lothal_2.JPG/500px-The_drainage_system_at_Lothal_2.JPG",
    "c": "Abhilashdvbk, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_drainage_system_at_Lothal_2.JPG"
  },
  "anq_gilgamesh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/British_Museum_Flood_Tablet.jpg/500px-British_Museum_Flood_Tablet.jpg",
    "c": "Wikimedia Commons, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:British_Museum_Flood_Tablet.jpg"
  },
  "anq_mentuhotep": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Statue_of_Montuhotep_from_Deir_al-Bahri%2C_11th_Dynasty%2C_2065-2014_BCE%3B_Egyptian_Museum%2C_Cairo_%283%29.jpg/500px-Statue_of_Montuhotep_from_Deir_al-Bahri%2C_11th_Dynasty%2C_2065-2014_BCE%3B_Egyptian_Museum%2C_Cairo_%283%29.jpg",
    "c": "Prof. Mortel, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Statue_of_Montuhotep_from_Deir_al-Bahri,_11th_Dynasty,_2065-2014_BCE;_Egyptian_Museum,_Cairo_(3).jpg"
  },
  "anq_thera": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Ancient_Akrotiri.jpeg/500px-Ancient_Akrotiri.jpeg",
    "c": "Rt44, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ancient_Akrotiri.jpeg"
  },
  "anq_hittites_babylon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/AlacaStandarte.jpg/500px-AlacaStandarte.jpg",
    "c": "Klaus-Peter Simon, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlacaStandarte.jpg"
  },
  "anq_anyang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/20250831_Temple_of_Han_Qi_02.jpg/500px-20250831_Temple_of_Han_Qi_02.jpg",
    "c": "Windmemories, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:20250831_Temple_of_Han_Qi_02.jpg"
  },
  "anq_megiddo_1457": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Thutmose_III_at_Karnak.jpg/500px-Thutmose_III_at_Karnak.jpg",
    "c": "en:User:Markh, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thutmose_III_at_Karnak.jpg"
  },
  "anq_kadesh_treaty": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Apologie_de_Hattusili_III.jpg/500px-Apologie_de_Hattusili_III.jpg",
    "c": "Edouard d'Erasme, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Apologie_de_Hattusili_III.jpg"
  },
  "anq_troy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/Walls_of_Troy_%282%29.jpg/500px-Walls_of_Troy_%282%29.jpg",
    "c": "CherryX, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Walls_of_Troy_(2).jpg"
  },
  "anq_muye": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Early_Western_Zhou_Bronze_Gui_01.jpg/500px-Early_Western_Zhou_Bronze_Gui_01.jpg",
    "c": "Gary Lee Todd, Ph.D., CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Early_Western_Zhou_Bronze_Gui_01.jpg"
  },
  "anq_chavin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Chav%C3%ADn_de_Hu%C3%A1ntar_-_51149086708.jpg/500px-Chav%C3%ADn_de_Hu%C3%A1ntar_-_51149086708.jpg",
    "c": "Apollo⠀, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chav%C3%ADn_de_Hu%C3%A1ntar_-_51149086708.jpg"
  },
  "anq_hallstatt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Hallstatt_-_Zentrum_.JPG/500px-Hallstatt_-_Zentrum_.JPG",
    "c": "C.Stadler/Bwag, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hallstatt_-_Zentrum_.JPG"
  },
  "anq_tel_dan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/JRSLM_300116_Tel_Dan_Stele_01.jpg/500px-JRSLM_300116_Tel_Dan_Stele_01.jpg",
    "c": "Oren Rozen, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:JRSLM_300116_Tel_Dan_Stele_01.jpg"
  },
  "anq_samaria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Sargon_II%2C_Iraq_Museum_in_Baghdad.jpg/500px-Sargon_II%2C_Iraq_Museum_in_Baghdad.jpg",
    "c": "Osama Shukir Muhammed Amin FRCP(Glasg), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sargon_II,_Iraq_Museum_in_Baghdad.jpg"
  },
  "anq_pithekoussai": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Eduard_Agricola_Porto_Ischia.jpg/500px-Eduard_Agricola_Porto_Ischia.jpg",
    "c": "Eduard Agricola, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eduard_Agricola_Porto_Ischia.jpg"
  },
  "anq_babylon_689": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Sanherib-tr-4271.jpg/500px-Sanherib-tr-4271.jpg",
    "c": "Timo Roller, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sanherib-tr-4271.jpg"
  },
  "anq_psamtik": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4f/Bust_from_Statue_of_a_King_MET_EGX.358.jpeg",
    "c": "Wikimedia Commons, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Bust_from_Statue_of_a_King_MET_EGX.358.jpeg"
  },
  "anq_esarhaddon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Detail._Sam%27al_stele_of_Esarhaddon%2C_671_BCE%2C_Pergamon_Museum.jpg/500px-Detail._Sam%27al_stele_of_Esarhaddon%2C_671_BCE%2C_Pergamon_Museum.jpg",
    "c": "Osama Shukir Muhammed Amin FRCP(Glasg), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Detail._Sam%27al_stele_of_Esarhaddon,_671_BCE,_Pergamon_Museum.jpg"
  },
  "anq_draco": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Draco_engraving_from_1833_%28cropped%29.jpg/500px-Draco_engraving_from_1833_%28cropped%29.jpg",
    "c": "Max Karl Baldamus, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Draco_engraving_from_1833_(cropped).jpg"
  },
  "anq_lydian_coins": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/ae/BMC_06.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:BMC_06.jpg"
  },
  "anq_thales": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Arte_romana%2C_testa_di_talete_di_mileto%2C_II_sec..JPG/500px-Arte_romana%2C_testa_di_talete_di_mileto%2C_II_sec..JPG",
    "c": "Sailko, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Arte_romana,_testa_di_talete_di_mileto,_II_sec..JPG"
  },
  "anq_croesus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Banville_-_%C3%89sope%2C_1893.jpg/500px-Banville_-_%C3%89sope%2C_1893.jpg",
    "c": "Georges Rochegrosse, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Banville_-_%C3%89sope,_1893.jpg"
  },
  "anq_pelusium": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Meeting_Between_Cambyses_II_and_Psammetichus_III.jpg/500px-Meeting_Between_Cambyses_II_and_Psammetichus_III.jpg",
    "c": "Adrien Guignet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Meeting_Between_Cambyses_II_and_Psammetichus_III.jpg"
  },
  "anq_cleisthenes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Cleisthenes.jpg/500px-Cleisthenes.jpg",
    "c": "Unknown authorUnknown author, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Cleisthenes.jpg"
  },
  "anq_marathon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Scene_of_the_Battle_of_Marathon.jpg/500px-Scene_of_the_Battle_of_Marathon.jpg",
    "c": "John Steeple Davis, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Scene_of_the_Battle_of_Marathon.jpg"
  },
  "anq_peloponnese": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Destruction_of_the_Athenian_army_at_Syracuse.jpg/500px-Destruction_of_the_Athenian_army_at_Syracuse.jpg",
    "c": "John Steeple Davis, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Destruction_of_the_Athenian_army_at_Syracuse.jpg"
  },
  "anq_twelve_tables": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Gortys_Law_Code.jpg/500px-Gortys_Law_Code.jpg",
    "c": "Afrank99, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Gortys_Law_Code.jpg"
  },
  "anq_leuctra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Epaminondas_defending_Pelopidas.jpg/500px-Epaminondas_defending_Pelopidas.jpg",
    "c": "William Rainey, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Epaminondas_defending_Pelopidas.jpg"
  },
  "anq_via_appia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Paesaggio_dell%27Appia_antica.jpg/500px-Paesaggio_dell%27Appia_antica.jpg",
    "c": "LuisaV72, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Paesaggio_dell%27Appia_antica.jpg"
  },
  "anq_alexandria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Lighthouse_-_Thiersch.png/500px-Lighthouse_-_Thiersch.png",
    "c": "Prof. Hermann Thiersch (1874–1939), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lighthouse_-_Thiersch.png"
  },
  "anq_cannae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/The_Death_of_Paulus_Aemilius_at_the_Battle_of_Cannae_%28Yale_University_Art_Gallery_scan%29.jpg/500px-The_Death_of_Paulus_Aemilius_at_the_Battle_of_Cannae_%28Yale_University_Art_Gallery_scan%29.jpg",
    "c": "John Trumbull, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Death_of_Paulus_Aemilius_at_the_Battle_of_Cannae_(Yale_University_Art_Gallery_scan).jpg"
  },
  "anq_punic1": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/Corvus_%C3%A4nterbrygga.png/500px-Corvus_%C3%A4nterbrygga.png",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Corvus_%C3%A4nterbrygga.png"
  },
  "anq_maccabees": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Antiochus_IV_Epiphanes_-_Altes_Museum_-_Berlin_-_Germany_2017.jpg/500px-Antiochus_IV_Epiphanes_-_Altes_Museum_-_Berlin_-_Germany_2017.jpg",
    "c": "José Luiz, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Antiochus_IV_Epiphanes_-_Altes_Museum_-_Berlin_-_Germany_2017.jpg"
  },
  "anq_zhang_qian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/ZhangQianTravels.jpg/500px-ZhangQianTravels.jpg",
    "c": "PHG, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:ZhangQianTravels.jpg"
  },
  "anq_carrhae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Bust_of_an_unknown_citizen_in_the_realist_republican_tradition_%28Louvre_MR_510%29.jpg/500px-Bust_of_an_unknown_citizen_in_the_realist_republican_tradition_%28Louvre_MR_510%29.jpg",
    "c": "UnknownUnknown, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bust_of_an_unknown_citizen_in_the_realist_republican_tradition_(Louvre_MR_510).jpg"
  },
  "anq_aeneid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Virgil_mosaic_in_the_Bardo_National_Museum_%28Tunis%29_%2812241228546%29.jpg/500px-Virgil_mosaic_in_the_Bardo_National_Museum_%28Tunis%29_%2812241228546%29.jpg",
    "c": "Boyd Dwyer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Virgil_mosaic_in_the_Bardo_National_Museum_(Tunis)_(12241228546).jpg"
  },
  "anq_claudius_britain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Claudius_crop.jpg/500px-Claudius_crop.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Claudius_crop.jpg"
  },
  "anq_dacia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Separation_of_the_two_Dacian_Wars_on_Trajan%27s_Column.jpg/500px-Separation_of_the_two_Dacian_Wars_on_Trajan%27s_Column.jpg",
    "c": "Carole Raddato, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Separation_of_the_two_Dacian_Wars_on_Trajan%27s_Column.jpg"
  },
  "anq_zhang_heng": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/20251004_Tomb_of_Zhang_Heng_03.jpg/500px-20251004_Tomb_of_Zhang_Heng_03.jpg",
    "c": "Windmemories, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:20251004_Tomb_of_Zhang_Heng_03.jpg"
  },
  "anq_antoniniana": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/0_Caracalla_-_Museo_Massimo_alle_Terme.JPG/500px-0_Caracalla_-_Museo_Massimo_alle_Terme.JPG",
    "c": "Jean-Pol GRANDMONT, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:0_Caracalla_-_Museo_Massimo_alle_Terme.JPG"
  },
  "anq_tikal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/CPN_ST_B_01.jpg/500px-CPN_ST_B_01.jpg",
    "c": "Talk2winik, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:CPN_ST_B_01.jpg"
  },
  "anq_ardashir": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Ardashir_i%27s_relief_at_Firuzabad%2C_Fars%2C_Iran.JPG/500px-Ardashir_i%27s_relief_at_Firuzabad%2C_Fars%2C_Iran.JPG",
    "c": "Milad Vandaee (میلاد وندائی), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ardashir_i%27s_relief_at_Firuzabad,_Fars,_Iran.JPG"
  },
  "anq_armenia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Gregory_the_Illuminator_mosaic_on_Pammakaristos_Church_in_Constantinople.jpg/500px-Gregory_the_Illuminator_mosaic_on_Pammakaristos_Church_in_Constantinople.jpg",
    "c": "G.dallorto, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Gregory_the_Illuminator_mosaic_on_Pammakaristos_Church_in_Constantinople.jpg"
  },
  "anq_thessalonica": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Nicaea_icon.jpg/500px-Nicaea_icon.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nicaea_icon.jpg"
  },
  "anq_faxian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Faxian_statue_in_Maritime_Experiential_Museum_%26_Aquarium_Singapore.jpg/500px-Faxian_statue_in_Maritime_Experiential_Museum_%26_Aquarium_Singapore.jpg",
    "c": "Ms Sarah Welch, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Faxian_statue_in_Maritime_Experiential_Museum_%26_Aquarium_Singapore.jpg"
  },
  "anq_hypatia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Chora-Kirche_2013-03-21zh_%28cropped%29.jpg/500px-Chora-Kirche_2013-03-21zh_%28cropped%29.jpg",
    "c": "Rabe!, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chora-Kirche_2013-03-21zh_(cropped).jpg"
  },
  "anq_catalaunian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Thur%C3%B3czy_kr%C3%B3nika_-_Attila_kir%C3%A1ly_csat%C3%A1ja_a_catalaunumi_s%C3%ADkon.jpg/500px-Thur%C3%B3czy_kr%C3%B3nika_-_Attila_kir%C3%A1ly_csat%C3%A1ja_a_catalaunumi_s%C3%ADkon.jpg",
    "c": "Johannes de Thurocz, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thur%C3%B3czy_kr%C3%B3nika_-_Attila_kir%C3%A1ly_csat%C3%A1ja_a_catalaunumi_s%C3%ADkon.jpg"
  },
  "anq_luoyang_move": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Longmen_Grottoes_3.jpg/500px-Longmen_Grottoes_3.jpg",
    "c": "Rialfver Original uploader was Rialfver at nl.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Longmen_Grottoes_3.jpg"
  },
  "med_augustine": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Statue_Ethelbert_jub%C3%A9_Rochester_%283x4_cropped%29.jpg/500px-Statue_Ethelbert_jub%C3%A9_Rochester_%283x4_cropped%29.jpg",
    "c": "Giogo, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Statue_Ethelbert_jub%C3%A9_Rochester_(3x4_cropped).jpg"
  },
  "med_covadonga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/De_Heilige_grot_van_Covadonga.jpg/500px-De_Heilige_grot_van_Covadonga.jpg",
    "c": "Coralma*, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:De_Heilige_grot_van_Covadonga.jpg"
  },
  "med_lindisfarne": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Viking_attack_on_Gu%C3%A9rande%2C_from_a_Saint-Aubin_MS.jpg/500px-Viking_attack_on_Gu%C3%A9rande%2C_from_a_Saint-Aubin_MS.jpg",
    "c": "Abbey of Saint-Aubin, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Viking_attack_on_Gu%C3%A9rande,_from_a_Saint-Aubin_MS.jpg"
  },
  "med_iceland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Ingolf_by_Raadsig.jpg/500px-Ingolf_by_Raadsig.jpg",
    "c": "Johan Peter Raadsig (1806 - 1882), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ingolf_by_Raadsig.jpg"
  },
  "med_cyrilmethodius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/75/Sv_Kiril_Metodij_Zahari_Zograf_Trojanski_mon_1848.jpg",
    "c": "painted by Zahari Zograf (Захарий Христович Димитров), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sv_Kiril_Metodij_Zahari_Zograf_Trojanski_mon_1848.jpg"
  },
  "med_makuria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Abu_oda_painting.jpg/500px-Abu_oda_painting.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Abu_oda_painting.jpg"
  },
  "med_sind": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/A_wide_angle_picture_of_Muhammad_Bin_Qasim_Masjid.jpg/500px-A_wide_angle_picture_of_Muhammad_Bin_Qasim_Masjid.jpg",
    "c": "Usman.pg, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:A_wide_angle_picture_of_Muhammad_Bin_Qasim_Masjid.jpg"
  },
  "med_baghdad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Abb%C4%81sid_Caliph_al-Man%E1%B9%A3%C5%ABr_from_the_genealogy_%28silsilan%C4%81ma%29%2C_Cream_of_Histories_%28Z%C3%BCbdet-%C3%BCt_Tevarih%2C_1598%29.jpg/500px-Abb%C4%81sid_Caliph_al-Man%E1%B9%A3%C5%ABr_from_the_genealogy_%28silsilan%C4%81ma%29%2C_Cream_of_Histories_%28Z%C3%BCbdet-%C3%BCt_Tevarih%2C_1598%29.jpg",
    "c": "1598 author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Abb%C4%81sid_Caliph_al-Man%E1%B9%A3%C5%ABr_from_the_genealogy_(silsilan%C4%81ma),_Cream_of_Histories_(Z%C3%BCbdet-%C3%BCt_Tevarih,_1598).jpg"
  },
  "med_saadia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Guide_for_the_Perplexed_by_Maimonides.jpg/500px-Guide_for_the_Perplexed_by_Maimonides.jpg",
    "c": "Moshe ben Maimon, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Guide_for_the_Perplexed_by_Maimonides.jpg"
  },
  "med_cordoba929": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Salon_Rico_1.jpg/500px-Salon_Rico_1.jpg",
    "c": "Justojosemm, GFDL",
    "p": "https://commons.wikimedia.org/wiki/File:Salon_Rico_1.jpg"
  },
  "med_basil": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Basilios_II.jpg/500px-Basilios_II.jpg",
    "c": "from the Middle Ages, unknown, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Basilios_II.jpg"
  },
  "med_norwich": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Norwich_Cathedral_-_panoramio_%285%29.jpg/500px-Norwich_Cathedral_-_panoramio_%285%29.jpg",
    "c": "Tanya Dedyukhina, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Norwich_Cathedral_-_panoramio_(5).jpg"
  },
  "med_somnath": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Somanath_mandir_%28cropped%29.jpg/500px-Somanath_mandir_%28cropped%29.jpg",
    "c": "B. SurajPatro1997, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Somanath_mandir_(cropped).jpg"
  },
  "med_grandcanal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Gcjiangnan1.JPG/500px-Gcjiangnan1.JPG",
    "c": "Tomtom08 at en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gcjiangnan1.JPG"
  },
  "med_wuzetian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Longmen_Grottoes_3.jpg/500px-Longmen_Grottoes_3.jpg",
    "c": "Rialfver Original uploader was Rialfver at nl.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Longmen_Grottoes_3.jpg"
  },
  "med_songfound": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Song_Taizu.jpg/500px-Song_Taizu.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Song_Taizu.jpg"
  },
  "med_buddhismjapan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/7th_century_Tang_dynasty_painting_of_envoys_from_the_from_Baekje.jpg/500px-7th_century_Tang_dynasty_painting_of_envoys_from_the_from_Baekje.jpg",
    "c": "Unknown authorUnknown author (Life time: Tang dynasty (618–907)), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:7th_century_Tang_dynasty_painting_of_envoys_from_the_from_Baekje.jpg"
  },
  "med_danoura": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Battle-of-Akama-Strait-at-Dan-no-Ura-in-Choshu-1185.png/500px-Battle-of-Akama-Strait-at-Dan-no-Ura-in-Choshu-1185.png",
    "c": "Utagawa Sadahide (aka Gountei Sadahide, 五雲亭 貞秀), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle-of-Akama-Strait-at-Dan-no-Ura-in-Choshu-1185.png"
  },
  "med_gokturk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Kultigin_Monument_of_Orkhon_Inscriptions.jpeg/500px-Kultigin_Monument_of_Orkhon_Inscriptions.jpeg",
    "c": "Vezirtonyukuk, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kultigin_Monument_of_Orkhon_Inscriptions.jpeg"
  },
  "med_pakal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/K%27inich_Janaab_Pakal_I_v2.jpg/500px-K%27inich_Janaab_Pakal_I_v2.jpg",
    "c": "K'inich_Janaab_Pakal_I.jpg: Jami Dwyer derivative work: Simon Burchell (talk), CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:K%27inich_Janaab_Pakal_I_v2.jpg"
  },
  "med_cahokia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Monks_Mound_in_July.JPG/500px-Monks_Mound_in_July.JPG",
    "c": "Skubasteve834, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Monks_Mound_in_July.JPG"
  },
  "med_jokyu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Emperor_Go-Toba.jpg/500px-Emperor_Go-Toba.jpg",
    "c": "Fujiwara no Nobuzane, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Emperor_Go-Toba.jpg"
  },
  "med_sundiata": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Balafoon.jpg/500px-Balafoon.jpg",
    "c": "Redmedea at Dutch Wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Balafoon.jpg"
  },
  "med_ain_jalut": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/%D8%AA%D9%85%D8%AB%D8%A7%D9%84_%D9%84%D9%84%D8%B3%D9%84%D8%B7%D8%A7%D9%86_%D8%A7%D9%84%D8%B8%D8%A7%D9%87%D8%B1_%D8%A8%D9%8A%D8%A8%D8%B1%D8%B3.JPG/500px-%D8%AA%D9%85%D8%AB%D8%A7%D9%84_%D9%84%D9%84%D8%B3%D9%84%D8%B7%D8%A7%D9%86_%D8%A7%D9%84%D8%B8%D8%A7%D9%87%D8%B1_%D8%A8%D9%8A%D8%A8%D8%B1%D8%B3.JPG",
    "c": "Ahmed yousri elmamlouk, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:%D8%AA%D9%85%D8%AB%D8%A7%D9%84_%D9%84%D9%84%D8%B3%D9%84%D8%B7%D8%A7%D9%86_%D8%A7%D9%84%D8%B8%D8%A7%D9%87%D8%B1_%D8%A8%D9%8A%D8%A8%D8%B1%D8%B3.JPG"
  },
  "med_england_jews": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Edward_I_-_Westminster_Abbey_Sedilia.jpg/500px-Edward_I_-_Westminster_Abbey_Sedilia.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Edward_I_-_Westminster_Abbey_Sedilia.jpg"
  },
  "med_rumi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/%D9%85%D9%88%D9%84%D8%A7%D9%86%D8%A7_%D8%A7%D8%AB%D8%B1_%D8%AD%D8%B3%DB%8C%D9%86_%D8%A8%D9%87%D8%B2%D8%A7%D8%AF_%28cropped%29.jpg/500px-%D9%85%D9%88%D9%84%D8%A7%D9%86%D8%A7_%D8%A7%D8%AB%D8%B1_%D8%AD%D8%B3%DB%8C%D9%86_%D8%A8%D9%87%D8%B2%D8%A7%D8%AF_%28cropped%29.jpg",
    "c": "Hossein Behzad, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%D9%85%D9%88%D9%84%D8%A7%D9%86%D8%A7_%D8%A7%D8%AB%D8%B1_%D8%AD%D8%B3%DB%8C%D9%86_%D8%A8%D9%87%D8%B2%D8%A7%D8%AF_(cropped).jpg"
  },
  "med_mansa_musa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Catalan_Atlas_BNF_Sheet_6_Mansa_Musa_%28cropped%29.jpg/500px-Catalan_Atlas_BNF_Sheet_6_Mansa_Musa_%28cropped%29.jpg",
    "c": "attributed to Abraham Cresques, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Catalan_Atlas_BNF_Sheet_6_Mansa_Musa_(cropped).jpg"
  },
  "med_jews_1391": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Esgl%C3%A9sia_de_Monti-sion_de_Palma.jpg/500px-Esgl%C3%A9sia_de_Monti-sion_de_Palma.jpg",
    "c": "Drozi Yarka, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Esgl%C3%A9sia_de_Monti-sion_de_Palma.jpg"
  },
  "med_ming": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Portrait_assis_de_l%27empereur_Ming_Taizu.jpg/500px-Portrait_assis_de_l%27empereur_Ming_Taizu.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_assis_de_l%27empereur_Ming_Taizu.jpg"
  },
  "med_ankara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Timur_reconstruction03.jpg/500px-Timur_reconstruction03.jpg",
    "c": "user:shakko, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Timur_reconstruction03.jpg"
  },
  "med_joan_of_arc": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Albert_Lynch_-_Jeanne_d%27Arc.png/500px-Albert_Lynch_-_Jeanne_d%27Arc.png",
    "c": "Albert Lynch, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Albert_Lynch_-_Jeanne_d%27Arc.png"
  },
  "med_lagos_slaves": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Henry_the_Navigator1.jpg/500px-Henry_the_Navigator1.jpg",
    "c": "Nuno Gonçalves, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Henry_the_Navigator1.jpg"
  },
  "med_kongo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/be/Manikongo.jpg",
    "c": "Affricoll9, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Manikongo.jpg"
  },
  "med_kilwa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Ruins_of_Kilwa_Kisiwani_and_Ruins_of_Songo_Mnara-108279.jpg/500px-Ruins_of_Kilwa_Kisiwani_and_Ruins_of_Songo_Mnara-108279.jpg",
    "c": "Ron Van Oers, CC BY-SA 3.0 igo",
    "p": "https://commons.wikimedia.org/wiki/File:Ruins_of_Kilwa_Kisiwani_and_Ruins_of_Songo_Mnara-108279.jpg"
  },
  "med_ottoman_egypt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Nakka%C5%9F_Selim.jpg/500px-Nakka%C5%9F_Selim.jpg",
    "c": "Naḳḳāş ʿOs̠mān, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nakka%C5%9F_Selim.jpg"
  },
  "med_pizarro": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/La_Captura_de_Atahualpa_-_Juan_Lepiani_1920s.png/500px-La_Captura_de_Atahualpa_-_Juan_Lepiani_1920s.png",
    "c": "Juan Lepiani, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:La_Captura_de_Atahualpa_-_Juan_Lepiani_1920s.png"
  },
  "med_trent": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Concilio_Trento_Museo_Buonconsiglio.jpg/500px-Concilio_Trento_Museo_Buonconsiglio.jpg",
    "c": "Laurom, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Concilio_Trento_Museo_Buonconsiglio.jpg"
  },
  "med_bartholomew": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/La_masacre_de_San_Bartolom%C3%A9%2C_por_Fran%C3%A7ois_Dubois.jpg/500px-La_masacre_de_San_Bartolom%C3%A9%2C_por_Fran%C3%A7ois_Dubois.jpg",
    "c": "François Dubois 1529-1584, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:La_masacre_de_San_Bartolom%C3%A9,_por_Fran%C3%A7ois_Dubois.jpg"
  },
  "mod_aurangzeb": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/%27Jujhar_Singh_Bundela_Kneels_in_Submission_to_Shah_Jahan%27%2C_painted_by_Bichitr%2C_c._1630%2C_Chester_Beatty_Library_%28cropped2%29.jpg/500px-%27Jujhar_Singh_Bundela_Kneels_in_Submission_to_Shah_Jahan%27%2C_painted_by_Bichitr%2C_c._1630%2C_Chester_Beatty_Library_%28cropped2%29.jpg",
    "c": "Bichitr, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%27Jujhar_Singh_Bundela_Kneels_in_Submission_to_Shah_Jahan%27,_painted_by_Bichitr,_c._1630,_Chester_Beatty_Library_(cropped2).jpg"
  },
  "med_qing": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/%E6%B8%85%E4%B8%96%E7%A5%96%E9%A1%BA%E6%B2%BB%E7%9A%87%E5%B8%9D%E6%9C%9D%E6%9C%8D%E5%83%8F.jpg/500px-%E6%B8%85%E4%B8%96%E7%A5%96%E9%A1%BA%E6%B2%BB%E7%9A%87%E5%B8%9D%E6%9C%9D%E6%9C%8D%E5%83%8F.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%E6%B8%85%E4%B8%96%E7%A5%96%E9%A1%BA%E6%B2%BB%E7%9A%87%E5%B8%9D%E6%9C%9D%E6%9C%8D%E5%83%8F.jpg"
  },
  "mod_glorious": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/King_William_III_of_England%2C_%281650-1702%29.jpg/500px-King_William_III_of_England%2C_%281650-1702%29.jpg",
    "c": "Godfrey Kneller, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:King_William_III_of_England,_(1650-1702).jpg"
  },
  "mod_plassey": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Lord_Clive_meeting_with_Mir_Jafar_after_the_Battle_of_Plassey.jpg/500px-Lord_Clive_meeting_with_Mir_Jafar_after_the_Battle_of_Plassey.jpg",
    "c": "Francis Hayman, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lord_Clive_meeting_with_Mir_Jafar_after_the_Battle_of_Plassey.jpg"
  },
  "mod_pugachev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Pugachev.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 709
  },
  "mod_yorktown": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Surrender_of_Lord_Cornwallis.jpg/500px-Surrender_of_Lord_Cornwallis.jpg",
    "c": "John Trumbull, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Surrender_of_Lord_Cornwallis.jpg"
  },
  "mod_bastille": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Anonymous_-_Prise_de_la_Bastille.jpg/500px-Anonymous_-_Prise_de_la_Bastille.jpg",
    "c": "Unidentified painter, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Anonymous_-_Prise_de_la_Bastille.jpg"
  },
  "mod_pyramids": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Francois-Louis-Joseph_Watteau_001.jpg/500px-Francois-Louis-Joseph_Watteau_001.jpg",
    "c": "François-Louis-Joseph Watteau, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Francois-Louis-Joseph_Watteau_001.jpg"
  },
  "mod_louisiana": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Official_Presidential_portrait_of_Thomas_Jefferson_%28by_Rembrandt_Peale%2C_1800%29.jpg/500px-Official_Presidential_portrait_of_Thomas_Jefferson_%28by_Rembrandt_Peale%2C_1800%29.jpg",
    "c": "Rembrandt Peale, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Official_Presidential_portrait_of_Thomas_Jefferson_(by_Rembrandt_Peale,_1800).jpg"
  },
  "mod_dosdemayo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/El_dos_de_mayo_de_1808_en_Madrid.jpg/500px-El_dos_de_mayo_de_1808_en_Madrid.jpg",
    "c": "Francisco Goya, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:El_dos_de_mayo_de_1808_en_Madrid.jpg"
  },
  "mod_tambora": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Mount_Tambora_Volcano%2C_Sumbawa_Island%2C_Indonesia.jpg/500px-Mount_Tambora_Volcano%2C_Sumbawa_Island%2C_Indonesia.jpg",
    "c": "This image was taken by the NASA Expedition 20 crew., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mount_Tambora_Volcano,_Sumbawa_Island,_Indonesia.jpg"
  },
  "mod_stockton": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/First_passenger_railway_1830.jpg/500px-First_passenger_railway_1830.jpg",
    "c": "Tolnai - korabeli képek alapján, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:First_passenger_railway_1830.jpg"
  },
  "mod_greekrevolt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/75/Alexandros_Ypsilantis_by_Hess.jpg",
    "c": "Peter von Hess, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Alexandros_Ypsilantis_by_Hess.jpg"
  },
  "mod_slavery1833": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/William_wilberforce.jpg/500px-William_wilberforce.jpg",
    "c": "Anton Hickel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:William_wilberforce.jpg"
  },
  "mod_tanzimat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Edict_of_G%C3%BClhane.jpg/500px-Edict_of_G%C3%BClhane.jpg",
    "c": "Maldek™, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Edict_of_G%C3%BClhane.jpg"
  },
  "mod_waitangi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Te_whare_runanga.jpg/500px-Te_whare_runanga.jpg",
    "c": "Vanderven, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Te_whare_runanga.jpg"
  },
  "mod_sevastopol": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Panorama_dentro.JPG/500px-Panorama_dentro.JPG",
    "c": "Valentin Ramirez, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Panorama_dentro.JPG"
  },
  "mod_garibaldi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Partenza_da_Quarto.jpg/500px-Partenza_da_Quarto.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Partenza_da_Quarto.jpg"
  },
  "mod_guadalupe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Nebel_Mexican_War_12_Scott_in_Mexico_City_%28cropped%29.jpg/500px-Nebel_Mexican_War_12_Scott_in_Mexico_City_%28cropped%29.jpg",
    "c": "Adolphe Jean-Baptiste Bayot / Carl Nebel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nebel_Mexican_War_12_Scott_in_Mexico_City_(cropped).jpg"
  },
  "mod_alaska": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/AleutianManWoman.jpg/500px-AleutianManWoman.jpg",
    "c": "Густав-Федор Христианович Паули, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:AleutianManWoman.jpg"
  },
  "mod_serfs": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Reading_of_the_Manifest_%28Liberation_of_peasants%29_-_Kustodiev%2C_1907.jpg/500px-Reading_of_the_Manifest_%28Liberation_of_peasants%29_-_Kustodiev%2C_1907.jpg",
    "c": "Boris Kustodiev, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Reading_of_the_Manifest_(Liberation_of_peasants)_-_Kustodiev,_1907.jpg"
  },
  "mod_railroad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/East_and_West_Shaking_hands_at_the_laying_of_last_rail_Union_Pacific_Railroad_-_Restoration.jpg/500px-East_and_West_Shaking_hands_at_the_laying_of_last_rail_Union_Pacific_Railroad_-_Restoration.jpg",
    "c": "Andrew J. Russell / Adam Cuerden, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:East_and_West_Shaking_hands_at_the_laying_of_last_rail_Union_Pacific_Railroad_-_Restoration.jpg"
  },
  "mod_reich": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/A_v_Werner_-_Kaiserproklamation_am_18_Januar_1871_%283._Fassung_1885%29.jpg/500px-A_v_Werner_-_Kaiserproklamation_am_18_Januar_1871_%283._Fassung_1885%29.jpg",
    "c": "Anton von Werner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_v_Werner_-_Kaiserproklamation_am_18_Januar_1871_(3._Fassung_1885).jpg"
  },
  "poland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/The_Nazi-soviet_Invasion_of_Poland%2C_1939_HU106374.jpg/500px-The_Nazi-soviet_Invasion_of_Poland%2C_1939_HU106374.jpg",
    "c": "Associated Press photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Nazi-soviet_Invasion_of_Poland,_1939_HU106374.jpg"
  },
  "mod_holodomor": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/HolodomorKharkiv_1933_Wienerberger.jpg/500px-HolodomorKharkiv_1933_Wienerberger.jpg",
    "c": "Alexander Wienerberger, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:HolodomorKharkiv_1933_Wienerberger.jpg"
  },
  "mod_barbarossa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Bundesarchiv_Bild_101I-009-0882-04%2C_Russland-Nord%2C_Vormarsch_durch_Lettland.jpg/500px-Bundesarchiv_Bild_101I-009-0882-04%2C_Russland-Nord%2C_Vormarsch_durch_Lettland.jpg",
    "c": "Schröter, CC BY-SA 3.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_101I-009-0882-04,_Russland-Nord,_Vormarsch_durch_Lettland.jpg"
  },
  "mod_hungary": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Imre_Nagy_portrait.jpg/500px-Imre_Nagy_portrait.jpg",
    "c": "ismeretlen szerző(Nagy Imre Emlékház tulajdona), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Imre_Nagy_portrait.jpg"
  },
  "mod_wall_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/West_and_East_Germans_at_the_Brandenburg_Gate_in_1989.jpg/500px-West_and_East_Germans_at_the_Brandenburg_Gate_in_1989.jpg",
    "c": "Unknown photographer, Reproduction by Lear 21 at English Wikipedia., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:West_and_East_Germans_at_the_Brandenburg_Gate_in_1989.jpg"
  },
  "mod_srebrenica": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Srebrenica_massacre_memorial_gravestones_2009_1.jpg/500px-Srebrenica_massacre_memorial_gravestones_2009_1.jpg",
    "c": "Michael Büker, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Srebrenica_massacre_memorial_gravestones_2009_1.jpg"
  },
  "mod_indonesia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Indonesia_declaration_of_independence_17_August_1945.jpg/500px-Indonesia_declaration_of_independence_17_August_1945.jpg",
    "c": "Frans Mendur (also Frans Mendoer) (1913 – 1971), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Indonesia_declaration_of_independence_17_August_1945.jpg"
  },
  "mod_long_march": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/01/1938_Mao_Zedong_Zhang_Guotao_in_Yan%27an.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1938_Mao_Zedong_Zhang_Guotao_in_Yan%27an.jpg"
  },
  "mod_saigon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/South_Vietnamese_helicopter_is_pushed_over_the_side_of_the_USS_Okinawa_during_Operation_Frequent_Wind%2C_April_1975.jpg/500px-South_Vietnamese_helicopter_is_pushed_over_the_side_of_the_USS_Okinawa_during_Operation_Frequent_Wind%2C_April_1975.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:South_Vietnamese_helicopter_is_pushed_over_the_side_of_the_USS_Okinawa_during_Operation_Frequent_Wind,_April_1975.jpg"
  },
  "mod_dien_bien_phu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Victory_in_Battle_of_Dien_Bien_Phu.jpg/500px-Victory_in_Battle_of_Dien_Bien_Phu.jpg",
    "c": "Vietnam People's Army, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Victory_in_Battle_of_Dien_Bien_Phu.jpg"
  },
  "mod_afghanistan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Mortar_attack_on_Shigal_Tarna_garrison%2C_Kunar_Province%2C_87.jpg/500px-Mortar_attack_on_Shigal_Tarna_garrison%2C_Kunar_Province%2C_87.jpg",
    "c": "erwinlux, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mortar_attack_on_Shigal_Tarna_garrison,_Kunar_Province,_87.jpg"
  },
  "mod_berlin_conf": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Kongokonferenz.jpg/500px-Kongokonferenz.jpg",
    "c": "Adalbert von Roessler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kongokonferenz.jpg"
  },
  "mod_tunisia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Tunisian_Revolution_Protest.jpg/500px-Tunisian_Revolution_Protest.jpg",
    "c": "cjb, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tunisian_Revolution_Protest.jpg"
  },
  "mod_suez_2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Port_Said_from_air.jpg/500px-Port_Said_from_air.jpg",
    "c": "Fleet Air Arm official photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Port_Said_from_air.jpg"
  },
  "mod_gulf_war": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/USAF_F-16A_F-15C_F-15E_Desert_Storm_edit2.jpg/500px-USAF_F-16A_F-15C_F-15E_Desert_Storm_edit2.jpg",
    "c": "US Air Force, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:USAF_F-16A_F-15C_F-15E_Desert_Storm_edit2.jpg"
  },
  "mod_yom_kippur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Egyptianbridge.jpg/500px-Egyptianbridge.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Egyptianbridge.jpg"
  },
  "mod_nz_suffrage": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Kate_Sheppard.jpg/500px-Kate_Sheppard.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kate_Sheppard.jpg"
  },
  "mod_mabo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Murray_Islands_%28Landsat%29.png/500px-Murray_Islands_%28Landsat%29.png",
    "c": "NASA, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Murray_Islands_(Landsat).png"
  },
  "anc_erlitou": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/20240815_Erlitou_Site_05.jpg/500px-20240815_Erlitou_Site_05.jpg",
    "c": "Windmemories, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:20240815_Erlitou_Site_05.jpg"
  },
  "anc_chavin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Chav%C3%ADn_de_Hu%C3%A1ntar_-_51149086708.jpg/500px-Chav%C3%ADn_de_Hu%C3%A1ntar_-_51149086708.jpg",
    "c": "Apollo⠀, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chav%C3%ADn_de_Hu%C3%A1ntar_-_51149086708.jpg"
  },
  "anc_olympics": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/GR-olympia-palaestra.jpg/500px-GR-olympia-palaestra.jpg",
    "c": "Bgabel, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:GR-olympia-palaestra.jpg"
  },
  "anc_necho": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Necho-KnellingStatue_BrooklynMuseum.png/500px-Necho-KnellingStatue_BrooklynMuseum.png",
    "c": "Keith Schengili-Roberts, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Necho-KnellingStatue_BrooklynMuseum.png"
  },
  "anc_republic": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/51/M._Junius_Brutus%2C_denarius%2C_54_BC%2C_RRC_433-2_%28obverse_L._Junius%29.jpg",
    "c": "CNG, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:M._Junius_Brutus,_denarius,_54_BC,_RRC_433-2_(obverse_L._Junius).jpg"
  },
  "anc_twelvetables": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Foro_Romano_Musei_Capitolini_Roma.jpg/500px-Foro_Romano_Musei_Capitolini_Roma.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Foro_Romano_Musei_Capitolini_Roma.jpg"
  },
  "marathon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Scene_of_the_Battle_of_Marathon.jpg/500px-Scene_of_the_Battle_of_Marathon.jpg",
    "c": "John Steeple Davis, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Scene_of_the_Battle_of_Marathon.jpg"
  },
  "anc_alexdeath": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Alexander_Mosaic_detail_of_Alexander_the_Great_%283x4_cropped%29.jpg/500px-Alexander_Mosaic_detail_of_Alexander_the_Great_%283x4_cropped%29.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Alexander_Mosaic_detail_of_Alexander_the_Great_(3x4_cropped).jpg"
  },
  "anc_ashoka": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Ashoka_Lauriya_Areraj_inscription.jpg/500px-Ashoka_Lauriya_Areraj_inscription.jpg",
    "c": "Sachin kumar tiwary, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ashoka_Lauriya_Areraj_inscription.jpg"
  },
  "anc_vesuvius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Destruction_of_Pompeii_and_Herculaneum.jpg/500px-Destruction_of_Pompeii_and_Herculaneum.jpg",
    "c": "John Martin, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Destruction_of_Pompeii_and_Herculaneum.jpg"
  },
  "anc_paper": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/be/Cai-lun.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cai-lun.jpg"
  },
  "anc_gupta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/SamudraguptaCoin.png/500px-SamudraguptaCoin.png",
    "c": "PHGCOM, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:SamudraguptaCoin.png"
  },
  "anc_attila": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Thur%C3%B3czy_kr%C3%B3nika_-_Attila_kir%C3%A1ly_csat%C3%A1ja_a_catalaunumi_s%C3%ADkon.jpg/500px-Thur%C3%B3czy_kr%C3%B3nika_-_Attila_kir%C3%A1ly_csat%C3%A1ja_a_catalaunumi_s%C3%ADkon.jpg",
    "c": "Johannes de Thurocz, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thur%C3%B3czy_kr%C3%B3nika_-_Attila_kir%C3%A1ly_csat%C3%A1ja_a_catalaunumi_s%C3%ADkon.jpg"
  },
  "anc_justinianplague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Plaguet03.jpg/500px-Plaguet03.jpg",
    "c": "Josse Lieferinxe, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Plaguet03.jpg"
  },
  "anc_tang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/TangGaozu.jpg/500px-TangGaozu.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:TangGaozu.jpg"
  },
  "anc_xuanzang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Xuanzang_w.jpg/500px-Xuanzang_w.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Xuanzang_w.jpg"
  },
  "anc_uthman": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Birmingham_Quran_manuscript_full.jpg/500px-Birmingham_Quran_manuscript_full.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Birmingham_Quran_manuscript_full.jpg"
  },
  "anc_karbala": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Brooklyn_Museum_-_Battle_of_Karbala_-_Abbas_Al-Musavi_-_cropped.jpg/500px-Brooklyn_Museum_-_Battle_of_Karbala_-_Abbas_Al-Musavi_-_cropped.jpg",
    "c": "Persian Painter Abbas Al-Musavi., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Brooklyn_Museum_-_Battle_of_Karbala_-_Abbas_Al-Musavi_-_cropped.jpg"
  },
  "anc_srivijaya": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Prasasti_Kedukan_Bukit_3.jpg/500px-Prasasti_Kedukan_Bukit_3.jpg",
    "c": "Gunawan Kartapranata, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Prasasti_Kedukan_Bukit_3.jpg"
  },
  "anc_tours": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Steuben_-_Bataille_de_Poitiers.png/500px-Steuben_-_Bataille_de_Poitiers.png",
    "c": "Charles de Steuben, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Steuben_-_Bataille_de_Poitiers.png"
  },
  "anc_nestorian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/An_epitaph_of_a_Nestorian_Christian.jpg/500px-An_epitaph_of_a_Nestorian_Christian.jpg",
    "c": "Baomi, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:An_epitaph_of_a_Nestorian_Christian.jpg"
  },
  "anc_khwarizmi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Madrid_-_Ciudad_Universitaria%2C_Monumento_a_Muhammad_al-Juarismi_%28cropped%29.jpg/500px-Madrid_-_Ciudad_Universitaria%2C_Monumento_a_Muhammad_al-Juarismi_%28cropped%29.jpg",
    "c": "Zarateman, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Madrid_-_Ciudad_Universitaria,_Monumento_a_Muhammad_al-Juarismi_(cropped).jpg"
  },
  "anc_safavid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Shah_Ismail_I_Safavid%2C_Behzad.jpg/500px-Shah_Ismail_I_Safavid%2C_Behzad.jpg",
    "c": "Kamāl ud-Dīn Behzād, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Shah_Ismail_I_Safavid,_Behzad.jpg"
  },
  "anc_cajamarca": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/La_Captura_de_Atahualpa_-_Juan_Lepiani_1920s.png/500px-La_Captura_de_Atahualpa_-_Juan_Lepiani_1920s.png",
    "c": "Juan Lepiani, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:La_Captura_de_Atahualpa_-_Juan_Lepiani_1920s.png"
  },
  "anc_tanegashima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/PS8004046.jpg/500px-PS8004046.jpg",
    "c": "Rainer Halama, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:PS8004046.jpg"
  },
  "anc_slavery1619": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/1639_Jamestown_Church_%282883847775%29.jpg/500px-1639_Jamestown_Church_%282883847775%29.jpg",
    "c": "Tony Fischer, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:1639_Jamestown_Church_(2883847775).jpg"
  },
  "anc_haiti": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Le_g%C3%A9n%C3%A9ral_Toussaint_L%27Ouverture_recevant_le_g%C3%A9n%C3%A9ral_anglais_Thomas_Maitland_le_30_mars_1798_%28cropped%29.jpg/500px-Le_g%C3%A9n%C3%A9ral_Toussaint_L%27Ouverture_recevant_le_g%C3%A9n%C3%A9ral_anglais_Thomas_Maitland_le_30_mars_1798_%28cropped%29.jpg",
    "c": "François Grenier de Saint-Martin / Jean-François Villain, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Le_g%C3%A9n%C3%A9ral_Toussaint_L%27Ouverture_recevant_le_g%C3%A9n%C3%A9ral_anglais_Thomas_Maitland_le_30_mars_1798_(cropped).jpg"
  },
  "anc_tambora": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Mount_Tambora_Volcano%2C_Sumbawa_Island%2C_Indonesia.jpg/500px-Mount_Tambora_Volcano%2C_Sumbawa_Island%2C_Indonesia.jpg",
    "c": "This image was taken by the NASA Expedition 20 crew., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mount_Tambora_Volcano,_Sumbawa_Island,_Indonesia.jpg"
  },
  "anc_railway": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Stephenson%27s_Rocket_drawing.jpg/500px-Stephenson%27s_Rocket_drawing.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Stephenson%27s_Rocket_drawing.jpg"
  },
  "anc_meiji": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Emperor_Meiji_by_Takahashi_Yuichi.jpg/500px-Emperor_Meiji_by_Takahashi_Yuichi.jpg",
    "c": "Takahashi Yuichi (1828-1894), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Emperor_Meiji_by_Takahashi_Yuichi.jpg"
  },
  "anc_berlinconf": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Kongokonferenz.jpg/500px-Kongokonferenz.jpg",
    "c": "Adalbert von Roessler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kongokonferenz.jpg"
  },
  "anc_wright": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/First_flight2.jpg/500px-First_flight2.jpg",
    "c": "John T. Daniels, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:First_flight2.jpg"
  },
  "anc_longmarch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/01/1938_Mao_Zedong_Zhang_Guotao_in_Yan%27an.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1938_Mao_Zedong_Zhang_Guotao_in_Yan%27an.jpg"
  },
  "anc_prc": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Mao_Proclaiming_New_China.JPG/500px-Mao_Proclaiming_New_China.JPG",
    "c": "Orihara1, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mao_Proclaiming_New_China.JPG"
  },
  "anc_www": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Tim_Berners-Lee_at_the_2025_Web_Summit_%28Cropped%29.jpg/500px-Tim_Berners-Lee_at_the_2025_Web_Summit_%28Cropped%29.jpg",
    "c": "Summit, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tim_Berners-Lee_at_the_2025_Web_Summit_(Cropped).jpg"
  },
  "anc_saigon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/20190923_Independence_Palace-10.jpg/500px-20190923_Independence_Palace-10.jpg",
    "c": "Balon Greyjoy, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:20190923_Independence_Palace-10.jpg"
  },
  "anc_arabspring": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Tahrir_Square_during_8_February_2011.jpg/500px-Tahrir_Square_during_8_February_2011.jpg",
    "c": "Mona, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tahrir_Square_during_8_February_2011.jpg"
  },
  "columbus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Portrait_of_a_Man%2C_Said_to_be_Christopher_Columbus.jpg/500px-Portrait_of_a_Man%2C_Said_to_be_Christopher_Columbus.jpg",
    "c": "Sebastiano del Piombo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_of_a_Man,_Said_to_be_Christopher_Columbus.jpg"
  },
  "anq_narmer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Narmer_Palette.jpg/500px-Narmer_Palette.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Narmer_Palette.jpg"
  },
  "anq_caral": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Mayor_Pyramid_and_circular_enclosure._Caral%2C_Peru.jpg/500px-Mayor_Pyramid_and_circular_enclosure._Caral%2C_Peru.jpg",
    "c": "Jon Gudorf Photography, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mayor_Pyramid_and_circular_enclosure._Caral,_Peru.jpg"
  },
  "anq_vultures": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Stele_of_the_Vultures_in_the_Louvre_Museum_%28enhanced_composite%29.jpg/500px-Stele_of_the_Vultures_in_the_Louvre_Museum_%28enhanced_composite%29.jpg",
    "c": "Wikimedia Commons, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Stele_of_the_Vultures_in_the_Louvre_Museum_(enhanced_composite).jpg"
  },
  "anq_ebla": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Calco_di_tavoletta_in_terracotta_da_Ebla_-_Museo_d%27Arte_Orientale_Roma.jpg/500px-Calco_di_tavoletta_in_terracotta_da_Ebla_-_Museo_d%27Arte_Orientale_Roma.jpg",
    "c": "Davide Mauro, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Calco_di_tavoletta_in_terracotta_da_Ebla_-_Museo_d%27Arte_Orientale_Roma.jpg"
  },
  "anq_kanesh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Itur-ili_-_Business_Letter_-_Walters_481462_-_View_A.jpg/500px-Itur-ili_-_Business_Letter_-_Walters_481462_-_View_A.jpg",
    "c": "Itur-ili (Assyrian), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Itur-ili_-_Business_Letter_-_Walters_481462_-_View_A.jpg"
  },
  "anq_kerma": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Kerma_city.JPG/500px-Kerma_city.JPG",
    "c": "Lassi, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kerma_city.JPG"
  },
  "anq_nebra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Nebra_disc_1.jpg/500px-Nebra_disc_1.jpg",
    "c": "Frank Vincentz, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nebra_disc_1.jpg"
  },
  "anq_ahmose": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Head_of_Ahmose_I_MET_DP140854.jpg/500px-Head_of_Ahmose_I_MET_DP140854.jpg",
    "c": "anonymous, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Head_of_Ahmose_I_MET_DP140854.jpg"
  },
  "anq_uluburun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Uluburun1.jpg/500px-Uluburun1.jpg",
    "c": "Martin Bahmann, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Uluburun1.jpg"
  },
  "anq_abu_simbel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Ramsis%2C_Aswan_Governorate%2C_Egypt_-_panoramio.jpg/500px-Ramsis%2C_Aswan_Governorate%2C_Egypt_-_panoramio.jpg",
    "c": "youssef_alam, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ramsis,_Aswan_Governorate,_Egypt_-_panoramio.jpg"
  },
  "anq_sanxingdui": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Gold_Mask_%28%E9%BB%84%E9%87%91%E9%9D%A2%E7%BD%A9%29.jpg/500px-Gold_Mask_%28%E9%BB%84%E9%87%91%E9%9D%A2%E7%BD%A9%29.jpg",
    "c": "momo, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gold_Mask_(%E9%BB%84%E9%87%91%E9%9D%A2%E7%BD%A9).jpg"
  },
  "anq_sea_peoples": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Medinet_Habu_Ramses_III._Tempel_Nordostwand_Abzeichnung_01.jpg/500px-Medinet_Habu_Ramses_III._Tempel_Nordostwand_Abzeichnung_01.jpg",
    "c": "Unknown artistUnknown artist in pay of Ramesses III, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Medinet_Habu_Ramses_III._Tempel_Nordostwand_Abzeichnung_01.jpg"
  },
  "anq_qarqar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/The_Black_Obelisk_of_Shalmaneser_III%2C_9th_century_BC%2C_from_Nimrud%2C_Iraq._The_British_Museum.jpg/500px-The_Black_Obelisk_of_Shalmaneser_III%2C_9th_century_BC%2C_from_Nimrud%2C_Iraq._The_British_Museum.jpg",
    "c": "Osama Shukir Muhammed Amin FRCP(Glasg), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_Black_Obelisk_of_Shalmaneser_III,_9th_century_BC,_from_Nimrud,_Iraq._The_British_Museum.jpg"
  },
  "anq_israel_judah_split": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Rehoboam._Fragment_of_Wall_Painting_from_Basel_Town_Hall_Council_Chamber%2C_by_Hans_Holbein_the_Younger..jpg/500px-Rehoboam._Fragment_of_Wall_Painting_from_Basel_Town_Hall_Council_Chamber%2C_by_Hans_Holbein_the_Younger..jpg",
    "c": "Hans Holbein the Younger, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rehoboam._Fragment_of_Wall_Painting_from_Basel_Town_Hall_Council_Chamber,_by_Hans_Holbein_the_Younger..jpg"
  },
  "anq_carthage": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Archaeological_Site_of_Carthage-130237.jpg/500px-Archaeological_Site_of_Carthage-130237.jpg",
    "c": "Christian Manhart, CC BY-SA 3.0 igo",
    "p": "https://commons.wikimedia.org/wiki/File:Archaeological_Site_of_Carthage-130237.jpg"
  },
  "anq_zhou_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Bronze_Ding%2C_Early_Western_Zhou_01_%28cropped%29.jpg/500px-Bronze_Ding%2C_Early_Western_Zhou_01_%28cropped%29.jpg",
    "c": "Gary Lee Todd, Ph.D., CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Bronze_Ding,_Early_Western_Zhou_01_(cropped).jpg"
  },
  "anq_piye": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Piye_Stele_%28Louvre_Museum_reconstruction%29.jpg/500px-Piye_Stele_%28Louvre_Museum_reconstruction%29.jpg",
    "c": "Tangopaso, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Piye_Stele_(Louvre_Museum_reconstruction).jpg"
  },
  "anq_sennacherib_jerusalem": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Sanherib-tr-4271.jpg/500px-Sanherib-tr-4271.jpg",
    "c": "Timo Roller, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sanherib-tr-4271.jpg"
  },
  "anq_huan_qi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/%E9%BD%8A%E6%A1%93%E5%85%AC_%E7%B9%A1%E5%83%8F%E6%9D%B1%E5%91%A8%E5%88%97%E5%9C%8B%E5%85%A8%E5%BF%97.jpg/500px-%E9%BD%8A%E6%A1%93%E5%85%AC_%E7%B9%A1%E5%83%8F%E6%9D%B1%E5%91%A8%E5%88%97%E5%9C%8B%E5%85%A8%E5%BF%97.jpg",
    "c": "馮夢龍, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%E9%BD%8A%E6%A1%93%E5%85%AC_%E7%B9%A1%E5%83%8F%E6%9D%B1%E5%91%A8%E5%88%97%E5%9C%8B%E5%85%A8%E5%BF%97.jpg"
  },
  "anq_thebes_sack": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/AshurbanipalKingOfAssyria.jpg/500px-AshurbanipalKingOfAssyria.jpg",
    "c": "KeyolTranslater, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:AshurbanipalKingOfAssyria.jpg"
  },
  "anq_nabopolassar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Ishtar_Gate.jpg/500px-Ishtar_Gate.jpg",
    "c": "David Stanley, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ishtar_Gate.jpg"
  },
  "anq_carchemish": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/The_Battle_of_Carchemish.png/500px-The_Battle_of_Carchemish.png",
    "c": "Egisto C., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Battle_of_Carchemish.png"
  },
  "anq_necho_africa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Necho-KnellingStatue_BrooklynMuseum.png/500px-Necho-KnellingStatue_BrooklynMuseum.png",
    "c": "Keith Schengili-Roberts, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Necho-KnellingStatue_BrooklynMuseum.png"
  },
  "anq_confucius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/7e/Confucius%2C_fresco_from_a_Western_Han_tomb_of_Dongping_County%2C_Shandong_province%2C_China_%28cropped%29.jpg",
    "c": "Anonymous Chinese painter of the Western Han period, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Confucius,_fresco_from_a_Western_Han_tomb_of_Dongping_County,_Shandong_province,_China_(cropped).jpg"
  },
  "anq_buddha": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Bodhgaya_3639641913_f4c5f73689_t.jpg/500px-Bodhgaya_3639641913_f4c5f73689_t.jpg",
    "c": "Ken Wieland from Philadelphia, USA, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Bodhgaya_3639641913_f4c5f73689_t.jpg"
  },
  "anq_second_temple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Second_Temple.jpg/500px-Second_Temple.jpg",
    "c": "Ariely, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Second_Temple.jpg"
  },
  "anq_ionian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Miletus_-_Ancient_Greek_theatre_02.jpg/500px-Miletus_-_Ancient_Greek_theatre_02.jpg",
    "c": "Bernard Gagnon, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Miletus_-_Ancient_Greek_theatre_02.jpg"
  },
  "anq_salamis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Illustrerad_Verldshistoria_band_I_Ill_116.png/500px-Illustrerad_Verldshistoria_band_I_Ill_116.png",
    "c": "Evald Hansen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Illustrerad_Verldshistoria_band_I_Ill_116.png"
  },
  "anq_nehemiah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Building_the_Wall_of_Jerusalem.jpg/500px-Building_the_Wall_of_Jerusalem.jpg",
    "c": "publishers of Sunrays Quarterly, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Building_the_Wall_of_Jerusalem.jpg"
  },
  "anq_warring_states": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Cavalry_and_Horse_Warring_States_period_475-221_BCE_Terracotta_Warriors_2013_exhibit_at_San_Francisco%27s_Asian_Art_Museum_20130320-110726_C4A.jpg/500px-Cavalry_and_Horse_Warring_States_period_475-221_BCE_Terracotta_Warriors_2013_exhibit_at_San_Francisco%27s_Asian_Art_Museum_20130320-110726_C4A.jpg",
    "c": "Charlie &amp; Melody Wambeke, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cavalry_and_Horse_Warring_States_period_475-221_BCE_Terracotta_Warriors_2013_exhibit_at_San_Francisco%27s_Asian_Art_Museum_20130320-110726_C4A.jpg"
  },
  "anq_chaeronea": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Phillip_II%2C_king_of_Macedonia%2C_Roman_copy_of_Greek_original%2C_Ny_Carlsberg_Glyptotek%2C_Copenhagen_%2836420294055%29.jpg/500px-Phillip_II%2C_king_of_Macedonia%2C_Roman_copy_of_Greek_original%2C_Ny_Carlsberg_Glyptotek%2C_Copenhagen_%2836420294055%29.jpg",
    "c": "Richard Mortel from Riyadh, Saudi Arabia, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Phillip_II,_king_of_Macedonia,_Roman_copy_of_Greek_original,_Ny_Carlsberg_Glyptotek,_Copenhagen_(36420294055).jpg"
  },
  "anq_chandragupta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Chandragupt_maurya_Birla_mandir_6_dec_2009_%2831%29_%28cropped%29.JPG/500px-Chandragupt_maurya_Birla_mandir_6_dec_2009_%2831%29_%28cropped%29.JPG",
    "c": "आशीष भटनागर at Hindi Wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Chandragupt_maurya_Birla_mandir_6_dec_2009_(31)_(cropped).JPG"
  },
  "anq_ipsus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/The_Battle_of_Ipsus.jpg/500px-The_Battle_of_Ipsus.jpg",
    "c": "James D. McCabe, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Battle_of_Ipsus.jpg"
  },
  "anq_kalinga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Ashoka_Lauriya_Areraj_inscription.jpg/500px-Ashoka_Lauriya_Areraj_inscription.jpg",
    "c": "Sachin kumar tiwary, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ashoka_Lauriya_Areraj_inscription.jpg"
  },
  "anq_archimedes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Archimedes_Directing_the_Defenses_of_Syracuse.jpg/500px-Archimedes_Directing_the_Defenses_of_Syracuse.jpg",
    "c": "Thomas Ralph Spence, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Archimedes_Directing_the_Defenses_of_Syracuse.jpg"
  },
  "anq_carthage_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Catapulta_by_Edward_Poynter.jpg/500px-Catapulta_by_Edward_Poynter.jpg",
    "c": "Edward Poynter, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Catapulta_by_Edward_Poynter.jpg"
  },
  "anq_sima_qian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/ab/Si_maqian.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Si_maqian.jpg"
  },
  "anq_wang_mang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/WUL-he21_01467_%E6%96%B0%E9%90%AB%E7%B9%AA%E5%83%8F%E6%9D%B1%E8%A5%BF%E6%BC%A2%E5%85%A8%E5%82%B3_01_%28%E7%8E%8B%E8%8E%BD%29.jpg/500px-WUL-he21_01467_%E6%96%B0%E9%90%AB%E7%B9%AA%E5%83%8F%E6%9D%B1%E8%A5%BF%E6%BC%A2%E5%85%A8%E5%82%B3_01_%28%E7%8E%8B%E8%8E%BD%29.jpg",
    "c": "鍾 惺, 1574-1624, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:WUL-he21_01467_%E6%96%B0%E9%90%AB%E7%B9%AA%E5%83%8F%E6%9D%B1%E8%A5%BF%E6%BC%A2%E5%85%A8%E5%82%B3_01_(%E7%8E%8B%E8%8E%BD).jpg"
  },
  "anq_julian_cal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Retrato_de_Julio_C%C3%A9sar_%2826724093101%29_%28cropped%29.jpg/500px-Retrato_de_Julio_C%C3%A9sar_%2826724093101%29_%28cropped%29.jpg",
    "c": "Ángel M. Felicísimo from Mérida, España, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Retrato_de_Julio_C%C3%A9sar_(26724093101)_(cropped).jpg"
  },
  "anq_colosseum": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Colosseo_2020.jpg/500px-Colosseo_2020.jpg",
    "c": "FeaturedPics, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Colosseo_2020.jpg"
  },
  "anq_kanishka": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/KanishkaCoin3.JPG/500px-KanishkaCoin3.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KanishkaCoin3.JPG"
  },
  "anq_roman_china": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/MSR-ra-61-b-1-DM.jpg/500px-MSR-ra-61-b-1-DM.jpg",
    "c": "Daniel Martin, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:MSR-ra-61-b-1-DM.jpg"
  },
  "anq_han_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Cao_Pi_Tang.jpg/500px-Cao_Pi_Tang.jpg",
    "c": "Yan Li-pen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cao_Pi_Tang.jpg"
  },
  "anq_valerian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Naghsh-e_rostam%2C_Ir%C3%A1n%2C_2016-09-24%2C_DD_12.jpg/500px-Naghsh-e_rostam%2C_Ir%C3%A1n%2C_2016-09-24%2C_DD_12.jpg",
    "c": "Diego Delso, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Naghsh-e_rostam,_Ir%C3%A1n,_2016-09-24,_DD_12.jpg"
  },
  "anq_tetrarchy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Venice_%E2%80%93_The_Tetrarchs_03.jpg/500px-Venice_%E2%80%93_The_Tetrarchs_03.jpg",
    "c": "Nino Barbieri (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Venice_%E2%80%93_The_Tetrarchs_03.jpg"
  },
  "anq_milan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Constantine_I_The_Great%2C_Colossal_bronze_statue_fragments%2C_Capitoline_Museums.jpg/500px-Constantine_I_The_Great%2C_Colossal_bronze_statue_fragments%2C_Capitoline_Museums.jpg",
    "c": "Apaleutos25, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Constantine_I_The_Great,_Colossal_bronze_statue_fragments,_Capitoline_Museums.jpg"
  },
  "anq_serapeum": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Serapis_Pio-Clementino_Inv689_n2.jpg/500px-Serapis_Pio-Clementino_Inv689_n2.jpg",
    "c": "Copy of Bryaxis, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Serapis_Pio-Clementino_Inv689_n2.jpg"
  },
  "anq_alaric": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Visigoths_sack_Rome.jpg/500px-Visigoths_sack_Rome.jpg",
    "c": "Joseph-Noël Sylvestre, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Visigoths_sack_Rome.jpg"
  },
  "anq_odoacer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Coin_of_Odoacer_at_the_British_Museum_%28obverse%29.png/500px-Coin_of_Odoacer_at_the_British_Museum_%28obverse%29.png",
    "c": "British Museum (photo), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Coin_of_Odoacer_at_the_British_Museum_(obverse).png"
  },
  "anq_vandals_carthage": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/57/M%C3%BCnze_50_Denari_-_Gelimer_-_K%C3%B6nig_der_Vandalen_%28cropped%29.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:M%C3%BCnze_50_Denari_-_Gelimer_-_K%C3%B6nig_der_Vandalen_(cropped).jpg"
  },
  "anq_aryabhata": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Aryabhatta_of_Bihar.jpg/500px-Aryabhatta_of_Bihar.jpg",
    "c": "Cpjha13, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Aryabhatta_of_Bihar.jpg"
  },
  "med_whitby": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Whitby_Abbey_%28geograph_7249897%29.jpg/500px-Whitby_Abbey_%28geograph_7249897%29.jpg",
    "c": "Jeff Buck, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Whitby_Abbey_(geograph_7249897).jpg"
  },
  "med_pippin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/PippinImperialChronicleCorpusChristiCollegeMS373Fol14.jpg/500px-PippinImperialChronicleCorpusChristiCollegeMS373Fol14.jpg",
    "c": "from the Middle Ages, unknown, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:PippinImperialChronicleCorpusChristiCollegeMS373Fol14.jpg"
  },
  "med_schism": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Hagia_Sophia_%28228968325%29.jpeg/500px-Hagia_Sophia_%28228968325%29.jpeg",
    "c": "Adli Wahid, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hagia_Sophia_(228968325).jpeg"
  },
  "med_edington": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cc/Alfred_the_Great%2C_silver_penny%3B_struck_875%E2%80%93880_%28obverse%29.png",
    "c": "CNG - Classical Numismatic Group, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Alfred_the_Great,_silver_penny;_struck_875%E2%80%93880_(obverse).png"
  },
  "med_normandy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/RolloA.jpg/500px-RolloA.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:RolloA.jpg"
  },
  "med_jerusalem638": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Jerusalem_DomeoftheRock_J65_%28cropped%29.JPG/500px-Jerusalem_DomeoftheRock_J65_%28cropped%29.JPG",
    "c": "Ludvig14, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Jerusalem_DomeoftheRock_J65_(cropped).JPG"
  },
  "med_khosrow": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/001125-TaqKasra-Iraq-IMG_7914-2.jpg/500px-001125-TaqKasra-Iraq-IMG_7914-2.jpg",
    "c": "Safa.daneshvar, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:001125-TaqKasra-Iraq-IMG_7914-2.jpg"
  },
  "med_karbala": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Brooklyn_Museum_-_Battle_of_Karbala_-_Abbas_Al-Musavi_-_cropped.jpg/500px-Brooklyn_Museum_-_Battle_of_Karbala_-_Abbas_Al-Musavi_-_cropped.jpg",
    "c": "Persian Painter Abbas Al-Musavi., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Brooklyn_Museum_-_Battle_of_Karbala_-_Abbas_Al-Musavi_-_cropped.jpg"
  },
  "med_talas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/20090822_Shanghai_Museum_3596.jpg/500px-20090822_Shanghai_Museum_3596.jpg",
    "c": "Jakub Hałun, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:20090822_Shanghai_Museum_3596.jpg"
  },
  "med_abbasid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Portrait_of_Abu_Muslim_%28d._755%29_from_the_genealogy_%28silsilan%C4%81ma%29%2C_Cream_of_Histories_%28Z%C3%BCbdet-%C3%BCt_Tevarih%2C_1598%29.jpg/500px-Portrait_of_Abu_Muslim_%28d._755%29_from_the_genealogy_%28silsilan%C4%81ma%29%2C_Cream_of_Histories_%28Z%C3%BCbdet-%C3%BCt_Tevarih%2C_1598%29.jpg",
    "c": "1598 author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_of_Abu_Muslim_(d._755)_from_the_genealogy_(silsilan%C4%81ma),_Cream_of_Histories_(Z%C3%BCbdet-%C3%BCt_Tevarih,_1598).jpg"
  },
  "med_fatimid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Calif_al_Mahdi_Kairouan_912_CE%28png%29.png/500px-Calif_al_Mahdi_Kairouan_912_CE%28png%29.png",
    "c": "PHGCOM, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Calif_al_Mahdi_Kairouan_912_CE(png).png"
  },
  "med_manzikert": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/12/BnF_Fr232_fol323_Alp_Arslan_Romanus.jpg",
    "c": "Boccace, De Casibus, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BnF_Fr232_fol323_Alp_Arslan_Romanus.jpg"
  },
  "med_ramla": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Church_of_Fontevraud_Abbey_Richard_I_effigy.jpg/500px-Church_of_Fontevraud_Abbey_Richard_I_effigy.jpg",
    "c": "Adam Bishop, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Church_of_Fontevraud_Abbey_Richard_I_effigy.jpg"
  },
  "med_khazars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Lebedev_Svyatoslavs_meeting_with_Emperor_John.jpg/500px-Lebedev_Svyatoslavs_meeting_with_Emperor_John.jpg",
    "c": "Klavdy Lebedev, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lebedev_Svyatoslavs_meeting_with_Emperor_John.jpg"
  },
  "med_brihadisvara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Brihadeeswarar_Kovil.jpg/500px-Brihadeeswarar_Kovil.jpg",
    "c": "Nirinsanity, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Brihadeeswarar_Kovil.jpg"
  },
  "med_harsha": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Harshavardhana_Circa_AD_606-647.jpg/500px-Harshavardhana_Circa_AD_606-647.jpg",
    "c": "CNG Coins, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Harshavardhana_Circa_AD_606-647.jpg"
  },
  "med_xuanzang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Xuanzang_w.jpg/500px-Xuanzang_w.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Xuanzang_w.jpg"
  },
  "med_diamondsutra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Jingangjing.jpg/500px-Jingangjing.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jingangjing.jpg"
  },
  "med_silla": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Front_view_of_Seokguram_from_front_chamber.jpg/500px-Front_view_of_Seokguram_from_front_chamber.jpg",
    "c": "Seok-Hong, Han, KOGL Type 1",
    "p": "https://commons.wikimedia.org/wiki/File:Front_view_of_Seokguram_from_front_chamber.jpg"
  },
  "med_kamakura": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Minamoto_no_Yoritomo.jpg/500px-Minamoto_no_Yoritomo.jpg",
    "c": "Fujiwara no Takanobu, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Minamoto_no_Yoritomo.jpg"
  },
  "med_heian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Emperor_Kammu_large.jpg/500px-Emperor_Kammu_large.jpg",
    "c": "Unknown, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Emperor_Kammu_large.jpg"
  },
  "med_temujin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/YuanEmperorAlbumGenghisPortrait.jpg/500px-YuanEmperorAlbumGenghisPortrait.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:YuanEmperorAlbumGenghisPortrait.jpg"
  },
  "med_caracol": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Panorama_atop_Caracol.png/500px-Panorama_atop_Caracol.png",
    "c": "Pgbk87, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Panorama_atop_Caracol.png"
  },
  "med_quirigua": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/K%CA%BCak%CA%BC_Tiliw_Chan_Yopaat_on_Stela_E.jpg/500px-K%CA%BCak%CA%BC_Tiliw_Chan_Yopaat_on_Stela_E.jpg",
    "c": "Blervis, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:K%CA%BCak%CA%BC_Tiliw_Chan_Yopaat_on_Stela_E.jpg"
  },
  "med_khwarazm": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Bataille_entre_mongols_%26_chinois_%281211%29.jpeg/500px-Bataille_entre_mongols_%26_chinois_%281211%29.jpeg",
    "c": "Sayf al-Vâhidî. Hérât. Afghanistan, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bataille_entre_mongols_%26_chinois_(1211).jpeg"
  },
  "med_yamen": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/57/Song_Modi.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Song_Modi.jpg"
  },
  "med_kiev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Sacking_of_Suzdal_by_Batu_Khan.jpg/500px-Sacking_of_Suzdal_by_Batu_Khan.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sacking_of_Suzdal_by_Batu_Khan.jpg"
  },
  "med_kamakura_buddha": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/230128_Kamakura_Daibutsu_Japan04s3.jpg/500px-230128_Kamakura_Daibutsu_Japan04s3.jpg",
    "c": "663highland, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:230128_Kamakura_Daibutsu_Japan04s3.jpg"
  },
  "med_vijayanagara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Wide_angle_of_Galigopuram_of_Virupaksha_Temple%2C_Hampi_%2804%29_%28cropped%29.jpg/500px-Wide_angle_of_Galigopuram_of_Virupaksha_Temple%2C_Hampi_%2804%29_%28cropped%29.jpg",
    "c": "iMahesh, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Wide_angle_of_Galigopuram_of_Virupaksha_Temple,_Hampi_(04)_(cropped).jpg"
  },
  "med_swiss": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Landesmuseum_Z%C3%BCrich_2010-09-20_14-38-14_ShiftN.jpg/500px-Landesmuseum_Z%C3%BCrich_2010-09-20_14-38-14_ShiftN.jpg",
    "c": "Hans Sandreuter; photograph: Roland zh, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Landesmuseum_Z%C3%BCrich_2010-09-20_14-38-14_ShiftN.jpg"
  },
  "med_osman": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/I_Osman.jpg/500px-I_Osman.jpg",
    "c": "Ottoman miniature painting, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:I_Osman.jpg"
  },
  "med_timur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Timur_reconstruction03.jpg/500px-Timur_reconstruction03.jpg",
    "c": "user:shakko, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Timur_reconstruction03.jpg"
  },
  "med_joseon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/King_Taejo_Yi_02.jpg/500px-King_Taejo_Yi_02.jpg",
    "c": "Jo Jung-muk(?-?), Pak Gijun(?-?), Baek Eunbae(1820-?), Yu Suk(1827-1873), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:King_Taejo_Yi_02.jpg"
  },
  "med_triple_alliance": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Nezahualcoyotl.jpg/500px-Nezahualcoyotl.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nezahualcoyotl.jpg"
  },
  "med_pachacuti": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Brooklyn_Museum_-_Pachacuti%2C_Tenth_Inca%2C_1_of_14_Portraits_of_Inca_Kings_%28cropped%29.jpg/500px-Brooklyn_Museum_-_Pachacuti%2C_Tenth_Inca%2C_1_of_14_Portraits_of_Inca_Kings_%28cropped%29.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Brooklyn_Museum_-_Pachacuti,_Tenth_Inca,_1_of_14_Portraits_of_Inca_Kings_(cropped).jpg"
  },
  "med_safavid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Shah_Ismail_I_Safavid%2C_Behzad.jpg/500px-Shah_Ismail_I_Safavid%2C_Behzad.jpg",
    "c": "Kamāl ud-Dīn Behzād, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Shah_Ismail_I_Safavid,_Behzad.jpg"
  },
  "med_tanegashima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Strings_for_night_firing.jpg/500px-Strings_for_night_firing.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Strings_for_night_firing.jpg"
  },
  "med_tondibi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Askia.jpg/500px-Askia.jpg",
    "c": "Taguelmoust, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Askia.jpg"
  },
  "med_fatehpur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Fatehput_Sikiri_Buland_Darwaza_gate_2010.jpg/500px-Fatehput_Sikiri_Buland_Darwaza_gate_2010.jpg",
    "c": "Marcin Białek, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Fatehput_Sikiri_Buland_Darwaza_gate_2010.jpg"
  },
  "mod_meireki": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Meireki_fire.JPG/500px-Meireki_fire.JPG",
    "c": "田代幸春, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Meireki_fire.JPG"
  },
  "mod_koxinga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/The_Portrait_of_Koxinga.jpg/500px-The_Portrait_of_Koxinga.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Portrait_of_Koxinga.jpg"
  },
  "mod_petersburg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/RUS-2016-Aerial-SPB-Peter_and_Paul_Fortress_02.jpg/500px-RUS-2016-Aerial-SPB-Peter_and_Paul_Fortress_02.jpg",
    "c": "Godot13, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:RUS-2016-Aerial-SPB-Peter_and_Paul_Fortress_02.jpg"
  },
  "mod_quebec": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Benjamin_West_005.jpg/500px-Benjamin_West_005.jpg",
    "c": "Benjamin West, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Benjamin_West_005.jpg"
  },
  "usa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Declaration_of_Independence_%281819%29%2C_by_John_Trumbull.jpg/500px-Declaration_of_Independence_%281819%29%2C_by_John_Trumbull.jpg",
    "c": "John Trumbull, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Declaration_of_Independence_(1819),_by_John_Trumbull.jpg"
  },
  "mod_firstfleet": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/A_view_of_Botany_Bay_A1475003h_%28cropped%29.jpg/500px-A_view_of_Botany_Bay_A1475003h_%28cropped%29.jpg",
    "c": "Original drawing by R. Cleveley, engraving by T. Medland., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_view_of_Botany_Bay_A1475003h_(cropped).jpg"
  },
  "mod_raclawice": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Jan_Matejko_-_Ko%C5%9Bciuszko_at_Rac%C5%82awice_-_MNK_II-a-151_-_National_Museum_Krak%C3%B3w.jpg/500px-Jan_Matejko_-_Ko%C5%9Bciuszko_at_Rac%C5%82awice_-_MNK_II-a-151_-_National_Museum_Krak%C3%B3w.jpg",
    "c": "Jan Matejko, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jan_Matejko_-_Ko%C5%9Bciuszko_at_Rac%C5%82awice_-_MNK_II-a-151_-_National_Museum_Krak%C3%B3w.jpg"
  },
  "mod_seringapatam": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Tipu_death.jpg/500px-Tipu_death.jpg",
    "c": "Henry Singleton (1766–1839), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Tipu_death.jpg"
  },
  "mod_haitiindep": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Jean_Jacques_Dessalines.jpg/500px-Jean_Jacques_Dessalines.jpg",
    "c": "Louis Rigaud, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jean_Jacques_Dessalines.jpg"
  },
  "mod_hawaii": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Louis_Choris_%281795-1828%29_-_Kamehameha%2C_King_of_the_Sandwich_Islands_by_Louis_Choris%2C_%28Russian%29%2C_pen_and_watercolor.jpg/500px-Louis_Choris_%281795-1828%29_-_Kamehameha%2C_King_of_the_Sandwich_Islands_by_Louis_Choris%2C_%28Russian%29%2C_pen_and_watercolor.jpg",
    "c": "Louis Choris, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Louis_Choris_(1795-1828)_-_Kamehameha,_King_of_the_Sandwich_Islands_by_Louis_Choris,_(Russian),_pen_and_watercolor.jpg"
  },
  "mod_boyaca": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Batalla_de_Boyaca_de_Martin_Tovar_y_Tovar.jpg/500px-Batalla_de_Boyaca_de_Martin_Tovar_y_Tovar.jpg",
    "c": "Martin Tovar y Tovar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Batalla_de_Boyaca_de_Martin_Tovar_y_Tovar.jpg"
  },
  "mod_ayacucho": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Batalla_de_Ayacucho_by_Mart%C3%ADn_Tovar_y_Tovar_%281827_-_1902%29.jpg/500px-Batalla_de_Ayacucho_by_Mart%C3%ADn_Tovar_y_Tovar_%281827_-_1902%29.jpg",
    "c": "Martín Tovar y Tovar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Batalla_de_Ayacucho_by_Mart%C3%ADn_Tovar_y_Tovar_(1827_-_1902).jpg"
  },
  "mod_algiers": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/La_prise_de_Constantine_1837_par_Horace_Vernet.jpg/500px-La_prise_de_Constantine_1837_par_Horace_Vernet.jpg",
    "c": "Horace Vernet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:La_prise_de_Constantine_1837_par_Horace_Vernet.jpg"
  },
  "mod_bloodriver": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Dingan_at_home.jpg/500px-Dingan_at_home.jpg",
    "c": "Internet Archive Book Images, No restrictions",
    "p": "https://commons.wikimedia.org/wiki/File:Dingan_at_home.jpg"
  },
  "mod_opiumlin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Portrait_of_Lin_Zexu.jpeg/500px-Portrait_of_Lin_Zexu.jpeg",
    "c": "Lam Qua, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_of_Lin_Zexu.jpeg"
  },
  "mod_liberia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/%281896%29_Departure_of_colored_emigrants_for_Liberia_-_The_Illustrated_American%2C_March_21%2C_1896.jpg/500px-%281896%29_Departure_of_colored_emigrants_for_Liberia_-_The_Illustrated_American%2C_March_21%2C_1896.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:(1896)_Departure_of_colored_emigrants_for_Liberia_-_The_Illustrated_American,_March_21,_1896.jpg"
  },
  "mod_eureka": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Doudiet_Swearing_allegiance_to_the_Southern_Cross.jpg/500px-Doudiet_Swearing_allegiance_to_the_Southern_Cross.jpg",
    "c": "Charles Doudiet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Doudiet_Swearing_allegiance_to_the_Southern_Cross.jpg"
  },
  "mod_sepoy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Bahadur_Shah_II_of_India.jpg/500px-Bahadur_Shah_II_of_India.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bahadur_Shah_II_of_India.jpg"
  },
  "mod_summerpalace": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/La_bataille_de_Palikiao.jpg/500px-La_bataille_de_Palikiao.jpg",
    "c": "Émile Bayard, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:La_bataille_de_Palikiao.jpg"
  },
  "mod_canada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Fathers_of_Confederation_LAC_c001855.jpg/500px-Fathers_of_Confederation_LAC_c001855.jpg",
    "c": "Photographer: James Ashfield, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Fathers_of_Confederation_LAC_c001855.jpg"
  },
  "mod_suez": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Ferdinand_de_Lesseps_by_Nadar.jpg/500px-Ferdinand_de_Lesseps_by_Nadar.jpg",
    "c": "Nadar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ferdinand_de_Lesseps_by_Nadar.jpg"
  },
  "mod_rome1870": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Ludovico_Tuminello_-_Veduta_delle_barricate_a_Porta_San_Giovanni._Fotografia_stereoscopica_scattata_il_21_settembre_1870_%28cropped%29.jpg/500px-Ludovico_Tuminello_-_Veduta_delle_barricate_a_Porta_San_Giovanni._Fotografia_stereoscopica_scattata_il_21_settembre_1870_%28cropped%29.jpg",
    "c": "Ludovico Tuminello, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ludovico_Tuminello_-_Veduta_delle_barricate_a_Porta_San_Giovanni._Fotografia_stereoscopica_scattata_il_21_settembre_1870_(cropped).jpg"
  },
  "mod_satsuma": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Saigo_Takamori_%28b%29.jpg/500px-Saigo_Takamori_%28b%29.jpg",
    "c": "C. Nakagawa (from signature), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Saigo_Takamori_(b).jpg"
  },
  "mod_titanic": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/St%C3%B6wer_Titanic.jpg/500px-St%C3%B6wer_Titanic.jpg",
    "c": "Willy Stöwer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:St%C3%B6wer_Titanic.jpg"
  },
  "mod_wannsee": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Haus_der_Wannsee-Konferenz_02-2014.jpg/500px-Haus_der_Wannsee-Konferenz_02-2014.jpg",
    "c": "A.Savin, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Haus_der_Wannsee-Konferenz_02-2014.jpg"
  },
  "mod_chernobyl": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/IAEA_02790015_%285613115146%29.jpg/500px-IAEA_02790015_%285613115146%29.jpg",
    "c": "IAEA Imagebank, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:IAEA_02790015_(5613115146).jpg"
  },
  "mod_spain_civil": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/%D0%98%D1%81%D0%BF%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F_11_%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%B1%D1%80%D0%B8%D0%B3%D0%B0%D0%B4%D0%B0_%D0%B2_%D0%B1%D0%BE%D1%8E_%D0%BF%D0%BE%D0%B4_%D0%91%D0%B5%D0%BB%D1%8C%D1%87%D0%B8%D1%82%D0%B5._1937-edit.jpg/500px-%D0%98%D1%81%D0%BF%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F_11_%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%B1%D1%80%D0%B8%D0%B3%D0%B0%D0%B4%D0%B0_%D0%B2_%D0%B1%D0%BE%D1%8E_%D0%BF%D0%BE%D0%B4_%D0%91%D0%B5%D0%BB%D1%8C%D1%87%D0%B8%D1%82%D0%B5._1937-edit.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%D0%98%D1%81%D0%BF%D0%B0%D0%BD%D1%81%D0%BA%D0%B0%D1%8F_11_%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%B1%D1%80%D0%B8%D0%B3%D0%B0%D0%B4%D0%B0_%D0%B2_%D0%B1%D0%BE%D1%8E_%D0%BF%D0%BE%D0%B4_%D0%91%D0%B5%D0%BB%D1%8C%D1%87%D0%B8%D1%82%D0%B5._1937-edit.jpg"
  },
  "mod_nagasaki": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Atomic_bombing_of_Japan.jpg/500px-Atomic_bombing_of_Japan.jpg",
    "c": "George R. Caron / Charles Levy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Atomic_bombing_of_Japan.jpg"
  },
  "mod_xinhai": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Opstanden%2C_revolutie%2C_SFA022823302.jpg/500px-Opstanden%2C_revolutie%2C_SFA022823302.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Opstanden,_revolutie,_SFA022823302.jpg"
  },
  "mod_ussr_end": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/RIAN_archive_848095_Signing_the_Agreement_to_eliminate_the_USSR_and_establish_the_Commonwealth_of_Independent_States.jpg/500px-RIAN_archive_848095_Signing_the_Agreement_to_eliminate_the_USSR_and_establish_the_Commonwealth_of_Independent_States.jpg",
    "c": "U. Ivanov / Ю. Иванов, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:RIAN_archive_848095_Signing_the_Agreement_to_eliminate_the_USSR_and_establish_the_Commonwealth_of_Independent_States.jpg"
  },
  "mod_cultural_rev": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Little_Red_Book_First_Edition_English_Scan.png/500px-Little_Red_Book_First_Edition_English_Scan.png",
    "c": "Scanner:Jp16103, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Little_Red_Book_First_Edition_English_Scan.png"
  },
  "mod_prc": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Mao_Proclaiming_New_China.JPG/500px-Mao_Proclaiming_New_China.JPG",
    "c": "Orihara1, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mao_Proclaiming_New_China.JPG"
  },
  "mod_khmer_rouge": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Tuol_Sleng.jpg/500px-Tuol_Sleng.jpg",
    "c": "Michael Gruijters at Dutch Wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tuol_Sleng.jpg"
  },
  "mod_ghana": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Kwame_Nkrumah_Portrait%2C_The_National_Archives_UK.jpg/500px-Kwame_Nkrumah_Portrait%2C_The_National_Archives_UK.jpg",
    "c": "The National Archives UK - Flickr account, OGL v1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kwame_Nkrumah_Portrait,_The_National_Archives_UK.jpg"
  },
  "mod_alamein": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/El_Alamein_1942_-_British_infantry.jpg/500px-El_Alamein_1942_-_British_infantry.jpg",
    "c": "Len Chetwyn, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:El_Alamein_1942_-_British_infantry.jpg"
  },
  "mod_tiananmen": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Chinese_tanks_in_Beijing%2C_July_1989.png/500px-Chinese_tanks_in_Beijing%2C_July_1989.png",
    "c": "Pete Campolongo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Chinese_tanks_in_Beijing,_July_1989.png"
  },
  "mod_arab_revolt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Sharif_Husayn.jpg/500px-Sharif_Husayn.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sharif_Husayn.jpg"
  },
  "mod_intifada1": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Intifada_in_Gaza_Strip%2C_1987_V_Dan_Hadani_Archive.jpg/500px-Intifada_in_Gaza_Strip%2C_1987_V_Dan_Hadani_Archive.jpg",
    "c": "Efi Sharir, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Intifada_in_Gaza_Strip,_1987_V_Dan_Hadani_Archive.jpg"
  },
  "mod_iraq_war": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/UStanks_baghdad_2003.JPEG/500px-UStanks_baghdad_2003.JPEG",
    "c": "Technical Sergeant John L. Houghton, Jr., United States Air Force, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:UStanks_baghdad_2003.JPEG"
  },
  "mod_federation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Edmund_Barton_1902_Swiss_Studios_Portrait_%283x4_cropped%29_%28cropped%29.jpg/500px-Edmund_Barton_1902_Swiss_Studios_Portrait_%283x4_cropped%29_%28cropped%29.jpg",
    "c": "Wikimedia Commons",
    "p": "https://commons.wikimedia.org/wiki/File:Edmund_Barton_1902_Swiss_Studios_Portrait_(3x4_cropped)_(cropped).jpg"
  },
  "anc_hattin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Codex_Manesse_Ulrich_von_Liechtenstein.jpg/500px-Codex_Manesse_Ulrich_von_Liechtenstein.jpg",
    "c": "Meister des Codex Manesse, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Codex_Manesse_Ulrich_von_Liechtenstein.jpg"
  },
  "anc_ming": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Ch%27en_Hung-shou_001.jpg/500px-Ch%27en_Hung-shou_001.jpg",
    "c": "Chen Hongshou, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ch%27en_Hung-shou_001.jpg"
  },
  "anc_vladimir": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Kievan_Rus_en.jpg/500px-Kievan_Rus_en.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kievan_Rus_en.jpg"
  },
  "anc_mansamusa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/c1/Mansa_Musa.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 381
  },
  "anc_jiaozi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/d9/Jiao_zi.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 872
  },
  "med_muhammadbirth": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Hazrat_Ali_slays_Marhab.JPG/500px-Hazrat_Ali_slays_Marhab.JPG",
    "c": "Major Sykes, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hazrat_Ali_slays_Marhab.JPG"
  },
  "med_goa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Dutch_and_Portuguese_in_Asia_c_1665.png/500px-Dutch_and_Portuguese_in_Asia_c_1665.png",
    "c": "User:The Red Hat of Pat Ferrick, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dutch_and_Portuguese_in_Asia_c_1665.png"
  },
  "med_nanak": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f7/Painting%2C_paint_on_ivory%2C_a_miniature_portrait_of_Guru_Nanak.jpg/500px-Painting%2C_paint_on_ivory%2C_a_miniature_portrait_of_Guru_Nanak.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "new_transistor": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Transistor-photo.JPG/500px-Transistor-photo.JPG",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Transistor-photo.JPG"
  },
  "new_great_zimbabwe": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/d9/Great-Zimbabwe-2.jpg/500px-Great-Zimbabwe-2.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 323
  },
  "new_benin_bronzes": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/be/Benin_Bronzes.jpg/500px-Benin_Bronzes.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "new_zulu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/KingShaka.jpg/500px-KingShaka.jpg",
    "c": "James King, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KingShaka.jpg"
  },
  "new_songhai_empire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Djenn%C3%A93.jpg/500px-Djenn%C3%A93.jpg",
    "c": "Wikimedia Commons, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Djenn%C3%A93.jpg"
  },
  "new_samarkand": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/45/Registan_-_Samarkand_-_15-10-2005.jpg/500px-Registan_-_Samarkand_-_15-10-2005.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 333
  },
  "new_silk_road": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/84/WLA_vanda_Camel_and_Rider_Tang_dynasty.jpg/500px-WLA_vanda_Camel_and_Rider_Tang_dynasty.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "new_bukhara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Courtyard2%28js%29.jpg/500px-Courtyard2%28js%29.jpg",
    "c": "Jerzy Strzelecki, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Courtyard2(js).jpg"
  },
  "new_kokand": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/dc/%D0%9A%D0%B0%D1%80%D1%82%D0%B0_%D0%91%D1%83%D1%85%D0%B0%D1%80%D1%81%D0%BA%D0%BE%D0%B3%D0%BE%2C_%D0%A5%D0%B8%D0%B2%D0%B8%D0%BD%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_%D0%B8_%D0%9A%D0%BE%D0%BA%D0%B0%D0%BD%D0%B4%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_%D1%85%D0%B0%D0%BD%D1%81%D1%82%D0%B2_%D0%B8_%D1%87%D0%B0%D1%81%D1%82%D0%B8_%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_%D0%A2%D1%83%D1%80%D0%BA%D0%B5%D1%81%D1%82%D0%B0%D0%BD%D0%B0_1875_%D0%B3%D0%BE%D0%B4.png/500px-%D0%9A%D0%B0%D1%80%D1%82%D0%B0_%D0%91%D1%83%D1%85%D0%B0%D1%80%D1%81%D0%BA%D0%BE%D0%B3%D0%BE%2C_%D0%A5%D0%B8%D0%B2%D0%B8%D0%BD%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_%D0%B8_%D0%9A%D0%BE%D0%BA%D0%B0%D0%BD%D0%B4%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_%D1%85%D0%B0%D0%BD%D1%81%D1%82%D0%B2_%D0%B8_%D1%87%D0%B0%D1%81%D1%82%D0%B8_%D0%A0%D1%83%D1%81%D1%81%D0%BA%D0%BE%D0%B3%D0%BE_%D0%A2%D1%83%D1%80%D0%BA%D0%B5%D1%81%D1%82%D0%B0%D0%BD%D0%B0_1875_%D0%B3%D0%BE%D0%B4.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 234
  },
  "new_aral": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Aral_sea_1985_from_STS.jpg/500px-Aral_sea_1985_from_STS.jpg",
    "c": "NASA, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Aral_sea_1985_from_STS.jpg"
  },
  "new_great_game": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Blue_Mosque_in_Mazar-e-Sharif.jpg/500px-Blue_Mosque_in_Mazar-e-Sharif.jpg",
    "c": "ISAF Headquarters Public Affairs Office from Kabul, Afghanistan, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Blue_Mosque_in_Mazar-e-Sharif.jpg"
  },
  "new_bagan": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c0/Bagan%2C_Hpaya-thon-zu-Group.JPG/500px-Bagan%2C_Hpaya-thon-zu-Group.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 331
  },
  "new_malacca": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/ChengHoonTeng.jpg/500px-ChengHoonTeng.jpg",
    "c": "Wikimedia Commons, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:ChengHoonTeng.jpg"
  },
  "new_aboriginal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/SantaCruz-CuevaManos-P2210651b.jpg/500px-SantaCruz-CuevaManos-P2210651b.jpg",
    "c": "Mariano, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:SantaCruz-CuevaManos-P2210651b.jpg"
  },
  "new_easter_island": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Ahu_Tahai.jpg/500px-Ahu_Tahai.jpg",
    "c": "Picture taken by Bjarte Sorensen., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ahu_Tahai.jpg"
  },
  "new_nazca": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Lignes_de_Nazca_oiseau.jpg/500px-Lignes_de_Nazca_oiseau.jpg",
    "c": "Marcito, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Lignes_de_Nazca_oiseau.jpg"
  },
  "new_tiwanaku": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/03/Bolivia_-_Gate_of_the_Sun_detail_-_Tiwanaku_or_Tiahuanaco_01.jpg/500px-Bolivia_-_Gate_of_the_Sun_detail_-_Tiwanaku_or_Tiahuanaco_01.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 328
  },
  "new_potosi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Potosi_air.jpg/500px-Potosi_air.jpg",
    "c": "Gerd Breitenbach, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Potosi_air.jpg"
  },
  "new_tupac_amaru": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Sapa_inkakuna.jpg/500px-Sapa_inkakuna.jpg",
    "c": "Cuzco School, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sapa_inkakuna.jpg"
  },
  "new_chaco": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Chaco_Canyon_Chetro_Ketl_great_kiva_plaza_NPS.jpg/500px-Chaco_Canyon_Chetro_Ketl_great_kiva_plaza_NPS.jpg",
    "c": "National Park Service (United States), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Chaco_Canyon_Chetro_Ketl_great_kiva_plaza_NPS.jpg"
  },
  "new_khmer_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Angkor_Phnom_Bakheng.jpg/500px-Angkor_Phnom_Bakheng.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Angkor_Phnom_Bakheng.jpg"
  },
  "new_zheng_he": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/A_18th_century_Nanjing_ship_or_sand_ship_from_Tosen_no_Zu.jpg/500px-A_18th_century_Nanjing_ship_or_sand_ship_from_Tosen_no_Zu.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_18th_century_Nanjing_ship_or_sand_ship_from_Tosen_no_Zu.jpg"
  },
  "new_mona_lisa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Crowd_at_Mona_Lisa.jpg/500px-Crowd_at_Mona_Lisa.jpg",
    "c": "Hu Totya, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Crowd_at_Mona_Lisa.jpg"
  },
  "new_mozart": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Mozart_drawing_by_Doris_Stock_1789.jpg/500px-Mozart_drawing_by_Doris_Stock_1789.jpg",
    "c": "Dora Stock, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mozart_drawing_by_Doris_Stock_1789.jpg"
  },
  "new_rembrandt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Nachtwacht-kopie-van-voor-1712.jpg/500px-Nachtwacht-kopie-van-voor-1712.jpg",
    "c": "Attributed to Gerrit Lundens / After Rembrandt, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nachtwacht-kopie-van-voor-1712.jpg"
  },
  "new_mayan_calendar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Tikal.jpg/500px-Tikal.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tikal.jpg"
  },
  "new_hagia_irene": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/ec/Karl_Brullov_-_The_Last_Day_of_Pompeii_-_Google_Art_Project.jpg/500px-Karl_Brullov_-_The_Last_Day_of_Pompeii_-_Google_Art_Project.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 351
  },
  "new_kwame_nkrumah": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/3f/Manchester-fifth-pan-african-conference-1.jpg/500px-Manchester-fifth-pan-african-conference-1.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 499
  },
  "new_srivijaya_peak": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Jogja.kraton.jpg/500px-Jogja.kraton.jpg",
    "c": "User:China_Crisis, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Jogja.kraton.jpg"
  },
  "new_versailles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Grand_Trianon6.JPG/500px-Grand_Trianon6.JPG",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Grand_Trianon6.JPG"
  },
  "new_khmer_rouge_trial": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Choeungek2.JPG/500px-Choeungek2.JPG",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Choeungek2.JPG"
  },
  "new_meroe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Sudan_Meroe_Pyramids_2001.JPG/500px-Sudan_Meroe_Pyramids_2001.JPG",
    "c": "Photographer: B N Chagny, CC BY-SA 1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sudan_Meroe_Pyramids_2001.JPG"
  },
  "new_verdi_aida": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/45/Famous_Composers_and_their_Works_v5_010.jpg/500px-Famous_Composers_and_their_Works_v5_010.jpg",
    "c": "book editor Philip Hale, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Famous_Composers_and_their_Works_v5_010.jpg"
  },
  "new_mongol_post": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5f/Mongol_cavalry.jpg/500px-Mongol_cavalry.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 203
  },
  "new_bamiyan": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c0/Flickr_-_DVIDSHUB_-_Giant_standing_Buddhas_of_Bamiyan_still_cast_shadows_%28Image_2_of_8%29.jpg/500px-Flickr_-_DVIDSHUB_-_Giant_standing_Buddhas_of_Bamiyan_still_cast_shadows_%28Image_2_of_8%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 332
  },
  "new_almaty": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a8/Joe-1_location_prediction_1949.jpg/500px-Joe-1_location_prediction_1949.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 385
  },
  "gr_troy_war": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Makieta_Troja_RB.jpg/500px-Makieta_Troja_RB.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Makieta_Troja_RB.jpg"
  },
  "gr_marathon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/9/97/Ac.marathon.jpg",
    "c": "Adam Carr, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ac.marathon.jpg"
  },
  "gr_caesar_assassinate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Brutus_and_the_Ghost_of_Caesar_1802.jpg/500px-Brutus_and_the_Ghost_of_Caesar_1802.jpg",
    "c": "Edward Scriven, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Brutus_and_the_Ghost_of_Caesar_1802.jpg"
  },
  "gr_rome_fall": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/2d/Invasions_of_the_Roman_Empire_1.png/500px-Invasions_of_the_Roman_Empire_1.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 354
  },
  "gr_thermopylae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/L%C3%A9onidas_aux_Thermopyles_%28Jacques-Louis_David%29.PNG/500px-L%C3%A9onidas_aux_Thermopyles_%28Jacques-Louis_David%29.PNG",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:L%C3%A9onidas_aux_Thermopyles_(Jacques-Louis_David).PNG"
  },
  "gr_alexander_empire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Macedonian_Army_Alexander.jpg/500px-Macedonian_Army_Alexander.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Macedonian_Army_Alexander.jpg"
  },
  "gr_parthenon": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c4/Akropolis_by_Leo_von_Klenze.jpg/500px-Akropolis_by_Leo_von_Klenze.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 343
  },
  "gr_democracy_athens": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Parthenon.jpg/500px-Parthenon.jpg",
    "c": "Tim Bekaert (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon.jpg"
  },
  "gr_olympics": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/11/Vatican_G_23_Group_-_Black-figure_Pseudo-Panathenaic_Amphora_with_Discus_Thrower_-_Walters_482109_-_Side_B.jpg/500px-Vatican_G_23_Group_-_Black-figure_Pseudo-Panathenaic_Amphora_with_Discus_Thrower_-_Walters_482109_-_Side_B.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 617
  },
  "gr_salamis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/de/Aischylos_B%C3%BCste.jpg",
    "c": "UnknownUnknown, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Aischylos_B%C3%BCste.jpg"
  },
  "gr_socrates_trial": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/David_-_The_Death_of_Socrates.jpg/500px-David_-_The_Death_of_Socrates.jpg",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:David_-_The_Death_of_Socrates.jpg"
  },
  "gr_punic_wars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/MessinaStrait.jpg/500px-MessinaStrait.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:MessinaStrait.jpg"
  },
  "gr_vesuvius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Pompeii_Garden_of_the_Fugitives_02.jpg/500px-Pompeii_Garden_of_the_Fugitives_02.jpg",
    "c": "Lancevortex, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pompeii_Garden_of_the_Fugitives_02.jpg"
  },
  "gr_constantinople_fall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Siege_of_a_city%2C_medieval_miniature.jpg/500px-Siege_of_a_city%2C_medieval_miniature.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siege_of_a_city,_medieval_miniature.jpg"
  },
  "gr_peloponnesian_war": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/SizilienExpedition.png/500px-SizilienExpedition.png",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:SizilienExpedition.png"
  },
  "gr_augustus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Statue-Augustus.jpg/500px-Statue-Augustus.jpg",
    "c": "Till Niermann, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Statue-Augustus.jpg"
  },
  "gr_colosseum": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Milan_Naumanchia%2C_1807.jpeg/500px-Milan_Naumanchia%2C_1807.jpeg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Milan_Naumanchia,_1807.jpeg"
  },
  "gr_spartacus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Spartacus_statue_by_Denis_Foyatier.jpg/500px-Spartacus_statue_by_Denis_Foyatier.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Spartacus_statue_by_Denis_Foyatier.jpg"
  },
  "gr_republic_founding": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/ef/Lupa_romana.jpeg",
    "c": "Giorces, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Lupa_romana.jpeg"
  },
  "gr_plato_academy": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c3/Raphael_School_of_Athens.jpg/500px-Raphael_School_of_Athens.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 326
  },
  "gr_gaugamela": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/AlexanderTheGreat_Bust.jpg/500px-AlexanderTheGreat_Bust.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlexanderTheGreat_Bust.jpg"
  },
  "gr_julius_gallic_wars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Ambiorix.jpg/500px-Ambiorix.jpg",
    "c": "ArtMechanic, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ambiorix.jpg"
  },
  "gr_homer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/William-Adolphe_Bouguereau_%281825-1905%29_-_Homer_and_his_Guide_%281874%29.jpg/500px-William-Adolphe_Bouguereau_%281825-1905%29_-_Homer_and_his_Guide_%281874%29.jpg",
    "c": "William-Adolphe Bouguereau, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:William-Adolphe_Bouguereau_(1825-1905)_-_Homer_and_his_Guide_(1874).jpg"
  },
  "gr_persian_wars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Trireme.jpg/500px-Trireme.jpg",
    "c": "F. Mitchell, Department of History, United States Military Academy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Trireme.jpg"
  },
  "gr_herodotus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Edwin_Long_001.jpg/500px-Edwin_Long_001.jpg",
    "c": "Edwin Long, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Edwin_Long_001.jpg"
  },
  "gr_philip_macedon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Filip_II_Macedonia.jpg/500px-Filip_II_Macedonia.jpg",
    "c": "Gunnar Bach Pedersen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Filip_II_Macedonia.jpg"
  },
  "gr_issus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/AlexanderTheGreat_Bust.jpg/500px-AlexanderTheGreat_Bust.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlexanderTheGreat_Bust.jpg"
  },
  "gr_alexandria_founding": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Alexandria_panorama.jpg/500px-Alexandria_panorama.jpg",
    "c": "Wing, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Alexandria_panorama.jpg"
  },
  "gr_library_alexandria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Ancientlibraryalex.jpg/500px-Ancientlibraryalex.jpg",
    "c": "O. Von Corven, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ancientlibraryalex.jpg"
  },
  "gr_rubicon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Foce_rubicone_1_by_Stefano_Bolognini.JPG/500px-Foce_rubicone_1_by_Stefano_Bolognini.JPG",
    "c": "Stefano Bolognini, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Foce_rubicone_1_by_Stefano_Bolognini.JPG"
  },
  "gr_constantine_christianity": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Baux-de-provence-eglise-st-vincent-crucifix.jpg/500px-Baux-de-provence-eglise-st-vincent-crucifix.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Baux-de-provence-eglise-st-vincent-crucifix.jpg"
  },
  "gr_constantinople_founding": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Nuremberg_chronicles_-_CONSTANTINOPEL.png/500px-Nuremberg_chronicles_-_CONSTANTINOPEL.png",
    "c": "Michel Wolgemut, Wilhelm Pleydenwurff (Text: Hartmann Schedel), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nuremberg_chronicles_-_CONSTANTINOPEL.png"
  },
  "gr_justinian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Diptych_Barberini_Louvre_OA3850.JPG/500px-Diptych_Barberini_Louvre_OA3850.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Diptych_Barberini_Louvre_OA3850.JPG"
  },
  "gr_hagia_sophia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/60/Christ_Hagia_Sofia.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Christ_Hagia_Sofia.jpg"
  },
  "gr_hippocrates": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/7c/Hippocrates.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 735
  },
  "gr_euclid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Title_page_of_Sir_Henry_Billingsley%27s_first_English_version_of_Euclid%27s_Elements%2C_1570_%28560x900%29.jpg/500px-Title_page_of_Sir_Henry_Billingsley%27s_first_English_version_of_Euclid%27s_Elements%2C_1570_%28560x900%29.jpg",
    "c": "Charles Thomas-Stanford, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Title_page_of_Sir_Henry_Billingsley%27s_first_English_version_of_Euclid%27s_Elements,_1570_(560x900).jpg"
  },
  "gr_sulla_march": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Sulla_Glyptothek_Munich_309.jpg/500px-Sulla_Glyptothek_Munich_309.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sulla_Glyptothek_Munich_309.jpg"
  },
  "gr_marius_reforms": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e9/Marius_Glyptothek_Munich_319.jpg/500px-Marius_Glyptothek_Munich_319.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 772
  },
  "gr_gracchi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/ef/Lupa_romana.jpeg",
    "c": "Giorces, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Lupa_romana.jpeg"
  },
  "gr_nero_fire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Siemiradski_Fackeln.jpg/500px-Siemiradski_Fackeln.jpg",
    "c": "Henryk Siemiradzki, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siemiradski_Fackeln.jpg"
  },
  "gr_hadrians_wall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Hadrian%27s_Wall_view_near_Greenhead.jpg/500px-Hadrian%27s_Wall_view_near_Greenhead.jpg",
    "c": "Photographed by Mark Burnett, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hadrian%27s_Wall_view_near_Greenhead.jpg"
  },
  "gr_greek_tragedy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Epidaurus_Theater.jpg/500px-Epidaurus_Theater.jpg",
    "c": "Morn, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Epidaurus_Theater.jpg"
  },
  "gr_sophocles_oedipus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/AGMA_Tetradrachm_Athens_5c_BC.jpg/500px-AGMA_Tetradrachm_Athens_5c_BC.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:AGMA_Tetradrachm_Athens_5c_BC.jpg"
  },
  "gr_aristophanes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/AGMA_Tetradrachm_Athens_5c_BC.jpg/500px-AGMA_Tetradrachm_Athens_5c_BC.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:AGMA_Tetradrachm_Athens_5c_BC.jpg"
  },
  "gr_thucydides": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Thucydides-bust-cutout_ROM.jpg/500px-Thucydides-bust-cutout_ROM.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thucydides-bust-cutout_ROM.jpg"
  },
  "gr_sparta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Parthenon.jpg/500px-Parthenon.jpg",
    "c": "Tim Bekaert (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon.jpg"
  },
  "gr_diadochi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Seleuco_I_Nicatore.JPG/500px-Seleuco_I_Nicatore.JPG",
    "c": "Wikimedia Commons, CC BY-SA 2.0 it",
    "p": "https://commons.wikimedia.org/wiki/File:Seleuco_I_Nicatore.JPG"
  },
  "gr_rosetta_stone": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/PepiII-DecreeOfOfficialExactionForTempleOfMin_MetropolitanMuseum.png/500px-PepiII-DecreeOfOfficialExactionForTempleOfMin_MetropolitanMuseum.png",
    "c": "Keith Schengili-Roberts, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:PepiII-DecreeOfOfficialExactionForTempleOfMin_MetropolitanMuseum.png"
  },
  "gr_zama": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Slaget_ved_Zama_-_Cornelis_Cort%2C_1567.jpg/500px-Slaget_ved_Zama_-_Cornelis_Cort%2C_1567.jpg",
    "c": "Cornelis Cort, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Slaget_ved_Zama_-_Cornelis_Cort,_1567.jpg"
  },
  "gr_corinth_destruction": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Parthenon.jpg/500px-Parthenon.jpg",
    "c": "Tim Bekaert (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon.jpg"
  },
  "gr_triumvirate2": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/8b/Antony_with_Octavian_aureus.jpg",
    "c": "You may select the license of your choice., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Antony_with_Octavian_aureus.jpg"
  },
  "gr_pompeii_city": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/1810%28Peregrinus%29.jpg/500px-1810%28Peregrinus%29.jpg",
    "c": "Fer.filol, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1810(Peregrinus).jpg"
  },
  "gr_pax_romana": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/eb/Statue-Augustus.jpg/500px-Statue-Augustus.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 750
  },
  "gr_trajan_column": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/072_Conrad_Cichorius%2C_Die_Reliefs_der_Traianss%C3%A4ule%2C_Tafel_LXXII_%28Ausschnitt_01%29.jpg/500px-072_Conrad_Cichorius%2C_Die_Reliefs_der_Traianss%C3%A4ule%2C_Tafel_LXXII_%28Ausschnitt_01%29.jpg",
    "c": "Attributed to Apollodorus of Damascus / Conrad Cichorius, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:072_Conrad_Cichorius,_Die_Reliefs_der_Traianss%C3%A4ule,_Tafel_LXXII_(Ausschnitt_01).jpg"
  },
  "gr_trajan_empire_peak": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/1f/La_justice_de_Trajan.jpg/500px-La_justice_de_Trajan.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 627
  },
  "gr_diocletian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Istanbul_-_Museo_archeol._-_Diocleziano_%28284-305_d.C.%29_-_Foto_G._Dall%27Orto_28-5-2006.jpg/500px-Istanbul_-_Museo_archeol._-_Diocleziano_%28284-305_d.C.%29_-_Foto_G._Dall%27Orto_28-5-2006.jpg",
    "c": "G.dallorto, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Istanbul_-_Museo_archeol._-_Diocleziano_(284-305_d.C.)_-_Foto_G._Dall%27Orto_28-5-2006.jpg"
  },
  "gr_adrianople": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/O_Fritsche_-_Invasion_of_the_Goths_into_the_Roman_Empire.jpg/500px-O_Fritsche_-_Invasion_of_the_Goths_into_the_Roman_Empire.jpg",
    "c": "O. Fritsche, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:O_Fritsche_-_Invasion_of_the_Goths_into_the_Roman_Empire.jpg"
  },
  "gr_alaric_sack": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b1/Visigoth_migrations.jpg",
    "c": "ru:User:Asta, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Visigoth_migrations.jpg"
  },
  "gr_greek_alphabet": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/33/Duenos_inscription.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Duenos_inscription.jpg"
  },
  "gr_solon_reforms": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Solon.jpg",
    "c": "No machine-readable author provided. Kpjas assumed (based on copyright claims)., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Solon.jpg"
  },
  "gr_sappho": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/0a/NAMA_Sappho_lisant.jpg/500px-NAMA_Sappho_lisant.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 510
  },
  "gr_delian_league": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Peloponnese_modis.jpg/500px-Peloponnese_modis.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Peloponnese_modis.jpg"
  },
  "gr_xenophon_anabasis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/8e/Xenophon.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 771
  },
  "gr_leuctra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/76/Schlacht_bei_Leuktra_Entscheidung.jpg",
    "c": "Benutzer:Nikolaus Vocator, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Schlacht_bei_Leuktra_Entscheidung.jpg"
  },
  "gr_diogenes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Sanzio_01_cropped.png/500px-Sanzio_01_cropped.png",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sanzio_01_cropped.png"
  },
  "gr_alexander_gordian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Alexander_cuts_the_Gordian_Knot.jpg/500px-Alexander_cuts_the_Gordian_Knot.jpg",
    "c": "Jean-Simon Berthélemy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Alexander_cuts_the_Gordian_Knot.jpg"
  },
  "gr_alexander_tyre": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/AlexanderTheGreat_Bust.jpg/500px-AlexanderTheGreat_Bust.jpg",
    "c": "Unknown authorUnknown author, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:AlexanderTheGreat_Bust.jpg"
  },
  "gr_ptolemaic_egypt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Parthenon.jpg/500px-Parthenon.jpg",
    "c": "Tim Bekaert (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon.jpg"
  },
  "gr_seleucid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/26/DemetriusII.jpg",
    "c": "The original uploader was PHG at English Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DemetriusII.jpg"
  },
  "gr_pharos": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/Alexandria_panorama.jpg/500px-Alexandria_panorama.jpg",
    "c": "Wing, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Alexandria_panorama.jpg"
  },
  "gr_roman_roads": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/FormiaCastelloneTorre.jpg/500px-FormiaCastelloneTorre.jpg",
    "c": "MM, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:FormiaCastelloneTorre.jpg"
  },
  "gr_aqueducts": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Part_of_Tabula_Peutingeriana.jpg/500px-Part_of_Tabula_Peutingeriana.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Part_of_Tabula_Peutingeriana.jpg"
  },
  "gr_gladiators": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Jean-Leon_Gerome_Pollice_Verso.jpg/500px-Jean-Leon_Gerome_Pollice_Verso.jpg",
    "c": "Jean-Léon Gérôme, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jean-Leon_Gerome_Pollice_Verso.jpg"
  },
  "gr_mithridatic_wars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Sulla_Glyptothek_Munich_309.jpg/500px-Sulla_Glyptothek_Munich_309.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sulla_Glyptothek_Munich_309.jpg"
  },
  "gr_crassus_parthia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/ef/Lupa_romana.jpeg",
    "c": "Giorces, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Lupa_romana.jpeg"
  },
  "gr_pharsalus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Battle_of_Pharsalus%2C_48_BC.png/500px-Battle_of_Pharsalus%2C_48_BC.png",
    "c": "The Department of History, United States Military Academy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_Pharsalus,_48_BC.png"
  },
  "gr_virgil_aeneid": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f7/Aeneas%27_Flight_from_Troy_by_Federico_Barocci.jpg/500px-Aeneas%27_Flight_from_Troy_by_Federico_Barocci.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 347
  },
  "gr_ovid_metamorphoses": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Turner_Ovid_Banished_from_Rome.jpg/500px-Turner_Ovid_Banished_from_Rome.jpg",
    "c": "J. M. W. Turner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Turner_Ovid_Banished_from_Rome.jpg"
  },
  "gr_caligula": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Gaius_Caesar_Caligula.jpg/500px-Gaius_Caesar_Caligula.jpg",
    "c": "Louis le Grand, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gaius_Caesar_Caligula.jpg"
  },
  "gr_claudius_britain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Claudius_%28M.A.N._Madrid%29_01.jpg/500px-Claudius_%28M.A.N._Madrid%29_01.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Claudius_(M.A.N._Madrid)_01.jpg"
  },
  "gr_boudicca": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/fc/Boudiccastatue.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 348
  },
  "gr_pantheon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Rome_Pantheon_front.jpg/500px-Rome_Pantheon_front.jpg",
    "c": "Roberta Dragan, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Rome_Pantheon_front.jpg"
  },
  "gr_julian_apostle": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/63/Saint_Mercurius_killing_Iulian.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Saint_Mercurius_killing_Iulian.jpg"
  },
  "gr_theodosius_christianity": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/8d/Theodosius_I._Roman_Coin.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Theodosius_I._Roman_Coin.jpg"
  },
  "gr_vandals_rome": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/The_Roman_Empire_ca_400_AD.png/500px-The_Roman_Empire_ca_400_AD.png",
    "c": "Cplakidas, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Roman_Empire_ca_400_AD.png"
  },
  "gr_belisarius": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b1/David_-_Belisarius.jpg/500px-David_-_Belisarius.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 465
  },
  "gr_justinian_plague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Diptych_Barberini_Louvre_OA3850.JPG/500px-Diptych_Barberini_Louvre_OA3850.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Diptych_Barberini_Louvre_OA3850.JPG"
  },
  "gr_nika_riots": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Diptych_Barberini_Louvre_OA3850.JPG/500px-Diptych_Barberini_Louvre_OA3850.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Diptych_Barberini_Louvre_OA3850.JPG"
  },
  "gr_iconoclasm": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Byzantinischer_Mosaizist_des_13._Jahrhunderts_001.jpg/500px-Byzantinischer_Mosaizist_des_13._Jahrhunderts_001.jpg",
    "c": "Byzantine mosaicist of the 13th century, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Byzantinischer_Mosaizist_des_13._Jahrhunderts_001.jpg"
  },
  "gr_basil_ii": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/dc/Basilios_II.jpg/500px-Basilios_II.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 621
  },
  "gr_fourth_crusade": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Siege_of_a_city%2C_medieval_miniature.jpg/500px-Siege_of_a_city%2C_medieval_miniature.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Siege_of_a_city,_medieval_miniature.jpg"
  },
  "gr_greek_fire": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f7/Greekfire-madridskylitzes1.jpg/500px-Greekfire-madridskylitzes1.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 256
  },
  "gr_pythagoras": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/3d/Kapitolinischer_Pythagoras.jpg",
    "c": "The original uploader was Galilea at German Wikipedia., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kapitolinischer_Pythagoras.jpg"
  },
  "gr_heraclitus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/fa/Heraclitus%2C_Johannes_Moreelse.jpg",
    "c": "Johannes Moreelse, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Heraclitus,_Johannes_Moreelse.jpg"
  },
  "gr_democritus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/AGMA_Tetradrachm_Athens_5c_BC.jpg/500px-AGMA_Tetradrachm_Athens_5c_BC.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:AGMA_Tetradrachm_Athens_5c_BC.jpg"
  },
  "gr_stoicism": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Stoa_in_Athens.jpg/500px-Stoa_in_Athens.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Stoa_in_Athens.jpg"
  },
  "gr_epicurus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Sanzio_01_cropped.png/500px-Sanzio_01_cropped.png",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sanzio_01_cropped.png"
  },
  "gr_ptolemy_almagest": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b3/PappusBook.jpg",
    "c": "Federico Commandino, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:PappusBook.jpg"
  },
  "gr_galen": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Medicine_aryballos_Louvre_CA1989-2183.jpg/500px-Medicine_aryballos_Louvre_CA1989-2183.jpg",
    "c": "Clinic Painter (eponymous vase), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Medicine_aryballos_Louvre_CA1989-2183.jpg"
  },
  "gr_seneca": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Nero-Summer_Garden-Saint_Petersburg.jpg/500px-Nero-Summer_Garden-Saint_Petersburg.jpg",
    "c": "Yair Haklai, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nero-Summer_Garden-Saint_Petersburg.jpg"
  },
  "gr_epictetus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Sanzio_01_cropped.png/500px-Sanzio_01_cropped.png",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sanzio_01_cropped.png"
  },
  "gr_roman_baths": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Baths_of_Diocletian-Antmoose1.jpg/500px-Baths_of_Diocletian-Antmoose1.jpg",
    "c": "Wikimedia Commons, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Baths_of_Diocletian-Antmoose1.jpg"
  },
  "gr_pont_du_gard": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Pontdugard.png/500px-Pontdugard.png",
    "c": "Édouard Baldus, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pontdugard.png"
  },
  "gr_roman_senate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/RomeViaSacra01.jpg/500px-RomeViaSacra01.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:RomeViaSacra01.jpg"
  },
  "gr_polis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Hephaistos.temple.AC.02.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hephaistos.temple.AC.02.jpg"
  },
  "gr_greek_colonization": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Parthenon.jpg/500px-Parthenon.jpg",
    "c": "Tim Bekaert (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon.jpg"
  },
  "gr_persian_royal_road": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/68/Persepolis_stairs_of_the_Apadana_relief.jpg/500px-Persepolis_stairs_of_the_Apadana_relief.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 335
  },
  "gr_delphic_oracle": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Delphi_stadium_DSC06305.jpg/500px-Delphi_stadium_DSC06305.jpg",
    "c": "Copyright © 2004 David Monniaux, CC BY-SA 1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Delphi_stadium_DSC06305.jpg"
  },
  "gr_tyrants": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Representacion_romantica_de_la_batalla_de_Himera.jpg/500px-Representacion_romantica_de_la_batalla_de_Himera.jpg",
    "c": "Giuseppe Sciuti, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Representacion_romantica_de_la_batalla_de_Himera.jpg"
  },
  "gr_thales": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Parthenon.jpg/500px-Parthenon.jpg",
    "c": "Tim Bekaert (talk · contribs), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon.jpg"
  },
  "gr_empedocles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/79/Empedokles.jpeg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Empedokles.jpeg"
  },
  "gr_parmenides": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Sanzio_01_Plato_Aristotle.jpg/500px-Sanzio_01_Plato_Aristotle.jpg",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sanzio_01_Plato_Aristotle.jpg"
  },
  "gr_pindar_odes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Pindar_statue.jpg/500px-Pindar_statue.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pindar_statue.jpg"
  },
  "gr_pergamon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2d/Pergamonmuseum_Pergamonaltar.jpg/500px-Pergamonmuseum_Pergamonaltar.jpg",
    "c": "Raimond Spekking, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pergamonmuseum_Pergamonaltar.jpg"
  },
  "gr_corinthian_order": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/e7/Corint.JPG",
    "c": "Napoleon Vier at Dutch Wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Corint.JPG"
  },
  "gr_venus_milo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/63/Vindplaats_venus_van_milo.jpg",
    "c": "By Idsert Joukes, 2 June 2003, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Vindplaats_venus_van_milo.jpg"
  },
  "gr_laocoon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/El_Greco_042.jpg/500px-El_Greco_042.jpg",
    "c": "El Greco, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:El_Greco_042.jpg"
  },
  "gr_samnite_wars": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/World_in_300_BCE.PNG/500px-World_in_300_BCE.PNG",
    "c": "Javierfv1212, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:World_in_300_BCE.PNG"
  },
  "gr_colosseum_games": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Milan_Naumanchia%2C_1807.jpeg/500px-Milan_Naumanchia%2C_1807.jpeg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Milan_Naumanchia,_1807.jpeg"
  },
  "gr_teutoburg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Varus01.jpg/500px-Varus01.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Varus01.jpg"
  },
  "gr_josephus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Josephus.jpg/500px-Josephus.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Josephus.jpg"
  },
  "gr_septimius_severus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/f7/Aureus_Septimius_Severus-193-leg_XIIII_GMV.jpg",
    "c": "Panairjdde, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Aureus_Septimius_Severus-193-leg_XIIII_GMV.jpg"
  },
  "gr_aurelian_walls": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/10/Celio_-_le_mura_tra_porta_san_Sebastiano_e_porta_Ardeatina_2004.JPG/500px-Celio_-_le_mura_tra_porta_san_Sebastiano_e_porta_Ardeatina_2004.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "gr_attila": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Attila_%C3%BCberreitet_Italien_und_die_K%C3%BCnste%2C_Detail_%28Eug%C3%A8ne_Ferdinand_Victor_Delacroix%29.jpg/500px-Attila_%C3%BCberreitet_Italien_und_die_K%C3%BCnste%2C_Detail_%28Eug%C3%A8ne_Ferdinand_Victor_Delacroix%29.jpg",
    "c": "Eugène Delacroix, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Attila_%C3%BCberreitet_Italien_und_die_K%C3%BCnste,_Detail_(Eug%C3%A8ne_Ferdinand_Victor_Delacroix).jpg"
  },
  "gr_battle_yarmouk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Arabischer_Maler_um_1335_003.jpg/500px-Arabischer_Maler_um_1335_003.jpg",
    "c": "arabic painter circa 1335date QS:P,+1335-00-00T00:00:00Z/9,P1480,Q5727902, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Arabischer_Maler_um_1335_003.jpg"
  },
  "gr_byzantium_1261": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/SiegeofAntioch.jpeg/500px-SiegeofAntioch.jpeg",
    "c": "Jean Colombe, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:SiegeofAntioch.jpeg"
  },
  "gr_constantine_xi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Rome-Capitole-StatueConstantin.jpg/500px-Rome-Capitole-StatueConstantin.jpg",
    "c": "Jean-Christophe BENOIST, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Rome-Capitole-StatueConstantin.jpg"
  },
  "gr_census_rome": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/87/Altar_Domitius_Ahenobarbus_Louvre_n1.jpg/500px-Altar_Domitius_Ahenobarbus_Louvre_n1.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 345
  },
  "gr_roman_marriage": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Statue-Augustus.jpg/500px-Statue-Augustus.jpg",
    "c": "Till Niermann, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Statue-Augustus.jpg"
  },
  "gr_latin_language": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Arco_Sisto_V_targa_M.jpg/500px-Arco_Sisto_V_targa_M.jpg",
    "c": "Flazaza, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Arco_Sisto_V_targa_M.jpg"
  },
  "gr_titus_arch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Canaletto_%28I%29_054.jpg/500px-Canaletto_%28I%29_054.jpg",
    "c": "Bernardo Bellotto, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Canaletto_(I)_054.jpg"
  },
  "gr_edict_caracalla": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b1/Caracalla_Denarius_RIC_0118b.jpg",
    "c": "CNG[1], CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Caracalla_Denarius_RIC_0118b.jpg"
  },
  "gr_decius_persecution": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/f0/Aureus-Trajan_Decius-RIC_0029a.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Aureus-Trajan_Decius-RIC_0029a.jpg"
  },
  "gr_roman_currency": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/72/Roman_silver_coin%2C_Trajan_denarius%2C_Rome_%28FindID_641244%29.jpg/500px-Roman_silver_coin%2C_Trajan_denarius%2C_Rome_%28FindID_641244%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 269
  },
  "gr_roman_concrete": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4c/Pantheon_%28Rome%29%2C_Dome_interior.jpg/500px-Pantheon_%28Rome%29%2C_Dome_interior.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 428
  },
  "gr_saturnalia": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/ce/Saturnalia_by_Antoine_Callet.jpg/500px-Saturnalia_by_Antoine_Callet.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 501
  },
  "gr_eleusinian": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/85/NAMA_Myst%C3%A8res_d%27Eleusis.jpg/500px-NAMA_Myst%C3%A8res_d%27Eleusis.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 600
  },
  "gr_greek_vases": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7c/Amphora_protogeometric_BM_A1123.jpg/500px-Amphora_protogeometric_BM_A1123.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 629
  },
  "gr_roman_slavery": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Official_medallion_of_the_British_Anti-Slavery_Society_%281795%29.jpg/500px-Official_medallion_of_the_British_Anti-Slavery_Society_%281795%29.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Official_medallion_of_the_British_Anti-Slavery_Society_(1795).jpg"
  },
  "gr_ostia": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4e/%27Port_of_Ostia_in_Calm_Weather%27%2C_oil_on_canvas_painting_by_Leonardo_Cocorante%2C_1740s%2C_Lowe_Art_Museum.jpg/500px-%27Port_of_Ostia_in_Calm_Weather%27%2C_oil_on_canvas_painting_by_Leonardo_Cocorante%2C_1740s%2C_Lowe_Art_Museum.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 354
  },
  "gr_miletus_school": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Sanzio_01_cropped.png/500px-Sanzio_01_cropped.png",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sanzio_01_cropped.png"
  },
  "gr_livy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/70/Titus_Livius.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Titus_Livius.jpg"
  },
  "gr_greek_music": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Hephaistos.temple.AC.02.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hephaistos.temple.AC.02.jpg"
  },
  "gr_roman_citizenship": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Bronze-Uranius_Antoninus-Elagabal_stone-SGI_4414.jpg/500px-Bronze-Uranius_Antoninus-Elagabal_stone-SGI_4414.jpg",
    "c": "Panairjdde ?, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bronze-Uranius_Antoninus-Elagabal_stone-SGI_4414.jpg"
  },
  "mu_beethoven_9th": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Beethoven.jpg/500px-Beethoven.jpg",
    "c": "Joseph Karl Stieler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Beethoven.jpg"
  },
  "mu_mozart_born": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/1e/Wolfgang-amadeus-mozart_1.jpg/500px-Wolfgang-amadeus-mozart_1.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 641
  },
  "mu_elvis_heartbreak": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/56/Elvis-Presley-Jacksonville-1955.jpg/500px-Elvis-Presley-Jacksonville-1955.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 368
  },
  "mu_woodstock": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Woodstock_redmond_cocker.JPG/500px-Woodstock_redmond_cocker.JPG",
    "c": "Derek Redmond and Paul Campbell, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Woodstock_redmond_cocker.JPG"
  },
  "mu_vivaldi_seasons": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Vivaldi.jpg/500px-Vivaldi.jpg",
    "c": "Unidentified painter, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Vivaldi.jpg"
  },
  "mu_bob_marley_exodus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Hollywood_Walk_of_Fame_stars_-_Bob_Marley.jpg/500px-Hollywood_Walk_of_Fame_stars_-_Bob_Marley.jpg",
    "c": "Sten Rüdrich, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Hollywood_Walk_of_Fame_stars_-_Bob_Marley.jpg"
  },
  "mu_stravinsky_rite": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/2e/Solovey_by_A._Benois_02.jpg",
    "c": "A. Benois, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Solovey_by_A._Benois_02.jpg"
  },
  "mu_miles_blue": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Pomnik_Milesa_Davisa_Kielce_01_ssj_20060304.jpg/500px-Pomnik_Milesa_Davisa_Kielce_01_ssj_20060304.jpg",
    "c": "Paweł Cieśla Staszek_Szybki_Jest, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pomnik_Milesa_Davisa_Kielce_01_ssj_20060304.jpg"
  },
  "mu_chopin_paris": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Frederic_Chopin_photo.jpeg/500px-Frederic_Chopin_photo.jpeg",
    "c": "Louis-Auguste Bisson, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Frederic_Chopin_photo.jpeg"
  },
  "mu_queen_bohemian": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/ef/Freddie_Mercury_performing_in_New_Haven%2C_CT%2C_November_1977.jpg/500px-Freddie_Mercury_performing_in_New_Haven%2C_CT%2C_November_1977.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 742
  },
  "mu_handel_messiah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Haendel.jpg/500px-Haendel.jpg",
    "c": "Balthasar Denner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Haendel.jpg"
  },
  "mu_wagner_ring": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/RichardWagner.jpg/500px-RichardWagner.jpg",
    "c": "Franz Hanfstaengl, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:RichardWagner.jpg"
  },
  "mu_bob_dylan_electric": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Joan_Baez_Bob_Dylan.jpg/500px-Joan_Baez_Bob_Dylan.jpg",
    "c": "Rowland Scherman, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Joan_Baez_Bob_Dylan.jpg"
  },
  "mu_nirvana_nevermind": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/19/Nirvana_around_1992.jpg",
    "c": "P.B. Rage from USA, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nirvana_around_1992.jpg"
  },
  "mu_pink_floyd_wall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/DarkSideOfTheMoon1973.jpg/500px-DarkSideOfTheMoon1973.jpg",
    "c": "TimDuncan, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:DarkSideOfTheMoon1973.jpg"
  },
  "mu_verdi_aida": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Giuseppe_Verdi_by_Giovanni_Boldini.jpg/500px-Giuseppe_Verdi_by_Giovanni_Boldini.jpg",
    "c": "Giovanni Boldini, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Giuseppe_Verdi_by_Giovanni_Boldini.jpg"
  },
  "mu_armstrong_west_end": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Louis_Armstrong_NYWTS2.jpg/500px-Louis_Armstrong_NYWTS2.jpg",
    "c": "Herman Hiller, World-Telegram staff photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Louis_Armstrong_NYWTS2.jpg"
  },
  "mu_monteverdi_orfeo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Claudio_Monteverdi.jpg/500px-Claudio_Monteverdi.jpg",
    "c": "After Bernardo Strozzi, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Claudio_Monteverdi.jpg"
  },
  "mu_led_zep_iv": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Led_Zeppelin_2007.jpg/500px-Led_Zeppelin_2007.jpg",
    "c": "p_a_h from United Kingdom, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Led_Zeppelin_2007.jpg"
  },
  "mu_tchaikovsky_nutcracker": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Snowdance.jpg/500px-Snowdance.jpg",
    "c": "Rick Dikeman, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Snowdance.jpg"
  },
  "mu_aretha_respect": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Aretha_Franklin_on_January_20%2C_2009.jpg/500px-Aretha_Franklin_on_January_20%2C_2009.jpg",
    "c": "Cecilio Ricardo, U.S. Air Force, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Aretha_Franklin_on_January_20,_2009.jpg"
  },
  "mu_opera_birth": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/bd/Jacopo_Peri_1.jpg/500px-Jacopo_Peri_1.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 599
  },
  "mu_hendrix_monterey": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Jimi_Hendrix_Memorial.jpg/500px-Jimi_Hendrix_Memorial.jpg",
    "c": "Glenn Watkins from Vancouver, Canada, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Jimi_Hendrix_Memorial.jpg"
  },
  "mu_reggae_jamaica": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Hollywood_Walk_of_Fame_stars_-_Bob_Marley.jpg/500px-Hollywood_Walk_of_Fame_stars_-_Bob_Marley.jpg",
    "c": "Sten Rüdrich, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Hollywood_Walk_of_Fame_stars_-_Bob_Marley.jpg"
  },
  "mu_haydn_farewell": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Haydn_portrait_by_Thomas_Hardy_%28small%29.jpg/500px-Haydn_portrait_by_Thomas_Hardy_%28small%29.jpg",
    "c": "Thomas Hardy, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Haydn_portrait_by_Thomas_Hardy_(small).jpg"
  },
  "mu_rolling_stones_satisfaction": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Mick_Jagger_and_Ron_Wood_-_Rolling_Stones_-_1975.jpg/500px-Mick_Jagger_and_Ron_Wood_-_Rolling_Stones_-_1975.jpg",
    "c": "Jim Summaria, http://www.jimsummariaphoto.com/, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mick_Jagger_and_Ron_Wood_-_Rolling_Stones_-_1975.jpg"
  },
  "mu_coltrane_love_supreme": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/U.S._Naval_Reserve_portrait_of_Johnny_Coltrane_edit.jpg/500px-U.S._Naval_Reserve_portrait_of_Johnny_Coltrane_edit.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:U.S._Naval_Reserve_portrait_of_Johnny_Coltrane_edit.jpg"
  },
  "mu_punk_sex_pistols": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Sex_Pistols_in_Paradiso.jpg/500px-Sex_Pistols_in_Paradiso.jpg",
    "c": "Wikimedia Commons, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Sex_Pistols_in_Paradiso.jpg"
  },
  "mu_debussy_prelude": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Claude_Debussy_portrait.jpg/500px-Claude_Debussy_portrait.jpg",
    "c": "Otto (Otto Wegener, 1849-1924) [1], Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Claude_Debussy_portrait.jpg"
  },
  "mu_motown_founded": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Hitsville_USA.jpg/500px-Hitsville_USA.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hitsville_USA.jpg"
  },
  "mu_schoenberg_twelve_tone": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Arnold_Schoenberg_la_1948.jpg/500px-Arnold_Schoenberg_la_1948.jpg",
    "c": "Florence Homolka, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Arnold_Schoenberg_la_1948.jpg"
  },
  "mu_gregorian_chant": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/15/Graduale_Aboense_2.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 757
  },
  "mu_prince_purple_rain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Prince_by_jimieye.jpg/500px-Prince_by_jimieye.jpg",
    "c": "jimieye from flickr.com - https://www.flickr.com/photos/jimieye/, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Prince_by_jimieye.jpg"
  },
  "mu_hip_hop_birth": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Pete_Rock_at_Launch_Party.jpg/500px-Pete_Rock_at_Launch_Party.jpg",
    "c": "pinguino k from North Hollywood, USA, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pete_Rock_at_Launch_Party.jpg"
  },
  "mu_billie_holiday_fruit": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Billie_Holiday_1949.jpg/500px-Billie_Holiday_1949.jpg",
    "c": "Carl Van Vechten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Billie_Holiday_1949.jpg"
  },
  "mu_david_bowie_ziggy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/David_Bowie_%281987%29.jpg/500px-David_Bowie_%281987%29.jpg",
    "c": "Elmar J. Lordemann (de:User:Jo Atmon), CC BY-SA 2.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:David_Bowie_(1987).jpg"
  },
  "mu_liszt_weimar": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/69/Liszt-kaulbach.jpg/500px-Liszt-kaulbach.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 619
  },
  "mu_kraftwerk_autobahn": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Kraftwerk_live_in_Stockholm.jpg/500px-Kraftwerk_live_in_Stockholm.jpg",
    "c": "Andréas Hagström, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kraftwerk_live_in_Stockholm.jpg"
  },
  "mu_naomi_shemer_gold": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/98/Naomi_Shemer_D507-159_%28cropped%29.jpg/500px-Naomi_Shemer_D507-159_%28cropped%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 500
  },
  "mu_radiohead_ok": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Radiohead.jpg/500px-Radiohead.jpg",
    "c": "Samuel Wiki, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Radiohead.jpg"
  },
  "mu_ellington_cotton_club": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/af/Duke_Ellington_-_publicity.JPG/500px-Duke_Ellington_-_publicity.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 610
  },
  "mu_blues_delta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/DeltaMS.png/500px-DeltaMS.png",
    "c": "Ori~, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:DeltaMS.png"
  },
  "mu_stevie_wonder_innervisions": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Stevie_Wonder.jpg/500px-Stevie_Wonder.jpg",
    "c": "Antonio Cruz/ABr, CC BY 3.0 br",
    "p": "https://commons.wikimedia.org/wiki/File:Stevie_Wonder.jpg"
  },
  "mu_marvin_gaye_going_on": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/0a/Marvin_Gaye_in_1973.jpg/500px-Marvin_Gaye_in_1973.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "mu_madonna_like_virgin": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b1/Madonna_Rebel_Heart_Tour_2015_-_Stockholm_%2823051472299%29_%28cropped%29.jpg/500px-Madonna_Rebel_Heart_Tour_2015_-_Stockholm_%2823051472299%29_%28cropped%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 733
  },
  "mu_notre_dame_school": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/12/Perotin_-_Alleluia_nativitas.jpg/500px-Perotin_-_Alleluia_nativitas.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 857
  },
  "mu_bach_matthew": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/f2/Passionhandschrift.jpg",
    "c": "Current user., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Passionhandschrift.jpg"
  },
  "mu_tupac_eyez": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/MARTa_Paolo_Chiasera_www.tupacproject.it.jpg/500px-MARTa_Paolo_Chiasera_www.tupacproject.it.jpg",
    "c": "ludger1961, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:MARTa_Paolo_Chiasera_www.tupacproject.it.jpg"
  },
  "mu_thelonious_monk_round": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Thelonious_Monk%2C_Minton%27s_Playhouse%2C_New_York%2C_N.Y.%2C_ca._Sept._1947_%28William_P._Gottlieb_06191%29.jpg/500px-Thelonious_Monk%2C_Minton%27s_Playhouse%2C_New_York%2C_N.Y.%2C_ca._Sept._1947_%28William_P._Gottlieb_06191%29.jpg",
    "c": "William P. Gottlieb / Adam Cuerden, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thelonious_Monk,_Minton%27s_Playhouse,_New_York,_N.Y.,_ca._Sept._1947_(William_P._Gottlieb_06191).jpg"
  },
  "mu_guido_arezzo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/53/Guido_van_Arezzo.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 744
  },
  "mu_eminem_slim_shady": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Eminem_and_Rihanna_in_Love_the_Way_You_Lie1.jpg/500px-Eminem_and_Rihanna_in_Love_the_Way_You_Lie1.jpg",
    "c": "Brandy Shaul, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Eminem_and_Rihanna_in_Love_the_Way_You_Lie1.jpg"
  },
  "mu_buena_vista": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Ibrahimferrer.JPG/500px-Ibrahimferrer.JPG",
    "c": "CODIGO PAIS, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ibrahimferrer.JPG"
  },
  "mu_schubert_winterreise": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Franz_Schubert.jpg/500px-Franz_Schubert.jpg",
    "c": "Josef Kriehuber, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Franz_Schubert.jpg"
  },
  "mu_public_enemy_nation": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/79/Public_Enemy_Zagreb_2006_%2802%29.jpg/500px-Public_Enemy_Zagreb_2006_%2802%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "mu_house_chicago": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/1d/TB-303.jpg",
    "c": "User ミシャー on de.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:TB-303.jpg"
  },
  "mu_shalom_hanoch_waiting": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/d6/Shalom_Hanoch_2.jpg",
    "c": "Morshem, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Shalom_Hanoch_2.jpg"
  },
  "mu_kendrick_damn": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Kendrick_Lamar_Pitchfork_2012.jpg/500px-Kendrick_Lamar_Pitchfork_2012.jpg",
    "c": "gozamos, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kendrick_Lamar_Pitchfork_2012.jpg"
  },
  "mu_kanye_graduation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Kanye_West_2007.jpg/500px-Kanye_West_2007.jpg",
    "c": "Shahril Affandi Radzali, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kanye_West_2007.jpg"
  },
  "mu_mahler_8th": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/MahlerSecondSymMov4AltSolo.png/500px-MahlerSecondSymMov4AltSolo.png",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:MahlerSecondSymMov4AltSolo.png"
  },
  "mu_record_player": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/EdisonPhonograph.jpg/500px-EdisonPhonograph.jpg",
    "c": "Norman Bruderhofer, www.cylinder.de, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:EdisonPhonograph.jpg"
  },
  "mu_techno_detroit": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/ef/Model_500.jpg",
    "c": "Dave Walker from Royal Oak, MI, USA, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Model_500.jpg"
  },
  "mu_troubadours": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/9/98/BnF_ms._12473_fol._110v_-_Na_Castelloza_%282%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 666
  },
  "mu_bartok_concerto": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/66/Bart%C3%B3k_B%C3%A9la_1927.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bart%C3%B3k_B%C3%A9la_1927.jpg"
  },
  "mu_clash_london": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Clash_21051980_12_800.jpg/500px-Clash_21051980_12_800.jpg",
    "c": "Helge Øverås, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Clash_21051980_12_800.jpg"
  },
  "mu_puccini_boheme": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/GiacomoPuccini.jpg/500px-GiacomoPuccini.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:GiacomoPuccini.jpg"
  },
  "mu_beatles_sgt_pepper": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Affiche_MrKite.jpg/500px-Affiche_MrKite.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Affiche_MrKite.jpg"
  },
  "mu_ars_nova": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/12/Perotin_-_Alleluia_nativitas.jpg/500px-Perotin_-_Alleluia_nativitas.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 857
  },
  "mu_kpop_gangnam": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/63/Psy_2012.jpg/500px-Psy_2012.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 703
  },
  "mu_idan_raichel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Idan_Raichel.jpg/500px-Idan_Raichel.jpg",
    "c": "Idan Raichel project, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Idan_Raichel.jpg"
  },
  "mu_shostakovich_5th": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/%D0%9A%D0%BE%D0%BC%D0%BF%D0%BE%D0%B7%D0%B8%D1%82%D0%BE%D1%80_%D0%94%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B9_%D0%94%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B5%D0%B2%D0%B8%D1%87_%D0%A8%D0%BE%D1%81%D1%82%D0%B0%D0%BA%D0%BE%D0%B2%D0%B8%D1%87.jpg/500px-%D0%9A%D0%BE%D0%BC%D0%BF%D0%BE%D0%B7%D0%B8%D1%82%D0%BE%D1%80_%D0%94%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B9_%D0%94%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B5%D0%B2%D0%B8%D1%87_%D0%A8%D0%BE%D1%81%D1%82%D0%B0%D0%BA%D0%BE%D0%B2%D0%B8%D1%87.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%D0%9A%D0%BE%D0%BC%D0%BF%D0%BE%D0%B7%D0%B8%D1%82%D0%BE%D1%80_%D0%94%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B9_%D0%94%D0%BC%D0%B8%D1%82%D1%80%D0%B8%D0%B5%D0%B2%D0%B8%D1%87_%D0%A8%D0%BE%D1%81%D1%82%D0%B0%D0%BA%D0%BE%D0%B2%D0%B8%D1%87.jpg"
  },
  "mu_greek_lyre": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/91/Lyre_of_Ur.jpg/500px-Lyre_of_Ur.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "mu_rachmaninoff_2nd": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Sergei_Rachmaninoff%2C_1910s.jpg/500px-Sergei_Rachmaninoff%2C_1910s.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sergei_Rachmaninoff,_1910s.jpg"
  },
  "mu_dvorak_new_world": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Dvorak.jpg/500px-Dvorak.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dvorak.jpg"
  },
  "mu_u2_joshua": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/43/Tim_Shaughnessy_as_Bono%2C_Desire_U2_Tribute_TOTK_2025.jpg/500px-Tim_Shaughnessy_as_Bono%2C_Desire_U2_Tribute_TOTK_2025.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 748
  },
  "mu_nwa_compton": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/7b/NWA-Logo.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 243
  },
  "mu_ethnix_ya_habibi": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/29/Ethnix2012-2.jpg/500px-Ethnix2012-2.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 376
  },
  "mu_messiaen_turangalila": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/64/Eglise_St_Louis_en_l_Ile-_The_Christ.JPG/500px-Eglise_St_Louis_en_l_Ile-_The_Christ.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "mu_abbey_road": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/The_Beatles_Abbey_Road_album_cover.jpg/500px-The_Beatles_Abbey_Road_album_cover.jpg",
    "c": "John Kosh / Iain Macmillan, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Beatles_Abbey_Road_album_cover.jpg"
  },
  "mu_mtv_launch": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/72/Columbia_University_Lion_Dance_team_at_MTV_Chi_studios%2C_New_York_City%2C_New_York%2C_USA_-_20051205.jpg/500px-Columbia_University_Lion_Dance_team_at_MTV_Chi_studios%2C_New_York_City%2C_New_York%2C_USA_-_20051205.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "mu_bach_goldberg": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Goldberg-titlepage.png/500px-Goldberg-titlepage.png",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Goldberg-titlepage.png"
  },
  "mu_spotify_launch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Cropped_image_of_Daniel_Ek.jpg/500px-Cropped_image_of_Daniel_Ek.jpg",
    "c": "Patrik Ragnarsson from Linköping, Sweden, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cropped_image_of_Daniel_Ek.jpg"
  },
  "mu_sumer_hymn": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b6/Ur_lyre.jpg/500px-Ur_lyre.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 500
  },
  "mu_beyonce_lemonade": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/97/Beyonce_Smile2.jpg/500px-Beyonce_Smile2.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 676
  },
  "mu_vivaldi_born": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Vivaldi.jpg/500px-Vivaldi.jpg",
    "c": "Unidentified painter, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Vivaldi.jpg"
  },
  "mu_grunge_seattle": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Seattle_Center_as_night_falls.jpg/500px-Seattle_Center_as_night_falls.jpg",
    "c": "Jeffery Hayes, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Seattle_Center_as_night_falls.jpg"
  },
  "mu_robert_johnson_crossroads": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/b3/Robert_Johnson.png/500px-Robert_Johnson.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 722
  },
  "mu_rave_uk": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/1d/TB-303.jpg",
    "c": "User ミシャー on de.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:TB-303.jpg"
  },
  "mu_carmen_premiere": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Georges_bizet.jpg/500px-Georges_bizet.jpg",
    "c": "Étienne Carjat, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Georges_bizet.jpg"
  },
  "mu_printing_music": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/IMSLP_main_page_2016.png/500px-IMSLP_main_page_2016.png",
    "c": "IMSLP / Petrucci Music Library, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:IMSLP_main_page_2016.png"
  },
  "mu_acid_house_303": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/fd/Roland_TB-303_Panel.jpg/500px-Roland_TB-303_Panel.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 246
  },
  "mu_glass_einstein": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Philip-Glass-DGQ-14.jpg/500px-Philip-Glass-DGQ-14.jpg",
    "c": "Fronobulax, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Philip-Glass-DGQ-14.jpg"
  },
  "mu_umm_kulthum": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Umm_Kulthum4.jpg/500px-Umm_Kulthum4.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Umm_Kulthum4.jpg"
  },
  "mu_sabbath_black": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/04/Black_Sabbath_1999-12-16_Stuttgart.jpg",
    "c": "Alex Ex, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Black_Sabbath_1999-12-16_Stuttgart.jpg"
  },
  "mu_persian_maqam": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/85/Persian_Tar.jpg/500px-Persian_Tar.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 890
  },
  "mu_la_scala_opens": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Milano_scala_2005.jpg/500px-Milano_scala_2005.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Milano_scala_2005.jpg"
  },
  "mu_prokofiev_romeo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Romeo_and_juliet_brown.jpg/500px-Romeo_and_juliet_brown.jpg",
    "c": "Ford Madox Brown, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Romeo_and_juliet_brown.jpg"
  },
  "mu_flamenco_cafes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/76/Edison_bulb.jpg",
    "c": "Uploaded at enwp by User:Alkivar, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Edison_bulb.jpg"
  },
  "mu_swing_goodman": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/1d/BennyGoodmanStageDoorCanteen.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 375
  },
  "mu_charlie_parker_koko": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/61/Charlie_Parker%2C_Tommy_Potter%2C_Miles_Davis%2C_Max_Roach_%28Gottlieb_06941%29.jpg/500px-Charlie_Parker%2C_Tommy_Potter%2C_Miles_Davis%2C_Max_Roach_%28Gottlieb_06941%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 689
  },
  "mu_depeche_mode_violator": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Bremen_2006_Depeche_Mode_by-RaBoe.jpg/500px-Bremen_2006_Depeche_Mode_by-RaBoe.jpg",
    "c": "Ra Boe, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Bremen_2006_Depeche_Mode_by-RaBoe.jpg"
  },
  "mu_ella_fitzgerald_songbook": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Ella_Fitzgerald_%281940%29.jpg/500px-Ella_Fitzgerald_%281940%29.jpg",
    "c": "Carl Van Vechten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ella_Fitzgerald_(1940).jpg"
  },
  "mu_indie_pixies": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Pixies_%2831027967917%29.jpg/500px-Pixies_%2831027967917%29.jpg",
    "c": "Vladimir from New York, NY, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pixies_(31027967917).jpg"
  },
  "mu_haydn_creation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/R%C3%B6%C3%9Fler_Joseph_Haydn.jpg/500px-R%C3%B6%C3%9Fler_Joseph_Haydn.jpg",
    "c": "Johann Carl Roessler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:R%C3%B6%C3%9Fler_Joseph_Haydn.jpg"
  },
  "mu_talking_heads_remain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/d8/Talking_Heads_band1.jpg",
    "c": "Jean-Luc, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Talking_Heads_band1.jpg"
  },
  "mu_rossini_barber": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/D%27apr%C3%A8s_Jean-Marc_Nattier%2C_Portrait_de_Pierre-Augustin_Caron_de_Beaumarchais_%28Biblioth%C3%A8que-mus%C3%A9e_de_la_Com%C3%A9die-Fran%C3%A7aise%29_-001.jpg/500px-D%27apr%C3%A8s_Jean-Marc_Nattier%2C_Portrait_de_Pierre-Augustin_Caron_de_Beaumarchais_%28Biblioth%C3%A8que-mus%C3%A9e_de_la_Com%C3%A9die-Fran%C3%A7aise%29_-001.jpg",
    "c": "After Jean-Marc Nattier, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:D%27apr%C3%A8s_Jean-Marc_Nattier,_Portrait_de_Pierre-Augustin_Caron_de_Beaumarchais_(Biblioth%C3%A8que-mus%C3%A9e_de_la_Com%C3%A9die-Fran%C3%A7aise)_-001.jpg"
  },
  "mu_amy_winehouse_back": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Amy_Winehouse_f4962007_crop.jpg/500px-Amy_Winehouse_f4962007_crop.jpg",
    "c": "Rama, CC BY-SA 2.0 fr",
    "p": "https://commons.wikimedia.org/wiki/File:Amy_Winehouse_f4962007_crop.jpg"
  },
  "mu_israel_philharmonic": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Bronislaw_Huberman.jpg/500px-Bronislaw_Huberman.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bronislaw_Huberman.jpg"
  },
  "mu_grateful_dead_live": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Jerry-Mickey_at_Red_Rocks_taken_08-11-87.jpg/500px-Jerry-Mickey_at_Red_Rocks_taken_08-11-87.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Jerry-Mickey_at_Red_Rocks_taken_08-11-87.jpg"
  },
  "mu_bernstein_west_side": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/67/Bernstein%2C_Leonard_%281918-1990%29_-_1944_-_foto_van_Vechten2.jpg",
    "c": "Carl Van Vechten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bernstein,_Leonard_(1918-1990)_-_1944_-_foto_van_Vechten2.jpg"
  },
  "mu_jay_z_blueprint": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Jay-Z_2011.jpg/500px-Jay-Z_2011.jpg",
    "c": "Joella Marano, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Jay-Z_2011.jpg"
  },
  "mu_stradivari_violins": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/YehudiMenuhinStageDoorCanteen.jpg/500px-YehudiMenuhinStageDoorCanteen.jpg",
    "c": "Film screenshot, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:YehudiMenuhinStageDoorCanteen.jpg"
  },
  "mu_bach_toccata": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Rincgk_01.jpg/500px-Rincgk_01.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rincgk_01.jpg"
  },
  "mu_bts_dynamite": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/180125_%EB%B0%A9%ED%83%84%EC%86%8C%EB%85%84%EB%8B%A8_%EC%A0%9C%EC%9D%B4%ED%99%89.jpg/500px-180125_%EB%B0%A9%ED%83%84%EC%86%8C%EB%85%84%EB%8B%A8_%EC%A0%9C%EC%9D%B4%ED%99%89.jpg",
    "c": "Hey Day, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:180125_%EB%B0%A9%ED%83%84%EC%86%8C%EB%85%84%EB%8B%A8_%EC%A0%9C%EC%9D%B4%ED%99%89.jpg"
  },
  "mu_mahalia_jackson_gospel": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7d/Mahalia_Jackson_1962%2C_van_Vechten%2C_LC-USZ62-91314.jpg/500px-Mahalia_Jackson_1962%2C_van_Vechten%2C_LC-USZ62-91314.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 806
  },
  "mu_gluck_orfeo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Fotothek_df_pk_0000019_037_Schluss-Szene_und_Rollenportr%C3%A4ts%2C_Anneliese_M%C3%BCller_als_Orpheus_und_Tiana_Lemnitz.jpg/500px-Fotothek_df_pk_0000019_037_Schluss-Szene_und_Rollenportr%C3%A4ts%2C_Anneliese_M%C3%BCller_als_Orpheus_und_Tiana_Lemnitz.jpg",
    "c": "Abraham Pisarek, CC BY-SA 3.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Fotothek_df_pk_0000019_037_Schluss-Szene_und_Rollenportr%C3%A4ts,_Anneliese_M%C3%BCller_als_Orpheus_und_Tiana_Lemnitz.jpg"
  },
  "mu_gilberto_bossa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/9/9c/Jo%C3%A3o_Gilberto.jpg",
    "c": "Tuca Vieira from São Paulo, Brazil, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Jo%C3%A3o_Gilberto.jpg"
  },
  "mu_tango_buenos_aires": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Astor_Piazzolla.jpg/500px-Astor_Piazzolla.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Astor_Piazzolla.jpg"
  },
  "mu_berry_maybellene": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Chuck_Berry_1957.jpg/500px-Chuck_Berry_1957.jpg",
    "c": "Universal Attractions (management), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Chuck_Berry_1957.jpg"
  },
  "mu_electric_guitar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Stratocaster_headstock.jpg/500px-Stratocaster_headstock.jpg",
    "c": "mrbill, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Stratocaster_headstock.jpg"
  },
  "mu_cabaret_weimar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Buntes_Brettl.jpg/500px-Buntes_Brettl.jpg",
    "c": "Georg Bartels, +1912, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Buntes_Brettl.jpg"
  },
  "mu_minimalism_riley": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/bb/Terry_Riley_85.jpg/500px-Terry_Riley_85.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 369
  },
  "mu_cure_disintegration": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f3/Robertsmith.jpg/500px-Robertsmith.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 332
  },
  "mu_berlioz_symphonie_fantastique": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/8d/Berlioz_young.jpg",
    "c": "Émile Signol, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Berlioz_young.jpg"
  },
  "mu_sabbath_paranoid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/04/Black_Sabbath_1999-12-16_Stuttgart.jpg",
    "c": "Alex Ex, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Black_Sabbath_1999-12-16_Stuttgart.jpg"
  },
  "mu_dvorak_cello": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Dvorak.jpg/500px-Dvorak.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dvorak.jpg"
  },
  "mu_cage_433": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Asian_woman_shushing.jpg/500px-Asian_woman_shushing.jpg",
    "c": "Kim Boek from Seoul, South Korea, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Asian_woman_shushing.jpg"
  },
  "mu_monk_brilliant": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Thelonious_Monk%2C_Minton%27s_Playhouse%2C_New_York%2C_N.Y.%2C_ca._Sept._1947_%28William_P._Gottlieb_06191%29.jpg/500px-Thelonious_Monk%2C_Minton%27s_Playhouse%2C_New_York%2C_N.Y.%2C_ca._Sept._1947_%28William_P._Gottlieb_06191%29.jpg",
    "c": "William P. Gottlieb / Adam Cuerden, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thelonious_Monk,_Minton%27s_Playhouse,_New_York,_N.Y.,_ca._Sept._1947_(William_P._Gottlieb_06191).jpg"
  },
  "mu_new_wave_blondie": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Blondie1977.jpg/500px-Blondie1977.jpg",
    "c": "Private Stock Records, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Blondie1977.jpg"
  },
  "mu_ladysmith_graceland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Graceland_cover_-_Paul_Simon.jpg/500px-Graceland_cover_-_Paul_Simon.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Graceland_cover_-_Paul_Simon.jpg"
  },
  "mu_opera_seria_naples": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Gioachino_Rossini_-_Semiramide_-_Alessandro_Sanquirico_-_Milan_1824_-_act_1%2C_scene_8_-_Atrio_nella_reggia.png/500px-Gioachino_Rossini_-_Semiramide_-_Alessandro_Sanquirico_-_Milan_1824_-_act_1%2C_scene_8_-_Atrio_nella_reggia.png",
    "c": "Alessandro Sanquirico, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gioachino_Rossini_-_Semiramide_-_Alessandro_Sanquirico_-_Milan_1824_-_act_1,_scene_8_-_Atrio_nella_reggia.png"
  },
  "mu_radiohead_kid_a": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Radiohead.jpg/500px-Radiohead.jpg",
    "c": "Samuel Wiki, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Radiohead.jpg"
  },
  "mu_country_carter_family": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4a/Carter_Family_1927.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 722
  },
  "mu_synthesizer_moog": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/OB12_synth.jpg/500px-OB12_synth.jpg",
    "c": "Grapetonix, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:OB12_synth.jpg"
  },
  "mu_lauryn_hill_miseducation": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/ad/LaurynHill.jpg/500px-LaurynHill.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "mu_bruckner_9th": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a4/Anton_bruckner.jpg/500px-Anton_bruckner.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 541
  },
  "mu_edith_piaf": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/2a/%C3%89dith_Piaf_914-6440.jpg/500px-%C3%89dith_Piaf_914-6440.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 758
  },
  "mu_outkast_stankonia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/OutKast_2001.jpg/500px-OutKast_2001.jpg",
    "c": "Joe Greenheron, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:OutKast_2001.jpg"
  },
  "mu_sibelius_finlandia": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/2b/Jean_Sibelius%2C_1913.jpg/500px-Jean_Sibelius%2C_1913.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "mu_bb_king_thrill": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/B.B._King%2C_2006-06-26.jpg/500px-B.B._King%2C_2006-06-26.jpg",
    "c": "Eric Draper, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:B.B._King,_2006-06-26.jpg"
  },
  "mu_sufi_whirling": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4c/Mevlevi_dervishes_1887.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mevlevi_dervishes_1887.jpg"
  },
  "mu_caruso_recordings": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Enrico_Caruso_tenor.jpg/500px-Enrico_Caruso_tenor.jpg",
    "c": "Copyright by Laveccha Studio, Chicago (no. 3)., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Enrico_Caruso_tenor.jpg"
  },
  "mu_boulez_marteau": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b4/Boulez25oct2004.jpg",
    "c": "Wikimedia Commons, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Boulez25oct2004.jpg"
  },
  "mu_korngold_robin_hood": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a4/Erich_Wolfgang_Korngold_01.jpg/500px-Erich_Wolfgang_Korngold_01.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 649
  },
  "mu_springsteen_born": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Bundesarchiv_Bild_183-1988-0719-38%2C_Bruce_Springsteen%2C_Konzert_in_der_DDR.jpg/500px-Bundesarchiv_Bild_183-1988-0719-38%2C_Bruce_Springsteen%2C_Konzert_in_der_DDR.jpg",
    "c": "Uhlemann, Thomas, CC BY-SA 3.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Bundesarchiv_Bild_183-1988-0719-38,_Bruce_Springsteen,_Konzert_in_der_DDR.jpg"
  },
  "mu_smith_horses": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Patti_Smith_performing_at_TIM_Festival%2C_Marina_da_Gloria%2C_Rio_De_Janeiro_%284%29.jpg/500px-Patti_Smith_performing_at_TIM_Festival%2C_Marina_da_Gloria%2C_Rio_De_Janeiro_%284%29.jpg",
    "c": "Daigo Oliva from São Paulo, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Patti_Smith_performing_at_TIM_Festival,_Marina_da_Gloria,_Rio_De_Janeiro_(4).jpg"
  },
  "mu_miriam_makeba": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/3d/Miriam_makeba_01.jpg/500px-Miriam_makeba_01.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 605
  },
  "mu_stockhausen_gesang": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Stockhausen_March_2004_excerpt.jpg/500px-Stockhausen_March_2004_excerpt.jpg",
    "c": "Kathinka Pasveer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Stockhausen_March_2004_excerpt.jpg"
  },
  "mu_miles_bitches_brew": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Pomnik_Milesa_Davisa_Kielce_01_ssj_20060304.jpg/500px-Pomnik_Milesa_Davisa_Kielce_01_ssj_20060304.jpg",
    "c": "Paweł Cieśla Staszek_Szybki_Jest, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Pomnik_Milesa_Davisa_Kielce_01_ssj_20060304.jpg"
  },
  "mu_ornette_coleman_free": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Ornette_Coleman_in_Ludwigshafen_%28fcm%29.jpg/500px-Ornette_Coleman_in_Ludwigshafen_%28fcm%29.jpg",
    "c": "Photograph: Frank C. Müller, Baden-Baden, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Ornette_Coleman_in_Ludwigshafen_(fcm).jpg"
  },
  "mu_tallis_spem": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/a2/Thomas_Tallis.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Thomas_Tallis.jpg"
  },
  "mu_napster_launch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/ITunes_Music_Store_in_a_mobile_Phone.jpg/500px-ITunes_Music_Store_in_a_mobile_Phone.jpg",
    "c": "Grajales, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:ITunes_Music_Store_in_a_mobile_Phone.jpg"
  },
  "mu_arik_sa_le_at": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Arik_Einstein.jpg/500px-Arik_Einstein.jpg",
    "c": "itsik64, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Arik_Einstein.jpg"
  },
  "mu_rossini_william_tell": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Wilhelm_Tell_Denkmal_Altdorf_um_1900.jpeg/500px-Wilhelm_Tell_Denkmal_Altdorf_um_1900.jpeg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Wilhelm_Tell_Denkmal_Altdorf_um_1900.jpeg"
  },
  "jh_independence": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Israel_ind_hall.JPG/500px-Israel_ind_hall.JPG",
    "c": "Amit A., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Israel_ind_hall.JPG"
  },
  "jh_second_temple_destruction": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Assedio_di_Gerusalemme_-_fase_7.png/500px-Assedio_di_Gerusalemme_-_fase_7.png",
    "c": "Jerusalem-1_Jht.svg: MHz`as derivative work: Cristiano64, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Assedio_di_Gerusalemme_-_fase_7.png"
  },
  "jh_holocaust": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Corpses_in_the_courtyard_of_Nordhausen_concentration_camp.jpg/500px-Corpses_in_the_courtyard_of_Nordhausen_concentration_camp.jpg",
    "c": "T4c. James E Myers, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Corpses_in_the_courtyard_of_Nordhausen_concentration_camp.jpg"
  },
  "jh_exodus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Israel_segment.jpg/500px-Israel_segment.jpg",
    "c": "king Merenptah's scribe, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Israel_segment.jpg"
  },
  "jh_maccabees": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/142.Matthias_Appealing_to_Jewish_Refugees.jpg/500px-142.Matthias_Appealing_to_Jewish_Refugees.jpg",
    "c": "Gustave Doré, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:142.Matthias_Appealing_to_Jewish_Refugees.jpg"
  },
  "jh_balfour": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Balfour_portrait_and_declaration.JPG/500px-Balfour_portrait_and_declaration.JPG",
    "c": "see original image descriptions, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Balfour_portrait_and_declaration.JPG"
  },
  "jh_herzl_congress": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/00/First_World_Zionist_Congress_delegates.jpg/500px-First_World_Zionist_Congress_delegates.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 467
  },
  "jh_camp_david": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/83/Menachem_Begin_2.jpg",
    "c": "MSGT DENHAM, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Menachem_Begin_2.jpg"
  },
  "jh_auschwitz": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e7/AerialAuschwitz1944.jpg/500px-AerialAuschwitz1944.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 410
  },
  "jh_solomon_temple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/50/To_the_trumpeting_place.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 214
  },
  "jh_david_jerusalem": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7c/JPF-Ophel_-_City_of_David.JPG/500px-JPF-Ophel_-_City_of_David.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "jh_rabin_assassination": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Flickr_-_Government_Press_Office_%28GPO%29_-_TEENAGERS_LIGHTING_MEMORIAL_CANDLES_AFTER_HEARING_OF_THE_ASSASSINATION_OF_P.M._YITZHAK_RABIN.jpg/500px-Flickr_-_Government_Press_Office_%28GPO%29_-_TEENAGERS_LIGHTING_MEMORIAL_CANDLES_AFTER_HEARING_OF_THE_ASSASSINATION_OF_P.M._YITZHAK_RABIN.jpg",
    "c": "Tsvika Israeli, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Flickr_-_Government_Press_Office_(GPO)_-_TEENAGERS_LIGHTING_MEMORIAL_CANDLES_AFTER_HEARING_OF_THE_ASSASSINATION_OF_P.M._YITZHAK_RABIN.jpg"
  },
  "jh_oslo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Hussein_Clinton_Rabin.jpg",
    "c": "White House, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hussein_Clinton_Rabin.jpg"
  },
  "jh_dead_sea_scrolls": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Amman_BW_10.JPG/500px-Amman_BW_10.JPG",
    "c": "Berthold Werner, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Amman_BW_10.JPG"
  },
  "jh_rambam": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/3/3c/Mishnetorah-1vol-menukad.JPG",
    "c": "Hillelg, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mishnetorah-1vol-menukad.JPG"
  },
  "jh_diaspora_begins": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/Nuremberg_chronicles_f_63r_1.png/500px-Nuremberg_chronicles_f_63r_1.png",
    "c": "Michel Wolgemut, Wilhelm Pleydenwurff (Text: Hartmann Schedel), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nuremberg_chronicles_f_63r_1.png"
  },
  "jh_eichmann_trial": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Israel_supreme_court_-_Eichmann%27s_trial_protocols.JPG/500px-Israel_supreme_court_-_Eichmann%27s_trial_protocols.JPG",
    "c": "דוד שי, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Israel_supreme_court_-_Eichmann%27s_trial_protocols.JPG"
  },
  "jh_aliyah_first": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4b/BYwork.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BYwork.jpg"
  },
  "jh_kristallnacht": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Nysa-Tkacka.JPG/500px-Nysa-Tkacka.JPG",
    "c": "Bonio, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nysa-Tkacka.JPG"
  },
  "jh_war_independence": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/Adhalom_bridge.jpg/500px-Adhalom_bridge.jpg",
    "c": "takem by David Shay, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Adhalom_bridge.jpg"
  },
  "jh_rashi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Rhashi_mechicot.jpg/500px-Rhashi_mechicot.jpg",
    "c": "דפוס הירץ לוי מאמסטרדם 1749, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rhashi_mechicot.jpg"
  },
  "jh_talmud": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Talmud_set.JPG/500px-Talmud_set.JPG",
    "c": "Reuvenk, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Talmud_set.JPG"
  },
  "jh_great_revolt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Golan_Heights_-_Gamla_view.jpg/500px-Golan_Heights_-_Gamla_view.jpg",
    "c": "EdoM, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Golan_Heights_-_Gamla_view.jpg"
  },
  "jh_hebron_massacre": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/House_destruction%2C_Hebron_1929.jpg/500px-House_destruction%2C_Hebron_1929.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:House_destruction,_Hebron_1929.jpg"
  },
  "jh_aliyah_second": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/PikiWiki_Israel_2130_Architecture_of_Israel_%D7%91%D7%99.jpg/500px-PikiWiki_Israel_2130_Architecture_of_Israel_%D7%91%D7%99.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:PikiWiki_Israel_2130_Architecture_of_Israel_%D7%91%D7%99.jpg"
  },
  "jh_abraham": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Moln%C3%A1r_%C3%81brah%C3%A1m_kik%C3%B6lt%C3%B6z%C3%A9se_1850.jpg/500px-Moln%C3%A1r_%C3%81brah%C3%A1m_kik%C3%B6lt%C3%B6z%C3%A9se_1850.jpg",
    "c": "József Molnár, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Moln%C3%A1r_%C3%81brah%C3%A1m_kik%C3%B6lt%C3%B6z%C3%A9se_1850.jpg"
  },
  "jh_western_wall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/British_police_wailing_wall1.jpg/500px-British_police_wailing_wall1.jpg",
    "c": "E.P. Tal &amp; co., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:British_police_wailing_wall1.jpg"
  },
  "jh_mishnah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/KaufmannManuscript.jpg/500px-KaufmannManuscript.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KaufmannManuscript.jpg"
  },
  "jh_expulsion_spain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0b/FerdinandIsabellaSpain.jpg/500px-FerdinandIsabellaSpain.jpg",
    "c": "Agustinas de Madrigal, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:FerdinandIsabellaSpain.jpg"
  },
  "jh_warsaw_ghetto_uprising": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Monument_of_ghetto_uprising.JPG/500px-Monument_of_ghetto_uprising.JPG",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Monument_of_ghetto_uprising.JPG"
  },
  "jh_dreyfus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Degradation_alfred_dreyfus.jpg/500px-Degradation_alfred_dreyfus.jpg",
    "c": "Henri Meyer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Degradation_alfred_dreyfus.jpg"
  },
  "jh_cyrus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Cyrus_II_le_Grand_et_les_H%C3%A9breux.jpg/500px-Cyrus_II_le_Grand_et_les_H%C3%A9breux.jpg",
    "c": "Jean Fouquet / Master of the Munich Boccaccio, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cyrus_II_le_Grand_et_les_H%C3%A9breux.jpg"
  },
  "jh_second_temple_built": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Model_of_Second_Temple_made_by_Michael_Osnis_from_Kedumim_2.jpg/500px-Model_of_Second_Temple_made_by_Michael_Osnis_from_Kedumim_2.jpg",
    "c": "Daniel Ventura, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Model_of_Second_Temple_made_by_Michael_Osnis_from_Kedumim_2.jpg"
  },
  "jh_entebbe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Entebbe_Uganda_Airport_Old_Tower1.jpg/500px-Entebbe_Uganda_Airport_Old_Tower1.jpg",
    "c": "Mr. Micha Sender, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Entebbe_Uganda_Airport_Old_Tower1.jpg"
  },
  "jh_pogroms_russia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/52/Bund_Odessa_1905.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bund_Odessa_1905.jpg"
  },
  "jh_ben_yehuda": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Eliezer_und_Hemda_Ben_Jehuda_im_Jahre_1912.jpg/500px-Eliezer_und_Hemda_Ben_Jehuda_im_Jahre_1912.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eliezer_und_Hemda_Ben_Jehuda_im_Jahre_1912.jpg"
  },
  "jh_lebanon_war_first": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Camille_Chamoun_Sports_City_Stadium_1982_-_Aerial.jpg/500px-Camille_Chamoun_Sports_City_Stadium_1982_-_Aerial.jpg",
    "c": "PHAN ROBERT FEARY, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Camille_Chamoun_Sports_City_Stadium_1982_-_Aerial.jpg"
  },
  "jh_kabbala_zohar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/21/Zohar.png",
    "c": "Possibly Simeon bar Yochai, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Zohar.png"
  },
  "jh_aliyah_mass": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Yemenites_go_to_Aden.jpg/500px-Yemenites_go_to_Aden.jpg",
    "c": "Zoltan Kluger, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Yemenites_go_to_Aden.jpg"
  },
  "jh_shabbtai_zvi": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f5/Brockhaus_and_Efron_Jewish_Encyclopedia_e13_785-0.jpg/500px-Brockhaus_and_Efron_Jewish_Encyclopedia_e13_785-0.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 577
  },
  "jh_hasidism": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/ce/Besht_Shul1_Medzhibozh.jpg/500px-Besht_Shul1_Medzhibozh.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 340
  },
  "jh_wannsee": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Carta_G%C3%B6ring.JPG/500px-Carta_G%C3%B6ring.JPG",
    "c": "Göring, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Carta_G%C3%B6ring.JPG"
  },
  "jh_haskalah": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e6/Germany-00160_-_Moses_Mendelssohn_%2830211520502%29.jpg/500px-Germany-00160_-_Moses_Mendelssohn_%2830211520502%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 750
  },
  "jh_haganah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/57/Haganah_fighters_-_1947.jpg",
    "c": "Unknown - not relevant for the licence, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Haganah_fighters_-_1947.jpg"
  },
  "jh_kibbutz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Deganya_Israel.jpg/500px-Deganya_Israel.jpg",
    "c": "Ben Herzberg, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Deganya_Israel.jpg"
  },
  "jh_nuremberg_laws": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/34/Blutschutzgesetz_v.15.9.1935_-_RGBl_I_1147.jpg/500px-Blutschutzgesetz_v.15.9.1935_-_RGBl_I_1147.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 754
  },
  "jh_herod_temple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Model_of_Second_Temple_made_by_Michael_Osnis_from_Kedumim_2.jpg/500px-Model_of_Second_Temple_made_by_Michael_Osnis_from_Kedumim_2.jpg",
    "c": "Daniel Ventura, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Model_of_Second_Temple_made_by_Michael_Osnis_from_Kedumim_2.jpg"
  },
  "jh_white_paper": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/British_out.jpg/500px-British_out.jpg",
    "c": "Tamarah, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:British_out.jpg"
  },
  "jh_altalena": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Altalena_off_Tel-Aviv_beach.jpg/500px-Altalena_off_Tel-Aviv_beach.jpg",
    "c": "Hans Pinn, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Altalena_off_Tel-Aviv_beach.jpg"
  },
  "jh_josephus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Josephus.jpg/500px-Josephus.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Josephus.jpg"
  },
  "jh_philistines": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/David-goliath28.jpg/500px-David-goliath28.jpg",
    "c": "Gustave Doré (1832-1883), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:David-goliath28.jpg"
  },
  "jh_printing_prague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4b/BYwork.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BYwork.jpg"
  },
  "jh_ghetto_venice": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/a6/Venice_Ghetto.JPG",
    "c": "Warburg, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Venice_Ghetto.JPG"
  },
  "jh_sanhedrin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/The_Sanhedrin_in_session_2013-12-25_00-59.jpg/500px-The_Sanhedrin_in_session_2013-12-25_00-59.jpg",
    "c": "User:Wrongkind707, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_Sanhedrin_in_session_2013-12-25_00-59.jpg"
  },
  "jh_operation_moses": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Ethiopian_highlands_01_mod.jpg/500px-Ethiopian_highlands_01_mod.jpg",
    "c": "Wikimedia Commons, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ethiopian_highlands_01_mod.jpg"
  },
  "jh_saul_king": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Witch_of_Endor._Dore_1866.jpg/500px-Witch_of_Endor._Dore_1866.jpg",
    "c": "Gustave Doré (1832-83), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Witch_of_Endor._Dore_1866.jpg"
  },
  "jh_split_kingdom": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Tel-Dan-NS-13703.jpg/500px-Tel-Dan-NS-13703.jpg",
    "c": "Bukvoed, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tel-Dan-NS-13703.jpg"
  },
  "jh_fall_samaria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Scinia.jpg/500px-Scinia.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Scinia.jpg"
  },
  "jh_irgun_david": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/KD_1940s.JPG/500px-KD_1940s.JPG",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KD_1940s.JPG"
  },
  "jh_death_march": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/PikiWiki_Israel_12490_the_death_march_from_dachau.jpg/500px-PikiWiki_Israel_12490_the_death_march_from_dachau.jpg",
    "c": "ד\"ר אבישי טייכר, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:PikiWiki_Israel_12490_the_death_march_from_dachau.jpg"
  },
  "jh_septuagint": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/bc/Codex_sinaticus_%28The_S.S._Teacher%27s_Edition-The_Holy_Bible_-_Plate_XXII%29.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Codex_sinaticus_(The_S.S._Teacher%27s_Edition-The_Holy_Bible_-_Plate_XXII).jpg"
  },
  "jh_gaon_saadia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/0025_FL45576750.jpg/500px-0025_FL45576750.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:0025_FL45576750.jpg"
  },
  "jh_blood_libel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Catedral_de_Wells_-_Volta_nau.JPG/500px-Catedral_de_Wells_-_Volta_nau.JPG",
    "c": "Josep Renalias, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Catedral_de_Wells_-_Volta_nau.JPG"
  },
  "jh_yavne": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Enterance_to_the_tomb_of_Hagai_IMG_3392.JPG/500px-Enterance_to_the_tomb_of_Hagai_IMG_3392.JPG",
    "c": "Deror Avi, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Enterance_to_the_tomb_of_Hagai_IMG_3392.JPG"
  },
  "jh_maimon_guide": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/V09p079001_Moses_ben_Maimon.jpg/500px-V09p079001_Moses_ben_Maimon.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:V09p079001_Moses_ben_Maimon.jpg"
  },
  "jh_vilna_gaon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Gaon-V.jpg/500px-Gaon-V.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gaon-V.jpg"
  },
  "jh_beit_alpha": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Beit_alfa01.jpg/500px-Beit_alfa01.jpg",
    "c": "Talmoryair, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Beit_alfa01.jpg"
  },
  "jh_black_death": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Doutielt1.jpg/500px-Doutielt1.jpg",
    "c": "Pierart dou Tielt (fl. 1340-1360), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Doutielt1.jpg"
  },
  "jh_pale": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Jewish_Children_with_their_Teacher_in_Samarkand_cropped.jpg/500px-Jewish_Children_with_their_Teacher_in_Samarkand_cropped.jpg",
    "c": "Sergei Prokudin-Gorskii, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jewish_Children_with_their_Teacher_in_Samarkand_cropped.jpg"
  },
  "jh_telaviv": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/TelAviv-paam4.jpg/500px-TelAviv-paam4.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:TelAviv-paam4.jpg"
  },
  "jh_gra_aliyah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Hurva22.jpg/500px-Hurva22.jpg",
    "c": "תמר הירדני, GFDL",
    "p": "https://commons.wikimedia.org/wiki/File:Hurva22.jpg"
  },
  "jh_law_return": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/RGBL_I_1933_S_0175.png/500px-RGBL_I_1933_S_0175.png",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:RGBL_I_1933_S_0175.png"
  },
  "jh_reform_movement": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/JTSA_122_Bway_jeh.JPG/500px-JTSA_122_Bway_jeh.JPG",
    "c": "Jim.henderson, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:JTSA_122_Bway_jeh.JPG"
  },
  "jh_yiddish": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cd/Page_from_Yiddish-Hebrew-Latin-German_dictionary_by_Elijah_Levita.jpg",
    "c": "Helias Levita (Elias Levita, Elijah Levita), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Page_from_Yiddish-Hebrew-Latin-German_dictionary_by_Elijah_Levita.jpg"
  },
  "jh_massada_revolt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/Architecture_Faculty_Technion.jpg/500px-Architecture_Faculty_Technion.jpg",
    "c": "Beny Shlevich, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Architecture_Faculty_Technion.jpg"
  },
  "jh_technion": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Amfiteatron-al-shem-Rothberg.JPG/500px-Amfiteatron-al-shem-Rothberg.JPG",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Amfiteatron-al-shem-Rothberg.JPG"
  },
  "jh_maimonides_controversy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Carl_Schleicher_Eine_Streitfrage_aus_dem_Talmud.jpg/500px-Carl_Schleicher_Eine_Streitfrage_aus_dem_Talmud.jpg",
    "c": "Carl Schleicher, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Carl_Schleicher_Eine_Streitfrage_aus_dem_Talmud.jpg"
  },
  "jh_bnei_akiva": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Hoshaya%27s_Bnei_Akiva_building.JPG/500px-Hoshaya%27s_Bnei_Akiva_building.JPG",
    "c": "Hanay, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hoshaya%27s_Bnei_Akiva_building.JPG"
  },
  "jh_exodus_ship": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/ExodusSh2.jpg/500px-ExodusSh2.jpg",
    "c": "Frank Scherschel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:ExodusSh2.jpg"
  },
  "jh_bund": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/5/52/Bund_Odessa_1905.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bund_Odessa_1905.jpg"
  },
  "jh_dimona": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5d/Nuclear_reactor_in_dimona_%28israel%29.jpg/500px-Nuclear_reactor_in_dimona_%28israel%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "jh_aliyah_third": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/a0/Joseph_Trumpeldor.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Joseph_Trumpeldor.jpg"
  },
  "jh_mendelssohn": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Juedischer_Friedhof_Berlin-mitte_2.jpg/500px-Juedischer_Friedhof_Berlin-mitte_2.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Juedischer_Friedhof_Berlin-mitte_2.jpg"
  },
  "jh_oslo_intifada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Ariel_Sharon%2C_by_Jim_Wallace_%28Smithsonian_Institution%29.jpg/500px-Ariel_Sharon%2C_by_Jim_Wallace_%28Smithsonian_Institution%29.jpg",
    "c": "Jim Wallace (Smithsonian Institution), CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ariel_Sharon,_by_Jim_Wallace_(Smithsonian_Institution).jpg"
  },
  "jh_sephardic_golden": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/cc/1880_Warsaw_Kuzari2.jpg",
    "c": "Judah Halevi, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1880_Warsaw_Kuzari2.jpg"
  },
  "jh_disengagement": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Ariel_Sharon_Headshot.jpg/500px-Ariel_Sharon_Headshot.jpg",
    "c": "Helene C. Stikkel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ariel_Sharon_Headshot.jpg"
  },
  "jh_jericho": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Jean_Fouquet_001.jpg/500px-Jean_Fouquet_001.jpg",
    "c": "Jean Fouquet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jean_Fouquet_001.jpg"
  },
  "jh_dead_sea_war": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Shrine_of_the_Book_2.jpg/500px-Shrine_of_the_Book_2.jpg",
    "c": "deror_avi, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Shrine_of_the_Book_2.jpg"
  },
  "jh_spinoza": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Spinoza.jpg/500px-Spinoza.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Spinoza.jpg"
  },
  "jh_leon_uris": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Atlit_interoior.jpg/500px-Atlit_interoior.jpg",
    "c": "Almog, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Atlit_interoior.jpg"
  },
  "jh_rachel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Rachel_Bluwstein_P1180705.JPG/500px-Rachel_Bluwstein_P1180705.JPG",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rachel_Bluwstein_P1180705.JPG"
  },
  "jh_agnon_nobel": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f9/%D7%A4%D7%95%D7%A8%D7%98%D7%A8%D7%98_%D7%A9%22%D7%99_%D7%A2%D7%92%D7%A0%D7%95%D7%9F_%28cropped%29.jpg/500px-%D7%A4%D7%95%D7%A8%D7%98%D7%A8%D7%98_%D7%A9%22%D7%99_%D7%A2%D7%92%D7%A0%D7%95%D7%9F_%28cropped%29.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 750
  },
  "jh_hatikvah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Hatikvah.jpg/500px-Hatikvah.jpg",
    "c": "Naftali Herz Imber, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hatikvah.jpg"
  },
  "jh_likud": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Israeli_Ballot_Divider.JPG/500px-Israeli_Ballot_Divider.JPG",
    "c": "משתמש:Yiftach T, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Israeli_Ballot_Divider.JPG"
  },
  "jh_treblinka": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Treblinka%27s_Memorial_in_Winter.JPG/500px-Treblinka%27s_Memorial_in_Winter.JPG",
    "c": "Little Savage, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Treblinka%27s_Memorial_in_Winter.JPG"
  },
  "jh_mizrachi_party": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/HaPoel_HaMizrachi.png/500px-HaPoel_HaMizrachi.png",
    "c": "הספרייה הלאומית, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:HaPoel_HaMizrachi.png"
  },
  "jh_jews_poland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/%D0%9E%D1%81%D1%82%D1%80%D0%BE%D0%B3_2018-09-24_127.jpg/500px-%D0%9E%D1%81%D1%82%D1%80%D0%BE%D0%B3_2018-09-24_127.jpg",
    "c": "Yurii-mr, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:%D0%9E%D1%81%D1%82%D1%80%D0%BE%D0%B3_2018-09-24_127.jpg"
  },
  "jh_ottoman_safed": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Hari-sfirot.jpg/500px-Hari-sfirot.jpg",
    "c": "זיו מולד, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hari-sfirot.jpg"
  },
  "jh_shulchan_aruch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/Shulchan_aruch.jpg/500px-Shulchan_aruch.jpg",
    "c": "Dr Yochanan and Binyamin Levi, publishers, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Shulchan_aruch.jpg"
  },
  "jh_histadrut": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Beit_havaad_hapoel3.jpg/500px-Beit_havaad_hapoel3.jpg",
    "c": "User:Sambach, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Beit_havaad_hapoel3.jpg"
  },
  "jh_night": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Buchenwald_Slave_Laborers_Liberation.jpg/500px-Buchenwald_Slave_Laborers_Liberation.jpg",
    "c": "Private H. Miller. (Army), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Buchenwald_Slave_Laborers_Liberation.jpg"
  },
  "jh_palmach": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Almog_IL8_Betkeshet.jpg/500px-Almog_IL8_Betkeshet.jpg",
    "c": "Almog, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Almog_IL8_Betkeshet.jpg"
  },
  "jh_chabad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Chabad5.jpg/500px-Chabad5.jpg",
    "c": "Shmuel Ribkin, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Chabad5.jpg"
  },
  "jh_aleppo_codex": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Aleppo_Codex_%28Deut%29.jpg/500px-Aleppo_Codex_%28Deut%29.jpg",
    "c": "Shlomo ben Buya'a, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Aleppo_Codex_(Deut).jpg"
  },
  "jh_sassoon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/29/David_Sassoon.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 603
  },
  "jh_galut_france": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/1182_french_expulsion_of_jews.jpg/500px-1182_french_expulsion_of_jews.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1182_french_expulsion_of_jews.jpg"
  },
  "jh_nachmanides": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/22/Beit_HaTfutzot_20162029-438.jpg/500px-Beit_HaTfutzot_20162029-438.jpg",
    "c": "ביקורת, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Beit_HaTfutzot_20162029-438.jpg"
  },
  "jh_lehi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lehi_Museum_in_Tel_Aviv.JPG/500px-Lehi_Museum_in_Tel_Aviv.JPG",
    "c": "Avi1111 dr. avishai teicher, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Lehi_Museum_in_Tel_Aviv.JPG"
  },
  "jh_mapai": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/David_BG.jpg/500px-David_BG.jpg",
    "c": "David Eldan, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:David_BG.jpg"
  },
  "jh_immigration_ussr": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Golda_Meir_03265u.jpg/500px-Golda_Meir_03265u.jpg",
    "c": "Marion S. Trikosko, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Golda_Meir_03265u.jpg"
  },
  "jh_temple_mount": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Bikur_Cholim_Hospital_02.jpg/500px-Bikur_Cholim_Hospital_02.jpg",
    "c": "DMY, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Bikur_Cholim_Hospital_02.jpg"
  },
  "jh_hannah_senesh": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Atlit_interoior.jpg/500px-Atlit_interoior.jpg",
    "c": "Almog, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Atlit_interoior.jpg"
  },
  "jh_1947_hebron": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Elsa_Pollak_Auschwitz.jpg/500px-Elsa_Pollak_Auschwitz.jpg",
    "c": "Ehud Amir, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Elsa_Pollak_Auschwitz.jpg"
  },
  "jh_wailing_wall_riots": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Desecrated_synagogue%2C_Hebron_1929.jpg/500px-Desecrated_synagogue%2C_Hebron_1929.jpg",
    "c": "American Colony (Jerusalem), Photo Dept., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Desecrated_synagogue,_Hebron_1929.jpg"
  },
  "jh_dead_sea_industry": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/DeadSea01_ST_04.jpg/500px-DeadSea01_ST_04.jpg",
    "c": "Wikimedia Commons, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:DeadSea01_ST_04.jpg"
  },
  "jh_tower_stockade": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Negba-homa-u-migdal.jpg/500px-Negba-homa-u-migdal.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Negba-homa-u-migdal.jpg"
  },
  "jh_trumpeldor": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Tel_Hai_graves.jpg/500px-Tel_Hai_graves.jpg",
    "c": "RonAlmog, (Flickr page), CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tel_Hai_graves.jpg"
  },
  "jh_israel_jordan_peace": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/0c/Hussein_Clinton_Rabin.jpg",
    "c": "White House, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hussein_Clinton_Rabin.jpg"
  },
  "jh_arava": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Beersheba_1948.jpg/500px-Beersheba_1948.jpg",
    "c": "Hugo Mendelson, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Beersheba_1948.jpg"
  },
  "jh_kotel_tunnels": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Entrance_tunnel_Western_Wall.JPG/500px-Entrance_tunnel_Western_Wall.JPG",
    "c": "Mewasul, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Entrance_tunnel_Western_Wall.JPG"
  },
  "jh_maimon_death": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Cairo_Genizah_Fragment.jpg/500px-Cairo_Genizah_Fragment.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cairo_Genizah_Fragment.jpg"
  },
  "jh_iraq_jews": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/105.The_Rebuilding_of_the_Temple_Is_Begun.jpg/500px-105.The_Rebuilding_of_the_Temple_Is_Begun.jpg",
    "c": "Gustave Doré, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:105.The_Rebuilding_of_the_Temple_Is_Begun.jpg"
  },
  "jh_maalot": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c7/146438_maalot_massacre_5-15-1974_27_murdered_68_injured_PikiWiki_Israel.jpg/500px-146438_maalot_massacre_5-15-1974_27_murdered_68_injured_PikiWiki_Israel.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "jh_arab_revolt_1936": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Havlagah_bus_during_1936-1939_Arab_revolt-British_Mandate_of_Palestine.jpg/500px-Havlagah_bus_during_1936-1939_Arab_revolt-British_Mandate_of_Palestine.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Havlagah_bus_during_1936-1939_Arab_revolt-British_Mandate_of_Palestine.jpg"
  },
  "jh_begin_sadat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Camp_David%2C_Menachem_Begin%2C_Anwar_Sadat%2C_1978.jpg/500px-Camp_David%2C_Menachem_Begin%2C_Anwar_Sadat%2C_1978.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Camp_David,_Menachem_Begin,_Anwar_Sadat,_1978.jpg"
  },
  "jh_ugandan_proposal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Die_Welt%2C_Basel_27_August_1903.png/500px-Die_Welt%2C_Basel_27_August_1903.png",
    "c": "Sir Clement Lloyd Hill (died 9 April 1913 [1]), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Die_Welt,_Basel_27_August_1903.png"
  },
  "jh_terezin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Majdanek_Crematorium_Butterfly.jpg/500px-Majdanek_Crematorium_Butterfly.jpg",
    "c": "Saifunny, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Majdanek_Crematorium_Butterfly.jpg"
  },
  "jh_sinai_campaign": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/PikiWiki_Israel_8974_the_tiran_guns.jpg/500px-PikiWiki_Israel_8974_the_tiran_guns.jpg",
    "c": "ד\"ר אבישי טייכר, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:PikiWiki_Israel_8974_the_tiran_guns.jpg"
  },
  "jh_eilat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/PikiWiki_Israel_4559_Dimona_renewal.JPG/500px-PikiWiki_Israel_4559_Dimona_renewal.JPG",
    "c": "יהודית גרעין-כל Yehudit Garinkol, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:PikiWiki_Israel_4559_Dimona_renewal.JPG"
  },
  "jh_ari_luria": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/21/Zohar.png",
    "c": "Possibly Simeon bar Yochai, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Zohar.png"
  },
  "jh_yemenite_aliyah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Op_Magic_Carpet_%28Yemenites%29.jpg/500px-Op_Magic_Carpet_%28Yemenites%29.jpg",
    "c": "The original uploader was Humus sapiens at English Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Op_Magic_Carpet_(Yemenites).jpg"
  },
  "jh_rothschild": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Rotschild_tomb.JPG/500px-Rotschild_tomb.JPG",
    "c": "Almog, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rotschild_tomb.JPG"
  },
  "jh_maimonides_egypt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Cairo_Genizah_Fragment.jpg/500px-Cairo_Genizah_Fragment.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cairo_Genizah_Fragment.jpg"
  },
  "jh_dona_gracia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Picard.jpg/500px-Picard.jpg",
    "c": "Bernard Picard, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Picard.jpg"
  },
  "jh_shoah_law": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Bundesarchiv_B_145_Bild-F078072-0004%2C_Konrad_Adenauer.jpg/500px-Bundesarchiv_B_145_Bild-F078072-0004%2C_Konrad_Adenauer.jpg",
    "c": "Katherine Young (1906–1993), CC BY-SA 3.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Bundesarchiv_B_145_Bild-F078072-0004,_Konrad_Adenauer.jpg"
  },
  "jh_galilee_boat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Brotvermehrungskirche_BW_3-2.JPG/500px-Brotvermehrungskirche_BW_3-2.JPG",
    "c": "Berthold Werner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Brotvermehrungskirche_BW_3-2.JPG"
  },
  "jh_elijah_cave": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Cave_of_elihau_1.jpg/500px-Cave_of_elihau_1.jpg",
    "c": "Daniel Ventura, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cave_of_elihau_1.jpg"
  },
  "jh_october_war_aftermath": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Knesset_building.jpg/500px-Knesset_building.jpg",
    "c": "Wikimedia Commons, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Knesset_building.jpg"
  },
  "jh_habima": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Ohel_1921-1925.jpg/500px-Ohel_1921-1925.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ohel_1921-1925.jpg"
  },
  "jh_weizmann_institute": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Daniel-Zajfman.jpg/500px-Daniel-Zajfman.jpg",
    "c": "Daniel Zajfman - Weizmann Institute, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Daniel-Zajfman.jpg"
  },
  "jh_lod_airport": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5b/16-03-30-Ben_Gurion_International_Airport-RalfR-DSCF7550.jpg/500px-16-03-30-Ben_Gurion_International_Airport-RalfR-DSCF7550.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 333
  },
  "jh_moroccan_jews": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/J%C3%BCdische_Hochzeit_in_Marokko-1024.jpg/500px-J%C3%BCdische_Hochzeit_in_Marokko-1024.jpg",
    "c": "Eugène Delacroix, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:J%C3%BCdische_Hochzeit_in_Marokko-1024.jpg"
  },
  "jh_shas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Israeli_Ballot_Divider.JPG/500px-Israeli_Ballot_Divider.JPG",
    "c": "משתמש:Yiftach T, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Israeli_Ballot_Divider.JPG"
  },
  "jh_canal_zone": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/EAF_IL-28_Attrition.jpg/500px-EAF_IL-28_Attrition.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:EAF_IL-28_Attrition.jpg"
  },
  "jh_lydda_airport": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/BGsculptureS.jpg/500px-BGsculptureS.jpg",
    "c": "Ori~, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:BGsculptureS.jpg"
  },
  "jh_dead_sea_community": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/bc/Qumran_Caves.jpg/500px-Qumran_Caves.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 756
  },
  "jh_cairo_geniza": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Cairo_Genizah_Fragment.jpg/500px-Cairo_Genizah_Fragment.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cairo_Genizah_Fragment.jpg"
  },
  "jh_yigael_yadin": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/6e/Masada02_ST_04.jpg/500px-Masada02_ST_04.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "jh_rothschild_wine": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/A431-RSLC.jpg/500px-A431-RSLC.jpg",
    "c": "Ori~, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A431-RSLC.jpg"
  },
  "jh_war_attrition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Germany_Israel_Olympics_Attack.jpg/500px-Germany_Israel_Olympics_Attack.jpg",
    "c": "AP Photo/Kurt Strumpf (? – 2014), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Germany_Israel_Olympics_Attack.jpg"
  },
  "jh_munich_1972": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/62/Munich_Massacre_Memorial_in_Tel_Aviv-Yaffo.JPG/500px-Munich_Massacre_Memorial_in_Tel_Aviv-Yaffo.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "jh_israel_philharmonic": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Bronislaw_Huberman.jpg/500px-Bronislaw_Huberman.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bronislaw_Huberman.jpg"
  },
  "jh_black_panther": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/25/Musrara_Jerusalem.jpg/500px-Musrara_Jerusalem.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 136
  },
  "jh_olim_france": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/4/4b/BYwork.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BYwork.jpg"
  },
  "jh_talpiot": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/HadarS.jpg/500px-HadarS.jpg",
    "c": "The original uploader was Gilabrand at English Wikipedia., CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:HadarS.jpg"
  },
  "jh_nachalat_binyamin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/KaufmannManuscript.jpg/500px-KaufmannManuscript.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KaufmannManuscript.jpg"
  },
  "jh_yehoshua_kenaz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Memorial_plaque_to_Aharon_Amir_in_Tel_Aviv.JPG/500px-Memorial_plaque_to_Aharon_Amir_in_Tel_Aviv.JPG",
    "c": "Avi1111 dr. avishai teicher, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Memorial_plaque_to_Aharon_Amir_in_Tel_Aviv.JPG"
  },
  "jh_tower_david": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Excavation_in_City_of_David_Givaty_parking_lot_Jerusalem_11_2010.JPG/500px-Excavation_in_City_of_David_Givaty_parking_lot_Jerusalem_11_2010.JPG",
    "c": "אני (Transferred by Matanya/Original uploaded by אור פ), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Excavation_in_City_of_David_Givaty_parking_lot_Jerusalem_11_2010.JPG"
  },
  "jh_water_carrier": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/National_Water_Carrier_of_Israel_near_Kadarim.jpg/500px-National_Water_Carrier_of_Israel_near_Kadarim.jpg",
    "c": "Hanay, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:National_Water_Carrier_of_Israel_near_Kadarim.jpg"
  },
  "jh_jnf": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Almog_IL6_Kakal.jpg/500px-Almog_IL6_Kakal.jpg",
    "c": "Almog, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Almog_IL6_Kakal.jpg"
  },
  "jh_bus_300_affair": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/40/David_Ben-Gurion_and_the_participants_in_the_operation_to_capture_Adolf_Eichmann.jpg/500px-David_Ben-Gurion_and_the_participants_in_the_operation_to_capture_Adolf_Eichmann.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "jh_iron_dome": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Flickr_-_U.S._Embassy_Tel_Aviv_-_Visit_to_Iron_Dome_No.106FL.jpg/500px-Flickr_-_U.S._Embassy_Tel_Aviv_-_Visit_to_Iron_Dome_No.106FL.jpg",
    "c": "U.S. Embassy Tel Aviv, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Flickr_-_U.S._Embassy_Tel_Aviv_-_Visit_to_Iron_Dome_No.106FL.jpg"
  },
  "jh_karaites": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a4/Trakai_Kenesa.JPG/500px-Trakai_Kenesa.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "jh_bahai_haifa": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7b/Knesset_Building_%28South_Side%29.JPG/500px-Knesset_Building_%28South_Side%29.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 212
  },
  "jh_dead_sea_fortress": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/77/Nof_HaGalil.jpg/500px-Nof_HaGalil.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 225
  },
  "jh_ruth_calderon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Ruth_Calderon.jpg/500px-Ruth_Calderon.jpg",
    "c": "en:Yesh Atid political party, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ruth_Calderon.jpg"
  },
  "jh_beresheet": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f2/Beresheet_model_on_Habima_Square_20190222_01.jpg/500px-Beresheet_model_on_Habima_Square_20190222_01.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 502
  },
  "jh_haredim_draft": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/6f/NetzahYehudafield.jpg",
    "c": "The original uploader was Naama at English Wikipedia., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:NetzahYehudafield.jpg"
  },
  "ar_mona_lisa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Crowd_at_Mona_Lisa.jpg/500px-Crowd_at_Mona_Lisa.jpg",
    "c": "Hu Totya, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Crowd_at_Mona_Lisa.jpg"
  },
  "ar_sistine_ceiling": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/DelphicSibylByMichelangelo.jpg/500px-DelphicSibylByMichelangelo.jpg",
    "c": "Michelangelo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DelphicSibylByMichelangelo.jpg"
  },
  "ar_starry_night": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/ea/Van_Gogh_-_Starry_Night_-_Google_Art_Project.jpg/500px-Van_Gogh_-_Starry_Night_-_Google_Art_Project.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 396
  },
  "ar_guernica": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Pablo_picasso_1.jpg/500px-Pablo_picasso_1.jpg",
    "c": "Argentina. Revista Vea y Lea, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pablo_picasso_1.jpg"
  },
  "ar_david_michel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Dying_slave_Louvre_MR_1590.jpg/500px-Dying_slave_Louvre_MR_1590.jpg",
    "c": "Michelangelo Buenarroti (1475-1564), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Dying_slave_Louvre_MR_1590.jpg"
  },
  "ar_last_supper": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Leonardo_da_Vinci_%281452-1519%29_-_The_Last_Supper_%281495-1498%29.jpg/500px-Leonardo_da_Vinci_%281452-1519%29_-_The_Last_Supper_%281495-1498%29.jpg",
    "c": "Leonardo da Vinci, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Leonardo_da_Vinci_(1452-1519)_-_The_Last_Supper_(1495-1498).jpg"
  },
  "ar_lascaux": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/0/07/Lascaux2.jpg/500px-Lascaux2.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 376
  },
  "ar_birth_venus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Birth_of_Venus_detail.jpg/500px-Birth_of_Venus_detail.jpg",
    "c": "Sandro Botticelli, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Birth_of_Venus_detail.jpg"
  },
  "ar_parthenon": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c4/Akropolis_by_Leo_von_Klenze.jpg/500px-Akropolis_by_Leo_von_Klenze.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 343
  },
  "ar_impression_sunrise": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Pierre_August_Renoir%2C_Claude_Monet_Reading.jpg/500px-Pierre_August_Renoir%2C_Claude_Monet_Reading.jpg",
    "c": "Pierre-Auguste Renoir, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pierre_August_Renoir,_Claude_Monet_Reading.jpg"
  },
  "ar_girl_pearl": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Johannes_Vermeer_%281632-1675%29_-_The_Girl_With_The_Pearl_Earring_%281665%29.jpg/500px-Johannes_Vermeer_%281632-1675%29_-_The_Girl_With_The_Pearl_Earring_%281665%29.jpg",
    "c": "Johannes Vermeer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Johannes_Vermeer_(1632-1675)_-_The_Girl_With_The_Pearl_Earring_(1665).jpg"
  },
  "ar_scream": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/c5/Edvard_Munch%2C_1893%2C_The_Scream%2C_oil%2C_tempera_and_pastel_on_cardboard%2C_91_x_73_cm%2C_National_Gallery_of_Norway.jpg/500px-Edvard_Munch%2C_1893%2C_The_Scream%2C_oil%2C_tempera_and_pastel_on_cardboard%2C_91_x_73_cm%2C_National_Gallery_of_Norway.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 621
  },
  "ar_fountain": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/29/%27Fountain%27_by_Marcel_Duchamp_%28replica%29.JPG/500px-%27Fountain%27_by_Marcel_Duchamp_%28replica%29.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 674
  },
  "ar_persistence_memory": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/64/Dargenta_%26_Salvador_Dali_The_persistance_of_Memory.png/500px-Dargenta_%26_Salvador_Dali_The_persistance_of_Memory.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 510
  },
  "ar_venus_willendorf": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Venus-de-Laussel-vue-generale-noir.jpg/500px-Venus-de-Laussel-vue-generale-noir.jpg",
    "c": "photo 120, œuvre dont l'auteur est mort depuis environ 25 000 ans, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Venus-de-Laussel-vue-generale-noir.jpg"
  },
  "ar_great_wave": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/a/a5/Tsunami_by_hokusai_19th_century.jpg/500px-Tsunami_by_hokusai_19th_century.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 336
  },
  "ar_kiss_klimt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Gustav_Klimt_010.jpg/500px-Gustav_Klimt_010.jpg",
    "c": "Gustav Klimt, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gustav_Klimt_010.jpg"
  },
  "ar_night_watch": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Rembrandt_Harmensz._van_Rijn_135.jpg/500px-Rembrandt_Harmensz._van_Rijn_135.jpg",
    "c": "Rembrandt, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rembrandt_Harmensz._van_Rijn_135.jpg"
  },
  "ar_thinker": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Rodin092.JPG/500px-Rodin092.JPG",
    "c": "Wikimedia Commons, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Rodin092.JPG"
  },
  "ar_caravaggio_calling": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Bild-Ottavio_Leoni%2C_Caravaggio.jpg/500px-Bild-Ottavio_Leoni%2C_Caravaggio.jpg",
    "c": "Ottavio Leoni, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bild-Ottavio_Leoni,_Caravaggio.jpg"
  },
  "ar_sunflowers": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Paul_Gauguin_1891.png/500px-Paul_Gauguin_1891.png",
    "c": "Louis-Maurice Boutet de Monvel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Paul_Gauguin_1891.png"
  },
  "ar_rodin_gates": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Hoellentor_Detail_gr.jpg/500px-Hoellentor_Detail_gr.jpg",
    "c": "Stefan Kühn, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hoellentor_Detail_gr.jpg"
  },
  "ar_gothic_notre_dame": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Bourdon-notre-dame-paris-tour-sud.jpg/500px-Bourdon-notre-dame-paris-tour-sud.jpg",
    "c": "Author: Tristan Nitot, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Bourdon-notre-dame-paris-tour-sud.jpg"
  },
  "ar_arnolfini": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/The_Arnolfini_Portrait%2C_d%C3%A9tail_%282%29.jpg/500px-The_Arnolfini_Portrait%2C_d%C3%A9tail_%282%29.jpg",
    "c": "Jan van Eyck, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Arnolfini_Portrait,_d%C3%A9tail_(2).jpg"
  },
  "ar_school_athens": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Raffael_059.jpg/500px-Raffael_059.jpg",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Raffael_059.jpg"
  },
  "ar_les_demoiselles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Pablo_picasso_1.jpg/500px-Pablo_picasso_1.jpg",
    "c": "Argentina. Revista Vea y Lea, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pablo_picasso_1.jpg"
  },
  "ar_liberty_delacroix": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Eugene_delacroix.jpg/500px-Eugene_delacroix.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eugene_delacroix.jpg"
  },
  "ar_sagrada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Cathedral_Sagrada_Familia.jpeg/500px-Cathedral_Sagrada_Familia.jpeg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cathedral_Sagrada_Familia.jpeg"
  },
  "ar_goya_third_may": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/fd/El_Tres_de_Mayo%2C_by_Francisco_de_Goya%2C_from_Prado_thin_black_margin.jpg/500px-El_Tres_de_Mayo%2C_by_Francisco_de_Goya%2C_from_Prado_thin_black_margin.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 386
  },
  "ar_pietà": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1f/Michelangelo%27s_Pieta_5450_cropncleaned_edit.jpg/500px-Michelangelo%27s_Pieta_5450_cropncleaned_edit.jpg",
    "c": "Stanislav Traykov, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Michelangelo%27s_Pieta_5450_cropncleaned_edit.jpg"
  },
  "ar_nighthawks": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7b/Hopper_Nighthawks.jpg/500px-Hopper_Nighthawks.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 273
  },
  "ar_velazquez_meninas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Margarita_Teresa_of_Spain.jpg/500px-Margarita_Teresa_of_Spain.jpg",
    "c": "anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Margarita_Teresa_of_Spain.jpg"
  },
  "ar_duchamp_nude": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Female_nude_motion_study_by_Eadweard_Muybridge_%282%29.jpg/500px-Female_nude_motion_study_by_Eadweard_Muybridge_%282%29.jpg",
    "c": "Eadweard Muybridge, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Female_nude_motion_study_by_Eadweard_Muybridge_(2).jpg"
  },
  "ar_brunelleschi_dome": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/90/Bunelleschi.jpg/500px-Bunelleschi.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 833
  },
  "ar_warhol_marilyn": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Andy_Warhol_by_Jack_Mitchell.jpg/500px-Andy_Warhol_by_Jack_Mitchell.jpg",
    "c": "Jack Mitchell, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Andy_Warhol_by_Jack_Mitchell.jpg"
  },
  "ar_degas_dancers": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Edgar_Germain_Hilaire_Degas_021.jpg/500px-Edgar_Germain_Hilaire_Degas_021.jpg",
    "c": "Edgar Degas, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Edgar_Germain_Hilaire_Degas_021.jpg"
  },
  "ar_matisse_dance": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Portrait_of_Henri_Matisse_1933_May_20.jpg/500px-Portrait_of_Henri_Matisse_1933_May_20.jpg",
    "c": "Carl Van Vechten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_of_Henri_Matisse_1933_May_20.jpg"
  },
  "ar_nefertiti": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/1f/Nofretete_Neues_Museum.jpg/500px-Nofretete_Neues_Museum.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 732
  },
  "ar_borobudur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Borobudur_relief_1.jpg/500px-Borobudur_relief_1.jpg",
    "c": "Dimas Yusuf, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Borobudur_relief_1.jpg"
  },
  "ar_angkor_wat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Angkor_Phnom_Bakheng.jpg/500px-Angkor_Phnom_Bakheng.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Angkor_Phnom_Bakheng.jpg"
  },
  "ar_taj_mahal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mumtaz_Mahal.jpg/500px-Mumtaz_Mahal.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mumtaz_Mahal.jpg"
  },
  "ar_hokusai_manga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/15/Hokusai-fuji-koryuu.png",
    "c": "Katsushika Hokusai, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hokusai-fuji-koryuu.png"
  },
  "ar_moai": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Ahu_Tahai.jpg/500px-Ahu_Tahai.jpg",
    "c": "Picture taken by Bjarte Sorensen., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ahu_Tahai.jpg"
  },
  "ar_renoir_moulin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Pierre-Auguste_Renoir%2C_Le_Moulin_de_la_Galette.jpg/500px-Pierre-Auguste_Renoir%2C_Le_Moulin_de_la_Galette.jpg",
    "c": "Pierre-Auguste Renoir, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pierre-Auguste_Renoir,_Le_Moulin_de_la_Galette.jpg"
  },
  "ar_michelangelo_judgment": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Last_Judgement_%28Michelangelo%29.jpg/500px-Last_Judgement_%28Michelangelo%29.jpg",
    "c": "Michelangelo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Last_Judgement_(Michelangelo).jpg"
  },
  "ar_bayeux": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/William_Duke_of_Normandy_accompanied_by_Eustatius_Count_of_Boulogne_and_followed_by_his_Knights_in_arms_Military_Dress_of_the_Eleventh_Century_from_Bayeux_Tapestry_said_to_have_been_worked_by_Queen_Matilda.png/500px-thumbnail.png",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:William_Duke_of_Normandy_accompanied_by_Eustatius_Count_of_Boulogne_and_followed_by_his_Knights_in_arms_Military_Dress_of_the_Eleventh_Century_from_Bayeux_Tapestry_said_to_have_been_worked_by_Queen_Matilda.png"
  },
  "ar_cezanne_saint_victoire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Mont_Sainte-Victoire_with_Large_Pine%2C_by_Paul_C%C3%A9zanne.jpg/500px-Mont_Sainte-Victoire_with_Large_Pine%2C_by_Paul_C%C3%A9zanne.jpg",
    "c": "Paul Cézanne, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mont_Sainte-Victoire_with_Large_Pine,_by_Paul_C%C3%A9zanne.jpg"
  },
  "ar_kandinsky_composition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Fugue.JPG/500px-Fugue.JPG",
    "c": "Wassily Kandinsky, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Fugue.JPG"
  },
  "ar_book_kells": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/1b/KellsFol019vBrevCausLuke.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:KellsFol019vBrevCausLuke.jpg"
  },
  "ar_malevich_square": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Supremus_55_%28Malevich%2C_1916%29.jpg/500px-Supremus_55_%28Malevich%2C_1916%29.jpg",
    "c": "Kazimir Malevich, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Supremus_55_(Malevich,_1916).jpg"
  },
  "ar_rubens_descent": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Tityus1.jpg/500px-Tityus1.jpg",
    "c": "Titian, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Tityus1.jpg"
  },
  "ar_bauhaus_weimar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Bauhaus.JPG/500px-Bauhaus.JPG",
    "c": "Mewes in de-Wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bauhaus.JPG"
  },
  "ar_monet_impression": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Edgar_Germain_Hilaire_Degas_061.jpg/500px-Edgar_Germain_Hilaire_Degas_061.jpg",
    "c": "Edgar Degas, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Edgar_Germain_Hilaire_Degas_061.jpg"
  },
  "ar_mondrian_composition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Piet_Mondriaan.jpg/500px-Piet_Mondriaan.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Piet_Mondriaan.jpg"
  },
  "ar_wright_falling": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/FallingwaterCantilever570320cv.jpg/500px-FallingwaterCantilever570320cv.jpg",
    "c": "Jack E Boucher, HABS staff photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:FallingwaterCantilever570320cv.jpg"
  },
  "ar_durer_rhinoceros": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/b/bc/The_Rhinoceros_%28NGA_1964.8.697%29_enhanced.png/500px-The_Rhinoceros_%28NGA_1964.8.697%29_enhanced.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 395
  },
  "ar_rembrandt_self": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Rembrandt_-_Samson_threatened_his_father-in-law_-_Google_Art_Project.jpg/500px-Rembrandt_-_Samson_threatened_his_father-in-law_-_Google_Art_Project.jpg",
    "c": "Rembrandt, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Rembrandt_-_Samson_threatened_his_father-in-law_-_Google_Art_Project.jpg"
  },
  "ar_turner_rain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Joseph_Mallord_William_Turner_-_The_Burning_of_the_Houses_of_Lords_and_Commons%2C_16_October_1834_-_1942.647_-_Cleveland_Museum_of_Art.jpg/500px-Joseph_Mallord_William_Turner_-_The_Burning_of_the_Houses_of_Lords_and_Commons%2C_16_October_1834_-_1942.647_-_Cleveland_Museum_of_Art.jpg",
    "c": "J. M. W. Turner, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Joseph_Mallord_William_Turner_-_The_Burning_of_the_Houses_of_Lords_and_Commons,_16_October_1834_-_1942.647_-_Cleveland_Museum_of_Art.jpg"
  },
  "ar_vermeer_milkmaid": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Vermeer-view-of-delft.jpg/500px-Vermeer-view-of-delft.jpg",
    "c": "Johannes Vermeer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Vermeer-view-of-delft.jpg"
  },
  "ar_bernini_ecstasy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Cornaro_SM_della_Vittoria.jpg/500px-Cornaro_SM_della_Vittoria.jpg",
    "c": "Jastrow, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cornaro_SM_della_Vittoria.jpg"
  },
  "ar_gaudi_park": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Reptil_Parc_Guell_Barcelona.jpg/500px-Reptil_Parc_Guell_Barcelona.jpg",
    "c": "Baikonur, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Reptil_Parc_Guell_Barcelona.jpg"
  },
  "ar_frida_two_fridas": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Frida_Kahlo_House%2C_Mexico_City_%286998147374%29.jpg/500px-Frida_Kahlo_House%2C_Mexico_City_%286998147374%29.jpg",
    "c": "Rod Waddington from Kergunyah, Australia, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Frida_Kahlo_House,_Mexico_City_(6998147374).jpg"
  },
  "ar_sphinx": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Sphinxfront.jpg/500px-Sphinxfront.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Sphinxfront.jpg"
  },
  "ar_altamira": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7e/Altamira-1880.jpg/500px-Altamira-1880.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 253
  },
  "ar_koons_balloon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Bilbao_Jeff_Koons_Puppy.jpg/500px-Bilbao_Jeff_Koons_Puppy.jpg",
    "c": "Noebse, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bilbao_Jeff_Koons_Puppy.jpg"
  },
  "ar_chauvet": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/SantaCruz-CuevaManos-P2210651b.jpg/500px-SantaCruz-CuevaManos-P2210651b.jpg",
    "c": "Mariano, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:SantaCruz-CuevaManos-P2210651b.jpg"
  },
  "ar_liu_calligraphy": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/40/KaishuOuyangxun.jpg/500px-KaishuOuyangxun.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 734
  },
  "ar_chartres": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Bourdon-notre-dame-paris-tour-sud.jpg/500px-Bourdon-notre-dame-paris-tour-sud.jpg",
    "c": "Author: Tristan Nitot, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Bourdon-notre-dame-paris-tour-sud.jpg"
  },
  "ar_alhambra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Alhambra_view.jpg/500px-Alhambra_view.jpg",
    "c": "Wikimedia Commons, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Alhambra_view.jpg"
  },
  "ar_benin_bronzes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Benin_Bronzes.jpg/500px-Benin_Bronzes.jpg",
    "c": "en:User:Warofdreams, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Benin_Bronzes.jpg"
  },
  "ar_rothko_seagram": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Simonschrama.JPG/500px-Simonschrama.JPG",
    "c": "The original uploader was David Shankbone at English Wikipedia., CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Simonschrama.JPG"
  },
  "ar_christo_gates": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/CentralParkFromAboveCropped.jpg/500px-CentralParkFromAboveCropped.jpg",
    "c": "Ellen Murphy / Roy Smith (RoySmith at English Wikipedia), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:CentralParkFromAboveCropped.jpg"
  },
  "ar_wright_guggenheim": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Guggenheim-bilbao-jan05.jpg/500px-Guggenheim-bilbao-jan05.jpg",
    "c": "Photograph taken by User:MykReeve., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Guggenheim-bilbao-jan05.jpg"
  },
  "ar_lumiere": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b5/Great_train_robbery_still.jpg",
    "c": "Edwin Stanton Porter, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Great_train_robbery_still.jpg"
  },
  "ar_sydney_opera": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Sydney_Opera_House_Australia.jpg/500px-Sydney_Opera_House_Australia.jpg",
    "c": "Thomas Schoch, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Sydney_Opera_House_Australia.jpg"
  },
  "ar_banksy_wall": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Cash%2C_Cans_%26_Candy_by_Know_Hope_%26_2501%2C_Liesing.jpg/500px-Cash%2C_Cans_%26_Candy_by_Know_Hope_%26_2501%2C_Liesing.jpg",
    "c": "Herzi Pinki, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Cash,_Cans_%26_Candy_by_Know_Hope_%26_2501,_Liesing.jpg"
  },
  "ar_botticelli_primavera": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Botticcelli%2C_Sandro_-_The_Punishment_of_Korah_and_the_Stoning_of_Moses_and_Aaron_-_1481-82.jpg/500px-Botticcelli%2C_Sandro_-_The_Punishment_of_Korah_and_the_Stoning_of_Moses_and_Aaron_-_1481-82.jpg",
    "c": "Sandro Botticelli, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Botticcelli,_Sandro_-_The_Punishment_of_Korah_and_the_Stoning_of_Moses_and_Aaron_-_1481-82.jpg"
  },
  "ar_ai_weiwei_seeds": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/34/%27Sunflower_Seeds%27_by_Ai_Weiwei%2C_Tate_Modern_Turbine_Hall.jpg/500px-%27Sunflower_Seeds%27_by_Ai_Weiwei%2C_Tate_Modern_Turbine_Hall.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "ar_moore_reclining": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e1/HenryMoore_RecliningFigure_1951.jpg/500px-HenryMoore_RecliningFigure_1951.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 272
  },
  "ar_frieze_alexander": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/1810%28Peregrinus%29.jpg/500px-1810%28Peregrinus%29.jpg",
    "c": "Fer.filol, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1810(Peregrinus).jpg"
  },
  "ar_kusama_infinity": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Eyes_Are_Singing_Out_2.jpg/500px-Eyes_Are_Singing_Out_2.jpg",
    "c": "Chris Olszewski, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Eyes_Are_Singing_Out_2.jpg"
  },
  "ar_hirst_shark": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Sensation_Young_British_Artists_from_the_Saatchi_Collection_at_the_Brooklyn_Museum_2.jpg/500px-Sensation_Young_British_Artists_from_the_Saatchi_Collection_at_the_Brooklyn_Museum_2.jpg",
    "c": "Brooklyn Museum, No restrictions",
    "p": "https://commons.wikimedia.org/wiki/File:Sensation_Young_British_Artists_from_the_Saatchi_Collection_at_the_Brooklyn_Museum_2.jpg"
  },
  "ar_eisenstein_potemkin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Panteleimon%2C_1906.jpg/500px-Panteleimon%2C_1906.jpg",
    "c": "Фотография из коллекции Юрия Чернова., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Panteleimon,_1906.jpg"
  },
  "ar_kapoor_bean": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/SkyMirror_NYC.jpg/500px-SkyMirror_NYC.jpg",
    "c": "BradPatrick at en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:SkyMirror_NYC.jpg"
  },
  "ar_van_gogh_room": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Portrait_of_Dr._Gachet.jpg/500px-Portrait_of_Dr._Gachet.jpg",
    "c": "Vincent van Gogh, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_of_Dr._Gachet.jpg"
  },
  "ar_donatello_david": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Florence_-_David_by_Donatello.jpg/500px-Florence_-_David_by_Donatello.jpg",
    "c": "Patrick A. Rodgers, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Florence_-_David_by_Donatello.jpg"
  },
  "ar_marina_artist_present": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Marina_Abramovi%C4%87.jpg/500px-Marina_Abramovi%C4%87.jpg",
    "c": "Shelby Lessig, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Marina_Abramovi%C4%87.jpg"
  },
  "ar_titian_venus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Manet%2C_Edouard_-_Olympia%2C_1863.jpg/500px-Manet%2C_Edouard_-_Olympia%2C_1863.jpg",
    "c": "Édouard Manet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Manet,_Edouard_-_Olympia,_1863.jpg"
  },
  "ar_citizen_kane": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Orson_Welles_1937.jpg/500px-Orson_Welles_1937.jpg",
    "c": "Carl Van Vechten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Orson_Welles_1937.jpg"
  },
  "ar_manet_olympia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/%C3%89douard_Manet.jpg/500px-%C3%89douard_Manet.jpg",
    "c": "Nadar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%C3%89douard_Manet.jpg"
  },
  "ar_picasso_blue": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Pablo_picasso_1.jpg/500px-Pablo_picasso_1.jpg",
    "c": "Argentina. Revista Vea y Lea, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pablo_picasso_1.jpg"
  },
  "ar_kurosawa_rashomon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Kinema-Junpo-1960-February-late-4.jpg/500px-Kinema-Junpo-1960-February-late-4.jpg",
    "c": "キネマ旬報社, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kinema-Junpo-1960-February-late-4.jpg"
  },
  "ar_stieglitz_gallery": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/A_Group_of_Young_American_Artists_of_the_Modern_School%2C_c._1911.jpg/500px-A_Group_of_Young_American_Artists_of_the_Modern_School%2C_c._1911.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_Group_of_Young_American_Artists_of_the_Modern_School,_c._1911.jpg"
  },
  "ar_klee_angelus": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4b/Klee%2C_paul%2C_angelus_novus%2C_1920.jpg/500px-Klee%2C_paul%2C_angelus_novus%2C_1920.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 623
  },
  "ar_melies_moon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/George_Melies.jpg/500px-George_Melies.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:George_Melies.jpg"
  },
  "ar_van_gogh_ear": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/VanGogh-self-portrait-with_bandaged_ear.jpg/500px-VanGogh-self-portrait-with_bandaged_ear.jpg",
    "c": "Vincent van Gogh, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:VanGogh-self-portrait-with_bandaged_ear.jpg"
  },
  "ar_gutenberg_bible": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Gutenberg.jpg/500px-Gutenberg.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gutenberg.jpg"
  },
  "ar_mughal_miniature": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/8f/Mughal_emperor_farrukhsiyar16_hi.jpg/500px-Mughal_emperor_farrukhsiyar16_hi.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 689
  },
  "ar_duchamp_bicycle": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Marcel_Duchamp.jpg/500px-Marcel_Duchamp.jpg",
    "c": "Marcel Duchamp, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Marcel_Duchamp.jpg"
  },
  "ar_picasso_dove": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Pablo_picasso_1.jpg/500px-Pablo_picasso_1.jpg",
    "c": "Argentina. Revista Vea y Lea, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pablo_picasso_1.jpg"
  },
  "ar_corbusier_unite": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/14/Nyc-un-building.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nyc-un-building.jpg"
  },
  "ar_warhol_factory": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Andy_Warhol_by_Jack_Mitchell.jpg/500px-Andy_Warhol_by_Jack_Mitchell.jpg",
    "c": "Jack Mitchell, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Andy_Warhol_by_Jack_Mitchell.jpg"
  },
  "ar_de_kooning_woman": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Willem_de_Kooning_in_his_studio.jpg/500px-Willem_de_Kooning_in_his_studio.jpg",
    "c": "Antony di Gesu, photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Willem_de_Kooning_in_his_studio.jpg"
  },
  "ar_judd_marfa": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/6/61/Donald%D6%B9Judd_IMJ.JPG/500px-Donald%D6%B9Judd_IMJ.JPG?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "ar_dali_elephants": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/09/Mus%C3%A9e_Salvador_Dali_Figueres.JPG",
    "c": "User:Kuxu76, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mus%C3%A9e_Salvador_Dali_Figueres.JPG"
  },
  "ar_ottoman_tiles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Edirne_7333_Nevit.JPG/500px-Edirne_7333_Nevit.JPG",
    "c": "Nevit Dilmen, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Edirne_7333_Nevit.JPG"
  },
  "ar_delaunay_simultaneous": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Delaunay_--_Paysage_au_disque%2C_1906.jpg/500px-Delaunay_--_Paysage_au_disque%2C_1906.jpg",
    "c": "Robert Delaunay, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Delaunay_--_Paysage_au_disque,_1906.jpg"
  },
  "ar_ernst_europe": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/87/Max_Ernst_1968.jpg/500px-Max_Ernst_1968.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 665
  },
  "ar_lichtenstein_whaam": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4f/Roy_Lichtenstein.jpg/500px-Roy_Lichtenstein.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 667
  },
  "ar_man_ray_rayograph": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Man_Ray_1934.jpg/500px-Man_Ray_1934.jpg",
    "c": "Carl Van Vechten, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Man_Ray_1934.jpg"
  },
  "ar_serra_tilted": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/40/Richard_Serra_Bramme_Essen_Schurenbachhalde.jpg/500px-Richard_Serra_Bramme_Essen_Schurenbachhalde.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 333
  },
  "ar_calder_mobile": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Whirligig.jpg/500px-Whirligig.jpg",
    "c": "User:Rklawton, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Whirligig.jpg"
  },
  "ar_hiroshige_tokaido": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Cats_suggested_as_the_fifty-three_stations_of_the_Tokaido.jpg/500px-Cats_suggested_as_the_fifty-three_stations_of_the_Tokaido.jpg",
    "c": "歌川国芳 (Utagawa Kuniyoshi, 1798 - 1861), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cats_suggested_as_the_fifty-three_stations_of_the_Tokaido.jpg"
  },
  "ar_basquiat_samo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/d/de/AsPoster-SAMO-Mania-D.-363x500.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 689
  },
  "ar_hogarth_progress": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Hogarth-Harlot-1.png/500px-Hogarth-Harlot-1.png",
    "c": "William Hogarth, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hogarth-Harlot-1.png"
  },
  "ar_islamic_calligraphy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Calligraphy.malmesbury.bible.arp.jpg/500px-Calligraphy.malmesbury.bible.arp.jpg",
    "c": "Gerard Brils, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Calligraphy.malmesbury.bible.arp.jpg"
  },
  "ar_cindy_sherman": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e0/Tom_Heman%2C_Cindy_Sherman%2C_Patsy_Reddy%2C_Elizabeth_Caldwell%2C_David_Gascoigne%2C_Ellie_Buttrose.jpg/500px-Tom_Heman%2C_Cindy_Sherman%2C_Patsy_Reddy%2C_Elizabeth_Caldwell%2C_David_Gascoigne%2C_Ellie_Buttrose.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 328
  },
  "ar_mies_barcelona": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Barcelona_mies_v_d_rohe_pavillon_weltausstellung1999_03.jpg/500px-Barcelona_mies_v_d_rohe_pavillon_weltausstellung1999_03.jpg",
    "c": "Hans Peter Schaefer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Barcelona_mies_v_d_rohe_pavillon_weltausstellung1999_03.jpg"
  },
  "ar_friedrich_wanderer": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Weimarer_Klassik.jpg/500px-Weimarer_Klassik.jpg",
    "c": "Andreas Müller, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Weimarer_Klassik.jpg"
  },
  "ar_versailles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Grand_Trianon6.JPG/500px-Grand_Trianon6.JPG",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Grand_Trianon6.JPG"
  },
  "ar_richter_atlas": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/dd/Gerhard_Richter_by_Lothar_Wolleh.jpg/500px-Gerhard_Richter_by_Lothar_Wolleh.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 500
  },
  "ar_gentileschi_judith": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/4/4e/Artemisia_Gentileschi_-_Judith_Beheading_Holofernes_-_WGA8563.jpg/500px-Artemisia_Gentileschi_-_Judith_Beheading_Holofernes_-_WGA8563.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 637
  },
  "ar_rodin_kiss": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Hoellentor_Detail_gr.jpg/500px-Hoellentor_Detail_gr.jpg",
    "c": "Stefan Kühn, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hoellentor_Detail_gr.jpg"
  },
  "ar_shirin_neshat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Viennale_talk_%282%29%2C_Shirin_Neshat.jpg/500px-Viennale_talk_%282%29%2C_Shirin_Neshat.jpg",
    "c": "Manfred Werner - Tsui, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Viennale_talk_(2),_Shirin_Neshat.jpg"
  },
  "ar_great_mosque_djenne": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Great_Mosque_of_Djenn%C3%A9_2.jpg/500px-Great_Mosque_of_Djenn%C3%A9_2.jpg",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Great_Mosque_of_Djenn%C3%A9_2.jpg"
  },
  "ar_constable_haywain": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/John_Constable_The_Hay_Wain.jpg/500px-John_Constable_The_Hay_Wain.jpg",
    "c": "John Constable, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:John_Constable_The_Hay_Wain.jpg"
  },
  "ar_ajanta_caves": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Ajanta_%2863%29.jpg/500px-Ajanta_%2863%29.jpg",
    "c": "No machine-readable author provided. Soman assumed (based on copyright claims)., CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Ajanta_(63).jpg"
  },
  "ar_dorothea_lange": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Lange-MigrantMother02.jpg/500px-Lange-MigrantMother02.jpg",
    "c": "Dorothea Lange, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lange-MigrantMother02.jpg"
  },
  "ar_notre_dame_reims": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Ange_au_sourire.jpg/500px-Ange_au_sourire.jpg",
    "c": "Vassil, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ange_au_sourire.jpg"
  },
  "ar_diego_detroit": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/f/f2/Diego_Rivera%2C_Entering_the_City%2C_1930.jpg/500px-Diego_Rivera%2C_Entering_the_City%2C_1930.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 412
  },
  "ar_pompeii_frescoes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/1810%28Peregrinus%29.jpg/500px-1810%28Peregrinus%29.jpg",
    "c": "Fer.filol, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1810(Peregrinus).jpg"
  },
  "ar_ghiberti_doors": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/Detalle_en_Puerta_Para%C3%ADso%2C_Baptisterio_de_San_Giovani_1%2C_Florencia.JPG/500px-Detalle_en_Puerta_Para%C3%ADso%2C_Baptisterio_de_San_Giovani_1%2C_Florencia.JPG",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Detalle_en_Puerta_Para%C3%ADso,_Baptisterio_de_San_Giovani_1,_Florencia.JPG"
  },
  "ar_meissonier_friedland": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Sargent_MadameX.jpeg/500px-Sargent_MadameX.jpeg",
    "c": "John Singer Sargent, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sargent_MadameX.jpeg"
  },
  "ar_kapoor_void": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/SkyMirror_NYC.jpg/500px-SkyMirror_NYC.jpg",
    "c": "BradPatrick at en.wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:SkyMirror_NYC.jpg"
  },
  "ar_tutankhamun_mask": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Tutanchamun_Maske.jpg/500px-Tutanchamun_Maske.jpg",
    "c": "en:User:MykReeve, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tutanchamun_Maske.jpg"
  },
  "ar_greek_kouros": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Athenskouros.jpg/500px-Athenskouros.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Athenskouros.jpg"
  },
  "ar_raphael_madonna": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/12/Raphael-cherubini.jpg",
    "c": "Raphael, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Raphael-cherubini.jpg"
  },
  "ar_olafur_weather": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Tate_Modern_tower_%282007%29.jpg/500px-Tate_Modern_tower_%282007%29.jpg",
    "c": "Carcharoth (Commons), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tate_Modern_tower_(2007).jpg"
  },
  "ar_ife_heads": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/1d/Yoruba-bronze-head.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
    "w": 500,
    "h": 643
  },
  "ar_mies_farnsworth": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Barcelona_mies_v_d_rohe_pavillon_weltausstellung1999_03.jpg/500px-Barcelona_mies_v_d_rohe_pavillon_weltausstellung1999_03.jpg",
    "c": "Hans Peter Schaefer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Barcelona_mies_v_d_rohe_pavillon_weltausstellung1999_03.jpg"
  },
  "ar_bruegel_hunters": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Pieter_Bruegel_d._%C3%84._106.jpg/500px-Pieter_Bruegel_d._%C3%84._106.jpg",
    "c": "Pieter Brueghel the Elder, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pieter_Bruegel_d._%C3%84._106.jpg"
  },
  "ar_barragán_house": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Architect.png/500px-Architect.png",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Architect.png"
  },
  "ar_gehry_bilbao": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/Guggenheim-bilbao-jan05.jpg/500px-Guggenheim-bilbao-jan05.jpg",
    "c": "Photograph taken by User:MykReeve., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Guggenheim-bilbao-jan05.jpg"
  },
  "ar_giorgione_tempest": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Giorgione_-_Judith_-_Eremitage.jpg/500px-Giorgione_-_Judith_-_Eremitage.jpg",
    "c": "Giorgione, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Giorgione_-_Judith_-_Eremitage.jpg"
  },
  "ar_zaha_hadid_fire": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/BMW_Leipzig.JPG/500px-BMW_Leipzig.JPG",
    "c": "Grombo, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:BMW_Leipzig.JPG"
  },
  "ar_joseph_beuys_felt": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/0f/Beuys-Feldman-Gallery.jpg",
    "c": "Ronald Feldman Fine Arts, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Beuys-Feldman-Gallery.jpg"
  },
  "ar_vermeer_astronomy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Vermeer-view-of-delft.jpg/500px-Vermeer-view-of-delft.jpg",
    "c": "Johannes Vermeer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Vermeer-view-of-delft.jpg"
  },
  "ar_whistler_mother": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Whistler_Selbstportr%C3%A4t.jpg/500px-Whistler_Selbstportr%C3%A4t.jpg",
    "c": "James McNeill Whistler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Whistler_Selbstportr%C3%A4t.jpg"
  },
  "ar_kara_walker": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Kara_Walker_Interview_Camden_Arts_Centre_01.47_%28cropped%29.jpg/500px-Kara_Walker_Interview_Camden_Arts_Centre_01.47_%28cropped%29.jpg",
    "c": "studio international, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kara_Walker_Interview_Camden_Arts_Centre_01.47_(cropped).jpg"
  },
  "ar_tintoretto_paradise": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Jacopo_Tintoretto_-_Finding_of_the_body_of_St_Mark_-_Yorck_Project.jpg/500px-Jacopo_Tintoretto_-_Finding_of_the_body_of_St_Mark_-_Yorck_Project.jpg",
    "c": "Jacopo Tintoretto, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jacopo_Tintoretto_-_Finding_of_the_body_of_St_Mark_-_Yorck_Project.jpg"
  },
  "ar_maya_lin_memorial": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/5/5a/Names_of_Vietnam_Veterans.jpg/500px-Names_of_Vietnam_Veterans.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 375
  },
  "ar_el_greco_burial": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/El_Greco_020.jpg/500px-El_Greco_020.jpg",
    "c": "El Greco, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:El_Greco_020.jpg"
  },
  "anc_dna": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/b/b8/DNA-structure-and-bases.png",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DNA-structure-and-bases.png"
  },
  "anc_rwanda": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Nyamata_Memorial_Site_13.jpg/500px-Nyamata_Memorial_Site_13.jpg",
    "c": "Fanny Schertzer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nyamata_Memorial_Site_13.jpg"
  },
  "anc_lindisfarne": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/T.homas_Girtin_Lindisfarne_1798.jpg/500px-T.homas_Girtin_Lindisfarne_1798.jpg",
    "c": "Thomas Girtin, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:T.homas_Girtin_Lindisfarne_1798.jpg"
  },
  "anc_ashurbanipal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/AshurbanipalKingOfAssyria.jpg/500px-AshurbanipalKingOfAssyria.jpg",
    "c": "KeyolTranslater, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:AshurbanipalKingOfAssyria.jpg"
  },
  "anc_hanfound": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Liu-bang.jpg/500px-Liu-bang.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Liu-bang.jpg"
  },
  "anc_anlushan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/An_Lushan_Rebellion.png/500px-An_Lushan_Rebellion.png",
    "c": "SY, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:An_Lushan_Rebellion.png"
  },
  "anc_ezana": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/AXUM._Ezanas._Circa_330-360.jpg/500px-AXUM._Ezanas._Circa_330-360.jpg",
    "c": "CNG Coins, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:AXUM._Ezanas._Circa_330-360.jpg"
  },
  "med_domesday": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Domesday-book-1804x972.jpg/500px-Domesday-book-1804x972.jpg",
    "c": "Andrews, William, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Domesday-book-1804x972.jpg"
  },
  "anq_eratosthenes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Eratosthenes_Teaching_in_Alexandria_%28Bernardo_Strozzi%2C_Montreal%29.jpg/500px-Eratosthenes_Teaching_in_Alexandria_%28Bernardo_Strozzi%2C_Montreal%29.jpg",
    "c": "Bernardo Strozzi, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eratosthenes_Teaching_in_Alexandria_(Bernardo_Strozzi,_Montreal).jpg"
  },
  "anq_assurbanipal_library": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Library_of_Ashurbanipal.jpg/500px-Library_of_Ashurbanipal.jpg",
    "c": "Gary Todd, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Library_of_Ashurbanipal.jpg"
  },
  "med_verdun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Louis_the_Pious_blessing_the_division_of_the_Carolingian_Empire_in_843_into_West_Francia%2C_Lotharingia%2C_and_East_Francia.jpg/500px-Louis_the_Pious_blessing_the_division_of_the_Carolingian_Empire_in_843_into_West_Francia%2C_Lotharingia%2C_and_East_Francia.jpg",
    "c": "AnonymousUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Louis_the_Pious_blessing_the_division_of_the_Carolingian_Empire_in_843_into_West_Francia,_Lotharingia,_and_East_Francia.jpg"
  },
  "med_saladincairo": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/c/cc/Selahaddin_Eyyubi_El_Kurdi.jpg/500px-Selahaddin_Eyyubi_El_Kurdi.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 585
  },
  "med_panipat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/The_battle_of_Panipat_and_the_death_of_Sultan_Ibr%C4%81h%C4%ABm%2C_the_last_of_the_L%C5%8Dd%C4%AB_Sultans_of_Delhi.jpg/500px-The_battle_of_Panipat_and_the_death_of_Sultan_Ibr%C4%81h%C4%ABm%2C_the_last_of_the_L%C5%8Dd%C4%AB_Sultans_of_Delhi.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_battle_of_Panipat_and_the_death_of_Sultan_Ibr%C4%81h%C4%ABm,_the_last_of_the_L%C5%8Dd%C4%AB_Sultans_of_Delhi.jpg"
  },
  "anq_julian_temple": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Juliancng8851obverse.jpg/500px-Juliancng8851obverse.jpg",
    "c": "Classical Numismatic Group, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Juliancng8851obverse.jpg"
  },
  "med_lechfeld": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Lechfeld1457.jpg/500px-Lechfeld1457.jpg",
    "c": "Hektor Mülich[1] (d. 1490), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lechfeld1457.jpg"
  },
  "anq_aksum": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/AXUM._Ezanas._Circa_330-360.jpg/500px-AXUM._Ezanas._Circa_330-360.jpg",
    "c": "CNG Coins, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:AXUM._Ezanas._Circa_330-360.jpg"
  },
  "anq_poverty_point": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Louisiana_-_Poverty_Point_-_Karte_%28English_version%29.png/500px-Louisiana_-_Poverty_Point_-_Karte_%28English_version%29.png",
    "c": "Maximilian Dörrbecker (Chumwa), CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Louisiana_-_Poverty_Point_-_Karte_(English_version).png"
  },
  "anq_ur_nammu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/King_Ur-Nammu.jpg/500px-King_Ur-Nammu.jpg",
    "c": "Steve Harris, source, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:King_Ur-Nammu.jpg"
  },
  "med_ashikaga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Hana-no-Gosho-Flower-Palace-Kyoto.png/500px-Hana-no-Gosho-Flower-Palace-Kyoto.png",
    "c": "日本語: 京都アスニー収蔵 English: Collection of Kyoto Asney archive, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hana-no-Gosho-Flower-Palace-Kyoto.png"
  },
  "anq_erlitou": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Characters_from_Erlitou_Culture%2C_Yanshi%2C_Henan_%2810185242295%29.jpg/500px-Characters_from_Erlitou_Culture%2C_Yanshi%2C_Henan_%2810185242295%29.jpg",
    "c": "Gary Todd from Xinzheng, China, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Characters_from_Erlitou_Culture,_Yanshi,_Henan_(10185242295).jpg"
  },
  "med_aksumhimyar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/07/Kaleb.jpg",
    "c": "Classical Numismatic Group, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Kaleb.jpg"
  },
  "new_magna_carta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Magna_Carta_%28British_Library_Cotton_MS_Augustus_II.106%29.jpg/500px-Magna_Carta_%28British_Library_Cotton_MS_Augustus_II.106%29.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Magna_Carta_(British_Library_Cotton_MS_Augustus_II.106).jpg"
  },
  "new_shakespeare": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/6/6a/Edwin_Booth_Hamlet_1870.jpg",
    "c": "J. Gurney &amp; Son, N.Y., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Edwin_Booth_Hamlet_1870.jpg"
  },
  "new_beethoven_9th": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/The_Premiere_of_Symphony_No._9.jpg/500px-The_Premiere_of_Symphony_No._9.jpg",
    "c": "Carl Offterdinger, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Premiere_of_Symphony_No._9.jpg"
  },
  "new_cinema": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Lumi%C3%A8re_brothers.jpg/500px-Lumi%C3%A8re_brothers.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Lumi%C3%A8re_brothers.jpg"
  },
  "new_pasteur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Louis_Pasteur%2C_foto_av_Paul_Nadar%2C_Crisco_edit.jpg/500px-Louis_Pasteur%2C_foto_av_Paul_Nadar%2C_Crisco_edit.jpg",
    "c": "Paul Nadar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Louis_Pasteur,_foto_av_Paul_Nadar,_Crisco_edit.jpg"
  },
  "new_telephone": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Telefono_di_Meucci_-_Museo_scienza_tecnologia_Milano_02148-02147_dia.jpg/500px-Telefono_di_Meucci_-_Museo_scienza_tecnologia_Milano_02148-02147_dia.jpg",
    "c": "Meucci Antonio (inventore), Officine Galileo (costruttore), CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Telefono_di_Meucci_-_Museo_scienza_tecnologia_Milano_02148-02147_dia.jpg"
  },
  "new_marconi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Guglielmo_Marconi.jpg/500px-Guglielmo_Marconi.jpg",
    "c": "Pach Brothers, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Guglielmo_Marconi.jpg"
  },
  "new_swahili_coast": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/7/74/Swahili_coast.png",
    "c": "Runehelmet, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Swahili_coast.png"
  },
  "new_nok": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Africa_Nok_Head_Kimbell.jpg/500px-Africa_Nok_Head_Kimbell.jpg",
    "c": "User:FA2010, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Africa_Nok_Head_Kimbell.jpg"
  },
  "new_kushan": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Map_of_the_Kushan_Empire.png/500px-Map_of_the_Kushan_Empire.png",
    "c": "Wikimedia Commons, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Map_of_the_Kushan_Empire.png"
  },
  "new_majapahit": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/%28139_of_160%29_%28cropped%29.jpg/500px-%28139_of_160%29_%28cropped%29.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:(139_of_160)_(cropped).jpg"
  },
  "new_maori": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/New_Zealand_-_Maori_rowing_-_8444.jpg/500px-New_Zealand_-_Maori_rowing_-_8444.jpg",
    "c": "Jorge Royan, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:New_Zealand_-_Maori_rowing_-_8444.jpg"
  },
  "new_sukhothai": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Ram_Khamhaeng_the_Great_%28I%29.jpg/500px-Ram_Khamhaeng_the_Great_%28I%29.jpg",
    "c": "Wikimedia Commons, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ram_Khamhaeng_the_Great_(I).jpg"
  },
  "new_nan_madol": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Nan_madol.jpg/500px-Nan_madol.jpg",
    "c": "NOAA, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nan_madol.jpg"
  },
  "new_mapungubwe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/MapungubweHill.jpg/500px-MapungubweHill.jpg",
    "c": "JJ van Zyl, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:MapungubweHill.jpg"
  },
  "gr_rome_founding": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/She-wolf_suckles_Romulus_and_Remus.jpg/500px-She-wolf_suckles_Romulus_and_Remus.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:She-wolf_suckles_Romulus_and_Remus.jpg"
  },
  "gr_hannibal_alps": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Hannibal_Barca_bust_from_Capua_photo.jpg/500px-Hannibal_Barca_bust_from_Capua_photo.jpg",
    "c": "Fratelli Alinari, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hannibal_Barca_bust_from_Capua_photo.jpg"
  },
  "gr_cannae": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/8/89/Annibale_a_Canne.jpg/500px-Annibale_a_Canne.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 334
  },
  "gr_aristotle": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Aristotle_Altemps_Inv8575.jpg/500px-Aristotle_Altemps_Inv8575.jpg",
    "c": "After Lysippos, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Aristotle_Altemps_Inv8575.jpg"
  },
  "gr_actium": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Medinaceli_Actium_reliefs_06.jpg/500px-Medinaceli_Actium_reliefs_06.jpg",
    "c": "Mark Landon, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Medinaceli_Actium_reliefs_06.jpg"
  },
  "gr_cleopatra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Kleopatra-VII.-Altes-Museum-Berlin1.jpg/500px-Kleopatra-VII.-Altes-Museum-Berlin1.jpg",
    "c": "Louis le Grand, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Kleopatra-VII.-Altes-Museum-Berlin1.jpg"
  },
  "gr_crucifixion": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Cristo_crucificado.jpg/500px-Cristo_crucificado.jpg",
    "c": "Diego Velázquez, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cristo_crucificado.jpg"
  },
  "gr_minoan_civ": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/AKROTIRI_SHIP-PROCESSION-FULL.jpg/500px-AKROTIRI_SHIP-PROCESSION-FULL.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:AKROTIRI_SHIP-PROCESSION-FULL.jpg"
  },
  "gr_mycenae": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Mycenaean_World_en.png/500px-Mycenaean_World_en.png",
    "c": "User:Alexikoua, User:Panthera tigris tigris, TL User:Reedside, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mycenaean_World_en.png"
  },
  "gr_trojan_horse": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Mykonos_vase.jpg/500px-Mykonos_vase.jpg",
    "c": "Travelling Runes, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mykonos_vase.jpg"
  },
  "gr_twelve_tables": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Gortys_Law_Code.jpg/500px-Gortys_Law_Code.jpg",
    "c": "Afrank99, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Gortys_Law_Code.jpg"
  },
  "gr_archimedes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Domenico-Fetti_Archimedes_1620.jpg/500px-Domenico-Fetti_Archimedes_1620.jpg",
    "c": "Domenico Fetti, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Domenico-Fetti_Archimedes_1620.jpg"
  },
  "gr_plataea": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Scene_of_the_Battle_of_Plataea.jpg/500px-Scene_of_the_Battle_of_Plataea.jpg",
    "c": "John Steeple Davis, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Scene_of_the_Battle_of_Plataea.jpg"
  },
  "gr_aeschylus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Herma_of_Aeschylus%2C_Klas08.jpg/500px-Herma_of_Aeschylus%2C_Klas08.jpg",
    "c": "Zde, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Herma_of_Aeschylus,_Klas08.jpg"
  },
  "gr_draco_laws": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Draco_engraving_from_1833_%28cropped%29.jpg/500px-Draco_engraving_from_1833_%28cropped%29.jpg",
    "c": "Max Karl Baldamus, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Draco_engraving_from_1833_(cropped).jpg"
  },
  "gr_pheidippides": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Statue_of_Pheidippides_along_the_Marathon_Road.jpg/500px-Statue_of_Pheidippides_along_the_Marathon_Road.jpg",
    "c": "The original uploader was Hammer of the Gods27 at English Wikipedia., CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Statue_of_Pheidippides_along_the_Marathon_Road.jpg"
  },
  "gr_phidias": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/The_Sculptor_Phidias-Ny_Carlsberg_Glyptotek.jpg/500px-The_Sculptor_Phidias-Ny_Carlsberg_Glyptotek.jpg",
    "c": "Yair-haklai, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_Sculptor_Phidias-Ny_Carlsberg_Glyptotek.jpg"
  },
  "gr_eratosthenes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Eratosthenes_Teaching_in_Alexandria_%28Bernardo_Strozzi%2C_Montreal%29.jpg/500px-Eratosthenes_Teaching_in_Alexandria_%28Bernardo_Strozzi%2C_Montreal%29.jpg",
    "c": "Bernardo Strozzi, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eratosthenes_Teaching_in_Alexandria_(Bernardo_Strozzi,_Montreal).jpg"
  },
  "gr_tiberius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/8095_-_Roma_-_Ara_Pacis_-_Tiberio_-_Foto_Giovanni_Dall%27Orto_-_28-Mar-2008.jpg/500px-8095_-_Roma_-_Ara_Pacis_-_Tiberio_-_Foto_Giovanni_Dall%27Orto_-_28-Mar-2008.jpg",
    "c": "Giovanni Dall'Orto, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:8095_-_Roma_-_Ara_Pacis_-_Tiberio_-_Foto_Giovanni_Dall%27Orto_-_28-Mar-2008.jpg"
  },
  "gr_masada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Israel-2013-Aerial_21-Masada.jpg/500px-Israel-2013-Aerial_21-Masada.jpg",
    "c": "Godot13, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Israel-2013-Aerial_21-Masada.jpg"
  },
  "gr_bar_kokhba": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Bar_kochba22.jpg/500px-Bar_kochba22.jpg",
    "c": "Tamar HaYardeni, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Bar_kochba22.jpg"
  },
  "gr_antonine_plague": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Aurelius180AD.png/500px-Aurelius180AD.png",
    "c": "Tataryn77, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Aurelius180AD.png"
  },
  "gr_commodus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Commodo_vestito_da_Ercole_ai_Musei_Capitolini.jpg/500px-Commodo_vestito_da_Ercole_ai_Musei_Capitolini.jpg",
    "c": "Merulana, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Commodo_vestito_da_Ercole_ai_Musei_Capitolini.jpg"
  },
  "gr_crisis_3rd": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/5305_-_Brescia_-_S._Giulia_-_Ritratto_di_Claudio_II_il_Gotico_-_Foto_Giovanni_Dall%27Orto%2C_25_Giu_2011_%28cropped%29.jpg/500px-5305_-_Brescia_-_S._Giulia_-_Ritratto_di_Claudio_II_il_Gotico_-_Foto_Giovanni_Dall%27Orto%2C_25_Giu_2011_%28cropped%29.jpg",
    "c": "Giovanni Dall'Orto., Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:5305_-_Brescia_-_S._Giulia_-_Ritratto_di_Claudio_II_il_Gotico_-_Foto_Giovanni_Dall%27Orto,_25_Giu_2011_(cropped).jpg"
  },
  "gr_milvian_bridge": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Battle_of_the_Milvian_Bridge_by_Giulio_Romano%2C_1520-24.jpg/500px-Battle_of_the_Milvian_Bridge_by_Giulio_Romano%2C_1520-24.jpg",
    "c": "Giulio Romano, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Battle_of_the_Milvian_Bridge_by_Giulio_Romano,_1520-24.jpg"
  },
  "gr_nicaea_council": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/%CE%9C%CE%B9%CF%87%CE%B1%CE%AE%CE%BB_%CE%94%CE%B1%CE%BC%CE%B1%CF%83%CE%BA%CE%B7%CE%BD%CF%8C%CF%82_-_%CE%91%CE%84_%CE%9F%CE%B9%CE%BA%CE%BF%CF%85%CE%BC%CE%B5%CE%BD%CE%B9%CE%BA%CE%AE_%CE%A3%CF%8D%CE%BD%CE%BF%CE%B4%CE%BF%CF%82_7741.jpg/500px-%CE%9C%CE%B9%CF%87%CE%B1%CE%AE%CE%BB_%CE%94%CE%B1%CE%BC%CE%B1%CF%83%CE%BA%CE%B7%CE%BD%CF%8C%CF%82_-_%CE%91%CE%84_%CE%9F%CE%B9%CE%BA%CE%BF%CF%85%CE%BC%CE%B5%CE%BD%CE%B9%CE%BA%CE%AE_%CE%A3%CF%8D%CE%BD%CE%BF%CE%B4%CE%BF%CF%82_7741.jpg",
    "c": "C messier, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:%CE%9C%CE%B9%CF%87%CE%B1%CE%AE%CE%BB_%CE%94%CE%B1%CE%BC%CE%B1%CF%83%CE%BA%CE%B7%CE%BD%CF%8C%CF%82_-_%CE%91%CE%84_%CE%9F%CE%B9%CE%BA%CE%BF%CF%85%CE%BC%CE%B5%CE%BD%CE%B9%CE%BA%CE%AE_%CE%A3%CF%8D%CE%BD%CE%BF%CE%B4%CE%BF%CF%82_7741.jpg"
  },
  "gr_empire_split": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/0418_Befreiung_einer_belagerten_Stadt_Bodemuseum_anagoria.JPG/500px-0418_Befreiung_einer_belagerten_Stadt_Bodemuseum_anagoria.JPG",
    "c": "Anagoria, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:0418_Befreiung_einer_belagerten_Stadt_Bodemuseum_anagoria.JPG"
  },
  "gr_corpus_juris": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Corpus_Iuris_Civilis_-_Dion%C3%ADsio_Godofredo_-_1583.jpg/500px-Corpus_Iuris_Civilis_-_Dion%C3%ADsio_Godofredo_-_1583.jpg",
    "c": "IusRomanum, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Corpus_Iuris_Civilis_-_Dion%C3%ADsio_Godofredo_-_1583.jpg"
  },
  "gr_great_schism": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Great_Schism_with_former_borders_%281054%29.png/500px-Great_Schism_with_former_borders_%281054%29.png",
    "c": "Barrikader (talk · contribs), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Great_Schism_with_former_borders_(1054).png"
  },
  "gr_manzikert": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/11_13th_century_Asia_Minor_Turkish_Invasions.png/500px-11_13th_century_Asia_Minor_Turkish_Invasions.png",
    "c": "Alexikoua, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:11_13th_century_Asia_Minor_Turkish_Invasions.png"
  },
  "gr_vitruvius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Vitruvio_Pollione_portrait_%28cropped%29.jpg/500px-Vitruvio_Pollione_portrait_%28cropped%29.jpg",
    "c": "Jacopo Bernardi (engraver); Vincenzo Raggio (painter), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Vitruvio_Pollione_portrait_(cropped).jpg"
  },
  "gr_persian_immortals": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Persian_warriors_from_Berlin_Museum.jpg/500px-Persian_warriors_from_Berlin_Museum.jpg",
    "c": "photo by mshamma, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Persian_warriors_from_Berlin_Museum.jpg"
  },
  "gr_peisistratus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/a/ac/Statue_of_Peisistratos.jpg",
    "c": "Statens Museum for Kunst via Europeana website, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Statue_of_Peisistratos.jpg"
  },
  "gr_cato_elder": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/8c/Patrizio_Torlonia.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Patrizio_Torlonia.jpg"
  },
  "gr_colossus_rhodes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Colosse_de_Rhodes_%28Barclay%29.jpg/500px-Colosse_de_Rhodes_%28Barclay%29.jpg",
    "c": "gravure sur bois de Sidney Barclay numérisée Google, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Colosse_de_Rhodes_(Barclay).jpg"
  },
  "gr_praetorian_guard": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Relief_historique_dit_Relief_des_Pr%C3%A9toriens_01.jpg/500px-Relief_historique_dit_Relief_des_Pr%C3%A9toriens_01.jpg",
    "c": "Sunappu-shashin, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Relief_historique_dit_Relief_des_Pr%C3%A9toriens_01.jpg"
  },
  "gr_pyrrhus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Pyrrhus_MAN_Napoli_Inv6150_n03.jpg/500px-Pyrrhus_MAN_Napoli_Inv6150_n03.jpg",
    "c": "Marie-Lan Nguyen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pyrrhus_MAN_Napoli_Inv6150_n03.jpg"
  },
  "gr_romulus_augustulus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Gold_Solidus_of_Romulus_Augustulus.jpg/500px-Gold_Solidus_of_Romulus_Augustulus.jpg",
    "c": "ANS, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Gold_Solidus_of_Romulus_Augustulus.jpg"
  },
  "gr_ottoman_siege": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e2/Le_si%C3%A8ge_de_Constantinople_%281453%29_by_Jean_Le_Tavernier_after_1455.jpg/500px-Le_si%C3%A8ge_de_Constantinople_%281453%29_by_Jean_Le_Tavernier_after_1455.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Le_si%C3%A8ge_de_Constantinople_(1453)_by_Jean_Le_Tavernier_after_1455.jpg"
  },
  "gr_hannibal_elephants": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Hannibal_traverse_le_Rh%C3%B4ne_Henri_Motte_1878.jpg/500px-Hannibal_traverse_le_Rh%C3%B4ne_Henri_Motte_1878.jpg",
    "c": "Henri-Paul Motte, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hannibal_traverse_le_Rh%C3%B4ne_Henri_Motte_1878.jpg"
  },
  "gr_tribunes": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Secessio_plebis.JPG/500px-Secessio_plebis.JPG",
    "c": "B. Barloccini, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Secessio_plebis.JPG"
  },
  "gr_silk_road_rome": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/East-Hem_050ad.jpg/500px-East-Hem_050ad.jpg",
    "c": "Thomas Lessman (Contact!), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:East-Hem_050ad.jpg"
  },
  "gr_nero_persecution": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Nero_Glyptothek_Munich_321.jpg/500px-Nero_Glyptothek_Munich_321.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Nero_Glyptothek_Munich_321.jpg"
  },
  "gr_vespasian": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Vespasian%2C_from_Naples%2C_c._AD_70%2C_Ny_Carlsberg_Glyptotek%2C_Copenhagen_%2813646730625%29.jpg/500px-Vespasian%2C_from_Naples%2C_c._AD_70%2C_Ny_Carlsberg_Glyptotek%2C_Copenhagen_%2813646730625%29.jpg",
    "c": "Carole Raddato from FRANKFURT, Germany, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Vespasian,_from_Naples,_c._AD_70,_Ny_Carlsberg_Glyptotek,_Copenhagen_(13646730625).jpg"
  },
  "gr_pliny_elder": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Grande_Illustrazione_del_Lombardo_Veneto_Vol_3_Plinio_Secondo_300dpi.jpg/500px-Grande_Illustrazione_del_Lombardo_Veneto_Vol_3_Plinio_Secondo_300dpi.jpg",
    "c": "Geoffrey, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Grande_Illustrazione_del_Lombardo_Veneto_Vol_3_Plinio_Secondo_300dpi.jpg"
  },
  "gr_tacitus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Wien-_Parlament-Tacitus.jpg/500px-Wien-_Parlament-Tacitus.jpg",
    "c": "Pe-Jo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Wien-_Parlament-Tacitus.jpg"
  },
  "gr_roman_triumph": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Bas_relief_from_Arch_of_Marcus_Aurelius_triumph_chariot_from_Roma_Project.jpg/500px-Bas_relief_from_Arch_of_Marcus_Aurelius_triumph_chariot_from_Roma_Project.jpg",
    "c": "Wilfredor, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Bas_relief_from_Arch_of_Marcus_Aurelius_triumph_chariot_from_Roma_Project.jpg"
  },
  "mu_bach_welltempered": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/Bach-wtc1-title-ms.jpg/500px-Bach-wtc1-title-ms.jpg",
    "c": "Johann Sebastian Bach, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bach-wtc1-title-ms.jpg"
  },
  "mu_michael_thriller": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Michael_Jackson_1983_%283x4_cropped%29_%28contrast%29.jpg/500px-Michael_Jackson_1983_%283x4_cropped%29_%28contrast%29.jpg",
    "c": "Matthew Rolston; Distributed by Epic Records, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Michael_Jackson_1983_(3x4_cropped)_(contrast).jpg"
  },
  "mu_palestrina_missa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/1/18/Giovanni_Pierluigi_da_Palestrina.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Giovanni_Pierluigi_da_Palestrina.jpg"
  },
  "mu_james_brown_live": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/James_Brown_1996_%28HQ%29.jpg/500px-James_Brown_1996_%28HQ%29.jpg",
    "c": "John Mathew Smith &amp; www.celebrity-photos.com from Laurel Maryland, USA, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:James_Brown_1996_(HQ).jpg"
  },
  "mu_fela_kuti_zombie": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Fela_Kuti_circa_1986.jpg/500px-Fela_Kuti_circa_1986.jpg",
    "c": "Distributed by Celluloid Records, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Fela_Kuti_circa_1986.jpg"
  },
  "mu_arik_einstein_poozy": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Arik_Einstein_D499-097_taken_by_Israel_Government_Press_Office.jpg/500px-Arik_Einstein_D499-097_taken_by_Israel_Government_Press_Office.jpg",
    "c": "Yaakov Saar, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Arik_Einstein_D499-097_taken_by_Israel_Government_Press_Office.jpg"
  },
  "mu_ravi_shankar_concert": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Ravi_Shankar.jpg/500px-Ravi_Shankar.jpg",
    "c": "Markgoff2972, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ravi_Shankar.jpg"
  },
  "mu_beethoven_eroica": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Eroica_Beethoven_title.jpg/500px-Eroica_Beethoven_title.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Eroica_Beethoven_title.jpg"
  },
  "mu_notorious_ready": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/97/The_Notorious_B.I.G._sig.png/500px-The_Notorious_B.I.G._sig.png?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 176
  },
  "mu_run_dmc_aerosmith": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Run-DMC_in_1986.jpg/500px-Run-DMC_in_1986.jpg",
    "c": "Not credited, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Run-DMC_in_1986.jpg"
  },
  "mu_josquin_missa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/c/c2/Josquin_woodcut.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Josquin_woodcut.jpg"
  },
  "mu_dr_dre_chronic": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/1/19/Excelbeats_and_Dr.dre.jpg/500px-Excelbeats_and_Dr.dre.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 431
  },
  "mu_guitar_invention": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Classical_Guitar_two_views2.png/500px-Classical_Guitar_two_views2.png",
    "c": "User:Martin Möller, CC BY-SA 2.0 de",
    "p": "https://commons.wikimedia.org/wiki/File:Classical_Guitar_two_views2.png"
  },
  "mu_ramones_debut": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Ramones_rocket_to_russia_photo.jpg/500px-Ramones_rocket_to_russia_photo.jpg",
    "c": "Danny Fields, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ramones_rocket_to_russia_photo.jpg"
  },
  "mu_meir_ariel_shlomtsiyon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Meir_Ariel.jpg/500px-Meir_Ariel.jpg",
    "c": "The original uploader was סקרלט at Hebrew Wikipedia., Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Meir_Ariel.jpg"
  },
  "mu_piazzolla_tango": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Astor_Piazzolla.jpg/500px-Astor_Piazzolla.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Astor_Piazzolla.jpg"
  },
  "mu_opera_verismo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/GiacomoPuccini.jpg/500px-GiacomoPuccini.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:GiacomoPuccini.jpg"
  },
  "mu_joy_division_unknown": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Strawberry_Studios_%283610622%29.jpg/500px-Strawberry_Studios_%283610622%29.jpg",
    "c": "Robin Stott, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Strawberry_Studios_(3610622).jpg"
  },
  "mu_musica_ricercata": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Gy%C3%B6rgy_Ligeti_%281984%29.jpg/500px-Gy%C3%B6rgy_Ligeti_%281984%29.jpg",
    "c": "Marcel Antonisse / Anefo, CC BY-SA 3.0 nl",
    "p": "https://commons.wikimedia.org/wiki/File:Gy%C3%B6rgy_Ligeti_(1984).jpg"
  },
  "mu_persian_tar": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/A_Youthful_Musician%2C_Persia%2C_Safavid%2C_Isfahan_or_Khurasan%2C_late_16th_century.jpg/500px-A_Youthful_Musician%2C_Persia%2C_Safavid%2C_Isfahan_or_Khurasan%2C_late_16th_century.jpg",
    "c": "unknown artist, 16th century C.E., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_Youthful_Musician,_Persia,_Safavid,_Isfahan_or_Khurasan,_late_16th_century.jpg"
  },
  "mu_samba_rio": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/01_jorgearagao.jpg/500px-01_jorgearagao.jpg",
    "c": "Olimor, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:01_jorgearagao.jpg"
  },
  "mu_nusrat_qawwali": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/2/2d/Nusrat_Fateh_Ali_Khan_%281948-1997%29.jpg",
    "c": "Thomas Rome, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Nusrat_Fateh_Ali_Khan_(1948-1997).jpg"
  },
  "mu_corelli_concerti": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Arcangelo_Corelli%2C_portrait_by_Hugh_Howard_%281697%29.jpg/500px-Arcangelo_Corelli%2C_portrait_by_Hugh_Howard_%281697%29.jpg",
    "c": "Hugh Howard, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Arcangelo_Corelli,_portrait_by_Hugh_Howard_(1697).jpg"
  },
  "mu_garage_motown_stooges": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Iggy_and_The_Stooges_-_4572393187.jpg/500px-Iggy_and_The_Stooges_-_4572393187.jpg",
    "c": "aurélien., CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Iggy_and_The_Stooges_-_4572393187.jpg"
  },
  "mu_ofra_haza_im_ninalu": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Ofra_Haza_1981_%28%D7%A2%D7%A4%D7%A8%D7%94_%D7%97%D7%96%D7%94_1981%29.jpg/500px-Ofra_Haza_1981_%28%D7%A2%D7%A4%D7%A8%D7%94_%D7%97%D7%96%D7%94_1981%29.jpg",
    "c": "Yaakov Saar, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ofra_Haza_1981_(%D7%A2%D7%A4%D7%A8%D7%94_%D7%97%D7%96%D7%94_1981).jpg"
  },
  "mu_mendelssohn_wedding": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/f/f4/Mendelssohn_wedding_march_autograph_arrangement_for_piano.jpg",
    "c": "Felix Mendelssohn, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Mendelssohn_wedding_march_autograph_arrangement_for_piano.jpg"
  },
  "mu_daft_punk_discovery": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/68/Daft_Punk_in_2013_2-_centered.jpg/500px-Daft_Punk_in_2013_2-_centered.jpg",
    "c": "Sony Music Entertainment, additional editing by W.carter, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Daft_Punk_in_2013_2-_centered.jpg"
  },
  "mu_cello_suites_bach": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Frontespizio_Cello_Suite.png/500px-Frontespizio_Cello_Suite.png",
    "c": "Anna Magdalena Bach, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Frontespizio_Cello_Suite.png"
  },
  "mu_strauss_blue_danube": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Donauwalzer_Spina_01.jpg/500px-Donauwalzer_Spina_01.jpg",
    "c": "Johann Strauss, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Donauwalzer_Spina_01.jpg"
  },
  "mu_gamelan_java": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Gamelan_Player_1.JPG/500px-Gamelan_Player_1.JPG",
    "c": "Gunawan Kartapranata, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gamelan_Player_1.JPG"
  },
  "mu_rap_sugarhill": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/The_Sugarhill_Gang_%2852789914906%29.jpg/500px-The_Sugarhill_Gang_%2852789914906%29.jpg",
    "c": "Gage Skidmore from Surprise, AZ, United States of America, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:The_Sugarhill_Gang_(52789914906).jpg"
  },
  "mu_salieri_vienna": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Antonio_Salieri_painted_by_Joseph_Willibrord_M%C3%A4hler.jpg/500px-Antonio_Salieri_painted_by_Joseph_Willibrord_M%C3%A4hler.jpg",
    "c": "Joseph Willibrord Mähler, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Antonio_Salieri_painted_by_Joseph_Willibrord_M%C3%A4hler.jpg"
  },
  "mu_penderecki_threnody": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/Hiroshima_10km.jpg/500px-Hiroshima_10km.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Hiroshima_10km.jpg"
  },
  "mu_paganini_caprices": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Paganini.jpeg/500px-Paganini.jpeg",
    "c": "John Whittle (active in Preston, early 19th century), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Paganini.jpeg"
  },
  "mu_cape_jazz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/0/0a/Abdullah_Ibrahim_Oslo_Jazzfestival_%28191335%29_%28cropped%29.jpg",
    "c": "Tore Sætre, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Abdullah_Ibrahim_Oslo_Jazzfestival_(191335)_(cropped).jpg"
  },
  "mu_organ_hydraulis": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Mosaique_Zliten.jpg/500px-Mosaique_Zliten.jpg",
    "c": "The original uploader was Nacéra Benseddik at French Wikipedia., CC BY-SA 1.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mosaique_Zliten.jpg"
  },
  "mu_hindustani_raga": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Melakarta.katapayadi.sankhya.72_correction_for_no_41-47-53-59-65-71_da2-instead-of-da3.png/500px-Melakarta.katapayadi.sankhya.72_correction_for_no_41-47-53-59-65-71_da2-instead-of-da3.png",
    "c": "Charlie Rem, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Melakarta.katapayadi.sankhya.72_correction_for_no_41-47-53-59-65-71_da2-instead-of-da3.png"
  },
  "mu_griot_west_africa": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/BaobabGriots.jpg/500px-BaobabGriots.jpg",
    "c": "Ji-Elle, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BaobabGriots.jpg"
  },
  "mu_satie_gymnopedies": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Gymnop%C3%A9die_1_d%27Erik_Satie%2C_autographe.jpg/500px-Gymnop%C3%A9die_1_d%27Erik_Satie%2C_autographe.jpg",
    "c": "Erik Satie, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Gymnop%C3%A9die_1_d%27Erik_Satie,_autographe.jpg"
  },
  "jh_six_day_war": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/6DayWarEnglish.png/500px-6DayWarEnglish.png",
    "c": "Zvikorn, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:6DayWarEnglish.png"
  },
  "jh_ten_commandments": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/0001_FL9694984.jpg/500px-0001_FL9694984.jpg",
    "c": "Wikimedia Commons, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:0001_FL9694984.jpg"
  },
  "jh_first_temple_destruction": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/The_art_Bible%2C_comprising_the_Old_and_new_Testaments_-_with_numerous_illustrations_%281896%29_%2814783032815%29.jpg/500px-The_art_Bible%2C_comprising_the_Old_and_new_Testaments_-_with_numerous_illustrations_%281896%29_%2814783032815%29.jpg",
    "c": "Internet Archive Book Images, No restrictions",
    "p": "https://commons.wikimedia.org/wiki/File:The_art_Bible,_comprising_the_Old_and_new_Testaments_-_with_numerous_illustrations_(1896)_(14783032815).jpg"
  },
  "jh_yom_kippur": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/15/143th_Division_during_Yom_Kippur_War._VI.jpg/500px-143th_Division_during_Yom_Kippur_War._VI.jpg",
    "c": "IDF Spokesperson's Unit photographer, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:143th_Division_during_Yom_Kippur_War._VI.jpg"
  },
  "jh_masada": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Israel-2013-Aerial_21-Masada.jpg/500px-Israel-2013-Aerial_21-Masada.jpg",
    "c": "Godot13, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Israel-2013-Aerial_21-Masada.jpg"
  },
  "jh_bar_kokhba": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Bar_kochba22.jpg/500px-Bar_kochba22.jpg",
    "c": "Tamar HaYardeni, Attribution",
    "p": "https://commons.wikimedia.org/wiki/File:Bar_kochba22.jpg"
  },
  "jh_salonika": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Jews_of_Salonika-1917.jpg/500px-Jews_of_Salonika-1917.jpg",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jews_of_Salonika-1917.jpg"
  },
  "jh_galut_england": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/BritLibCottonNeroDiiFol183vPersecutedJews.jpg/500px-BritLibCottonNeroDiiFol183vPersecutedJews.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:BritLibCottonNeroDiiFol183vPersecutedJews.jpg"
  },
  "jh_rhineland_1096": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/8/84/Massacre_of_Jews.jpg",
    "c": "Auguste Migette, 1802-1884, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Massacre_of_Jews.jpg"
  },
  "jh_birobidzhan": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/eb/Birobidzhan%2C_Jewish_Autonomous_Oblast%2C_Russia_-_panoramio.jpg/500px-Birobidzhan%2C_Jewish_Autonomous_Oblast%2C_Russia_-_panoramio.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 333
  },
  "jh_dreyfus_zola": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/J%27accuse.jpg/500px-J%27accuse.jpg",
    "c": "Émile Zola, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:J%27accuse.jpg"
  },
  "jh_abraham_accords": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/President_Trump_and_The_First_Lady_Participate_in_an_Abraham_Accords_Signing_Ceremony_%28cropped%29.jpg/500px-President_Trump_and_The_First_Lady_Participate_in_an_Abraham_Accords_Signing_Ceremony_%28cropped%29.jpg",
    "c": "The White House from Washington, DC, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:President_Trump_and_The_First_Lady_Participate_in_an_Abraham_Accords_Signing_Ceremony_(cropped).jpg"
  },
  "jh_mossad": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Dan_Hadani_collection_%28990044445280205171%29.jpg/500px-Dan_Hadani_collection_%28990044445280205171%29.jpg",
    "c": "Israel Press and Photo Agency (I.P.P.A.) photographer, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Dan_Hadani_collection_(990044445280205171).jpg"
  },
  "jh_emancipation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Napoleon_stellt_den_israelitischen_Kult_wieder_her%2C_30._Mai_1806.jpg/500px-Napoleon_stellt_den_israelitischen_Kult_wieder_her%2C_30._Mai_1806.jpg",
    "c": "Louis François Couché (1782-1849). Graveur, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Napoleon_stellt_den_israelitischen_Kult_wieder_her,_30._Mai_1806.jpg"
  },
  "jh_yehuda_halevi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Letter_%28T-S_8J18.5%29.jpg/500px-Letter_%28T-S_8J18.5%29.jpg",
    "c": "en:Judah ha-Levi, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Letter_(T-S_8J18.5).jpg"
  },
  "jh_irgun": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Altalena_off_Tel-Aviv_beach.jpg/500px-Altalena_off_Tel-Aviv_beach.jpg",
    "c": "Hans Pinn, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Altalena_off_Tel-Aviv_beach.jpg"
  },
  "jh_nuremberg_trials": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/39/Defendants_in_the_dock_at_nuremberg_trials.jpg/500px-Defendants_in_the_dock_at_nuremberg_trials.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 394
  },
  "jh_kibbutz_galuyot": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Flickr_-_Government_Press_Office_%28GPO%29_-_LINE_OF_ETHIOPIAN_IMMIGRANTS_STREAMING_OUT_OF_THE_HERCULES.jpg/500px-Flickr_-_Government_Press_Office_%28GPO%29_-_LINE_OF_ETHIOPIAN_IMMIGRANTS_STREAMING_OUT_OF_THE_HERCULES.jpg",
    "c": "Tsvika Israeli, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Flickr_-_Government_Press_Office_(GPO)_-_LINE_OF_ETHIOPIAN_IMMIGRANTS_STREAMING_OUT_OF_THE_HERCULES.jpg"
  },
  "jh_protocols": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/1905_2fnl_Velikoe_v_malom_i_antikhrist.jpg/500px-1905_2fnl_Velikoe_v_malom_i_antikhrist.jpg",
    "c": "Sergei Nilus (1862-1929), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:1905_2fnl_Velikoe_v_malom_i_antikhrist.jpg"
  },
  "jh_galut_portugal": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/A_Expuls%C3%A3o_dos_Judeus_%28Roque_Gameiro%2C_Quadros_da_Hist%C3%B3ria_de_Portugal%2C_1917%29.png/500px-A_Expuls%C3%A3o_dos_Judeus_%28Roque_Gameiro%2C_Quadros_da_Hist%C3%B3ria_de_Portugal%2C_1917%29.png",
    "c": "Roque Gameiro, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_Expuls%C3%A3o_dos_Judeus_(Roque_Gameiro,_Quadros_da_Hist%C3%B3ria_de_Portugal,_1917).png"
  },
  "jh_suez_war_context": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/EXODUS.jpeg/500px-EXODUS.jpeg",
    "c": "Fritz Cohen, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:EXODUS.jpeg"
  },
  "jh_wadi_ara": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Members_of_Israeli_Delegation_to_Armistice_talks_in_Rhodes%2C_January_1949.jpg/500px-Members_of_Israeli_Delegation_to_Armistice_talks_in_Rhodes%2C_January_1949.jpg",
    "c": "Israeli GPO photographer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Members_of_Israeli_Delegation_to_Armistice_talks_in_Rhodes,_January_1949.jpg"
  },
  "jh_start_up_nation": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Tel_Aviv_Skyline_03.jpg/500px-Tel_Aviv_Skyline_03.jpg",
    "c": "Ynhockey, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Tel_Aviv_Skyline_03.jpg"
  },
  "ar_campbell_soup": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/Campbell%27s_Soup_Cans_by_Andy_Warhol.jpg/500px-Campbell%27s_Soup_Cans_by_Andy_Warhol.jpg",
    "c": "Brandon Fick, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Campbell%27s_Soup_Cans_by_Andy_Warhol.jpg"
  },
  "ar_gobekli_tepe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/G%C3%B6bekli_Tepe%2C_Urfa.jpg/500px-G%C3%B6bekli_Tepe%2C_Urfa.jpg",
    "c": "Teomancimit, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:G%C3%B6bekli_Tepe,_Urfa.jpg"
  },
  "ar_terracotta": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/51714-Terracota-Army.jpg/500px-51714-Terracota-Army.jpg",
    "c": "xiquinhosilva, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:51714-Terracota-Army.jpg"
  },
  "ar_hagia_sophia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Hagia_Sophia_%28228968325%29.jpeg/500px-Hagia_Sophia_%28228968325%29.jpeg",
    "c": "Adli Wahid, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Hagia_Sophia_(228968325).jpeg"
  },
  "ar_giotto_scrovegni": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Padova_Cappella_degli_Scrovegni_Innen_Langhaus_West_5.jpg/500px-Padova_Cappella_degli_Scrovegni_Innen_Langhaus_West_5.jpg",
    "c": "Zairon, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Padova_Cappella_degli_Scrovegni_Innen_Langhaus_West_5.jpg"
  },
  "ar_waterlilies": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Reflections_of_Clouds_on_the_Water-Lily_Pond.jpg/500px-Reflections_of_Clouds_on_the_Water-Lily_Pond.jpg",
    "c": "Claude Monet, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Reflections_of_Clouds_on_the_Water-Lily_Pond.jpg"
  },
  "ar_pollock_drip": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Jackson_Pollock_by_Hans_Namuth_%28cropped%29.jpg/500px-Jackson_Pollock_by_Hans_Namuth_%28cropped%29.jpg",
    "c": "Hans Namuth, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Jackson_Pollock_by_Hans_Namuth_(cropped).jpg"
  },
  "ar_rothko_chapel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Rothko_Chapel_-_1_August_2010.jpg/500px-Rothko_Chapel_-_1_August_2010.jpg",
    "c": "David Van Horn from Boston, MA, USA, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Rothko_Chapel_-_1_August_2010.jpg"
  },
  "ar_seurat_sunday": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/A_Sunday_on_La_Grande_Jatte%2C_Georges_Seurat%2C_1884.jpg/500px-A_Sunday_on_La_Grande_Jatte%2C_Georges_Seurat%2C_1884.jpg",
    "c": "Georges Seurat, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:A_Sunday_on_La_Grande_Jatte,_Georges_Seurat,_1884.jpg"
  },
  "ar_elgin_marbles": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Elgin-marbles-jan-2024.jpg/500px-Elgin-marbles-jan-2024.jpg",
    "c": "Jay.M, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Elgin-marbles-jan-2024.jpg"
  },
  "ar_ukiyoe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Shibai_Ukie_by_Masanobu_Okumura.jpg/500px-Shibai_Ukie_by_Masanobu_Okumura.jpg",
    "c": "Okumura Masanobu, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Shibai_Ukie_by_Masanobu_Okumura.jpg"
  },
  "ar_daguerre": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Louis_Daguerre_2.jpg/500px-Louis_Daguerre_2.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Louis_Daguerre_2.jpg"
  },
  "ar_brancusi_bird": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Bird_in_Space.jpg/500px-Bird_in_Space.jpg",
    "c": "Art Poskanzer, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bird_in_Space.jpg"
  },
  "ar_maya_murals": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Zona_arqueologica_Bonampak_01_ID_ZA30_DBannasch.jpg/500px-Zona_arqueologica_Bonampak_01_ID_ZA30_DBannasch.jpg",
    "c": "Dbannasch, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Zona_arqueologica_Bonampak_01_ID_ZA30_DBannasch.jpg"
  },
  "ar_kahlo_diary": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Frida_Kahlo%2C_by_Guillermo_Kahlo.jpg/500px-Frida_Kahlo%2C_by_Guillermo_Kahlo.jpg",
    "c": "Guillermo Kahlo, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Frida_Kahlo,_by_Guillermo_Kahlo.jpg"
  },
  "ar_le_corbusier_chapel": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/Ronchamp-ville-chapelle.jpg/500px-Ronchamp-ville-chapelle.jpg",
    "c": "Nerijp, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ronchamp-ville-chapelle.jpg"
  },
  "ar_giacometti_walking": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Emmy_Andriesse_-_Alberto_Giacometti_%28Ende_1940er_PK-F-A.06801%29.jpg/500px-Emmy_Andriesse_-_Alberto_Giacometti_%28Ende_1940er_PK-F-A.06801%29.jpg",
    "c": "Emmy Andriesse, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Emmy_Andriesse_-_Alberto_Giacometti_(Ende_1940er_PK-F-A.06801).jpg"
  },
  "ar_van_eyck_altarpiece": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Ghent_Altarpiece_Google_Art_Project.jpg/500px-Ghent_Altarpiece_Google_Art_Project.jpg",
    "c": "Jan van Eyck / Presumably Hubert van Eyck, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Ghent_Altarpiece_Google_Art_Project.jpg"
  },
  "ar_gauguin_tahiti": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Paul_Gauguin_1891.png/500px-Paul_Gauguin_1891.png",
    "c": "Louis-Maurice Boutet de Monvel, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Paul_Gauguin_1891.png"
  },
  "ar_nadar_photography": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Self-portrait_of_Nadar.jpg/500px-Self-portrait_of_Nadar.jpg",
    "c": "Nadar, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Self-portrait_of_Nadar.jpg"
  },
  "ar_smithson_spiral": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Spiral-jetty-from-rozel-point.png/500px-Spiral-jetty-from-rozel-point.png",
    "c": "Sculpture: Robert Smithson 1938-1973Image:Soren.harward at en.wikipedia, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Spiral-jetty-from-rozel-point.png"
  },
  "ar_david_oath": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Le_Serment_des_Horaces_-_Jacques-Louis_David_-_Mus%C3%A9e_du_Louvre_Peintures_INV_3692_%3B_MR_1432.jpg/500px-Le_Serment_des_Horaces_-_Jacques-Louis_David_-_Mus%C3%A9e_du_Louvre_Peintures_INV_3692_%3B_MR_1432.jpg",
    "c": "Jacques-Louis David, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Le_Serment_des_Horaces_-_Jacques-Louis_David_-_Mus%C3%A9e_du_Louvre_Peintures_INV_3692_;_MR_1432.jpg"
  },
  "ar_african_nok": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Verbreitung_Nok-Kultur-en.png/500px-Verbreitung_Nok-Kultur-en.png",
    "c": "NordNordWest, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Verbreitung_Nok-Kultur-en.png"
  },
  "ar_new_wave": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Three_by_Truffaut_poster.jpg/500px-Three_by_Truffaut_poster.jpg",
    "c": "Janus Films, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Three_by_Truffaut_poster.jpg"
  },
  "ar_chartres_window": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Notre_Dame_de_Chartres.jpg/500px-Notre_Dame_de_Chartres.jpg",
    "c": "Olvr, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Notre_Dame_de_Chartres.jpg"
  },
  "ar_hockney_splash": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/9/9f/David_Hockney_in_Washington_Square_Park_%281977%29.jpg",
    "c": "United Press International, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:David_Hockney_in_Washington_Square_Park_(1977).jpg"
  },
  "ar_turrell_roden": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Roden.jpg/500px-Roden.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Roden.jpg"
  },
  "ar_klimt_secession": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Secession_2016%2C_Vienna.jpg/500px-Secession_2016%2C_Vienna.jpg",
    "c": "Thomas Ledl, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Secession_2016,_Vienna.jpg"
  },
  "ar_judd_specific": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/Donald_Judd_Untitled_Adelaide_MRD_01.jpg/500px-Donald_Judd_Untitled_Adelaide_MRD_01.jpg",
    "c": "Mike Dickison, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Donald_Judd_Untitled_Adelaide_MRD_01.jpg"
  },
  "ar_braque_violin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/e1/Georges_Braque%2C_1908%2C_photograph_published_in_Gelett_Burgess%2C_The_Wild_Men_of_Paris%2C_Architectural_Record%2C_May_1910.jpg",
    "c": "Photographer non-identified, anonymous, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Georges_Braque,_1908,_photograph_published_in_Gelett_Burgess,_The_Wild_Men_of_Paris,_Architectural_Record,_May_1910.jpg"
  },
  "ar_kiefer_margarethe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/2013_Mass_MoCA_Anselm_Kiefer_Hall_Art_Foundation.jpg/500px-2013_Mass_MoCA_Anselm_Kiefer_Hall_Art_Foundation.jpg",
    "c": "Maryseb14c, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:2013_Mass_MoCA_Anselm_Kiefer_Hall_Art_Foundation.jpg"
  },
  "ar_kapoor_descension": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Anish_Kapoor_2017.jpg/500px-Anish_Kapoor_2017.jpg",
    "c": "Vogler, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Anish_Kapoor_2017.jpg"
  },
  "ar_celtic_crosses": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/16/Muiredach_s_Cross.jpg/500px-Muiredach_s_Cross.jpg",
    "c": "Matteo Corti, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Muiredach_s_Cross.jpg"
  },
  "ar_noguchi_garden": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Isamu_Noguchi%2C_1983_%28cropped%29.jpg/500px-Isamu_Noguchi%2C_1983_%28cropped%29.jpg",
    "c": "Los Angeles Times, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Isamu_Noguchi,_1983_(cropped).jpg"
  },
  "ar_meret_oppenheim": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Meret_Oppenheim_Hochhaus.jpg/500px-Meret_Oppenheim_Hochhaus.jpg",
    "c": "Choinowski, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Meret_Oppenheim_Hochhaus.jpg"
  },
  "ar_borromini_carlo": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/San_Carlo_alle_Quattro_Fontane_-_Front.jpg/500px-San_Carlo_alle_Quattro_Fontane_-_Front.jpg",
    "c": "Architas, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:San_Carlo_alle_Quattro_Fontane_-_Front.jpg"
  },
  "ar_laocoon": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Laoco%C3%B6n_and_his_sons_group.jpg/500px-Laoco%C3%B6n_and_his_sons_group.jpg",
    "c": "Wilfredor, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Laoco%C3%B6n_and_his_sons_group.jpg"
  },
  "ar_bourgeois_spider": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Giant_spider_strikes_again%21.jpg/500px-Giant_spider_strikes_again%21.jpg",
    "c": "John Talbot, CC BY 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Giant_spider_strikes_again!.jpg"
  },
  "ar_doryphoros": {
    "u": "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/76/Doryphoros_MAN_Napoli_Inv6011_n02.jpg/500px-Doryphoros_MAN_Napoli_Inv6011_n02.jpg?utm_source=commons.wikimedia.org&utm_campaign=imageinfo&utm_content=thumbnail",
    "w": 500,
    "h": 1000
  },
  "ar_yayoi_pumpkin": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Yayoi_Kusama_in_2005.jpg/500px-Yayoi_Kusama_in_2005.jpg",
    "c": "Muriel Guingand, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Yayoi_Kusama_in_2005.jpg"
  },
  "ar_catalan_gothic": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Museu_nacional_d%27art_de_catalunya_2.jpg/500px-Museu_nacional_d%27art_de_catalunya_2.jpg",
    "c": "Jvhertum, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Museu_nacional_d%27art_de_catalunya_2.jpg"
  },
  "ar_magritte_pipe": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Portrait_en_buste_du_peintre_surr%C3%A9aliste_Ren%C3%A9_Magritte_%281898-1967%29_le_18_octobre_1961_devant_une_de_ses_toiles%2C_PH19994.jpg/500px-Portrait_en_buste_du_peintre_surr%C3%A9aliste_Ren%C3%A9_Magritte_%281898-1967%29_le_18_octobre_1961_devant_une_de_ses_toiles%2C_PH19994.jpg",
    "c": "Unknown authorUnknown author, CC0",
    "p": "https://commons.wikimedia.org/wiki/File:Portrait_en_buste_du_peintre_surr%C3%A9aliste_Ren%C3%A9_Magritte_(1898-1967)_le_18_octobre_1961_devant_une_de_ses_toiles,_PH19994.jpg"
  },
  "ar_olowe_yoruba": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Pair_of_door_panels_and_lintel_Yoruba_BM.jpg/500px-Pair_of_door_panels_and_lintel_Yoruba_BM.jpg",
    "c": "Photo: Andreas Praefcke, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Pair_of_door_panels_and_lintel_Yoruba_BM.jpg"
  },
  "ar_caravaggio_narcissus": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Narcissus-Caravaggio_%281594-96%29_edited.jpg/500px-Narcissus-Caravaggio_%281594-96%29_edited.jpg",
    "c": "Caravaggio, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Narcissus-Caravaggio_(1594-96)_edited.jpg"
  },
  "ar_ando_light": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Ibaraki_Kasugaoka_Church_light_cross.jpg/500px-Ibaraki_Kasugaoka_Church_light_cross.jpg",
    "c": "taken by Bergmann, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Ibaraki_Kasugaoka_Church_light_cross.jpg"
  },
  "ar_canova_psyche": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/0_Psych%C3%A9_ranim%C3%A9e_par_le_baiser_de_l%27Amour_-_Canova_-_Louvre_1.JPG/500px-0_Psych%C3%A9_ranim%C3%A9e_par_le_baiser_de_l%27Amour_-_Canova_-_Louvre_1.JPG",
    "c": "Jean-Pol GRANDMONT, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:0_Psych%C3%A9_ranim%C3%A9e_par_le_baiser_de_l%27Amour_-_Canova_-_Louvre_1.JPG"
  },
  "ar_niki_phalle": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Niki_de_Saint_Phalle_by_Lothar_Wolleh.jpg/500px-Niki_de_Saint_Phalle_by_Lothar_Wolleh.jpg",
    "c": "Lothar Wolleh, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Niki_de_Saint_Phalle_by_Lothar_Wolleh.jpg"
  },
  "ar_bill_viola": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/BillViola.jpg/500px-BillViola.jpg",
    "c": "Jean-Baptiste LABRUNE a.k.a. jeanbaptisteparis, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:BillViola.jpg"
  },
  "gr_pericles_age": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Parthenon_from_south.jpg/500px-Parthenon_from_south.jpg",
    "c": "Thermos, CC BY-SA 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:Parthenon_from_south.jpg"
  },
  "gr_first_triumvirate": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Sulla_Glyptothek_Munich_309.jpg/500px-Sulla_Glyptothek_Munich_309.jpg",
    "c": "Wikimedia Commons, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Sulla_Glyptothek_Munich_309.jpg"
  },
  "gr_cicero": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Cicero_Denounces_Catiline_in_the_Roman_Senate_by_Cesare_Maccari_-_3.jpg/500px-Cicero_Denounces_Catiline_in_the_Roman_Senate_by_Cesare_Maccari_-_3.jpg",
    "c": "Cesare Maccari, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Cicero_Denounces_Catiline_in_the_Roman_Senate_by_Cesare_Maccari_-_3.jpg"
  },
  "gr_heraclius_persia": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Part_of_Hoard_thet_was_found_in_City_of_David.jpg/500px-Part_of_Hoard_thet_was_found_in_City_of_David.jpg",
    "c": "אסף קרוואני Asaf karavani, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Part_of_Hoard_thet_was_found_in_City_of_David.jpg"
  },
  "gr_antikythera": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/NAMA_Machine_d%27Anticyth%C3%A8re_1.jpg/500px-NAMA_Machine_d%27Anticyth%C3%A8re_1.jpg",
    "c": "Wikimedia Commons, CC BY 2.5",
    "p": "https://commons.wikimedia.org/wiki/File:NAMA_Machine_d%27Anticyth%C3%A8re_1.jpg"
  },
  "gr_theodoric": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Teodorico_re_dei_Goti_%28493-526%29.png/500px-Teodorico_re_dei_Goti_%28493-526%29.png",
    "c": "Unknown authorUnknown author, CC BY 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Teodorico_re_dei_Goti_(493-526).png"
  },
  "mu_beatles_please": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/The_Beatles_1963_Dezo_Hoffman_Capitol_Records_press_photo_2.jpg/500px-The_Beatles_1963_Dezo_Hoffman_Capitol_Records_press_photo_2.jpg",
    "c": "Dezo Hoffmann, Distributed by Capitol Records, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:The_Beatles_1963_Dezo_Hoffman_Capitol_Records_press_photo_2.jpg"
  },
  "mu_gershwin_rhapsody": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Gershwin_best_800.jpg/500px-Gershwin_best_800.jpg",
    "c": "Anthony22 at English Wikipedia, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Gershwin_best_800.jpg"
  },
  "mu_hurrian_hymn": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Mastaba_of_Ti_05_a.jpg/500px-Mastaba_of_Ti_05_a.jpg",
    "c": "Mastaba_of_Ti_05.JPG: Einsamer Schütze derivative work: JMCC1 (talk), CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Mastaba_of_Ti_05_a.jpg"
  },
  "jh_ezra": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/DuraSyn-III-Jeremiah.jpg/500px-DuraSyn-III-Jeremiah.jpg",
    "c": "Gillman slide collection., Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:DuraSyn-III-Jeremiah.jpg"
  },
  "jh_knesset": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Elec20-2015.JPG/500px-Elec20-2015.JPG",
    "c": "חזרתי, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Elec20-2015.JPG"
  },
  "jh_chmielnitsky": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Bohdan_Chmelnicki-port.png/500px-Bohdan_Chmelnicki-port.png",
    "c": "Unknown authorUnknown author, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Bohdan_Chmelnicki-port.png"
  },
  "jh_maccabiah": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Flickr_-_Government_Press_Office_%28GPO%29_-_A_BASKETBALL_GAME_BETWEEN_THE_U.S._AND_BRAZIL.jpg/500px-Flickr_-_Government_Press_Office_%28GPO%29_-_A_BASKETBALL_GAME_BETWEEN_THE_U.S._AND_BRAZIL.jpg",
    "c": "Moshe Pridan, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:Flickr_-_Government_Press_Office_(GPO)_-_A_BASKETBALL_GAME_BETWEEN_THE_U.S._AND_BRAZIL.jpg"
  },
  "gr_marcus_aurelius": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/MSR-ra-61-b-1-DM.jpg/500px-MSR-ra-61-b-1-DM.jpg",
    "c": "Daniel Martin, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:MSR-ra-61-b-1-DM.jpg"
  },
  "gr_pompeii_graffiti": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Aerial_image_of_Pompeii_and_Mount_Vesuvius_%28view_from_the_southeast%29.jpg/500px-Aerial_image_of_Pompeii_and_Mount_Vesuvius_%28view_from_the_southeast%29.jpg",
    "c": "Carsten Steger, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Aerial_image_of_Pompeii_and_Mount_Vesuvius_(view_from_the_southeast).jpg"
  },
  "gr_olympic_truce": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/GR-olympia-palaestra.jpg/500px-GR-olympia-palaestra.jpg",
    "c": "Bgabel, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:GR-olympia-palaestra.jpg"
  },
  "mu_africa_70_afrobeat": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Fela_Kuti_circa_1986.jpg/500px-Fela_Kuti_circa_1986.jpg",
    "c": "Distributed by Celluloid Records, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Fela_Kuti_circa_1986.jpg"
  },
  "mu_afro_cuban_jazz": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Machito_and_his_sister_Graciella_Grillo.jpg/500px-Machito_and_his_sister_Graciella_Grillo.jpg",
    "c": "William P. Gottlieb, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Machito_and_his_sister_Graciella_Grillo.jpg"
  },
  "mu_philip_glass_koyaanisqatsi": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Philip_Glass_in_Florence%2C_Italy_-_1993_%28cropped%29.jpg/500px-Philip_Glass_in_Florence%2C_Italy_-_1993_%28cropped%29.jpg",
    "c": "Pasquale Salerno, CC BY-SA 2.0",
    "p": "https://commons.wikimedia.org/wiki/File:Philip_Glass_in_Florence,_Italy_-_1993_(cropped).jpg"
  },
  "mu_muddy_waters_chicago": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Muddy_Waters_november_1976.jpg/500px-Muddy_Waters_november_1976.jpg",
    "c": "Lionel Decoster, CC BY-SA 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Muddy_Waters_november_1976.jpg"
  },
  "jh_un_partition": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/UN_Palestine_Partition_Versions_1947.jpg/500px-UN_Palestine_Partition_Versions_1947.jpg",
    "c": "Zero0000A/RES/181(II), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:UN_Palestine_Partition_Versions_1947.jpg"
  },
  "mu_brahms_first": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/JohannesBrahms_%28cropped%29.jpg/500px-JohannesBrahms_%28cropped%29.jpg",
    "c": "C. Brasch, Berlin (biography), Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:JohannesBrahms_(cropped).jpg"
  },
  "jh_intifada_first": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Intifada_in_Gaza_Strip%2C_1987_V_Dan_Hadani_Archive.jpg/500px-Intifada_in_Gaza_Strip%2C_1987_V_Dan_Hadani_Archive.jpg",
    "c": "Efi Sharir, CC BY 4.0",
    "p": "https://commons.wikimedia.org/wiki/File:Intifada_in_Gaza_Strip,_1987_V_Dan_Hadani_Archive.jpg"
  },
  "jh_gaon_period": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Guide_for_the_Perplexed_by_Maimonides.jpg/500px-Guide_for_the_Perplexed_by_Maimonides.jpg",
    "c": "Moshe ben Maimon, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Guide_for_the_Perplexed_by_Maimonides.jpg"
  },
  "jh_intifada_second": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/%D7%97%D7%95%D7%9E%D7%AA_%D7%9E%D7%92%D7%9F_11.jpg/500px-%D7%97%D7%95%D7%9E%D7%AA_%D7%9E%D7%92%D7%9F_11.jpg",
    "c": "יואב גוטרמן / Israel Defense Forces, CC BY-SA 3.0",
    "p": "https://commons.wikimedia.org/wiki/File:%D7%97%D7%95%D7%9E%D7%AA_%D7%9E%D7%92%D7%9F_11.jpg"
  },
  "jh_mahapach": {
    "u": "https://upload.wikimedia.org/wikipedia/commons/e/e4/Menachem_Begin_and_Cyrus_R._Vance_%28cropped%29_%282%29.JPEG",
    "c": "MSGT DENHAM, Public domain",
    "p": "https://commons.wikimedia.org/wiki/File:Menachem_Begin_and_Cyrus_R._Vance_(cropped)_(2).JPEG"
  }
}
